(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.eY.bJ === region.f4.bJ)
	{
		return 'on line ' + region.eY.bJ;
	}
	return 'on lines ' + region.eY.bJ + ' through ' + region.f4.bJ;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (Object.prototype.hasOwnProperty.call(value, key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	var unwrapped = _Json_unwrap(value);
	if (!(key === 'toJSON' && typeof unwrapped === 'function'))
	{
		object[key] = unwrapped;
	}
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.kh,
		impl.ac,
		impl.mr,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		gI: func(record.gI),
		hR: record.hR,
		he: record.he
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.gI;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.hR;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.he) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.kh,
		impl.ac,
		impl.mr,
		function(sendToApp, initialModel) {
			var view = impl.mQ;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.kh,
		impl.ac,
		impl.mr,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.eX && impl.eX(sendToApp)
			var view = impl.mQ;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.iO);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.mz) && (_VirtualDom_doc.title = title = doc.mz);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.li;
	var onUrlRequest = impl.lj;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		eX: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.hi === next.hi
							&& curr.gj === next.gj
							&& curr.g9.a === next.g9.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		kh: function(flags)
		{
			return A3(impl.kh, flags, _Browser_getUrl(), key);
		},
		mQ: impl.mQ,
		ac: impl.ac,
		mr: impl.mr
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { j0: 'hidden', iW: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { j0: 'mozHidden', iW: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { j0: 'msHidden', iW: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { j0: 'webkitHidden', iW: 'webkitvisibilitychange' }
		: { j0: 'hidden', iW: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		hw: _Browser_getScene(),
		ij: {
			io: _Browser_window.pageXOffset,
			ip: _Browser_window.pageYOffset,
			im: _Browser_doc.documentElement.clientWidth,
			gi: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		im: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		gi: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			hw: {
				im: node.scrollWidth,
				gi: node.scrollHeight
			},
			ij: {
				io: node.scrollLeft,
				ip: node.scrollTop,
				im: node.clientWidth,
				gi: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			hw: _Browser_getScene(),
			ij: {
				io: x,
				ip: y,
				im: _Browser_doc.documentElement.clientWidth,
				gi: _Browser_doc.documentElement.clientHeight
			},
			jz: {
				io: x + rect.left,
				ip: y + rect.top,
				im: rect.width,
				gi: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}

// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.kQ) { flags += 'm'; }
	if (options.iU) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;


// BYTES

function _Bytes_width(bytes)
{
	return bytes.byteLength;
}

var _Bytes_getHostEndianness = F2(function(le, be)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(new Uint8Array(new Uint32Array([1]))[0] === 1 ? le : be));
	});
});


// ENCODERS

function _Bytes_encode(encoder)
{
	var mutableBytes = new DataView(new ArrayBuffer($elm$bytes$Bytes$Encode$getWidth(encoder)));
	$elm$bytes$Bytes$Encode$write(encoder)(mutableBytes)(0);
	return mutableBytes;
}


// SIGNED INTEGERS

var _Bytes_write_i8  = F3(function(mb, i, n) { mb.setInt8(i, n); return i + 1; });
var _Bytes_write_i16 = F4(function(mb, i, n, isLE) { mb.setInt16(i, n, isLE); return i + 2; });
var _Bytes_write_i32 = F4(function(mb, i, n, isLE) { mb.setInt32(i, n, isLE); return i + 4; });


// UNSIGNED INTEGERS

var _Bytes_write_u8  = F3(function(mb, i, n) { mb.setUint8(i, n); return i + 1 ;});
var _Bytes_write_u16 = F4(function(mb, i, n, isLE) { mb.setUint16(i, n, isLE); return i + 2; });
var _Bytes_write_u32 = F4(function(mb, i, n, isLE) { mb.setUint32(i, n, isLE); return i + 4; });


// FLOATS

var _Bytes_write_f32 = F4(function(mb, i, n, isLE) { mb.setFloat32(i, n, isLE); return i + 4; });
var _Bytes_write_f64 = F4(function(mb, i, n, isLE) { mb.setFloat64(i, n, isLE); return i + 8; });


// BYTES

var _Bytes_write_bytes = F3(function(mb, offset, bytes)
{
	for (var i = 0, len = bytes.byteLength, limit = len - 4; i <= limit; i += 4)
	{
		mb.setUint32(offset + i, bytes.getUint32(i));
	}
	for (; i < len; i++)
	{
		mb.setUint8(offset + i, bytes.getUint8(i));
	}
	return offset + len;
});


// STRINGS

function _Bytes_getStringWidth(string)
{
	for (var width = 0, i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		width +=
			(code < 0x80) ? 1 :
			(code < 0x800) ? 2 :
			(code < 0xD800 || 0xDBFF < code) ? 3 : (i++, 4);
	}
	return width;
}

var _Bytes_write_string = F3(function(mb, offset, string)
{
	for (var i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		offset +=
			(code < 0x80)
				? (mb.setUint8(offset, code)
				, 1
				)
				:
			(code < 0x800)
				? (mb.setUint16(offset, 0xC080 /* 0b1100000010000000 */
					| (code >>> 6 & 0x1F /* 0b00011111 */) << 8
					| code & 0x3F /* 0b00111111 */)
				, 2
				)
				:
			(code < 0xD800 || 0xDBFF < code)
				? (mb.setUint16(offset, 0xE080 /* 0b1110000010000000 */
					| (code >>> 12 & 0xF /* 0b00001111 */) << 8
					| code >>> 6 & 0x3F /* 0b00111111 */)
				, mb.setUint8(offset + 2, 0x80 /* 0b10000000 */
					| code & 0x3F /* 0b00111111 */)
				, 3
				)
				:
			(code = (code - 0xD800) * 0x400 + string.charCodeAt(++i) - 0xDC00 + 0x10000
			, mb.setUint32(offset, 0xF0808080 /* 0b11110000100000001000000010000000 */
				| (code >>> 18 & 0x7 /* 0b00000111 */) << 24
				| (code >>> 12 & 0x3F /* 0b00111111 */) << 16
				| (code >>> 6 & 0x3F /* 0b00111111 */) << 8
				| code & 0x3F /* 0b00111111 */)
			, 4
			);
	}
	return offset;
});


// DECODER

var _Bytes_decode = F2(function(decoder, bytes)
{
	try {
		return $elm$core$Maybe$Just(A2(decoder, bytes, 0).b);
	} catch(e) {
		return $elm$core$Maybe$Nothing;
	}
});

var _Bytes_read_i8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getInt8(offset)); });
var _Bytes_read_i16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getInt16(offset, isLE)); });
var _Bytes_read_i32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getInt32(offset, isLE)); });
var _Bytes_read_u8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getUint8(offset)); });
var _Bytes_read_u16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getUint16(offset, isLE)); });
var _Bytes_read_u32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getUint32(offset, isLE)); });
var _Bytes_read_f32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getFloat32(offset, isLE)); });
var _Bytes_read_f64 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 8, bytes.getFloat64(offset, isLE)); });

var _Bytes_read_bytes = F3(function(len, bytes, offset)
{
	return _Utils_Tuple2(offset + len, new DataView(bytes.buffer, bytes.byteOffset + offset, len));
});

var _Bytes_read_string = F3(function(len, bytes, offset)
{
	var string = '';
	var end = offset + len;
	for (; offset < end;)
	{
		var byte = bytes.getUint8(offset++);
		string +=
			(byte < 128)
				? String.fromCharCode(byte)
				:
			((byte & 0xE0 /* 0b11100000 */) === 0xC0 /* 0b11000000 */)
				? String.fromCharCode((byte & 0x1F /* 0b00011111 */) << 6 | bytes.getUint8(offset++) & 0x3F /* 0b00111111 */)
				:
			((byte & 0xF0 /* 0b11110000 */) === 0xE0 /* 0b11100000 */)
				? String.fromCharCode(
					(byte & 0xF /* 0b00001111 */) << 12
					| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
					| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
				)
				:
				(byte =
					((byte & 0x7 /* 0b00000111 */) << 18
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 12
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
						| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
					) - 0x10000
				, String.fromCharCode(Math.floor(byte / 0x400) + 0xD800, byte % 0x400 + 0xDC00)
				);
	}
	return _Utils_Tuple2(offset, string);
});

var _Bytes_decodeFailure = F2(function() { throw 0; });



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.cz.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.cz.b, xhr)); });
		$elm$core$Maybe$isJust(request.mG) && _Http_track(router, xhr, request.mG.a);

		try {
			xhr.open(request.kL, request.id, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.id));
		}

		_Http_configureRequest(xhr, request);

		request.iO.a && xhr.setRequestHeader('Content-Type', request.iO.a);
		xhr.send(request.iO.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.j_; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.my.a || 0;
	xhr.responseType = request.cz.d;
	xhr.withCredentials = request.iE;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		id: xhr.responseURL,
		ml: xhr.status,
		mm: xhr.statusText,
		j_: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			l7: event.loaded,
			hJ: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			lC: event.loaded,
			hJ: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}



// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $author$project$Main$ChangedUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$ClickedLink = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.q) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.t),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.t);
		} else {
			var treeLen = builder.q * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.u) : builder.u;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.q);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.t) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.t);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{u: nodeList, q: (len / $elm$core$Array$branchFactor) | 0, t: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {ge: fragment, gj: host, g7: path, g9: port_, hi: protocol, lB: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Main$NotFound = {$: 30};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Ports$doFetchToken = _Platform_outgoingPort(
	'doFetchToken',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {aK: frag, aO: params, aB: unvisited, ig: value, aU: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.aB;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.ig);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.ig);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.g7),
					$elm$url$Url$Parser$prepareQuery(url.lB),
					url.ge,
					$elm$core$Basics$identity)));
	});
var $author$project$Main$ComplexFoodsRoute = {$: 28};
var $author$project$Main$ConfirmRecoveryRoute = F2(
	function (a, b) {
		return {$: 27, a: a, b: b};
	});
var $author$project$Main$ConfirmRegistrationRoute = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $author$project$Main$DeletionRoute = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $author$project$Main$IngredientRoute = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$LandingRoute = {$: 0};
var $author$project$Main$LoginRoute = {$: 1};
var $author$project$Main$MealEntriesRoute = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Main$MealProfileChoice = {$: 5};
var $author$project$Main$MealsRoute = function (a) {
	return {$: 6, a: a};
};
var $author$project$Main$OverviewRoute = {$: 2};
var $author$project$Main$ProfilesRoute = {$: 29};
var $author$project$Main$RecipesRoute = {$: 3};
var $author$project$Main$ReferenceEntriesRoute = function (a) {
	return {$: 21, a: a};
};
var $author$project$Main$ReferenceMapsRoute = {$: 20};
var $author$project$Main$RequestRecoveryRoute = {$: 26};
var $author$project$Main$RequestRegistrationRoute = {$: 22};
var $author$project$Main$StatisticsComplexFoodSearchRoute = {$: 11};
var $author$project$Main$StatisticsComplexFoodSelectRoute = function (a) {
	return {$: 12, a: a};
};
var $author$project$Main$StatisticsFoodSearchRoute = {$: 9};
var $author$project$Main$StatisticsFoodSelectRoute = function (a) {
	return {$: 10, a: a};
};
var $author$project$Main$StatisticsMealProfileChoiceRoute = {$: 15};
var $author$project$Main$StatisticsMealSearchRoute = function (a) {
	return {$: 16, a: a};
};
var $author$project$Main$StatisticsMealSelectRoute = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Main$StatisticsRecipeOccurrencesProfileChoiceRoute = {$: 18};
var $author$project$Main$StatisticsRecipeOccurrencesRoute = function (a) {
	return {$: 19, a: a};
};
var $author$project$Main$StatisticsRecipeSearchRoute = {$: 13};
var $author$project$Main$StatisticsRecipeSelectRoute = function (a) {
	return {$: 14, a: a};
};
var $author$project$Main$StatisticsTimeRoute = {$: 8};
var $author$project$Main$UserSettingsRoute = {$: 24};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.aU;
		var unvisited = _v0.aB;
		var params = _v0.aO;
		var frag = _v0.aK;
		var value = _v0.ig;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $author$project$Addresses$Frontend$plain = function (string) {
	return {
		iA: $elm$core$Basics$always(
			_List_fromArray(
				[string])),
		aw: $elm$url$Url$Parser$s(string)
	};
};
var $author$project$Addresses$Frontend$complexFoods = $author$project$Addresses$Frontend$plain('complex-foods');
var $author$project$Api$Types$UserIdentifier$UserIdentifier = F2(
	function (nickname, email) {
		return {f2: email, gU: nickname};
	});
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.aU;
		var unvisited = _v0.aB;
		var params = _v0.aO;
		var frag = _v0.aK;
		var value = _v0.ig;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.aU;
			var unvisited = _v1.aB;
			var params = _v1.aO;
			var frag = _v1.aK;
			var value = _v1.ig;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.aU;
			var unvisited = _v0.aB;
			var params = _v0.aO;
			var frag = _v0.aK;
			var value = _v0.ig;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $author$project$Pages$Util$ParserUtil$with2 = function (ps) {
	return {
		iA: function (_v0) {
			var param1 = _v0.a;
			var param2 = _v0.b;
			return _Utils_ap(
				$elm$core$List$singleton(ps.dH),
				_Utils_ap(
					ps.h0(param1),
					_Utils_ap(
						$elm$core$List$singleton(ps.hQ),
						ps.h1(param2))));
		},
		aw: A2(
			$elm$url$Url$Parser$slash,
			$elm$url$Url$Parser$s(ps.dH),
			A2(
				$elm$url$Url$Parser$slash,
				ps.g2,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s(ps.hQ),
					ps.g3)))
	};
};
var $author$project$Pages$Util$ParserUtil$nicknameEmailParser = $author$project$Pages$Util$ParserUtil$with2(
	{g2: $elm$url$Url$Parser$string, g3: $elm$url$Url$Parser$string, dH: 'nickname', hQ: 'email', h0: $elm$core$List$singleton, h1: $elm$core$List$singleton});
var $author$project$Addresses$Frontend$confirm = function (step1) {
	return $author$project$Pages$Util$ParserUtil$with2(
		{
			g2: A2($elm$url$Url$Parser$map, $author$project$Api$Types$UserIdentifier$UserIdentifier, $author$project$Pages$Util$ParserUtil$nicknameEmailParser.aw),
			g3: $elm$url$Url$Parser$string,
			dH: step1,
			hQ: 'token',
			h0: $author$project$Pages$Util$ParserUtil$nicknameEmailParser.iA,
			h1: $elm$core$List$singleton
		});
};
var $author$project$Addresses$Frontend$confirmRecovery = $author$project$Addresses$Frontend$confirm('recover-account');
var $author$project$Addresses$Frontend$confirmRegistration = $author$project$Addresses$Frontend$confirm('confirm-registration');
var $author$project$Addresses$Frontend$deleteAccount = $author$project$Addresses$Frontend$confirm('delete-account');
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $danyx23$elm_uuid$Uuid$toString = function (_v0) {
	var internalString = _v0;
	return internalString;
};
var $danyx23$elm_uuid$Uuid$Uuid = $elm$core$Basics$identity;
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {kc: index, kB: match, k5: number, mq: submatches};
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{iU: false, kQ: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $danyx23$elm_uuid$Uuid$Barebones$uuidRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9A-Fa-f]{8,8}-[0-9A-Fa-f]{4,4}-[1-5][0-9A-Fa-f]{3,3}-[8-9A-Ba-b][0-9A-Fa-f]{3,3}-[0-9A-Fa-f]{12,12}$'));
var $danyx23$elm_uuid$Uuid$Barebones$isValidUuid = function (uuidAsString) {
	return A2($elm$regex$Regex$contains, $danyx23$elm_uuid$Uuid$Barebones$uuidRegex, uuidAsString);
};
var $elm$core$String$toLower = _String_toLower;
var $danyx23$elm_uuid$Uuid$fromString = function (text) {
	return $danyx23$elm_uuid$Uuid$Barebones$isValidUuid(text) ? $elm$core$Maybe$Just(
		$elm$core$String$toLower(text)) : $elm$core$Maybe$Nothing;
};
var $author$project$Pages$Util$ParserUtil$uuidParser = A2($elm$url$Url$Parser$custom, 'UUID', $danyx23$elm_uuid$Uuid$fromString);
var $author$project$Pages$Util$ParserUtil$with1 = function (ps) {
	return {
		iA: function (param) {
			return A2(
				$elm$core$List$cons,
				ps.dH,
				ps.bX(param));
		},
		aw: A2(
			$elm$url$Url$Parser$slash,
			$elm$url$Url$Parser$s(ps.dH),
			ps.bO)
	};
};
var $author$project$Addresses$Frontend$ingredientEditor = $author$project$Pages$Util$ParserUtil$with1(
	{
		bO: $author$project$Pages$Util$ParserUtil$uuidParser,
		dH: 'ingredient-editor',
		bX: A2($elm$core$Basics$composeR, $danyx23$elm_uuid$Uuid$toString, $elm$core$List$singleton)
	});
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Addresses$Frontend$landing = {
	iA: $elm$core$Basics$always(_List_Nil),
	aw: $elm$url$Url$Parser$top
};
var $author$project$Addresses$Frontend$login = $author$project$Addresses$Frontend$plain('login');
var $author$project$Addresses$Frontend$mealBranch = $author$project$Addresses$Frontend$plain('meals');
var $author$project$Addresses$Frontend$mealEntryEditor = $author$project$Pages$Util$ParserUtil$with2(
	{
		g2: $author$project$Pages$Util$ParserUtil$uuidParser,
		g3: $author$project$Pages$Util$ParserUtil$uuidParser,
		dH: 'profile',
		hQ: 'meal',
		h0: A2($elm$core$Basics$composeR, $danyx23$elm_uuid$Uuid$toString, $elm$core$List$singleton),
		h1: A2($elm$core$Basics$composeR, $danyx23$elm_uuid$Uuid$toString, $elm$core$List$singleton)
	});
var $author$project$Addresses$Frontend$meals = function () {
	var profilesWord = 'profiles';
	var mealsWord = 'meals';
	return {
		iA: function (param) {
			return _List_fromArray(
				[
					profilesWord,
					$danyx23$elm_uuid$Uuid$toString(param),
					mealsWord
				]);
		},
		aw: A2(
			$elm$url$Url$Parser$slash,
			$elm$url$Url$Parser$s(profilesWord),
			A2(
				$elm$url$Url$Parser$slash,
				$author$project$Pages$Util$ParserUtil$uuidParser,
				$elm$url$Url$Parser$s(mealsWord)))
	};
}();
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $author$project$Addresses$Frontend$overview = $author$project$Addresses$Frontend$plain('overview');
var $author$project$Addresses$Frontend$profiles = $author$project$Addresses$Frontend$plain('profiles');
var $author$project$Addresses$Frontend$recipes = $author$project$Addresses$Frontend$plain('recipes');
var $author$project$Addresses$Frontend$referenceEntries = $author$project$Pages$Util$ParserUtil$with1(
	{
		bO: $author$project$Pages$Util$ParserUtil$uuidParser,
		dH: 'reference-nutrients',
		bX: A2($elm$core$Basics$composeR, $danyx23$elm_uuid$Uuid$toString, $elm$core$List$singleton)
	});
var $author$project$Addresses$Frontend$referenceMaps = $author$project$Addresses$Frontend$plain('reference-maps');
var $author$project$Addresses$Frontend$requestRecovery = $author$project$Addresses$Frontend$plain('request-recovery');
var $author$project$Addresses$Frontend$requestRegistration = $author$project$Addresses$Frontend$plain('request-registration');
var $elm_community$basics_extra$Basics$Extra$flip = F3(
	function (f, b, a) {
		return A2(f, a, b);
	});
var $author$project$Main$route = $elm_community$basics_extra$Basics$Extra$flip($elm$url$Url$Parser$map);
var $author$project$Addresses$StatisticsVariant$complexFood = 'complex-food';
var $author$project$Pages$Util$ParserUtil$foldl1 = function (string) {
	return A2(
		$elm$core$List$foldl,
		F2(
			function (str, p) {
				return A2(
					$elm$url$Url$Parser$slash,
					p,
					$elm$url$Url$Parser$s(str));
			}),
		$elm$url$Url$Parser$s(string));
};
var $author$project$Addresses$Frontend$plainMultiple = F2(
	function (string, strings) {
		return {
			iA: $elm$core$Basics$always(strings),
			aw: A2($author$project$Pages$Util$ParserUtil$foldl1, string, strings)
		};
	});
var $author$project$Addresses$Frontend$statisticsComplexFoodSearch = A2(
	$author$project$Addresses$Frontend$plainMultiple,
	'statistics',
	_List_fromArray(
		[$author$project$Addresses$StatisticsVariant$complexFood]));
var $author$project$Pages$Util$ParserUtil$with1Multiple = function (ps) {
	return {
		iA: function (param) {
			return _Utils_ap(
				ps.e8,
				ps.bX(param));
		},
		aw: function () {
			var _v0 = ps.e8;
			if (!_v0.b) {
				return ps.bO;
			} else {
				var step = _v0.a;
				var steps = _v0.b;
				return A2(
					$elm$url$Url$Parser$slash,
					A2($author$project$Pages$Util$ParserUtil$foldl1, step, steps),
					ps.bO);
			}
		}()
	};
};
var $author$project$Addresses$Frontend$statisticsComplexFoodSelect = $author$project$Pages$Util$ParserUtil$with1Multiple(
	{
		bO: $author$project$Pages$Util$ParserUtil$uuidParser,
		e8: _List_fromArray(
			['statistics', $author$project$Addresses$StatisticsVariant$complexFood]),
		bX: A2($elm$core$Basics$composeR, $danyx23$elm_uuid$Uuid$toString, $elm$core$List$singleton)
	});
var $author$project$Addresses$StatisticsVariant$food = 'food';
var $author$project$Addresses$Frontend$statisticsFoodSearch = A2(
	$author$project$Addresses$Frontend$plainMultiple,
	'statistics',
	_List_fromArray(
		[$author$project$Addresses$StatisticsVariant$food]));
var $elm$url$Url$Parser$int = A2($elm$url$Url$Parser$custom, 'NUMBER', $elm$core$String$toInt);
var $author$project$Addresses$Frontend$statisticsFoodSelect = $author$project$Pages$Util$ParserUtil$with1Multiple(
	{
		bO: $elm$url$Url$Parser$int,
		e8: _List_fromArray(
			['statistics', $author$project$Addresses$StatisticsVariant$food]),
		bX: A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $elm$core$List$singleton)
	});
var $author$project$Addresses$Frontend$statisticsMealProfileChoice = A2(
	$author$project$Addresses$Frontend$plainMultiple,
	'statistics',
	_List_fromArray(
		['meal']));
var $author$project$Addresses$StatisticsVariant$meal = 'meal';
var $author$project$Addresses$Frontend$statisticsMealSearch = function () {
	var statisticsWord = 'statistics';
	var profilesWord = 'profiles';
	return {
		iA: function (param) {
			return _List_fromArray(
				[
					statisticsWord,
					profilesWord,
					$danyx23$elm_uuid$Uuid$toString(param),
					$author$project$Addresses$StatisticsVariant$meal
				]);
		},
		aw: A2(
			$elm$url$Url$Parser$slash,
			$elm$url$Url$Parser$s(statisticsWord),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s(profilesWord),
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Pages$Util$ParserUtil$uuidParser,
					$elm$url$Url$Parser$s($author$project$Addresses$StatisticsVariant$meal))))
	};
}();
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$Addresses$Frontend$statisticsMealSelect = function () {
	var statisticsWord = 'statistics';
	var profilesWord = 'profiles';
	return {
		iA: function (param) {
			return _List_fromArray(
				[
					statisticsWord,
					profilesWord,
					$danyx23$elm_uuid$Uuid$toString(param.a),
					$author$project$Addresses$StatisticsVariant$meal,
					$danyx23$elm_uuid$Uuid$toString(param.b)
				]);
		},
		aw: A2(
			$elm$url$Url$Parser$slash,
			$elm$url$Url$Parser$s(statisticsWord),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s(profilesWord),
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Pages$Util$ParserUtil$uuidParser,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Addresses$StatisticsVariant$meal),
						$author$project$Pages$Util$ParserUtil$uuidParser))))
	};
}();
var $author$project$Addresses$StatisticsVariant$recipeOccurrences = 'recipe-occurrences';
var $author$project$Addresses$Frontend$statisticsRecipeOccurrences = function () {
	var statisticsWord = 'statistics';
	var profilesWord = 'profiles';
	return {
		iA: function (param) {
			return _List_fromArray(
				[
					statisticsWord,
					profilesWord,
					$danyx23$elm_uuid$Uuid$toString(param),
					$author$project$Addresses$StatisticsVariant$recipeOccurrences
				]);
		},
		aw: A2(
			$elm$url$Url$Parser$slash,
			$elm$url$Url$Parser$s(statisticsWord),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s(profilesWord),
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Pages$Util$ParserUtil$uuidParser,
					$elm$url$Url$Parser$s($author$project$Addresses$StatisticsVariant$recipeOccurrences))))
	};
}();
var $author$project$Addresses$Frontend$statisticsRecipeOccurrencesProfileChoice = A2(
	$author$project$Addresses$Frontend$plainMultiple,
	'statistics',
	_List_fromArray(
		[$author$project$Addresses$StatisticsVariant$recipeOccurrences]));
var $author$project$Addresses$StatisticsVariant$recipe = 'recipe';
var $author$project$Addresses$Frontend$statisticsRecipeSearch = A2(
	$author$project$Addresses$Frontend$plainMultiple,
	'statistics',
	_List_fromArray(
		[$author$project$Addresses$StatisticsVariant$recipe]));
var $author$project$Addresses$Frontend$statisticsRecipeSelect = $author$project$Pages$Util$ParserUtil$with1Multiple(
	{
		bO: $author$project$Pages$Util$ParserUtil$uuidParser,
		e8: _List_fromArray(
			['statistics', $author$project$Addresses$StatisticsVariant$recipe]),
		bX: A2($elm$core$Basics$composeR, $danyx23$elm_uuid$Uuid$toString, $elm$core$List$singleton)
	});
var $author$project$Addresses$Frontend$statisticsTime = $author$project$Addresses$Frontend$plain('statistics');
var $author$project$Addresses$Frontend$userSettings = $author$project$Addresses$Frontend$plain('user-settings');
var $author$project$Main$plainRouteParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($author$project$Main$route, $author$project$Addresses$Frontend$landing.aw, $author$project$Main$LandingRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$login.aw, $author$project$Main$LoginRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$overview.aw, $author$project$Main$OverviewRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$recipes.aw, $author$project$Main$RecipesRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$ingredientEditor.aw, $author$project$Main$IngredientRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$mealBranch.aw, $author$project$Main$MealProfileChoice),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$meals.aw, $author$project$Main$MealsRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$mealEntryEditor.aw, $author$project$Main$MealEntriesRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$statisticsTime.aw, $author$project$Main$StatisticsTimeRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$statisticsFoodSearch.aw, $author$project$Main$StatisticsFoodSearchRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$statisticsFoodSelect.aw, $author$project$Main$StatisticsFoodSelectRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$statisticsComplexFoodSearch.aw, $author$project$Main$StatisticsComplexFoodSearchRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$statisticsComplexFoodSelect.aw, $author$project$Main$StatisticsComplexFoodSelectRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$statisticsRecipeSearch.aw, $author$project$Main$StatisticsRecipeSearchRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$statisticsRecipeSelect.aw, $author$project$Main$StatisticsRecipeSelectRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$statisticsMealProfileChoice.aw, $author$project$Main$StatisticsMealProfileChoiceRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$statisticsMealSearch.aw, $author$project$Main$StatisticsMealSearchRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$statisticsMealSelect.aw, $author$project$Main$StatisticsMealSelectRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$statisticsRecipeOccurrences.aw, $author$project$Main$StatisticsRecipeOccurrencesRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$statisticsRecipeOccurrencesProfileChoice.aw, $author$project$Main$StatisticsRecipeOccurrencesProfileChoiceRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$referenceMaps.aw, $author$project$Main$ReferenceMapsRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$referenceEntries.aw, $author$project$Main$ReferenceEntriesRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$requestRegistration.aw, $author$project$Main$RequestRegistrationRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$confirmRegistration.aw, $author$project$Main$ConfirmRegistrationRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$userSettings.aw, $author$project$Main$UserSettingsRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$deleteAccount.aw, $author$project$Main$DeletionRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$requestRecovery.aw, $author$project$Main$RequestRecoveryRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$confirmRecovery.aw, $author$project$Main$ConfirmRecoveryRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$complexFoods.aw, $author$project$Main$ComplexFoodsRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$profiles.aw, $author$project$Main$ProfilesRoute)
		]));
var $author$project$Main$parsePage = $elm$url$Url$Parser$parse($author$project$Main$plainRouteParser);
var $author$project$Main$init = F3(
	function (configuration, url, key) {
		return _Utils_Tuple2(
			{
				o: configuration,
				aI: $author$project$Main$parsePage(url),
				W: $elm$core$Maybe$Nothing,
				eo: key,
				N: $author$project$Main$NotFound
			},
			$author$project$Ports$doFetchToken(0));
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Main$DeleteToken = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$FetchFoods = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$FetchNutrients = function (a) {
	return {$: 5, a: a};
};
var $author$project$Main$FetchToken = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $author$project$Ports$deleteToken = _Platform_incomingPort(
	'deleteToken',
	$elm$json$Json$Decode$null(0));
var $author$project$Ports$fetchFoods = _Platform_incomingPort('fetchFoods', $elm$json$Json$Decode$string);
var $author$project$Ports$fetchNutrients = _Platform_incomingPort('fetchNutrients', $elm$json$Json$Decode$string);
var $author$project$Ports$fetchToken = _Platform_incomingPort('fetchToken', $elm$json$Json$Decode$string);
var $author$project$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$fetchToken($author$project$Main$FetchToken),
				$author$project$Ports$fetchFoods($author$project$Main$FetchFoods),
				$author$project$Ports$fetchNutrients($author$project$Main$FetchNutrients),
				$author$project$Ports$deleteToken($author$project$Main$DeleteToken)
			]));
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $simonh1000$elm_jwt$Jwt$TokenDecodeError = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $simonh1000$elm_jwt$Jwt$TokenHeaderError = {$: 2};
var $simonh1000$elm_jwt$Jwt$TokenProcessingError = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $simonh1000$elm_jwt$Jwt$fixlength = function (s) {
	var _v0 = A2(
		$elm$core$Basics$modBy,
		4,
		$elm$core$String$length(s));
	switch (_v0) {
		case 0:
			return $elm$core$Result$Ok(s);
		case 2:
			return $elm$core$Result$Ok(
				$elm$core$String$concat(
					_List_fromArray(
						[s, '=='])));
		case 3:
			return $elm$core$Result$Ok(
				$elm$core$String$concat(
					_List_fromArray(
						[s, '='])));
		default:
			return $elm$core$Result$Err(
				$simonh1000$elm_jwt$Jwt$TokenProcessingError('Wrong length'));
	}
};
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$bytes$Bytes$Encode$getWidth = function (builder) {
	switch (builder.$) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 4;
		case 6:
			return 4;
		case 7:
			return 8;
		case 8:
			var w = builder.a;
			return w;
		case 9:
			var w = builder.a;
			return w;
		default:
			var bs = builder.a;
			return _Bytes_width(bs);
	}
};
var $elm$bytes$Bytes$LE = 0;
var $elm$bytes$Bytes$Encode$write = F3(
	function (builder, mb, offset) {
		switch (builder.$) {
			case 0:
				var n = builder.a;
				return A3(_Bytes_write_i8, mb, offset, n);
			case 1:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i16, mb, offset, n, !e);
			case 2:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i32, mb, offset, n, !e);
			case 3:
				var n = builder.a;
				return A3(_Bytes_write_u8, mb, offset, n);
			case 4:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u16, mb, offset, n, !e);
			case 5:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u32, mb, offset, n, !e);
			case 6:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f32, mb, offset, n, !e);
			case 7:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f64, mb, offset, n, !e);
			case 8:
				var bs = builder.b;
				return A3($elm$bytes$Bytes$Encode$writeSequence, bs, mb, offset);
			case 9:
				var s = builder.b;
				return A3(_Bytes_write_string, mb, offset, s);
			default:
				var bs = builder.a;
				return A3(_Bytes_write_bytes, mb, offset, bs);
		}
	});
var $elm$bytes$Bytes$Encode$writeSequence = F3(
	function (builders, mb, offset) {
		writeSequence:
		while (true) {
			if (!builders.b) {
				return offset;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$builders = bs,
					$temp$mb = mb,
					$temp$offset = A3($elm$bytes$Bytes$Encode$write, b, mb, offset);
				builders = $temp$builders;
				mb = $temp$mb;
				offset = $temp$offset;
				continue writeSequence;
			}
		}
	});
var $elm$bytes$Bytes$Decode$decode = F2(
	function (_v0, bs) {
		var decoder = _v0;
		return A2(_Bytes_decode, decoder, bs);
	});
var $elm$bytes$Bytes$Decode$Decoder = $elm$core$Basics$identity;
var $elm$bytes$Bytes$Decode$string = function (n) {
	return _Bytes_read_string(n);
};
var $elm$bytes$Bytes$Encode$encode = _Bytes_encode;
var $elm$bytes$Bytes$BE = 1;
var $danfishgold$base64_bytes$Encode$isValidChar = function (c) {
	if ($elm$core$Char$isAlphaNum(c)) {
		return true;
	} else {
		switch (c) {
			case '+':
				return true;
			case '/':
				return true;
			default:
				return false;
		}
	}
};
var $elm$core$Bitwise$or = _Bitwise_or;
var $elm$bytes$Bytes$Encode$Seq = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$getWidths = F2(
	function (width, builders) {
		getWidths:
		while (true) {
			if (!builders.b) {
				return width;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$width = width + $elm$bytes$Bytes$Encode$getWidth(b),
					$temp$builders = bs;
				width = $temp$width;
				builders = $temp$builders;
				continue getWidths;
			}
		}
	});
var $elm$bytes$Bytes$Encode$sequence = function (builders) {
	return A2(
		$elm$bytes$Bytes$Encode$Seq,
		A2($elm$bytes$Bytes$Encode$getWidths, 0, builders),
		builders);
};
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $danfishgold$base64_bytes$Encode$unsafeConvertChar = function (_char) {
	var key = $elm$core$Char$toCode(_char);
	if ((key >= 65) && (key <= 90)) {
		return key - 65;
	} else {
		if ((key >= 97) && (key <= 122)) {
			return (key - 97) + 26;
		} else {
			if ((key >= 48) && (key <= 57)) {
				return ((key - 48) + 26) + 26;
			} else {
				switch (_char) {
					case '+':
						return 62;
					case '/':
						return 63;
					default:
						return -1;
				}
			}
		}
	}
};
var $elm$bytes$Bytes$Encode$U16 = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$unsignedInt16 = $elm$bytes$Bytes$Encode$U16;
var $elm$bytes$Bytes$Encode$U8 = function (a) {
	return {$: 3, a: a};
};
var $elm$bytes$Bytes$Encode$unsignedInt8 = $elm$bytes$Bytes$Encode$U8;
var $danfishgold$base64_bytes$Encode$encodeCharacters = F4(
	function (a, b, c, d) {
		if ($danfishgold$base64_bytes$Encode$isValidChar(a) && $danfishgold$base64_bytes$Encode$isValidChar(b)) {
			var n2 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(b);
			var n1 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(a);
			if ('=' === d) {
				if ('=' === c) {
					var n = (n1 << 18) | (n2 << 12);
					var b1 = n >> 16;
					return $elm$core$Maybe$Just(
						$elm$bytes$Bytes$Encode$unsignedInt8(b1));
				} else {
					if ($danfishgold$base64_bytes$Encode$isValidChar(c)) {
						var n3 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(c);
						var n = ((n1 << 18) | (n2 << 12)) | (n3 << 6);
						var combined = n >> 8;
						return $elm$core$Maybe$Just(
							A2($elm$bytes$Bytes$Encode$unsignedInt16, 1, combined));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
			} else {
				if ($danfishgold$base64_bytes$Encode$isValidChar(c) && $danfishgold$base64_bytes$Encode$isValidChar(d)) {
					var n4 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(d);
					var n3 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(c);
					var n = ((n1 << 18) | (n2 << 12)) | ((n3 << 6) | n4);
					var combined = n >> 8;
					var b3 = n;
					return $elm$core$Maybe$Just(
						$elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									A2($elm$bytes$Bytes$Encode$unsignedInt16, 1, combined),
									$elm$bytes$Bytes$Encode$unsignedInt8(b3)
								])));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $danfishgold$base64_bytes$Encode$encodeChunks = F2(
	function (input, accum) {
		encodeChunks:
		while (true) {
			var _v0 = $elm$core$String$toList(
				A2($elm$core$String$left, 4, input));
			_v0$4:
			while (true) {
				if (!_v0.b) {
					return $elm$core$Maybe$Just(accum);
				} else {
					if (_v0.b.b) {
						if (_v0.b.b.b) {
							if (_v0.b.b.b.b) {
								if (!_v0.b.b.b.b.b) {
									var a = _v0.a;
									var _v1 = _v0.b;
									var b = _v1.a;
									var _v2 = _v1.b;
									var c = _v2.a;
									var _v3 = _v2.b;
									var d = _v3.a;
									var _v4 = A4($danfishgold$base64_bytes$Encode$encodeCharacters, a, b, c, d);
									if (!_v4.$) {
										var enc = _v4.a;
										var $temp$input = A2($elm$core$String$dropLeft, 4, input),
											$temp$accum = A2($elm$core$List$cons, enc, accum);
										input = $temp$input;
										accum = $temp$accum;
										continue encodeChunks;
									} else {
										return $elm$core$Maybe$Nothing;
									}
								} else {
									break _v0$4;
								}
							} else {
								var a = _v0.a;
								var _v5 = _v0.b;
								var b = _v5.a;
								var _v6 = _v5.b;
								var c = _v6.a;
								var _v7 = A4($danfishgold$base64_bytes$Encode$encodeCharacters, a, b, c, '=');
								if (_v7.$ === 1) {
									return $elm$core$Maybe$Nothing;
								} else {
									var enc = _v7.a;
									return $elm$core$Maybe$Just(
										A2($elm$core$List$cons, enc, accum));
								}
							}
						} else {
							var a = _v0.a;
							var _v8 = _v0.b;
							var b = _v8.a;
							var _v9 = A4($danfishgold$base64_bytes$Encode$encodeCharacters, a, b, '=', '=');
							if (_v9.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var enc = _v9.a;
								return $elm$core$Maybe$Just(
									A2($elm$core$List$cons, enc, accum));
							}
						}
					} else {
						break _v0$4;
					}
				}
			}
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $danfishgold$base64_bytes$Encode$encoder = function (string) {
	return A2(
		$elm$core$Maybe$map,
		A2($elm$core$Basics$composeR, $elm$core$List$reverse, $elm$bytes$Bytes$Encode$sequence),
		A2($danfishgold$base64_bytes$Encode$encodeChunks, string, _List_Nil));
};
var $danfishgold$base64_bytes$Encode$toBytes = function (string) {
	return A2(
		$elm$core$Maybe$map,
		$elm$bytes$Bytes$Encode$encode,
		$danfishgold$base64_bytes$Encode$encoder(string));
};
var $danfishgold$base64_bytes$Base64$toBytes = $danfishgold$base64_bytes$Encode$toBytes;
var $elm$bytes$Bytes$width = _Bytes_width;
var $danfishgold$base64_bytes$Base64$toString = function (b64String) {
	var _v0 = $danfishgold$base64_bytes$Base64$toBytes(b64String);
	if (_v0.$ === 1) {
		return $elm$core$Maybe$Nothing;
	} else {
		var b64Bytes = _v0.a;
		return A2(
			$elm$bytes$Bytes$Decode$decode,
			$elm$bytes$Bytes$Decode$string(
				$elm$bytes$Bytes$width(b64Bytes)),
			b64Bytes);
	}
};
var $elm$core$String$map = _String_map;
var $simonh1000$elm_jwt$Jwt$unurl = function () {
	var fix = function (c) {
		switch (c) {
			case '-':
				return '+';
			case '_':
				return '/';
			default:
				return c;
		}
	};
	return $elm$core$String$map(fix);
}();
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $simonh1000$elm_jwt$Jwt$getTokenParts = function (token) {
	var verifyJson = F2(
		function (errorHandler, str) {
			return A2(
				$elm$core$Result$mapError,
				errorHandler,
				A2(
					$elm$core$Result$map,
					function (_v8) {
						return str;
					},
					A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$value, str)));
		});
	var processor = A2(
		$elm$core$Basics$composeR,
		$simonh1000$elm_jwt$Jwt$unurl,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$split('.'),
			$elm$core$List$map($simonh1000$elm_jwt$Jwt$fixlength)));
	var _v0 = processor(token);
	_v0$1:
	while (true) {
		if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
			if (!_v0.a.$) {
				if (!_v0.b.a.$) {
					var header = _v0.a.a;
					var _v1 = _v0.b;
					var body = _v1.a.a;
					var _v2 = _v1.b;
					var header_ = A2(
						$elm$core$Result$andThen,
						verifyJson(
							function (_v3) {
								return $simonh1000$elm_jwt$Jwt$TokenHeaderError;
							}),
						A2(
							$elm$core$Result$fromMaybe,
							$simonh1000$elm_jwt$Jwt$TokenHeaderError,
							$danfishgold$base64_bytes$Base64$toString(header)));
					var body_ = A2(
						$elm$core$Result$andThen,
						verifyJson($simonh1000$elm_jwt$Jwt$TokenDecodeError),
						A2(
							$elm$core$Result$fromMaybe,
							$simonh1000$elm_jwt$Jwt$TokenProcessingError('Invalid UTF-16'),
							$danfishgold$base64_bytes$Base64$toString(body)));
					return A3(
						$elm$core$Result$map2,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						header_,
						body_);
				} else {
					break _v0$1;
				}
			} else {
				if (_v0.b.a.$ === 1) {
					break _v0$1;
				} else {
					var err = _v0.a.a;
					var _v6 = _v0.b;
					var _v7 = _v6.b;
					return $elm$core$Result$Err(err);
				}
			}
		} else {
			return $elm$core$Result$Err(
				$simonh1000$elm_jwt$Jwt$TokenProcessingError('Token has invalid shape'));
		}
	}
	var _v4 = _v0.b;
	var err = _v4.a.a;
	var _v5 = _v4.b;
	return $elm$core$Result$Err(err);
};
var $simonh1000$elm_jwt$Jwt$decodeToken = F2(
	function (dec, token) {
		return A2(
			$elm$core$Result$andThen,
			A2(
				$elm$core$Basics$composeR,
				$elm$json$Json$Decode$decodeString(dec),
				$elm$core$Result$mapError($simonh1000$elm_jwt$Jwt$TokenDecodeError)),
			A2(
				$elm$core$Result$map,
				$elm$core$Tuple$second,
				$simonh1000$elm_jwt$Jwt$getTokenParts(token)));
	});
var $author$project$Api$Types$LoginContent$LoginContent = F3(
	function (userId, sessionId, nickname) {
		return {gU: nickname, hG: sessionId, $8: userId};
	});
var $elm$json$Json$Decode$fail = _Json_fail;
var $danyx23$elm_uuid$Uuid$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		var _v0 = $danyx23$elm_uuid$Uuid$fromString(string);
		if (!_v0.$) {
			var uuid = _v0.a;
			return $elm$json$Json$Decode$succeed(uuid);
		} else {
			return $elm$json$Json$Decode$fail('Not a valid UUID');
		}
	},
	$elm$json$Json$Decode$string);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Api$Types$LoginContent$decoderLoginContent = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'nickname',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sessionId',
		$danyx23$elm_uuid$Uuid$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'userId',
			$danyx23$elm_uuid$Uuid$decoder,
			$elm$json$Json$Decode$succeed($author$project$Api$Types$LoginContent$LoginContent))));
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (_default, f, m) {
		if (m.$ === 1) {
			return _default;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$Main$titleFor = function (model) {
	var nickname = A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		'',
		function (u) {
			return $elm$core$String$concat(
				_List_fromArray(
					[': ', u.gU]));
		},
		A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				$simonh1000$elm_jwt$Jwt$decodeToken($author$project$Api$Types$LoginContent$decoderLoginContent),
				$elm$core$Result$toMaybe),
			model.W));
	return 'Foodie' + nickname;
};
var $author$project$Pages$View$Tristate$Logic = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Ingredients$Page$UpdateFoods = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Statistics$Food$Search$Page$UpdateFoods = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$ReferenceEntries$Page$UpdateNutrients = function (a) {
	return {$: 2, a: a};
};
var $elm_community$maybe_extra$Maybe$Extra$filter = F2(
	function (f, m) {
		if (!m.$) {
			var a = m.a;
			return f(a) ? m : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Main$Landing = {$: 0};
var $author$project$Pages$ComplexFoods$Page$FoodsMsg = $elm$core$Basics$identity;
var $author$project$Pages$View$Tristate$Initial = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$View$Tristate$Model = F2(
	function (configuration, status) {
		return {o: configuration, bU: status};
	});
var $author$project$Pages$View$Tristate$createInitial = function (configuration) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Pages$View$Tristate$Initial,
		$author$project$Pages$View$Tristate$Model(configuration));
};
var $author$project$Pages$Util$Choice$Page$initialWith = F2(
	function (jwt, parentId) {
		return {i$: $elm$core$Maybe$Nothing, jD: $elm$core$Maybe$Nothing, W: jwt, eG: parentId};
	});
var $author$project$Pages$ComplexFoods$Page$initial = function (authorizedAccess) {
	return A2(
		$author$project$Pages$View$Tristate$createInitial,
		authorizedAccess.o,
		{
			jS: A2($author$project$Pages$Util$Choice$Page$initialWith, authorizedAccess.W, 0),
			W: authorizedAccess.W
		});
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Pages$Util$Choice$Page$GotFetchElementsResponse = function (a) {
	return {$: 10, a: a};
};
var $author$project$Util$HttpUtil$DELETE = 4;
var $author$project$Addresses$Backend$pattern = F2(
	function (verb, path) {
		return {iA: path, lB: _List_Nil, mP: verb};
	});
var $author$project$Addresses$Backend$delete = $author$project$Addresses$Backend$pattern(4);
var $author$project$Util$HttpUtil$GET = 0;
var $author$project$Addresses$Backend$get = $author$project$Addresses$Backend$pattern(0);
var $author$project$Util$HttpUtil$PATCH = 3;
var $author$project$Addresses$Backend$patch = $author$project$Addresses$Backend$pattern(3);
var $author$project$Util$HttpUtil$POST = 1;
var $author$project$Addresses$Backend$post = $author$project$Addresses$Backend$pattern(1);
var $author$project$Addresses$Backend$complexFoods = function () {
	var base = $elm$core$List$cons('complex-foods');
	return {
		aW: $author$project$Addresses$Backend$get(
			base(_List_Nil)),
		ae: $author$project$Addresses$Backend$post(
			base(_List_Nil)),
		af: function (complexFoodId) {
			return $author$project$Addresses$Backend$delete(
				base(
					_List_fromArray(
						[
							$danyx23$elm_uuid$Uuid$toString(complexFoodId)
						])));
		},
		bT: function (complexFoodId) {
			return $author$project$Addresses$Backend$get(
				base(
					_List_fromArray(
						[
							$danyx23$elm_uuid$Uuid$toString(complexFoodId)
						])));
		},
		ac: function (complexFoodId) {
			return $author$project$Addresses$Backend$patch(
				base(
					_List_fromArray(
						[
							$danyx23$elm_uuid$Uuid$toString(complexFoodId)
						])));
		}
	};
}();
var $author$project$Api$Types$ComplexFood$ComplexFood = F5(
	function (recipeId, amountGrams, amountMilliLitres, name, description) {
		return {fq: amountGrams, fr: amountMilliLitres, fX: description, gN: name, hk: recipeId};
	});
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (path, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					return A2(
						$elm$json$Json$Decode$at,
						path,
						nullOr(valDecoder));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				_List_fromArray(
					[key]),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Api$Types$ComplexFood$decoderComplexFood = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'description',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'amountMilliLitres',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'amountGrams',
				$elm$json$Json$Decode$float,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'recipeId',
					$danyx23$elm_uuid$Uuid$decoder,
					$elm$json$Json$Decode$succeed($author$project$Api$Types$ComplexFood$ComplexFood))))));
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $author$project$Util$HttpUtil$BadBody = function (a) {
	return {$: 4, a: a};
};
var $author$project$Util$HttpUtil$BadStatus = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Util$HttpUtil$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $author$project$Util$HttpUtil$NetworkError = {$: 2};
var $author$project$Util$HttpUtil$Timeout = {$: 1};
var $author$project$Util$HttpUtil$BackendError = function (message) {
	return {gI: message};
};
var $author$project$Util$HttpUtil$decoderBackendError = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'message',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Util$HttpUtil$BackendError));
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $author$project$Util$HttpUtil$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			function (response) {
				switch (response.$) {
					case 0:
						var url = response.a;
						return $elm$core$Result$Err(
							$author$project$Util$HttpUtil$BadUrl(url));
					case 1:
						return $elm$core$Result$Err($author$project$Util$HttpUtil$Timeout);
					case 2:
						return $elm$core$Result$Err($author$project$Util$HttpUtil$NetworkError);
					case 3:
						var metadata = response.a;
						var body = response.b;
						return A2(
							$elm$core$Result$andThen,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.gI;
								},
								A2(
									$elm$core$Basics$composeR,
									$author$project$Util$HttpUtil$BadStatus(metadata.ml),
									$elm$core$Result$Err)),
							A2(
								$elm$core$Result$mapError,
								A2($elm$core$Basics$composeR, $elm$json$Json$Decode$errorToString, $author$project$Util$HttpUtil$BadBody),
								A2($elm$json$Json$Decode$decodeString, $author$project$Util$HttpUtil$decoderBackendError, body)));
					default:
						var body = response.b;
						return A2(
							$elm$core$Result$mapError,
							A2($elm$core$Basics$composeR, $elm$json$Json$Decode$errorToString, $author$project$Util$HttpUtil$BadBody),
							A2($elm$json$Json$Decode$decodeString, decoder, body));
				}
			});
	});
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$relative = F2(
	function (pathSegments, parameters) {
		return _Utils_ap(
			A2($elm$core$String$join, '/', pathSegments),
			$elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Pages$Util$Links$backendPage = F3(
	function (configuration, pathSteps, querySteps) {
		return A3(
			$elm_community$basics_extra$Basics$Extra$flip,
			$elm$url$Url$Builder$relative,
			querySteps,
			A2($elm$core$List$cons, configuration.iL, pathSteps));
	});
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $author$project$Util$HttpUtil$userTokenHeader = 'User-Token';
var $author$project$Util$HttpUtil$jwtHeader = $elm$http$Http$header($author$project$Util$HttpUtil$userTokenHeader);
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {hp: reqs, hU: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.mG;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.hp));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.hU)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					iE: r.iE,
					iO: r.iO,
					cz: A2(_Http_mapExpect, func, r.cz),
					j_: r.j_,
					kL: r.kL,
					my: r.my,
					mG: r.mG,
					id: r.id
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{iE: false, iO: r.iO, cz: r.cz, j_: r.j_, kL: r.kL, my: r.my, mG: r.mG, id: r.id}));
};
var $elm_community$maybe_extra$Maybe$Extra$toList = function (m) {
	if (m.$ === 1) {
		return _List_Nil;
	} else {
		var x = m.a;
		return _List_fromArray(
			[x]);
	}
};
var $author$project$Util$HttpUtil$verbToString = function (verb) {
	switch (verb) {
		case 0:
			return 'GET';
		case 1:
			return 'POST';
		case 2:
			return 'PUT';
		case 3:
			return 'PATCH';
		default:
			return 'DELETE';
	}
};
var $author$project$Util$HttpUtil$byVerb = F2(
	function (verb, ps) {
		return $elm$http$Http$request(
			{
				iO: ps.iO,
				cz: ps.cz,
				j_: $elm_community$maybe_extra$Maybe$Extra$toList(
					A2($elm$core$Maybe$map, $author$project$Util$HttpUtil$jwtHeader, ps.W)),
				kL: $author$project$Util$HttpUtil$verbToString(verb),
				my: $elm$core$Maybe$Nothing,
				mG: $elm$core$Maybe$Nothing,
				id: ps.id
			});
	});
var $author$project$Util$HttpUtil$run = F2(
	function (resource, ps) {
		return A2(
			$author$project$Util$HttpUtil$byVerb,
			resource.mP,
			{iO: ps.iO, cz: ps.cz, W: ps.W, id: resource.id});
	});
var $author$project$Util$HttpUtil$runPattern = F2(
	function (configuration, resourcePattern) {
		return $author$project$Util$HttpUtil$run(
			{
				id: A3($author$project$Pages$Util$Links$backendPage, configuration, resourcePattern.iA, resourcePattern.lB),
				mP: resourcePattern.mP
			});
	});
var $author$project$Util$HttpUtil$runPatternWithJwt = F3(
	function (authorizedAccess, pattern, ps) {
		return A3(
			$author$project$Util$HttpUtil$runPattern,
			authorizedAccess.o,
			pattern,
			{
				iO: ps.iO,
				cz: ps.cz,
				W: $elm$core$Maybe$Just(authorizedAccess.W)
			});
	});
var $author$project$Pages$ComplexFoods$Foods$Requests$fetchComplexFoods = function (authorizedAccess) {
	return A3(
		$author$project$Util$HttpUtil$runPatternWithJwt,
		authorizedAccess,
		$author$project$Addresses$Backend$complexFoods.aW,
		{
			iO: $elm$http$Http$emptyBody,
			cz: A2(
				$author$project$Util$HttpUtil$expectJson,
				$author$project$Pages$Util$Choice$Page$GotFetchElementsResponse,
				$elm$json$Json$Decode$list($author$project$Api$Types$ComplexFood$decoderComplexFood))
		});
};
var $author$project$Pages$Util$Choice$Page$GotFetchChoicesResponse = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Types$Recipe$Recipe = F5(
	function (id, name, description, numberOfServings, servingSize) {
		return {fX: description, gn: id, gN: name, gY: numberOfServings, hF: servingSize};
	});
var $author$project$Api$Types$Recipe$decoderRecipe = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'servingSize',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'numberOfServings',
		$elm$json$Json$Decode$float,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'description',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$danyx23$elm_uuid$Uuid$decoder,
					$elm$json$Json$Decode$succeed($author$project$Api$Types$Recipe$Recipe))))));
var $author$project$Addresses$Backend$recipes = function () {
	var rescaleWord = 'rescale';
	var ingredientsWord = 'ingredients';
	var foodsWord = 'foods';
	var duplicateWord = 'duplicate';
	var complexIngredientsWord = 'complex-ingredients';
	var base = $elm$core$List$cons('recipes');
	var complexIngredients = function (recipeId) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$List$cons(complexIngredientsWord),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$cons(
					$danyx23$elm_uuid$Uuid$toString(recipeId)),
				base));
	};
	var ingredients = function (recipeId) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$List$cons(ingredientsWord),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$cons(
					$danyx23$elm_uuid$Uuid$toString(recipeId)),
				base));
	};
	return {
		aW: $author$project$Addresses$Backend$get(
			base(_List_Nil)),
		i8: {
			cg: function (recipeId) {
				return $author$project$Addresses$Backend$get(
					A2(complexIngredients, recipeId, _List_Nil));
			},
			ae: function (recipeId) {
				return $author$project$Addresses$Backend$post(
					A2(complexIngredients, recipeId, _List_Nil));
			},
			af: F2(
				function (recipeId, complexIngredientId) {
					return $author$project$Addresses$Backend$delete(
						A2(
							complexIngredients,
							recipeId,
							_List_fromArray(
								[
									$danyx23$elm_uuid$Uuid$toString(complexIngredientId)
								])));
				}),
			ac: F2(
				function (recipeId, complexIngredientId) {
					return $author$project$Addresses$Backend$patch(
						A2(
							complexIngredients,
							recipeId,
							_List_fromArray(
								[
									$danyx23$elm_uuid$Uuid$toString(complexIngredientId)
								])));
				})
		},
		ae: $author$project$Addresses$Backend$post(
			base(_List_Nil)),
		af: function (recipeId) {
			return $author$project$Addresses$Backend$delete(
				base(
					_List_fromArray(
						[
							$danyx23$elm_uuid$Uuid$toString(recipeId)
						])));
		},
		ea: function (recipeId) {
			return $author$project$Addresses$Backend$post(
				base(
					_List_fromArray(
						[
							$danyx23$elm_uuid$Uuid$toString(recipeId),
							duplicateWord
						])));
		},
		gc: function (foodId) {
			return $author$project$Addresses$Backend$get(
				base(
					_List_fromArray(
						[
							foodsWord,
							$elm$core$String$fromInt(foodId)
						])));
		},
		jS: $author$project$Addresses$Backend$get(
			base(
				_List_fromArray(
					[foodsWord]))),
		kg: {
			cg: function (recipeId) {
				return $author$project$Addresses$Backend$get(
					base(
						_List_fromArray(
							[
								$danyx23$elm_uuid$Uuid$toString(recipeId),
								ingredientsWord
							])));
			},
			ae: function (recipeId) {
				return $author$project$Addresses$Backend$post(
					A2(ingredients, recipeId, _List_Nil));
			},
			af: F2(
				function (recipeId, ingredientId) {
					return $author$project$Addresses$Backend$delete(
						base(
							A2(
								$elm$core$List$cons,
								$danyx23$elm_uuid$Uuid$toString(recipeId),
								A2(
									$elm$core$List$cons,
									ingredientsWord,
									_List_fromArray(
										[
											$danyx23$elm_uuid$Uuid$toString(ingredientId)
										])))));
				}),
			ac: F2(
				function (recipeId, ingredientId) {
					return $author$project$Addresses$Backend$patch(
						base(
							A2(
								$elm$core$List$cons,
								$danyx23$elm_uuid$Uuid$toString(recipeId),
								A2(
									$elm$core$List$cons,
									ingredientsWord,
									_List_fromArray(
										[
											$danyx23$elm_uuid$Uuid$toString(ingredientId)
										])))));
				})
		},
		kI: $author$project$Addresses$Backend$get(
			base(
				_List_fromArray(
					['measures']))),
		lW: function (recipeId) {
			return $author$project$Addresses$Backend$patch(
				base(
					_List_fromArray(
						[
							$danyx23$elm_uuid$Uuid$toString(recipeId),
							rescaleWord
						])));
		},
		bT: function (recipeId) {
			return $author$project$Addresses$Backend$get(
				base(
					_List_fromArray(
						[
							$danyx23$elm_uuid$Uuid$toString(recipeId)
						])));
		},
		ac: function (recipeId) {
			return $author$project$Addresses$Backend$patch(
				base(
					_List_fromArray(
						[
							$danyx23$elm_uuid$Uuid$toString(recipeId)
						])));
		}
	};
}();
var $author$project$Pages$Util$Requests$fetchRecipesWith = F2(
	function (mkMsg, authorizedAccess) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$recipes.aW,
			{
				iO: $elm$http$Http$emptyBody,
				cz: A2(
					$author$project$Util$HttpUtil$expectJson,
					mkMsg,
					$elm$json$Json$Decode$list($author$project$Api$Types$Recipe$decoderRecipe))
			});
	});
var $author$project$Pages$ComplexFoods$Foods$Requests$fetchRecipes = $author$project$Pages$Util$Requests$fetchRecipesWith($author$project$Pages$Util$Choice$Page$GotFetchChoicesResponse);
var $author$project$Pages$ComplexFoods$Foods$Handler$initialFetch = function (authorizedAccess) {
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				$author$project$Pages$ComplexFoods$Foods$Requests$fetchRecipes(authorizedAccess),
				$author$project$Pages$ComplexFoods$Foods$Requests$fetchComplexFoods(authorizedAccess)
			]));
};
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Pages$ComplexFoods$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$ComplexFoods$Page$initial(flags.n),
		A2(
			$elm$core$Platform$Cmd$map,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $author$project$Pages$View$Tristate$Logic),
			$author$project$Pages$ComplexFoods$Foods$Handler$initialFetch(flags.n)));
};
var $author$project$Pages$Deletion$Page$Checking = 0;
var $author$project$Pages$View$Tristate$Main = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$View$Tristate$createMain = function (configuration) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Pages$View$Tristate$Main,
		$author$project$Pages$View$Tristate$Model(configuration));
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Pages$Deletion$Handler$init = function (flags) {
	return _Utils_Tuple2(
		A2(
			$author$project$Pages$View$Tristate$createMain,
			flags.o,
			{js: flags.js, gK: 0, fe: flags.fe}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Util$Parent$Page$initialWith = function (jwt) {
	return {W: jwt, g4: $elm$core$Maybe$Nothing};
};
var $author$project$Pages$Ingredients$Page$initial = F2(
	function (authorizedAccess, recipeId) {
		return A2(
			$author$project$Pages$View$Tristate$createInitial,
			authorizedAccess.o,
			{
				fO: A2($author$project$Pages$Util$Choice$Page$initialWith, authorizedAccess.W, recipeId),
				em: A2($author$project$Pages$Util$Choice$Page$initialWith, authorizedAccess.W, recipeId),
				W: authorizedAccess.W,
				lD: $author$project$Pages$Util$Parent$Page$initialWith(authorizedAccess.W)
			});
	});
var $author$project$Pages$Ingredients$Page$ComplexIngredientMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Ingredients$Page$IngredientMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Ingredients$Page$RecipeMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Util$Requests$fetchComplexFoodsWith = F2(
	function (mkMsg, authorizedAccess) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$complexFoods.aW,
			{
				iO: $elm$http$Http$emptyBody,
				cz: A2(
					$author$project$Util$HttpUtil$expectJson,
					mkMsg,
					$elm$json$Json$Decode$list($author$project$Api$Types$ComplexFood$decoderComplexFood))
			});
	});
var $author$project$Pages$Ingredients$Complex$Requests$fetchComplexFoods = $author$project$Pages$Util$Requests$fetchComplexFoodsWith($author$project$Pages$Util$Choice$Page$GotFetchChoicesResponse);
var $author$project$Api$Types$ComplexIngredient$ComplexIngredient = F3(
	function (complexFoodId, factor, scalingMode) {
		return {fN: complexFoodId, f9: factor, hv: scalingMode};
	});
var $author$project$Api$Types$ScalingMode$Recipe = 0;
var $author$project$Api$Types$ScalingMode$Volume = 2;
var $author$project$Api$Types$ScalingMode$Weight = 1;
var $author$project$Api$Types$ScalingMode$decoderScalingModeByString = function (string) {
	switch (string) {
		case 'Recipe':
			return $elm$json$Json$Decode$succeed(0);
		case 'Weight':
			return $elm$json$Json$Decode$succeed(1);
		case 'Volume':
			return $elm$json$Json$Decode$succeed(2);
		default:
			return $elm$json$Json$Decode$fail('Unexpected type for ScalingMode: ' + string);
	}
};
var $author$project$Api$Types$ScalingMode$decoderScalingMode = A2($elm$json$Json$Decode$andThen, $author$project$Api$Types$ScalingMode$decoderScalingModeByString, $elm$json$Json$Decode$string);
var $author$project$Api$Types$ComplexIngredient$decoderComplexIngredient = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'scalingMode',
	$author$project$Api$Types$ScalingMode$decoderScalingMode,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'factor',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'complexFoodId',
			$danyx23$elm_uuid$Uuid$decoder,
			$elm$json$Json$Decode$succeed($author$project$Api$Types$ComplexIngredient$ComplexIngredient))));
var $author$project$Pages$Ingredients$Complex$Requests$fetchComplexIngredients = F2(
	function (flags, recipeId) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			flags,
			$author$project$Addresses$Backend$recipes.i8.cg(recipeId),
			{
				iO: $elm$http$Http$emptyBody,
				cz: A2(
					$author$project$Util$HttpUtil$expectJson,
					$author$project$Pages$Util$Choice$Page$GotFetchElementsResponse,
					$elm$json$Json$Decode$list($author$project$Api$Types$ComplexIngredient$decoderComplexIngredient))
			});
	});
var $author$project$Pages$Ingredients$Complex$Handler$initialFetch = F2(
	function (authorizedAccess, recipeId) {
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Pages$Ingredients$Complex$Requests$fetchComplexIngredients, authorizedAccess, recipeId),
					$author$project$Pages$Ingredients$Complex$Requests$fetchComplexFoods(authorizedAccess)
				]));
	});
var $author$project$Ports$doFetchFoods = _Platform_outgoingPort(
	'doFetchFoods',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Api$Types$Ingredient$Ingredient = F3(
	function (id, foodId, amountUnit) {
		return {fs: amountUnit, gd: foodId, gn: id};
	});
var $author$project$Api$Types$AmountUnit$AmountUnit = F2(
	function (measureId, factor) {
		return {f9: factor, gH: measureId};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$Api$Types$AmountUnit$decoderAmountUnit = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'factor',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'measureId',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Api$Types$AmountUnit$AmountUnit)));
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
var $author$project$Api$Types$Ingredient$decoderIngredient = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'amountUnit',
	$elm$json$Json$Decode$lazy(
		function (_v0) {
			return $author$project$Api$Types$AmountUnit$decoderAmountUnit;
		}),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'foodId',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$danyx23$elm_uuid$Uuid$decoder,
			$elm$json$Json$Decode$succeed($author$project$Api$Types$Ingredient$Ingredient))));
var $author$project$Pages$Ingredients$Plain$Requests$fetchIngredients = F2(
	function (flags, recipeId) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			flags,
			$author$project$Addresses$Backend$recipes.kg.cg(recipeId),
			{
				iO: $elm$http$Http$emptyBody,
				cz: A2(
					$author$project$Util$HttpUtil$expectJson,
					$author$project$Pages$Util$Choice$Page$GotFetchElementsResponse,
					$elm$json$Json$Decode$list($author$project$Api$Types$Ingredient$decoderIngredient))
			});
	});
var $author$project$Pages$Ingredients$Plain$Handler$initialFetch = F2(
	function (authorizedAccess, recipeId) {
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Pages$Ingredients$Plain$Requests$fetchIngredients, authorizedAccess, recipeId),
					$author$project$Ports$doFetchFoods(0)
				]));
	});
var $author$project$Pages$Util$Parent$Page$GotFetchResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Ingredients$Recipe$Page$ParentMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Util$Requests$fetchRecipeWith = F3(
	function (mkMsg, authorizedAccess, recipeId) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$recipes.bT(recipeId),
			{
				iO: $elm$http$Http$emptyBody,
				cz: A2($author$project$Util$HttpUtil$expectJson, mkMsg, $author$project$Api$Types$Recipe$decoderRecipe)
			});
	});
var $author$project$Pages$Ingredients$Recipe$Handler$initialFetch = $author$project$Pages$Util$Requests$fetchRecipeWith(
	A2($elm$core$Basics$composeR, $author$project$Pages$Util$Parent$Page$GotFetchResponse, $author$project$Pages$Ingredients$Recipe$Page$ParentMsg));
var $author$project$Pages$Ingredients$Handler$initialFetch = F2(
	function (authorizedAccess, recipeId) {
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Pages$Ingredients$Page$RecipeMsg,
					A2($author$project$Pages$Ingredients$Recipe$Handler$initialFetch, authorizedAccess, recipeId)),
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Pages$Ingredients$Page$IngredientMsg,
					A2($author$project$Pages$Ingredients$Plain$Handler$initialFetch, authorizedAccess, recipeId)),
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Pages$Ingredients$Page$ComplexIngredientMsg,
					A2($author$project$Pages$Ingredients$Complex$Handler$initialFetch, authorizedAccess, recipeId))
				]));
	});
var $author$project$Pages$Ingredients$Handler$init = function (flags) {
	return _Utils_Tuple2(
		A2($author$project$Pages$Ingredients$Page$initial, flags.n, flags.hk),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			A2($author$project$Pages$Ingredients$Handler$initialFetch, flags.n, flags.hk)));
};
var $author$project$Pages$Login$Handler$init = function (flags) {
	return _Utils_Tuple2(
		A2(
			$author$project$Pages$View$Tristate$createMain,
			flags.o,
			{
				ct: {gU: '', g5: ''}
			}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$MealEntries$Page$initial = F3(
	function (authorizedAccess, profId, mealId) {
		return A2(
			$author$project$Pages$View$Tristate$createInitial,
			authorizedAccess.o,
			{
				f5: A2($author$project$Pages$Util$Choice$Page$initialWith, authorizedAccess.W, mealId),
				kD: $author$project$Pages$Util$Parent$Page$initialWith(authorizedAccess.W),
				ly: $elm$core$Maybe$Nothing,
				bS: profId
			});
	});
var $author$project$Pages$MealEntries$Page$EntriesMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$MealEntries$Page$GotFetchProfileResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$MealEntries$Page$MealMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Types$Profile$Profile = F2(
	function (id, name) {
		return {gn: id, gN: name};
	});
var $author$project$Api$Types$Profile$decoderProfile = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$danyx23$elm_uuid$Uuid$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Types$Profile$Profile)));
var $author$project$Addresses$Backend$profiles = function () {
	var base = $elm$core$List$cons('profiles');
	return {
		aW: $author$project$Addresses$Backend$get(
			base(_List_Nil)),
		ae: $author$project$Addresses$Backend$post(
			base(_List_Nil)),
		af: function (profileId) {
			return $author$project$Addresses$Backend$delete(
				base(
					_List_fromArray(
						[
							$danyx23$elm_uuid$Uuid$toString(profileId)
						])));
		},
		bT: function (profileId) {
			return $author$project$Addresses$Backend$get(
				base(
					_List_fromArray(
						[
							$danyx23$elm_uuid$Uuid$toString(profileId)
						])));
		},
		ac: function (profileId) {
			return $author$project$Addresses$Backend$patch(
				base(
					_List_fromArray(
						[
							$danyx23$elm_uuid$Uuid$toString(profileId)
						])));
		}
	};
}();
var $author$project$Pages$Util$Requests$fetchProfileWith = F3(
	function (mkMsg, authorizedAccess, profileId) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$profiles.bT(profileId),
			{
				iO: $elm$http$Http$emptyBody,
				cz: A2($author$project$Util$HttpUtil$expectJson, mkMsg, $author$project$Api$Types$Profile$decoderProfile)
			});
	});
var $author$project$Api$Types$MealEntry$MealEntry = F3(
	function (id, recipeId, numberOfServings) {
		return {gn: id, gY: numberOfServings, hk: recipeId};
	});
var $author$project$Api$Types$MealEntry$decoderMealEntry = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'numberOfServings',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'recipeId',
		$danyx23$elm_uuid$Uuid$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$danyx23$elm_uuid$Uuid$decoder,
			$elm$json$Json$Decode$succeed($author$project$Api$Types$MealEntry$MealEntry))));
var $author$project$Addresses$Backend$meals = function () {
	var profilesWord = 'profiles';
	var mealsWord = 'meals';
	var entriesWord = 'entries';
	var duplicateWord = 'duplicate';
	var base = function (profileId) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$List$cons(mealsWord),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$cons(
					$danyx23$elm_uuid$Uuid$toString(profileId)),
				$elm$core$List$cons(profilesWord)));
	};
	var entries = F2(
		function (profileId, mealId) {
			return A2(
				$elm$core$Basics$composeR,
				$elm$core$List$cons(entriesWord),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$cons(
						$danyx23$elm_uuid$Uuid$toString(mealId)),
					base(profileId)));
		});
	return {
		aW: function (profileId) {
			return $author$project$Addresses$Backend$get(
				A2(base, profileId, _List_Nil));
		},
		ae: function (profileId) {
			return $author$project$Addresses$Backend$post(
				A2(base, profileId, _List_Nil));
		},
		af: F2(
			function (profileId, mealId) {
				return $author$project$Addresses$Backend$delete(
					A2(
						base,
						profileId,
						_List_fromArray(
							[
								$danyx23$elm_uuid$Uuid$toString(mealId)
							])));
			}),
		ea: F2(
			function (profileId, mealId) {
				return $author$project$Addresses$Backend$post(
					A2(
						base,
						profileId,
						_List_fromArray(
							[
								$danyx23$elm_uuid$Uuid$toString(mealId),
								duplicateWord
							])));
			}),
		f5: {
			cg: F2(
				function (profileId, mealId) {
					return $author$project$Addresses$Backend$get(
						A3(entries, profileId, mealId, _List_Nil));
				}),
			ae: F2(
				function (profileId, mealId) {
					return $author$project$Addresses$Backend$post(
						A3(entries, profileId, mealId, _List_Nil));
				}),
			af: F3(
				function (profileId, mealId, mealEntryId) {
					return $author$project$Addresses$Backend$delete(
						A3(
							entries,
							profileId,
							mealId,
							_List_fromArray(
								[
									$danyx23$elm_uuid$Uuid$toString(mealEntryId)
								])));
				}),
			ac: F3(
				function (profileId, mealId, mealEntryId) {
					return $author$project$Addresses$Backend$patch(
						A3(
							entries,
							profileId,
							mealId,
							_List_fromArray(
								[
									$danyx23$elm_uuid$Uuid$toString(mealEntryId)
								])));
				})
		},
		bT: F2(
			function (profileId, mealId) {
				return $author$project$Addresses$Backend$get(
					A2(
						base,
						profileId,
						_List_fromArray(
							[
								$danyx23$elm_uuid$Uuid$toString(mealId)
							])));
			}),
		ac: F2(
			function (profileId, mealId) {
				return $author$project$Addresses$Backend$patch(
					A2(
						base,
						profileId,
						_List_fromArray(
							[
								$danyx23$elm_uuid$Uuid$toString(mealId)
							])));
			})
	};
}();
var $author$project$Pages$MealEntries$Entries$Requests$fetchMealEntries = F3(
	function (authorizedAccess, profileId, mealId) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			A2($author$project$Addresses$Backend$meals.f5.cg, profileId, mealId),
			{
				iO: $elm$http$Http$emptyBody,
				cz: A2(
					$author$project$Util$HttpUtil$expectJson,
					$author$project$Pages$Util$Choice$Page$GotFetchElementsResponse,
					$elm$json$Json$Decode$list($author$project$Api$Types$MealEntry$decoderMealEntry))
			});
	});
var $author$project$Pages$MealEntries$Entries$Requests$fetchRecipes = $author$project$Pages$Util$Requests$fetchRecipesWith($author$project$Pages$Util$Choice$Page$GotFetchChoicesResponse);
var $author$project$Pages$MealEntries$Entries$Handler$initialFetch = F3(
	function (authorizedAccess, profileId, mealId) {
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					$author$project$Pages$MealEntries$Entries$Requests$fetchRecipes(authorizedAccess),
					A3($author$project$Pages$MealEntries$Entries$Requests$fetchMealEntries, authorizedAccess, profileId, mealId)
				]));
	});
var $author$project$Api$Types$Meal$Meal = F3(
	function (id, date, name) {
		return {fR: date, gn: id, gN: name};
	});
var $author$project$Api$Types$SimpleDate$SimpleDate = F2(
	function (date, time) {
		return {fR: date, h$: time};
	});
var $author$project$Api$Types$Date$Date = F3(
	function (year, month, day) {
		return {fS: day, gL: month, iq: year};
	});
var $author$project$Api$Types$Date$decoderDate = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'day',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'month',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'year',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Api$Types$Date$Date))));
var $author$project$Api$Types$Time$Time = F2(
	function (hour, minute) {
		return {gk: hour, gJ: minute};
	});
var $author$project$Api$Types$Time$decoderTime = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'minute',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'hour',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Api$Types$Time$Time)));
var $author$project$Api$Types$SimpleDate$decoderSimpleDate = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'time',
	$elm$json$Json$Decode$maybe(
		$elm$json$Json$Decode$lazy(
			function (_v1) {
				return $author$project$Api$Types$Time$decoderTime;
			})),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'date',
		$elm$json$Json$Decode$lazy(
			function (_v0) {
				return $author$project$Api$Types$Date$decoderDate;
			}),
		$elm$json$Json$Decode$succeed($author$project$Api$Types$SimpleDate$SimpleDate)));
var $author$project$Api$Types$Meal$decoderMeal = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'name',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'date',
		$elm$json$Json$Decode$lazy(
			function (_v0) {
				return $author$project$Api$Types$SimpleDate$decoderSimpleDate;
			}),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$danyx23$elm_uuid$Uuid$decoder,
			$elm$json$Json$Decode$succeed($author$project$Api$Types$Meal$Meal))));
var $author$project$Pages$Util$Requests$fetchMealWith = F4(
	function (mkMsg, authorizedAccess, profileId, mealId) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			A2($author$project$Addresses$Backend$meals.bT, profileId, mealId),
			{
				iO: $elm$http$Http$emptyBody,
				cz: A2($author$project$Util$HttpUtil$expectJson, mkMsg, $author$project$Api$Types$Meal$decoderMeal)
			});
	});
var $author$project$Pages$MealEntries$Meal$Handler$initialFetch = $author$project$Pages$Util$Requests$fetchMealWith($author$project$Pages$Util$Parent$Page$GotFetchResponse);
var $author$project$Pages$MealEntries$Handler$initialFetch = F3(
	function (authorizedAccess, profileId, mealId) {
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Pages$MealEntries$Page$MealMsg,
					A3($author$project$Pages$MealEntries$Meal$Handler$initialFetch, authorizedAccess, profileId, mealId)),
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Pages$MealEntries$Page$EntriesMsg,
					A3($author$project$Pages$MealEntries$Entries$Handler$initialFetch, authorizedAccess, profileId, mealId)),
					A3($author$project$Pages$Util$Requests$fetchProfileWith, $author$project$Pages$MealEntries$Page$GotFetchProfileResponse, authorizedAccess, profileId)
				]));
	});
var $author$project$Pages$MealEntries$Handler$init = function (flags) {
	return _Utils_Tuple2(
		A3($author$project$Pages$MealEntries$Page$initial, flags.n, flags.bS, flags.gF),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			A3($author$project$Pages$MealEntries$Handler$initialFetch, flags.n, flags.bS, flags.gF)));
};
var $author$project$Pages$Meals$Editor$Page$GotFetchProfileResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Util$ParentEditor$Page$GotFetchResponse = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Meals$Editor$Page$ParentEditorMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Util$Requests$fetchMealsWith = F3(
	function (mkMsg, authorizedAccess, profileId) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$meals.aW(profileId),
			{
				iO: $elm$http$Http$emptyBody,
				cz: A2(
					$author$project$Util$HttpUtil$expectJson,
					mkMsg,
					$elm$json$Json$Decode$list($author$project$Api$Types$Meal$decoderMeal))
			});
	});
var $author$project$Pages$Meals$Editor$Requests$fetchMeals = $author$project$Pages$Util$Requests$fetchMealsWith(
	A2($elm$core$Basics$composeR, $author$project$Pages$Util$ParentEditor$Page$GotFetchResponse, $author$project$Pages$Meals$Editor$Page$ParentEditorMsg));
var $author$project$Pages$Meals$Editor$Handler$init = function (flags) {
	return _Utils_Tuple2(
		A2(
			$author$project$Pages$View$Tristate$createInitial,
			flags.n.o,
			{
				eF: {W: flags.n.W, lu: $elm$core$Maybe$Nothing},
				ly: $elm$core$Maybe$Nothing,
				bS: flags.bS
			}),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Pages$Util$Requests$fetchProfileWith, $author$project$Pages$Meals$Editor$Page$GotFetchProfileResponse, flags.n, flags.bS),
						A2($author$project$Pages$Meals$Editor$Requests$fetchMeals, flags.n, flags.bS)
					]))));
};
var $author$project$Pages$Util$ProfileChoice$Page$GotFetchProfilesResponse = $elm$core$Basics$identity;
var $author$project$Pages$Util$Requests$fetchProfilesWith = F2(
	function (mkMsg, authorizedAccess) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$profiles.aW,
			{
				iO: $elm$http$Http$emptyBody,
				cz: A2(
					$author$project$Util$HttpUtil$expectJson,
					mkMsg,
					$elm$json$Json$Decode$list($author$project$Api$Types$Profile$decoderProfile))
			});
	});
var $author$project$Pages$Util$ProfileChoice$Page$initial = A2(
	$elm_community$basics_extra$Basics$Extra$flip,
	$author$project$Pages$View$Tristate$createInitial,
	{eM: $elm$core$Maybe$Nothing});
var $author$project$Pages$Util$ProfileChoice$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Util$ProfileChoice$Page$initial(flags.n.o),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			A2($author$project$Pages$Util$Requests$fetchProfilesWith, $elm$core$Basics$identity, flags.n)));
};
var $author$project$Pages$Meals$ProfileChoice$Handler$init = $author$project$Pages$Util$ProfileChoice$Handler$init;
var $author$project$Pages$Overview$Page$initial = A2($elm_community$basics_extra$Basics$Extra$flip, $author$project$Pages$View$Tristate$createMain, 0);
var $author$project$Pages$Overview$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Overview$Page$initial(flags.o),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Profiles$Requests$fetchProfiles = $author$project$Pages$Util$Requests$fetchProfilesWith($author$project$Pages$Util$ParentEditor$Page$GotFetchResponse);
var $author$project$Pages$Util$ParentEditor$Page$initial = function (authorizedAccess) {
	return A2(
		$author$project$Pages$View$Tristate$createInitial,
		authorizedAccess.o,
		{W: authorizedAccess.W, lu: $elm$core$Maybe$Nothing});
};
var $author$project$Pages$Profiles$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Util$ParentEditor$Page$initial(flags.n),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			$author$project$Pages$Profiles$Requests$fetchProfiles(flags.n)));
};
var $author$project$Pages$Recipes$Page$ParentMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Recipes$Requests$fetchRecipes = $author$project$Pages$Util$Requests$fetchRecipesWith($author$project$Pages$Util$ParentEditor$Page$GotFetchResponse);
var $author$project$Pages$Recipes$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Util$ParentEditor$Page$initial(flags.n),
		A2(
			$elm$core$Platform$Cmd$map,
			A2($elm$core$Basics$composeR, $author$project$Pages$Recipes$Page$ParentMsg, $author$project$Pages$View$Tristate$Logic),
			$author$project$Pages$Recipes$Requests$fetchRecipes(flags.n)));
};
var $author$project$Pages$Recovery$Confirm$Page$Resetting = 0;
var $author$project$Pages$Util$PasswordInput$initial = {lw: '', g6: ''};
var $author$project$Pages$Recovery$Confirm$Page$initial = function (flags) {
	return A2(
		$author$project$Pages$View$Tristate$createMain,
		flags.o,
		{gK: 0, eH: $author$project$Pages$Util$PasswordInput$initial, lK: flags.lK, fe: flags.fe});
};
var $author$project$Pages$Recovery$Confirm$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Recovery$Confirm$Page$initial(flags),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Recovery$Request$Page$Initial = 0;
var $author$project$Pages$Recovery$Request$Page$initial = function (configuration) {
	return A2(
		$author$project$Pages$View$Tristate$createMain,
		configuration,
		{gK: 0, hz: '', mN: _List_Nil});
};
var $author$project$Pages$Recovery$Request$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Recovery$Request$Page$initial(flags.o),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$ReferenceEntries$Page$initial = F2(
	function (authorizedAccess, referenceMapId) {
		return A2(
			$author$project$Pages$View$Tristate$createInitial,
			authorizedAccess.o,
			{
				f5: A2($author$project$Pages$Util$Choice$Page$initialWith, authorizedAccess.W, referenceMapId),
				W: authorizedAccess.W,
				gE: $author$project$Pages$Util$Parent$Page$initialWith(authorizedAccess.W)
			});
	});
var $author$project$Pages$ReferenceEntries$Page$EntriesMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$ReferenceEntries$Page$MapMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ports$doFetchNutrients = _Platform_outgoingPort(
	'doFetchNutrients',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Api$Types$ReferenceEntry$ReferenceEntry = F2(
	function (nutrientCode, amount) {
		return {fp: amount, gZ: nutrientCode};
	});
var $author$project$Api$Types$ReferenceEntry$decoderReferenceEntry = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'amount',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'nutrientCode',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Api$Types$ReferenceEntry$ReferenceEntry)));
var $author$project$Addresses$Backend$references = function () {
	var treesWord = 'trees';
	var entriesWord = 'entries';
	var duplicateWord = 'duplicate';
	var base = $elm$core$List$cons('reference-maps');
	return {
		aW: $author$project$Addresses$Backend$get(
			base(_List_Nil)),
		iD: $author$project$Addresses$Backend$get(
			base(
				A2($elm$core$List$cons, treesWord, _List_Nil))),
		ae: $author$project$Addresses$Backend$post(
			base(_List_Nil)),
		af: function (referenceMapId) {
			return $author$project$Addresses$Backend$delete(
				base(
					_List_fromArray(
						[
							$danyx23$elm_uuid$Uuid$toString(referenceMapId)
						])));
		},
		ea: function (referenceMapId) {
			return $author$project$Addresses$Backend$post(
				base(
					_List_fromArray(
						[
							$danyx23$elm_uuid$Uuid$toString(referenceMapId),
							duplicateWord
						])));
		},
		f5: {
			cg: function (referenceMapId) {
				return $author$project$Addresses$Backend$get(
					base(
						_List_fromArray(
							[
								$danyx23$elm_uuid$Uuid$toString(referenceMapId),
								entriesWord
							])));
			},
			ae: function (referenceMapId) {
				return $author$project$Addresses$Backend$post(
					base(
						_List_fromArray(
							[
								$danyx23$elm_uuid$Uuid$toString(referenceMapId),
								entriesWord
							])));
			},
			af: F2(
				function (referenceMapId, nutrientCode) {
					return $author$project$Addresses$Backend$delete(
						base(
							A2(
								$elm$core$List$cons,
								$danyx23$elm_uuid$Uuid$toString(referenceMapId),
								A2(
									$elm$core$List$cons,
									entriesWord,
									_List_fromArray(
										[
											$elm$core$String$fromInt(nutrientCode)
										])))));
				}),
			ac: F2(
				function (referenceMapId, nutrientCode) {
					return $author$project$Addresses$Backend$patch(
						base(
							A2(
								$elm$core$List$cons,
								$danyx23$elm_uuid$Uuid$toString(referenceMapId),
								A2(
									$elm$core$List$cons,
									entriesWord,
									_List_fromArray(
										[
											$elm$core$String$fromInt(nutrientCode)
										])))));
				})
		},
		bT: function (referenceMapId) {
			return $author$project$Addresses$Backend$get(
				base(
					_List_fromArray(
						[
							$danyx23$elm_uuid$Uuid$toString(referenceMapId)
						])));
		},
		ac: function (referenceMapId) {
			return $author$project$Addresses$Backend$patch(
				base(
					_List_fromArray(
						[
							$danyx23$elm_uuid$Uuid$toString(referenceMapId)
						])));
		}
	};
}();
var $author$project$Pages$ReferenceEntries$Entries$Requests$fetchReferenceEntries = F2(
	function (authorizedAccess, referenceMapId) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$references.f5.cg(referenceMapId),
			{
				iO: $elm$http$Http$emptyBody,
				cz: A2(
					$author$project$Util$HttpUtil$expectJson,
					$author$project$Pages$Util$Choice$Page$GotFetchElementsResponse,
					$elm$json$Json$Decode$list($author$project$Api$Types$ReferenceEntry$decoderReferenceEntry))
			});
	});
var $author$project$Pages$ReferenceEntries$Entries$Handler$initialFetch = F2(
	function (authorizedAccess, referenceMapId) {
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Pages$ReferenceEntries$Entries$Requests$fetchReferenceEntries, authorizedAccess, referenceMapId),
					$author$project$Ports$doFetchNutrients(0)
				]));
	});
var $author$project$Api$Types$ReferenceMap$ReferenceMap = F2(
	function (id, name) {
		return {gn: id, gN: name};
	});
var $author$project$Api$Types$ReferenceMap$decoderReferenceMap = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$danyx23$elm_uuid$Uuid$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Types$ReferenceMap$ReferenceMap)));
var $author$project$Pages$ReferenceEntries$Map$Requests$fetchReferenceMap = F2(
	function (authorizedAccess, referenceMapId) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$references.bT(referenceMapId),
			{
				iO: $elm$http$Http$emptyBody,
				cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$Util$Parent$Page$GotFetchResponse, $author$project$Api$Types$ReferenceMap$decoderReferenceMap)
			});
	});
var $author$project$Pages$ReferenceEntries$Map$Handler$initialFetch = $author$project$Pages$ReferenceEntries$Map$Requests$fetchReferenceMap;
var $author$project$Pages$ReferenceEntries$Handler$initialFetch = function (flags) {
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Pages$ReferenceEntries$Page$MapMsg,
				A2($author$project$Pages$ReferenceEntries$Map$Handler$initialFetch, flags.n, flags.lN)),
				A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Pages$ReferenceEntries$Page$EntriesMsg,
				A2($author$project$Pages$ReferenceEntries$Entries$Handler$initialFetch, flags.n, flags.lN))
			]));
};
var $author$project$Pages$ReferenceEntries$Handler$init = function (flags) {
	return _Utils_Tuple2(
		A2($author$project$Pages$ReferenceEntries$Page$initial, flags.n, flags.lN),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			$author$project$Pages$ReferenceEntries$Handler$initialFetch(flags)));
};
var $author$project$Pages$ReferenceMaps$Requests$fetchReferenceMaps = function (authorizedAccess) {
	return A3(
		$author$project$Util$HttpUtil$runPatternWithJwt,
		authorizedAccess,
		$author$project$Addresses$Backend$references.aW,
		{
			iO: $elm$http$Http$emptyBody,
			cz: A2(
				$author$project$Util$HttpUtil$expectJson,
				$author$project$Pages$Util$ParentEditor$Page$GotFetchResponse,
				$elm$json$Json$Decode$list($author$project$Api$Types$ReferenceMap$decoderReferenceMap))
		});
};
var $author$project$Pages$ReferenceMaps$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Util$ParentEditor$Page$initial(flags.n),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			$author$project$Pages$ReferenceMaps$Requests$fetchReferenceMaps(flags.n)));
};
var $author$project$Pages$Registration$Confirm$Page$Editing = 0;
var $author$project$Pages$Util$ComplementInput$initial = {fZ: $elm$core$Maybe$Nothing, eH: $author$project$Pages$Util$PasswordInput$initial};
var $author$project$Pages$Registration$Confirm$Page$initial = function (flags) {
	return A2(
		$author$project$Pages$View$Tristate$createMain,
		flags.o,
		{d2: $author$project$Pages$Util$ComplementInput$initial, gK: 0, lS: flags.lS, fe: flags.fe});
};
var $author$project$Pages$Registration$Confirm$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Registration$Confirm$Page$initial(flags),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Registration$Request$Page$Editing = 0;
var $elm$core$Basics$not = _Basics_not;
var $author$project$Pages$Util$ValidatedInput$nonEmptyString = {
	cL: '',
	bi: A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$Just,
		A2(
			$elm$core$Basics$composeR,
			$elm_community$maybe_extra$Maybe$Extra$filter(
				A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)),
			$elm$core$Result$fromMaybe('Error: Empty string'))),
	bP: $elm$core$Basics$always(true),
	mx: '',
	ig: ''
};
var $author$project$Pages$Registration$Request$Page$initial = function (configuration) {
	return A2(
		$author$project$Pages$View$Tristate$createMain,
		configuration,
		{f2: $author$project$Pages$Util$ValidatedInput$nonEmptyString, gK: 0, gU: $author$project$Pages$Util$ValidatedInput$nonEmptyString});
};
var $author$project$Pages$Registration$Request$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Registration$Request$Page$initial(flags.o),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Statistics$ComplexFood$Search$Page$initial = function (authorizedAccess) {
	return A2(
		$author$project$Pages$View$Tristate$createInitial,
		authorizedAccess.o,
		{d3: $elm$core$Maybe$Nothing, W: authorizedAccess.W});
};
var $author$project$Pages$Statistics$ComplexFood$Search$Page$GotFetchComplexFoodsResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Statistics$ComplexFood$Search$Requests$fetchComplexFoods = $author$project$Pages$Util$Requests$fetchComplexFoodsWith($author$project$Pages$Statistics$ComplexFood$Search$Page$GotFetchComplexFoodsResponse);
var $author$project$Pages$Statistics$ComplexFood$Search$Handler$initialFetch = $author$project$Pages$Statistics$ComplexFood$Search$Requests$fetchComplexFoods;
var $author$project$Pages$Statistics$ComplexFood$Search$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Statistics$ComplexFood$Search$Page$initial(flags.n),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			$author$project$Pages$Statistics$ComplexFood$Search$Handler$initialFetch(flags.n)));
};
var $author$project$Pages$Statistics$ComplexFood$Select$Page$initial = function (authorizedAccess) {
	return A2(
		$author$project$Pages$View$Tristate$createInitial,
		authorizedAccess.o,
		{i4: $elm$core$Maybe$Nothing, i6: $elm$core$Maybe$Nothing, W: authorizedAccess.W, lO: $elm$core$Maybe$Nothing});
};
var $author$project$Pages$Statistics$ComplexFood$Select$Page$GotFetchComplexFoodResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Statistics$ComplexFood$Select$Requests$fetchComplexFood = function (flags) {
	return A3(
		$author$project$Util$HttpUtil$runPatternWithJwt,
		flags.n,
		$author$project$Addresses$Backend$complexFoods.bT(flags.fN),
		{
			iO: $elm$http$Http$emptyBody,
			cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$Statistics$ComplexFood$Select$Page$GotFetchComplexFoodResponse, $author$project$Api$Types$ComplexFood$decoderComplexFood)
		});
};
var $author$project$Pages$Statistics$ComplexFood$Select$Page$GotFetchReferenceTreesResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Types$ReferenceTree$ReferenceTree = F2(
	function (referenceMap, nutrients) {
		return {k8: nutrients, hm: referenceMap};
	});
var $author$project$Api$Types$ReferenceValue$ReferenceValue = F2(
	function (nutrientCode, referenceAmount) {
		return {gZ: nutrientCode, hl: referenceAmount};
	});
var $author$project$Api$Types$ReferenceValue$decoderReferenceValue = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'referenceAmount',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'nutrientCode',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Api$Types$ReferenceValue$ReferenceValue)));
var $author$project$Api$Types$ReferenceTree$decoderReferenceTree = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'nutrients',
	$elm$json$Json$Decode$list(
		$elm$json$Json$Decode$lazy(
			function (_v1) {
				return $author$project$Api$Types$ReferenceValue$decoderReferenceValue;
			})),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'referenceMap',
		$elm$json$Json$Decode$lazy(
			function (_v0) {
				return $author$project$Api$Types$ReferenceMap$decoderReferenceMap;
			}),
		$elm$json$Json$Decode$succeed($author$project$Api$Types$ReferenceTree$ReferenceTree)));
var $author$project$Pages$Statistics$StatisticsRequests$fetchReferenceTreesWith = F2(
	function (mkMsg, authorizedAccess) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$references.iD,
			{
				iO: $elm$http$Http$emptyBody,
				cz: A2(
					$author$project$Util$HttpUtil$expectJson,
					mkMsg,
					$elm$json$Json$Decode$list($author$project$Api$Types$ReferenceTree$decoderReferenceTree))
			});
	});
var $author$project$Pages$Statistics$ComplexFood$Select$Requests$fetchReferenceTrees = $author$project$Pages$Statistics$StatisticsRequests$fetchReferenceTreesWith($author$project$Pages$Statistics$ComplexFood$Select$Page$GotFetchReferenceTreesResponse);
var $author$project$Pages$Statistics$ComplexFood$Select$Page$GotFetchStatsResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Types$TotalOnlyStats$TotalOnlyStats = F2(
	function (nutrients, weightInGrams) {
		return {k8: nutrients, ik: weightInGrams};
	});
var $author$project$Api$Types$TotalOnlyNutrientInformation$TotalOnlyNutrientInformation = F2(
	function (base, amount) {
		return {fp: amount, fx: base};
	});
var $author$project$Api$Types$NutrientInformationBase$NutrientInformationBase = F4(
	function (nutrientCode, name, symbol, unit) {
		return {gN: name, gZ: nutrientCode, hV: symbol, ib: unit};
	});
var $author$project$Api$Types$NutrientUnit$Gram = 0;
var $author$project$Api$Types$NutrientUnit$IU = 1;
var $author$project$Api$Types$NutrientUnit$Kilocalorie = 2;
var $author$project$Api$Types$NutrientUnit$Kilojoule = 3;
var $author$project$Api$Types$NutrientUnit$Microgram = 4;
var $author$project$Api$Types$NutrientUnit$Milligram = 5;
var $author$project$Api$Types$NutrientUnit$NiacinEquivalent = 6;
var $author$project$Api$Types$NutrientUnit$decoderNutrientUnitByString = function (string) {
	switch (string) {
		case 'g':
			return $elm$json$Json$Decode$succeed(0);
		case 'IU':
			return $elm$json$Json$Decode$succeed(1);
		case 'kCal':
			return $elm$json$Json$Decode$succeed(2);
		case 'kJ':
			return $elm$json$Json$Decode$succeed(3);
		case 'µg':
			return $elm$json$Json$Decode$succeed(4);
		case 'mg':
			return $elm$json$Json$Decode$succeed(5);
		case 'NE':
			return $elm$json$Json$Decode$succeed(6);
		default:
			return $elm$json$Json$Decode$fail('Unexpected type for NutrientUnit: ' + string);
	}
};
var $author$project$Api$Types$NutrientUnit$decoderNutrientUnit = A2($elm$json$Json$Decode$andThen, $author$project$Api$Types$NutrientUnit$decoderNutrientUnitByString, $elm$json$Json$Decode$string);
var $author$project$Api$Types$NutrientInformationBase$decoderNutrientInformationBase = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'unit',
	$author$project$Api$Types$NutrientUnit$decoderNutrientUnit,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'symbol',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'nutrientCode',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Api$Types$NutrientInformationBase$NutrientInformationBase)))));
var $author$project$Api$Types$TotalOnlyAmount$TotalOnlyAmount = F3(
	function (value, numberOfIngredients, numberOfDefinedValues) {
		return {gW: numberOfDefinedValues, gX: numberOfIngredients, ig: value};
	});
var $author$project$Api$Types$TotalOnlyAmount$decoderTotalOnlyAmount = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'numberOfDefinedValues',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'numberOfIngredients',
		$elm$json$Json$Decode$int,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'value',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$Api$Types$TotalOnlyAmount$TotalOnlyAmount))));
var $author$project$Api$Types$TotalOnlyNutrientInformation$decoderTotalOnlyNutrientInformation = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'amount',
	$elm$json$Json$Decode$lazy(
		function (_v1) {
			return $author$project$Api$Types$TotalOnlyAmount$decoderTotalOnlyAmount;
		}),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'base',
		$elm$json$Json$Decode$lazy(
			function (_v0) {
				return $author$project$Api$Types$NutrientInformationBase$decoderNutrientInformationBase;
			}),
		$elm$json$Json$Decode$succeed($author$project$Api$Types$TotalOnlyNutrientInformation$TotalOnlyNutrientInformation)));
var $author$project$Api$Types$TotalOnlyStats$decoderTotalOnlyStats = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'weightInGrams',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'nutrients',
		$elm$json$Json$Decode$list(
			$elm$json$Json$Decode$lazy(
				function (_v0) {
					return $author$project$Api$Types$TotalOnlyNutrientInformation$decoderTotalOnlyNutrientInformation;
				})),
		$elm$json$Json$Decode$succeed($author$project$Api$Types$TotalOnlyStats$TotalOnlyStats)));
var $author$project$Util$HttpUtil$ResourcePattern = F3(
	function (verb, address, query) {
		return {iA: address, lB: query, mP: verb};
	});
var $author$project$Addresses$Backend$getQ = $author$project$Util$HttpUtil$ResourcePattern(0);
var $elm_community$maybe_extra$Maybe$Extra$cons = F2(
	function (item, list) {
		if (!item.$) {
			var v = item.a;
			return A2($elm$core$List$cons, v, list);
		} else {
			return list;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$values = A2($elm$core$List$foldr, $elm_community$maybe_extra$Maybe$Extra$cons, _List_Nil);
var $author$project$Addresses$Backend$stats = function () {
	var profilesWord = 'profiles';
	var base = $elm$core$List$cons('stats');
	return {
		aW: F2(
			function (profileId, interval) {
				return A2(
					$author$project$Addresses$Backend$getQ,
					base(
						_List_fromArray(
							[
								profilesWord,
								$danyx23$elm_uuid$Uuid$toString(profileId)
							])),
					$elm_community$maybe_extra$Maybe$Extra$values(
						_List_fromArray(
							[interval.jV, interval.mA])));
			}),
		i4: function (complexFoodId) {
			return $author$project$Addresses$Backend$get(
				base(
					_List_fromArray(
						[
							$author$project$Addresses$StatisticsVariant$complexFood,
							$danyx23$elm_uuid$Uuid$toString(complexFoodId)
						])));
		},
		gc: function (foodId) {
			return $author$project$Addresses$Backend$get(
				base(
					_List_fromArray(
						[
							$author$project$Addresses$StatisticsVariant$food,
							$elm$core$String$fromInt(foodId)
						])));
		},
		kD: F2(
			function (profileId, mealId) {
				return $author$project$Addresses$Backend$get(
					base(
						_List_fromArray(
							[
								profilesWord,
								$danyx23$elm_uuid$Uuid$toString(profileId),
								$author$project$Addresses$StatisticsVariant$meal,
								$danyx23$elm_uuid$Uuid$toString(mealId)
							])));
			}),
		k8: $author$project$Addresses$Backend$get(
			base(
				_List_fromArray(
					['nutrients']))),
		lD: function (recipeId) {
			return $author$project$Addresses$Backend$get(
				base(
					_List_fromArray(
						[
							$author$project$Addresses$StatisticsVariant$recipe,
							$danyx23$elm_uuid$Uuid$toString(recipeId)
						])));
		},
		lG: function (profileId) {
			return $author$project$Addresses$Backend$get(
				base(
					_List_fromArray(
						[
							'recipe-occurrences',
							profilesWord,
							$danyx23$elm_uuid$Uuid$toString(profileId)
						])));
		}
	};
}();
var $author$project$Pages$Statistics$ComplexFood$Select$Requests$fetchStats = function (flags) {
	return A3(
		$author$project$Util$HttpUtil$runPatternWithJwt,
		flags.n,
		$author$project$Addresses$Backend$stats.i4(flags.fN),
		{
			iO: $elm$http$Http$emptyBody,
			cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$Statistics$ComplexFood$Select$Page$GotFetchStatsResponse, $author$project$Api$Types$TotalOnlyStats$decoderTotalOnlyStats)
		});
};
var $author$project$Pages$Statistics$ComplexFood$Select$Handler$initialFetch = function (flags) {
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				$author$project$Pages$Statistics$ComplexFood$Select$Requests$fetchComplexFood(flags),
				$author$project$Pages$Statistics$ComplexFood$Select$Requests$fetchStats(flags),
				$author$project$Pages$Statistics$ComplexFood$Select$Requests$fetchReferenceTrees(flags.n)
			]));
};
var $author$project$Pages$Statistics$ComplexFood$Select$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Statistics$ComplexFood$Select$Page$initial(flags.n),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			$author$project$Pages$Statistics$ComplexFood$Select$Handler$initialFetch(flags)));
};
var $author$project$Pages$Statistics$Food$Search$Page$initial = function (authorizedAccess) {
	return A2(
		$author$project$Pages$View$Tristate$createInitial,
		authorizedAccess.o,
		{jS: $elm$core$Maybe$Nothing, W: authorizedAccess.W});
};
var $author$project$Pages$Statistics$Food$Search$Handler$initialFetch = $author$project$Ports$doFetchFoods(0);
var $author$project$Pages$Statistics$Food$Search$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Statistics$Food$Search$Page$initial(flags.n),
		A2($elm$core$Platform$Cmd$map, $author$project$Pages$View$Tristate$Logic, $author$project$Pages$Statistics$Food$Search$Handler$initialFetch));
};
var $author$project$Pages$Statistics$Food$Select$Page$initial = function (authorizedAccess) {
	return A2(
		$author$project$Pages$View$Tristate$createInitial,
		authorizedAccess.o,
		{jR: $elm$core$Maybe$Nothing, bB: $elm$core$Maybe$Nothing, W: authorizedAccess.W, lO: $elm$core$Maybe$Nothing});
};
var $author$project$Pages$Statistics$Food$Select$Page$GotFetchFoodInfoResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Types$FoodInfo$FoodInfo = F2(
	function (id, name) {
		return {gn: id, gN: name};
	});
var $author$project$Api$Types$FoodInfo$decoderFoodInfo = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Api$Types$FoodInfo$FoodInfo)));
var $author$project$Pages$Statistics$Food$Select$Requests$fetchFoodInfo = function (flags) {
	return A3(
		$author$project$Util$HttpUtil$runPatternWithJwt,
		flags.n,
		$author$project$Addresses$Backend$recipes.gc(flags.gd),
		{
			iO: $elm$http$Http$emptyBody,
			cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$Statistics$Food$Select$Page$GotFetchFoodInfoResponse, $author$project$Api$Types$FoodInfo$decoderFoodInfo)
		});
};
var $author$project$Pages$Statistics$Food$Select$Page$GotFetchReferenceTreesResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Statistics$Food$Select$Requests$fetchReferenceTrees = $author$project$Pages$Statistics$StatisticsRequests$fetchReferenceTreesWith($author$project$Pages$Statistics$Food$Select$Page$GotFetchReferenceTreesResponse);
var $author$project$Pages$Statistics$Food$Select$Page$GotFetchStatsResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Types$FoodStats$FoodStats = F2(
	function (nutrients, weightInGrams) {
		return {k8: nutrients, ik: weightInGrams};
	});
var $author$project$Api$Types$FoodNutrientInformation$FoodNutrientInformation = F2(
	function (base, amount) {
		return {fp: amount, fx: base};
	});
var $author$project$Api$Types$FoodNutrientInformation$decoderFoodNutrientInformation = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'amount',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'base',
		$elm$json$Json$Decode$lazy(
			function (_v0) {
				return $author$project$Api$Types$NutrientInformationBase$decoderNutrientInformationBase;
			}),
		$elm$json$Json$Decode$succeed($author$project$Api$Types$FoodNutrientInformation$FoodNutrientInformation)));
var $author$project$Api$Types$FoodStats$decoderFoodStats = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'weightInGrams',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'nutrients',
		$elm$json$Json$Decode$list(
			$elm$json$Json$Decode$lazy(
				function (_v0) {
					return $author$project$Api$Types$FoodNutrientInformation$decoderFoodNutrientInformation;
				})),
		$elm$json$Json$Decode$succeed($author$project$Api$Types$FoodStats$FoodStats)));
var $author$project$Pages$Statistics$Food$Select$Requests$fetchStats = function (flags) {
	return A3(
		$author$project$Util$HttpUtil$runPatternWithJwt,
		flags.n,
		$author$project$Addresses$Backend$stats.gc(flags.gd),
		{
			iO: $elm$http$Http$emptyBody,
			cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$Statistics$Food$Select$Page$GotFetchStatsResponse, $author$project$Api$Types$FoodStats$decoderFoodStats)
		});
};
var $author$project$Pages$Statistics$Food$Select$Handler$initialFetch = function (flags) {
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				$author$project$Pages$Statistics$Food$Select$Requests$fetchFoodInfo(flags),
				$author$project$Pages$Statistics$Food$Select$Requests$fetchStats(flags),
				$author$project$Pages$Statistics$Food$Select$Requests$fetchReferenceTrees(flags.n)
			]));
};
var $author$project$Pages$Statistics$Food$Select$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Statistics$Food$Select$Page$initial(flags.n),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			$author$project$Pages$Statistics$Food$Select$Handler$initialFetch(flags)));
};
var $author$project$Pages$Statistics$Meal$ProfileChoice$Handler$init = $author$project$Pages$Util$ProfileChoice$Handler$init;
var $author$project$Pages$Statistics$Meal$Search$Page$initial = function (authorizedAccess) {
	return A2(
		$author$project$Pages$View$Tristate$createInitial,
		authorizedAccess.o,
		{W: authorizedAccess.W, gG: $elm$core$Maybe$Nothing, ly: $elm$core$Maybe$Nothing});
};
var $author$project$Pages$Statistics$Meal$Search$Page$GotFetchProfileResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Statistics$Meal$Search$Page$GotFetchMealsResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Statistics$Meal$Search$Requests$fetchMeals = $author$project$Pages$Util$Requests$fetchMealsWith($author$project$Pages$Statistics$Meal$Search$Page$GotFetchMealsResponse);
var $author$project$Pages$Statistics$Meal$Search$Handler$initialFetch = F2(
	function (authorizedAccess, profileId) {
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Pages$Statistics$Meal$Search$Requests$fetchMeals, authorizedAccess, profileId),
					A3($author$project$Pages$Util$Requests$fetchProfileWith, $author$project$Pages$Statistics$Meal$Search$Page$GotFetchProfileResponse, authorizedAccess, profileId)
				]));
	});
var $author$project$Pages$Statistics$Meal$Search$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Statistics$Meal$Search$Page$initial(flags.n),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			A2($author$project$Pages$Statistics$Meal$Search$Handler$initialFetch, flags.n, flags.bS)));
};
var $author$project$Pages$Statistics$Meal$Select$Page$initial = function (authorizedAccess) {
	return A2(
		$author$project$Pages$View$Tristate$createInitial,
		authorizedAccess.o,
		{W: authorizedAccess.W, kD: $elm$core$Maybe$Nothing, kG: $elm$core$Maybe$Nothing, ly: $elm$core$Maybe$Nothing, lO: $elm$core$Maybe$Nothing});
};
var $author$project$Pages$Statistics$Meal$Select$Page$GotFetchProfileResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Statistics$Meal$Select$Page$GotFetchMealResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Statistics$Meal$Select$Requests$fetchMeal = $author$project$Pages$Util$Requests$fetchMealWith($author$project$Pages$Statistics$Meal$Select$Page$GotFetchMealResponse);
var $author$project$Pages$Statistics$Meal$Select$Page$GotFetchReferenceTreesResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Statistics$Meal$Select$Requests$fetchReferenceTrees = $author$project$Pages$Statistics$StatisticsRequests$fetchReferenceTreesWith($author$project$Pages$Statistics$Meal$Select$Page$GotFetchReferenceTreesResponse);
var $author$project$Pages$Statistics$Meal$Select$Page$GotFetchStatsResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Statistics$Meal$Select$Requests$fetchStats = F3(
	function (authorizedAccess, profileId, mealId) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			A2($author$project$Addresses$Backend$stats.kD, profileId, mealId),
			{
				iO: $elm$http$Http$emptyBody,
				cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$Statistics$Meal$Select$Page$GotFetchStatsResponse, $author$project$Api$Types$TotalOnlyStats$decoderTotalOnlyStats)
			});
	});
var $author$project$Pages$Statistics$Meal$Select$Handler$initialFetch = function (flags) {
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				A3($author$project$Pages$Statistics$Meal$Select$Requests$fetchMeal, flags.n, flags.bS, flags.gF),
				A3($author$project$Pages$Statistics$Meal$Select$Requests$fetchStats, flags.n, flags.bS, flags.gF),
				$author$project$Pages$Statistics$Meal$Select$Requests$fetchReferenceTrees(flags.n),
				A3($author$project$Pages$Util$Requests$fetchProfileWith, $author$project$Pages$Statistics$Meal$Select$Page$GotFetchProfileResponse, flags.n, flags.bS)
			]));
};
var $author$project$Pages$Statistics$Meal$Select$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Statistics$Meal$Select$Page$initial(flags.n),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			$author$project$Pages$Statistics$Meal$Select$Handler$initialFetch(flags)));
};
var $author$project$Pages$Statistics$Recipe$Search$Page$initial = function (authorizedAccess) {
	return A2(
		$author$project$Pages$View$Tristate$createInitial,
		authorizedAccess.o,
		{W: authorizedAccess.W, eO: $elm$core$Maybe$Nothing});
};
var $author$project$Pages$Statistics$Recipe$Search$Page$GotFetchRecipesResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Statistics$Recipe$Search$Requests$fetchRecipes = $author$project$Pages$Util$Requests$fetchRecipesWith($author$project$Pages$Statistics$Recipe$Search$Page$GotFetchRecipesResponse);
var $author$project$Pages$Statistics$Recipe$Search$Handler$initialFetch = $author$project$Pages$Statistics$Recipe$Search$Requests$fetchRecipes;
var $author$project$Pages$Statistics$Recipe$Search$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Statistics$Recipe$Search$Page$initial(flags.n),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			$author$project$Pages$Statistics$Recipe$Search$Handler$initialFetch(flags.n)));
};
var $author$project$Pages$Statistics$Recipe$Select$Page$initial = function (authorizedAccess) {
	return A2(
		$author$project$Pages$View$Tristate$createInitial,
		authorizedAccess.o,
		{W: authorizedAccess.W, lD: $elm$core$Maybe$Nothing, lH: $elm$core$Maybe$Nothing, lO: $elm$core$Maybe$Nothing});
};
var $author$project$Pages$Statistics$Recipe$Select$Page$GotFetchRecipeResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Statistics$Recipe$Select$Requests$fetchRecipe = $author$project$Pages$Util$Requests$fetchRecipeWith($author$project$Pages$Statistics$Recipe$Select$Page$GotFetchRecipeResponse);
var $author$project$Pages$Statistics$Recipe$Select$Page$GotFetchReferenceTreesResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Statistics$Recipe$Select$Requests$fetchReferenceTrees = $author$project$Pages$Statistics$StatisticsRequests$fetchReferenceTreesWith($author$project$Pages$Statistics$Recipe$Select$Page$GotFetchReferenceTreesResponse);
var $author$project$Pages$Statistics$Recipe$Select$Page$GotFetchStatsResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Statistics$Recipe$Select$Requests$fetchStats = F2(
	function (authorizedAccess, recipeId) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$stats.lD(recipeId),
			{
				iO: $elm$http$Http$emptyBody,
				cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$Statistics$Recipe$Select$Page$GotFetchStatsResponse, $author$project$Api$Types$TotalOnlyStats$decoderTotalOnlyStats)
			});
	});
var $author$project$Pages$Statistics$Recipe$Select$Handler$initialFetch = function (flags) {
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				A2($author$project$Pages$Statistics$Recipe$Select$Requests$fetchRecipe, flags.n, flags.hk),
				A2($author$project$Pages$Statistics$Recipe$Select$Requests$fetchStats, flags.n, flags.hk),
				$author$project$Pages$Statistics$Recipe$Select$Requests$fetchReferenceTrees(flags.n)
			]));
};
var $author$project$Pages$Statistics$Recipe$Select$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Statistics$Recipe$Select$Page$initial(flags.n),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			$author$project$Pages$Statistics$Recipe$Select$Handler$initialFetch(flags)));
};
var $author$project$Pages$Statistics$RecipeOccurrences$ProfileChoice$Handler$init = $author$project$Pages$Util$ProfileChoice$Handler$init;
var $author$project$Pages$Statistics$RecipeOccurrences$Search$Page$initial = function (authorizedAccess) {
	return A2(
		$author$project$Pages$View$Tristate$createInitial,
		authorizedAccess.o,
		{W: authorizedAccess.W, ly: $elm$core$Maybe$Nothing, lG: $elm$core$Maybe$Nothing});
};
var $author$project$Pages$Statistics$RecipeOccurrences$Search$Page$GotFetchProfileResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Statistics$RecipeOccurrences$Search$Page$GotFetchRecipeOccurrencesResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Types$RecipeOccurrence$RecipeOccurrence = F2(
	function (recipe, lastUsedInMeal) {
		return {gC: lastUsedInMeal, lD: recipe};
	});
var $author$project$Api$Types$RecipeOccurrence$decoderRecipeOccurrence = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'lastUsedInMeal',
	$elm$json$Json$Decode$maybe(
		$elm$json$Json$Decode$lazy(
			function (_v1) {
				return $author$project$Api$Types$Meal$decoderMeal;
			})),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'recipe',
		$elm$json$Json$Decode$lazy(
			function (_v0) {
				return $author$project$Api$Types$Recipe$decoderRecipe;
			}),
		$elm$json$Json$Decode$succeed($author$project$Api$Types$RecipeOccurrence$RecipeOccurrence)));
var $author$project$Pages$Statistics$RecipeOccurrences$Search$Requests$fetchRecipeOccurrences = F2(
	function (authorizedAccess, profileId) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$stats.lG(profileId),
			{
				iO: $elm$http$Http$emptyBody,
				cz: A2(
					$author$project$Util$HttpUtil$expectJson,
					$author$project$Pages$Statistics$RecipeOccurrences$Search$Page$GotFetchRecipeOccurrencesResponse,
					$elm$json$Json$Decode$list($author$project$Api$Types$RecipeOccurrence$decoderRecipeOccurrence))
			});
	});
var $author$project$Pages$Statistics$RecipeOccurrences$Search$Handler$initialFetch = F2(
	function (authorizedAccess, profileId) {
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Pages$Statistics$RecipeOccurrences$Search$Requests$fetchRecipeOccurrences, authorizedAccess, profileId),
					A3($author$project$Pages$Util$Requests$fetchProfileWith, $author$project$Pages$Statistics$RecipeOccurrences$Search$Page$GotFetchProfileResponse, authorizedAccess, profileId)
				]));
	});
var $author$project$Pages$Statistics$RecipeOccurrences$Search$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Statistics$RecipeOccurrences$Search$Page$initial(flags.n),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			A2($author$project$Pages$Statistics$RecipeOccurrences$Search$Handler$initialFetch, flags.n, flags.bS)));
};
var $author$project$Pages$Statistics$Time$Page$initial = function (authorizedAccess) {
	return A2(
		$author$project$Pages$View$Tristate$createInitial,
		authorizedAccess.o,
		{W: authorizedAccess.W, eM: $elm$core$Maybe$Nothing, lO: $elm$core$Maybe$Nothing});
};
var $author$project$Pages$Statistics$Time$Page$GotFetchProfilesResponse = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Statistics$Time$Requests$fetchProfiles = $author$project$Pages$Util$Requests$fetchProfilesWith($author$project$Pages$Statistics$Time$Page$GotFetchProfilesResponse);
var $author$project$Pages$Statistics$Time$Page$GotFetchReferenceTreesResponse = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Statistics$Time$Requests$fetchReferenceTrees = $author$project$Pages$Statistics$StatisticsRequests$fetchReferenceTreesWith($author$project$Pages$Statistics$Time$Page$GotFetchReferenceTreesResponse);
var $author$project$Pages$Statistics$Time$Handler$initialFetch = function (authorizedAccess) {
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				$author$project$Pages$Statistics$Time$Requests$fetchReferenceTrees(authorizedAccess),
				$author$project$Pages$Statistics$Time$Requests$fetchProfiles(authorizedAccess)
			]));
};
var $author$project$Pages$Statistics$Time$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Statistics$Time$Page$initial(flags.n),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			$author$project$Pages$Statistics$Time$Handler$initialFetch(flags.n)));
};
var $author$project$Pages$UserSettings$Page$initial = function (authorizedAccess) {
	return A2(
		$author$project$Pages$View$Tristate$createInitial,
		authorizedAccess.o,
		{W: authorizedAccess.W, ie: $elm$core$Maybe$Nothing});
};
var $author$project$Pages$UserSettings$Page$GotFetchUserResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Types$User$User = F4(
	function (id, nickname, displayName, email) {
		return {fZ: displayName, f2: email, gn: id, gU: nickname};
	});
var $author$project$Api$Types$User$decoderUser = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'email',
	$elm$json$Json$Decode$string,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'displayName',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'nickname',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$danyx23$elm_uuid$Uuid$decoder,
				$elm$json$Json$Decode$succeed($author$project$Api$Types$User$User)))));
var $author$project$Addresses$Backend$users = function () {
	var base = $elm$core$List$cons('users');
	var deletion = A2(
		$elm$core$Basics$composeR,
		$elm$core$List$cons('deletion'),
		base);
	var recovery = A2(
		$elm$core$Basics$composeR,
		$elm$core$List$cons('recovery'),
		base);
	var registration = A2(
		$elm$core$Basics$composeR,
		$elm$core$List$cons('registration'),
		base);
	return {
		jr: {
			d4: $author$project$Addresses$Backend$post(
				deletion(
					_List_fromArray(
						['confirm']))),
			eS: $author$project$Addresses$Backend$post(
				deletion(
					_List_fromArray(
						['request'])))
		},
		jY: $author$project$Addresses$Backend$get(
			base(_List_Nil)),
		kw: $author$project$Addresses$Backend$post(
			base(
				_List_fromArray(
					['login']))),
		kx: $author$project$Addresses$Backend$post(
			base(
				_List_fromArray(
					['logout']))),
		lJ: {
			d4: $author$project$Addresses$Backend$post(
				recovery(
					_List_fromArray(
						['confirm']))),
			jQ: function (searchString) {
				return $author$project$Addresses$Backend$get(
					recovery(
						_List_fromArray(
							['find', searchString])));
			},
			eS: $author$project$Addresses$Backend$post(
				recovery(
					_List_fromArray(
						['request'])))
		},
		lR: {
			d4: $author$project$Addresses$Backend$post(
				registration(
					_List_fromArray(
						['confirm']))),
			eS: $author$project$Addresses$Backend$post(
				registration(
					_List_fromArray(
						['request'])))
		},
		ac: $author$project$Addresses$Backend$patch(
			base(_List_Nil)),
		mL: $author$project$Addresses$Backend$patch(
			base(
				_List_fromArray(
					['password'])))
	};
}();
var $author$project$Pages$UserSettings$Requests$fetchUser = function (authorizedAccess) {
	return A3(
		$author$project$Util$HttpUtil$runPatternWithJwt,
		authorizedAccess,
		$author$project$Addresses$Backend$users.jY,
		{
			iO: $elm$http$Http$emptyBody,
			cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$UserSettings$Page$GotFetchUserResponse, $author$project$Api$Types$User$decoderUser)
		});
};
var $author$project$Pages$UserSettings$Handler$initialFetch = $author$project$Pages$UserSettings$Requests$fetchUser;
var $author$project$Pages$UserSettings$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$UserSettings$Page$initial(flags.n),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			$author$project$Pages$UserSettings$Handler$initialFetch(flags.n)));
};
var $author$project$Main$stepThrough = F3(
	function (ps, model, _v0) {
		var subModel = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					N: ps.N(subModel)
				}),
			A2($elm$core$Platform$Cmd$map, ps.gI, cmd));
	});
var $author$project$Main$ComplexFoods = function (a) {
	return {$: 28, a: a};
};
var $author$project$Main$ComplexFoodsMsg = function (a) {
	return {$: 33, a: a};
};
var $author$project$Main$ConfirmRecovery = function (a) {
	return {$: 27, a: a};
};
var $author$project$Main$ConfirmRecoveryMsg = function (a) {
	return {$: 32, a: a};
};
var $author$project$Main$ConfirmRegistration = function (a) {
	return {$: 23, a: a};
};
var $author$project$Main$ConfirmRegistrationMsg = function (a) {
	return {$: 28, a: a};
};
var $author$project$Main$Deletion = function (a) {
	return {$: 25, a: a};
};
var $author$project$Main$DeletionMsg = function (a) {
	return {$: 30, a: a};
};
var $author$project$Main$Ingredients = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$IngredientsMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Main$Login = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$LoginMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Main$MealEntries = function (a) {
	return {$: 7, a: a};
};
var $author$project$Main$MealEntriesMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Main$Meals = function (a) {
	return {$: 6, a: a};
};
var $author$project$Main$MealsMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Main$Overview = function (a) {
	return {$: 2, a: a};
};
var $author$project$Main$OverviewMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Main$ProfileChoice = function (a) {
	return {$: 5, a: a};
};
var $author$project$Main$ProfileChoiceMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Main$Profiles = function (a) {
	return {$: 29, a: a};
};
var $author$project$Main$ProfilesMsg = function (a) {
	return {$: 34, a: a};
};
var $author$project$Main$Recipes = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$RecipesMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Main$ReferenceEntries = function (a) {
	return {$: 21, a: a};
};
var $author$project$Main$ReferenceEntriesMsg = function (a) {
	return {$: 26, a: a};
};
var $author$project$Main$ReferenceMaps = function (a) {
	return {$: 20, a: a};
};
var $author$project$Main$ReferenceMapsMsg = function (a) {
	return {$: 25, a: a};
};
var $author$project$Main$RequestRecovery = function (a) {
	return {$: 26, a: a};
};
var $author$project$Main$RequestRecoveryMsg = function (a) {
	return {$: 31, a: a};
};
var $author$project$Main$RequestRegistration = function (a) {
	return {$: 22, a: a};
};
var $author$project$Main$RequestRegistrationMsg = function (a) {
	return {$: 27, a: a};
};
var $author$project$Main$StatisticsComplexFoodSearch = function (a) {
	return {$: 11, a: a};
};
var $author$project$Main$StatisticsComplexFoodSearchMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Main$StatisticsComplexFoodSelect = function (a) {
	return {$: 12, a: a};
};
var $author$project$Main$StatisticsComplexFoodSelectMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Main$StatisticsFoodSearch = function (a) {
	return {$: 9, a: a};
};
var $author$project$Main$StatisticsFoodSearchMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Main$StatisticsFoodSelect = function (a) {
	return {$: 10, a: a};
};
var $author$project$Main$StatisticsFoodSelectMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Main$StatisticsMealProfileChoice = function (a) {
	return {$: 15, a: a};
};
var $author$project$Main$StatisticsMealProfileChoiceMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Main$StatisticsMealSearch = function (a) {
	return {$: 16, a: a};
};
var $author$project$Main$StatisticsMealSearchMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Main$StatisticsMealSelect = function (a) {
	return {$: 17, a: a};
};
var $author$project$Main$StatisticsMealSelectMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Main$StatisticsRecipeOccurrences = function (a) {
	return {$: 19, a: a};
};
var $author$project$Main$StatisticsRecipeOccurrencesMsg = function (a) {
	return {$: 24, a: a};
};
var $author$project$Main$StatisticsRecipeOccurrencesProfileChoice = function (a) {
	return {$: 18, a: a};
};
var $author$project$Main$StatisticsRecipeOccurrencesProfileChoiceMsg = function (a) {
	return {$: 23, a: a};
};
var $author$project$Main$StatisticsRecipeSearch = function (a) {
	return {$: 13, a: a};
};
var $author$project$Main$StatisticsRecipeSearchMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Main$StatisticsRecipeSelect = function (a) {
	return {$: 14, a: a};
};
var $author$project$Main$StatisticsRecipeSelectMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Main$StatisticsTime = function (a) {
	return {$: 8, a: a};
};
var $author$project$Main$StatisticsTimeMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Main$StepParameters = F2(
	function (page, message) {
		return {gI: message, N: page};
	});
var $author$project$Main$UserSettings = function (a) {
	return {$: 24, a: a};
};
var $author$project$Main$UserSettingsMsg = function (a) {
	return {$: 29, a: a};
};
var $author$project$Main$steps = {
	d3: A2($author$project$Main$StepParameters, $author$project$Main$ComplexFoods, $author$project$Main$ComplexFoodsMsg),
	d5: A2($author$project$Main$StepParameters, $author$project$Main$ConfirmRecovery, $author$project$Main$ConfirmRecoveryMsg),
	d6: A2($author$project$Main$StepParameters, $author$project$Main$ConfirmRegistration, $author$project$Main$ConfirmRegistrationMsg),
	jr: A2($author$project$Main$StepParameters, $author$project$Main$Deletion, $author$project$Main$DeletionMsg),
	kg: A2($author$project$Main$StepParameters, $author$project$Main$Ingredients, $author$project$Main$IngredientsMsg),
	kw: A2($author$project$Main$StepParameters, $author$project$Main$Login, $author$project$Main$LoginMsg),
	es: A2($author$project$Main$StepParameters, $author$project$Main$MealEntries, $author$project$Main$MealEntriesMsg),
	gG: A2($author$project$Main$StepParameters, $author$project$Main$Meals, $author$project$Main$MealsMsg),
	eD: A2($author$project$Main$StepParameters, $author$project$Main$Overview, $author$project$Main$OverviewMsg),
	eL: A2($author$project$Main$StepParameters, $author$project$Main$ProfileChoice, $author$project$Main$ProfileChoiceMsg),
	eM: A2($author$project$Main$StepParameters, $author$project$Main$Profiles, $author$project$Main$ProfilesMsg),
	eO: A2($author$project$Main$StepParameters, $author$project$Main$Recipes, $author$project$Main$RecipesMsg),
	dr: A2($author$project$Main$StepParameters, $author$project$Main$ReferenceEntries, $author$project$Main$ReferenceEntriesMsg),
	eR: A2($author$project$Main$StepParameters, $author$project$Main$ReferenceMaps, $author$project$Main$ReferenceMapsMsg),
	eT: A2($author$project$Main$StepParameters, $author$project$Main$RequestRecovery, $author$project$Main$RequestRecoveryMsg),
	eU: A2($author$project$Main$StepParameters, $author$project$Main$RequestRegistration, $author$project$Main$RequestRegistrationMsg),
	eZ: A2($author$project$Main$StepParameters, $author$project$Main$StatisticsComplexFoodSearch, $author$project$Main$StatisticsComplexFoodSearchMsg),
	e_: A2($author$project$Main$StepParameters, $author$project$Main$StatisticsComplexFoodSelect, $author$project$Main$StatisticsComplexFoodSelectMsg),
	dG: A2($author$project$Main$StepParameters, $author$project$Main$StatisticsFoodSearch, $author$project$Main$StatisticsFoodSearchMsg),
	e$: A2($author$project$Main$StepParameters, $author$project$Main$StatisticsFoodSelect, $author$project$Main$StatisticsFoodSelectMsg),
	e0: A2($author$project$Main$StepParameters, $author$project$Main$StatisticsMealProfileChoice, $author$project$Main$StatisticsMealProfileChoiceMsg),
	e1: A2($author$project$Main$StepParameters, $author$project$Main$StatisticsMealSearch, $author$project$Main$StatisticsMealSearchMsg),
	e2: A2($author$project$Main$StepParameters, $author$project$Main$StatisticsMealSelect, $author$project$Main$StatisticsMealSelectMsg),
	e3: A2($author$project$Main$StepParameters, $author$project$Main$StatisticsRecipeOccurrences, $author$project$Main$StatisticsRecipeOccurrencesMsg),
	e4: A2($author$project$Main$StepParameters, $author$project$Main$StatisticsRecipeOccurrencesProfileChoice, $author$project$Main$StatisticsRecipeOccurrencesProfileChoiceMsg),
	e5: A2($author$project$Main$StepParameters, $author$project$Main$StatisticsRecipeSearch, $author$project$Main$StatisticsRecipeSearchMsg),
	e6: A2($author$project$Main$StepParameters, $author$project$Main$StatisticsRecipeSelect, $author$project$Main$StatisticsRecipeSelectMsg),
	e7: A2($author$project$Main$StepParameters, $author$project$Main$StatisticsTime, $author$project$Main$StatisticsTimeMsg),
	ff: A2($author$project$Main$StepParameters, $author$project$Main$UserSettings, $author$project$Main$UserSettingsMsg)
};
var $author$project$Main$followRoute = function (model) {
	var authorizedAccessWith = function (jwt) {
		return {o: model.o, W: jwt};
	};
	var _v0 = model.aI;
	if (_v0.$ === 1) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{N: $author$project$Main$NotFound}),
			$elm$core$Platform$Cmd$none);
	} else {
		var entryRoute = _v0.a;
		var _v1 = _Utils_Tuple2(entryRoute, model.W);
		_v1$30:
		while (true) {
			switch (_v1.a.$) {
				case 0:
					var _v2 = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{N: $author$project$Main$Landing}),
						$elm$core$Platform$Cmd$none);
				case 1:
					var _v3 = _v1.a;
					return A3(
						$author$project$Main$stepThrough,
						$author$project$Main$steps.kw,
						model,
						$author$project$Pages$Login$Handler$init(
							{o: model.o}));
				case 2:
					if (!_v1.b.$) {
						var _v4 = _v1.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.eD,
							model,
							$author$project$Pages$Overview$Handler$init(
								{o: model.o}));
					} else {
						break _v1$30;
					}
				case 3:
					if (!_v1.b.$) {
						var _v5 = _v1.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.eO,
							model,
							$author$project$Pages$Recipes$Handler$init(
								{
									n: authorizedAccessWith(userJWT)
								}));
					} else {
						break _v1$30;
					}
				case 4:
					if (!_v1.b.$) {
						var recipeId = _v1.a.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.kg,
							model,
							$author$project$Pages$Ingredients$Handler$init(
								{
									n: authorizedAccessWith(userJWT),
									hk: recipeId
								}));
					} else {
						break _v1$30;
					}
				case 5:
					if (!_v1.b.$) {
						var _v6 = _v1.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.eL,
							model,
							$author$project$Pages$Meals$ProfileChoice$Handler$init(
								{
									n: authorizedAccessWith(userJWT)
								}));
					} else {
						break _v1$30;
					}
				case 6:
					if (!_v1.b.$) {
						var profileId = _v1.a.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.gG,
							model,
							$author$project$Pages$Meals$Editor$Handler$init(
								{
									n: authorizedAccessWith(userJWT),
									bS: profileId
								}));
					} else {
						break _v1$30;
					}
				case 7:
					if (!_v1.b.$) {
						var _v7 = _v1.a;
						var profileId = _v7.a;
						var mealId = _v7.b;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.es,
							model,
							$author$project$Pages$MealEntries$Handler$init(
								{
									n: authorizedAccessWith(userJWT),
									gF: mealId,
									bS: profileId
								}));
					} else {
						break _v1$30;
					}
				case 8:
					if (!_v1.b.$) {
						var _v8 = _v1.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.e7,
							model,
							$author$project$Pages$Statistics$Time$Handler$init(
								{
									n: authorizedAccessWith(userJWT)
								}));
					} else {
						break _v1$30;
					}
				case 9:
					if (!_v1.b.$) {
						var _v9 = _v1.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.dG,
							model,
							$author$project$Pages$Statistics$Food$Search$Handler$init(
								{
									n: authorizedAccessWith(userJWT)
								}));
					} else {
						break _v1$30;
					}
				case 10:
					if (!_v1.b.$) {
						var foodId = _v1.a.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.e$,
							model,
							$author$project$Pages$Statistics$Food$Select$Handler$init(
								{
									n: authorizedAccessWith(userJWT),
									gd: foodId
								}));
					} else {
						break _v1$30;
					}
				case 11:
					if (!_v1.b.$) {
						var _v10 = _v1.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.eZ,
							model,
							$author$project$Pages$Statistics$ComplexFood$Search$Handler$init(
								{
									n: authorizedAccessWith(userJWT)
								}));
					} else {
						break _v1$30;
					}
				case 12:
					if (!_v1.b.$) {
						var complexFoodId = _v1.a.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.e_,
							model,
							$author$project$Pages$Statistics$ComplexFood$Select$Handler$init(
								{
									n: authorizedAccessWith(userJWT),
									fN: complexFoodId
								}));
					} else {
						break _v1$30;
					}
				case 13:
					if (!_v1.b.$) {
						var _v11 = _v1.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.e5,
							model,
							$author$project$Pages$Statistics$Recipe$Search$Handler$init(
								{
									n: authorizedAccessWith(userJWT)
								}));
					} else {
						break _v1$30;
					}
				case 14:
					if (!_v1.b.$) {
						var recipeId = _v1.a.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.e6,
							model,
							$author$project$Pages$Statistics$Recipe$Select$Handler$init(
								{
									n: authorizedAccessWith(userJWT),
									hk: recipeId
								}));
					} else {
						break _v1$30;
					}
				case 15:
					if (!_v1.b.$) {
						var _v12 = _v1.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.e0,
							model,
							$author$project$Pages$Statistics$Meal$ProfileChoice$Handler$init(
								{
									n: authorizedAccessWith(userJWT)
								}));
					} else {
						break _v1$30;
					}
				case 16:
					if (!_v1.b.$) {
						var profileId = _v1.a.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.e1,
							model,
							$author$project$Pages$Statistics$Meal$Search$Handler$init(
								{
									n: authorizedAccessWith(userJWT),
									bS: profileId
								}));
					} else {
						break _v1$30;
					}
				case 17:
					if (!_v1.b.$) {
						var _v13 = _v1.a;
						var profileId = _v13.a;
						var mealId = _v13.b;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.e2,
							model,
							$author$project$Pages$Statistics$Meal$Select$Handler$init(
								{
									n: authorizedAccessWith(userJWT),
									gF: mealId,
									bS: profileId
								}));
					} else {
						break _v1$30;
					}
				case 18:
					if (!_v1.b.$) {
						var _v14 = _v1.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.e4,
							model,
							$author$project$Pages$Statistics$RecipeOccurrences$ProfileChoice$Handler$init(
								{
									n: authorizedAccessWith(userJWT)
								}));
					} else {
						break _v1$30;
					}
				case 19:
					if (!_v1.b.$) {
						var profileId = _v1.a.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.e3,
							model,
							$author$project$Pages$Statistics$RecipeOccurrences$Search$Handler$init(
								{
									n: authorizedAccessWith(userJWT),
									bS: profileId
								}));
					} else {
						break _v1$30;
					}
				case 20:
					if (!_v1.b.$) {
						var _v15 = _v1.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.eR,
							model,
							$author$project$Pages$ReferenceMaps$Handler$init(
								{
									n: authorizedAccessWith(userJWT)
								}));
					} else {
						break _v1$30;
					}
				case 21:
					if (!_v1.b.$) {
						var referenceMapId = _v1.a.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.dr,
							model,
							$author$project$Pages$ReferenceEntries$Handler$init(
								{
									n: authorizedAccessWith(userJWT),
									lN: referenceMapId
								}));
					} else {
						break _v1$30;
					}
				case 22:
					var _v16 = _v1.a;
					return A3(
						$author$project$Main$stepThrough,
						$author$project$Main$steps.eU,
						model,
						$author$project$Pages$Registration$Request$Handler$init(
							{o: model.o}));
				case 23:
					var _v17 = _v1.a;
					var userIdentifier = _v17.a;
					var jwt = _v17.b;
					return A3(
						$author$project$Main$stepThrough,
						$author$project$Main$steps.d6,
						model,
						$author$project$Pages$Registration$Confirm$Handler$init(
							{o: model.o, lS: jwt, fe: userIdentifier}));
				case 24:
					if (!_v1.b.$) {
						var _v18 = _v1.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.ff,
							model,
							$author$project$Pages$UserSettings$Handler$init(
								{
									n: authorizedAccessWith(userJWT)
								}));
					} else {
						break _v1$30;
					}
				case 25:
					var _v19 = _v1.a;
					var userIdentifier = _v19.a;
					var jwt = _v19.b;
					return A3(
						$author$project$Main$stepThrough,
						$author$project$Main$steps.jr,
						model,
						$author$project$Pages$Deletion$Handler$init(
							{o: model.o, js: jwt, fe: userIdentifier}));
				case 26:
					var _v20 = _v1.a;
					return A3(
						$author$project$Main$stepThrough,
						$author$project$Main$steps.eT,
						model,
						$author$project$Pages$Recovery$Request$Handler$init(
							{o: model.o}));
				case 27:
					var _v21 = _v1.a;
					var userIdentifier = _v21.a;
					var jwt = _v21.b;
					return A3(
						$author$project$Main$stepThrough,
						$author$project$Main$steps.d5,
						model,
						$author$project$Pages$Recovery$Confirm$Handler$init(
							{o: model.o, lK: jwt, fe: userIdentifier}));
				case 28:
					if (!_v1.b.$) {
						var _v22 = _v1.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.d3,
							model,
							$author$project$Pages$ComplexFoods$Handler$init(
								{
									n: authorizedAccessWith(userJWT)
								}));
					} else {
						break _v1$30;
					}
				default:
					if (!_v1.b.$) {
						var _v23 = _v1.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.eM,
							model,
							$author$project$Pages$Profiles$Handler$init(
								{
									n: authorizedAccessWith(userJWT)
								}));
					} else {
						break _v1$30;
					}
			}
		}
		return A3(
			$author$project$Main$stepThrough,
			$author$project$Main$steps.kw,
			model,
			$author$project$Pages$Login$Handler$init(
				{o: model.o}));
	}
};
var $arturopala$elm_monocle$Monocle$Lens$Lens = F2(
	function (get, set) {
		return {jY: get, eW: set};
	});
var $author$project$Main$lenses = {
	aI: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.aI;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{aI: b});
			})),
	W: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.W;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{W: b});
			})),
	N: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.N;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{N: b});
			}))
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.hi;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.ge,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.lB,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.g9,
					_Utils_ap(http, url.gj)),
				url.g7)));
};
var $author$project$Util$EditState$View = function (a) {
	return {$: 0, a: a};
};
var $author$project$Util$Editing$asView = function (element) {
	return {
		J: $author$project$Util$EditState$View(false),
		ln: element
	};
};
var $author$project$Pages$Util$PaginationSettings$initial = {jg: 1, bG: 25};
var $author$project$Pages$Util$Choice$Pagination$initial = {i$: $author$project$Pages$Util$PaginationSettings$initial, jD: $author$project$Pages$Util$PaginationSettings$initial};
var $author$project$Util$DictList$DictList = $elm$core$Basics$identity;
var $author$project$Util$DictList$fromList = $elm$core$Basics$identity;
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$Util$DictList$toList = function (_v0) {
	var kvs = _v0;
	return kvs;
};
var $author$project$Util$DictList$map = function (f) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Util$DictList$toList,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map(
				$elm$core$Tuple$mapSecond(f)),
			$author$project$Util$DictList$fromList));
};
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$Pages$Util$Choice$Page$initialToMain = function (i) {
	return A3(
		$elm$core$Maybe$map2,
		F2(
			function (elements, choices) {
				return {
					i$: A2($author$project$Util$DictList$map, $author$project$Util$Editing$asView, choices),
					i0: '',
					jD: A2($author$project$Util$DictList$map, $author$project$Util$Editing$asView, elements),
					jE: '',
					W: i.W,
					lt: $author$project$Pages$Util$Choice$Pagination$initial,
					eG: i.eG
				};
			}),
		i.jD,
		i.i$);
};
var $author$project$Pages$ComplexFoods$Page$initialToMain = function (i) {
	return A2(
		$elm$core$Maybe$map,
		function (foods) {
			return {jS: foods, W: i.W};
		},
		$author$project$Pages$Util$Choice$Page$initialToMain(i.jS));
};
var $author$project$Pages$ComplexFoods$Page$lenses = {
	ki: {
		jS: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.jS;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{jS: b});
				}))
	},
	kz: {
		jS: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.jS;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{jS: b});
				}))
	}
};
var $author$project$Pages$View$Tristate$Error = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$View$Tristate$asInitial = function (t) {
	var _v0 = t.bU;
	if (!_v0.$) {
		var initial = _v0.a;
		return $elm$core$Maybe$Just(initial);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$View$Tristate$fromInitToMain = F2(
	function (_with, t) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			t,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pages$View$Tristate$Main,
				$author$project$Pages$View$Tristate$Model(t.o)),
			A2(
				$elm$core$Maybe$andThen,
				_with,
				$author$project$Pages$View$Tristate$asInitial(t)));
	});
var $arturopala$elm_monocle$Monocle$Optional$Optional = F2(
	function (getOption, set) {
		return {jZ: getOption, eW: set};
	});
var $author$project$Pages$View$Tristate$asError = function (t) {
	var _v0 = t.bU;
	if (_v0.$ === 2) {
		var errorState = _v0.a;
		return $elm$core$Maybe$Just(errorState.V);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$View$Tristate$asMain = function (t) {
	var _v0 = t.bU;
	if (_v0.$ === 1) {
		var main = _v0.a;
		return $elm$core$Maybe$Just(main);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$View$Tristate$lenses = {
	f6: A2(
		$arturopala$elm_monocle$Monocle$Optional$Optional,
		$author$project$Pages$View$Tristate$asError,
		F2(
			function (b, a) {
				var _v0 = a.bU;
				if (_v0.$ === 2) {
					var errorState = _v0.a;
					return A2(
						$author$project$Pages$View$Tristate$Model,
						a.o,
						$author$project$Pages$View$Tristate$Error(
							_Utils_update(
								errorState,
								{V: b})));
				} else {
					return a;
				}
			})),
	ki: A2(
		$arturopala$elm_monocle$Monocle$Optional$Optional,
		$author$project$Pages$View$Tristate$asInitial,
		F2(
			function (b, a) {
				var _v1 = a.bU;
				if (!_v1.$) {
					return A2(
						$author$project$Pages$View$Tristate$Model,
						a.o,
						$author$project$Pages$View$Tristate$Initial(b));
				} else {
					return a;
				}
			})),
	kz: A2(
		$arturopala$elm_monocle$Monocle$Optional$Optional,
		$author$project$Pages$View$Tristate$asMain,
		F2(
			function (b, a) {
				var _v2 = a.bU;
				if (_v2.$ === 1) {
					return A2(
						$author$project$Pages$View$Tristate$Model,
						a.o,
						$author$project$Pages$View$Tristate$Main(b));
				} else {
					return a;
				}
			}))
};
var $author$project$Pages$View$Tristate$fold = F2(
	function (fs, t) {
		var _v0 = t.bU;
		switch (_v0.$) {
			case 0:
				var initial = _v0.a;
				return fs.lc(initial);
			case 1:
				var main = _v0.a;
				return fs.ld(main);
			default:
				var errorState = _v0.a;
				return fs.lb(errorState);
		}
	});
var $author$project$Pages$View$TristateUtil$subModelWith = F2(
	function (ps, model) {
		return {
			o: model.o,
			bU: A2(
				$author$project$Pages$View$Tristate$fold,
				{
					lb: function (es) {
						return $author$project$Pages$View$Tristate$Error(
							{
								V: es.V,
								df: A2($elm$core$Maybe$map, ps.eq.jY, es.df)
							});
					},
					lc: A2($elm$core$Basics$composeR, ps.gq.jY, $author$project$Pages$View$Tristate$Initial),
					ld: A2($elm$core$Basics$composeR, ps.eq.jY, $author$project$Pages$View$Tristate$Main)
				},
				model)
		};
	});
var $author$project$Pages$View$TristateUtil$updateFromSubModel = F3(
	function (ps, msg, model) {
		var subModelOf = $author$project$Pages$View$TristateUtil$subModelWith(
			{gq: ps.kj, eq: ps.kA});
		var _v0 = A2(
			ps.mM,
			msg,
			subModelOf(model));
		var subModel = _v0.a;
		var subModelCmd = _v0.b;
		var newModel = function () {
			var _v1 = _Utils_Tuple2(model.bU, subModel.bU);
			_v1$3:
			while (true) {
				switch (_v1.b.$) {
					case 0:
						if (!_v1.a.$) {
							var i = _v1.a.a;
							var subModelInitial = _v1.b.a;
							return A2(
								$author$project$Pages$View$Tristate$fromInitToMain,
								ps.jW,
								A2(
									$author$project$Pages$View$Tristate$createInitial,
									model.o,
									A2(ps.kj.eW, subModelInitial, i)));
						} else {
							break _v1$3;
						}
					case 1:
						if (_v1.a.$ === 1) {
							var m = _v1.a.a;
							var subModelMain = _v1.b.a;
							return A2(
								$author$project$Pages$View$Tristate$createMain,
								model.o,
								A2(ps.kA.eW, subModelMain, m));
						} else {
							break _v1$3;
						}
					default:
						var subModelError = _v1.b.a;
						return {
							o: model.o,
							bU: $author$project$Pages$View$Tristate$Error(
								{
									V: subModelError.V,
									df: $author$project$Pages$View$Tristate$lenses.kz.jZ(model)
								})
						};
				}
			}
			return model;
		}();
		var newCmd = A2($elm$core$Platform$Cmd$map, ps.mC, subModelCmd);
		return _Utils_Tuple2(newModel, newCmd);
	});
var $author$project$Pages$Util$Choice$Page$GotCreateResponse = function (a) {
	return {$: 16, a: a};
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $danyx23$elm_uuid$Uuid$encode = A2($elm$core$Basics$composeR, $danyx23$elm_uuid$Uuid$toString, $elm$json$Json$Encode$string);
var $elm$json$Json$Encode$float = _Json_wrap;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Api$Types$ComplexFoodCreation$encoderComplexFoodCreation = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'recipeId',
				$danyx23$elm_uuid$Uuid$encode(obj.hk)),
				_Utils_Tuple2(
				'amountGrams',
				$elm$json$Json$Encode$float(obj.fq)),
				_Utils_Tuple2(
				'amountMilliLitres',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$float, obj.fr)))
			]));
};
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $author$project$Pages$ComplexFoods$Foods$Requests$createComplexFood = F2(
	function (authorizedAccess, complexFoodCreation) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$complexFoods.ae,
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$ComplexFoodCreation$encoderComplexFoodCreation(complexFoodCreation)),
				cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$Util$Choice$Page$GotCreateResponse, $author$project$Api$Types$ComplexFood$decoderComplexFood)
			});
	});
var $author$project$Pages$Util$Choice$Page$GotDeleteResponse = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Util$HttpUtil$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		function (response) {
			switch (response.$) {
				case 0:
					var url = response.a;
					return $elm$core$Result$Err(
						$author$project$Util$HttpUtil$BadUrl(url));
				case 1:
					return $elm$core$Result$Err($author$project$Util$HttpUtil$Timeout);
				case 2:
					return $elm$core$Result$Err($author$project$Util$HttpUtil$NetworkError);
				case 3:
					var body = response.b;
					return $elm$core$Result$Err(
						$author$project$Util$HttpUtil$BadBody(body));
				default:
					return $elm$core$Result$Ok(0);
			}
		});
};
var $author$project$Pages$ComplexFoods$Foods$Requests$deleteComplexFood = F2(
	function (authorizedAccess, complexFoodId) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$complexFoods.af(complexFoodId),
			{
				iO: $elm$http$Http$emptyBody,
				cz: $author$project$Util$HttpUtil$expectWhatever(
					$author$project$Pages$Util$Choice$Page$GotDeleteResponse(complexFoodId))
			});
	});
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$Pages$Util$ValidatedInput$lenses = {
	mx: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.mx;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{mx: b});
			})),
	ig: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.ig;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{ig: b});
			}))
};
var $author$project$Pages$Util$ValidatedInput$partialFloat = function (str) {
	return ($elm$core$List$length(
		A2($elm$core$String$split, '.', str)) <= 2) && A2(
		$elm$core$String$all,
		function (c) {
			return (c === '.') || $elm$core$Char$isDigit(c);
		},
		str);
};
var $elm$core$String$toFloat = _String_toFloat;
var $author$project$Pages$Util$ValidatedInput$maybePositive = {
	cL: $elm$core$Maybe$Nothing,
	bi: function (str) {
		return $elm$core$String$isEmpty(str) ? $elm$core$Result$Ok($elm$core$Maybe$Nothing) : A2(
			$elm$core$Result$map,
			$elm$core$Maybe$Just,
			A2(
				$elm$core$Result$fromMaybe,
				'Error',
				A2(
					$elm_community$maybe_extra$Maybe$Extra$filter,
					function (x) {
						return x > 0;
					},
					$elm$core$String$toFloat(str))));
	},
	bP: $author$project$Pages$Util$ValidatedInput$partialFloat,
	mx: '',
	ig: $elm$core$Maybe$Nothing
};
var $author$project$Pages$Util$ValidatedInput$positive = {
	cL: 1,
	bi: A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toFloat,
		A2(
			$elm$core$Basics$composeR,
			$elm_community$maybe_extra$Maybe$Extra$filter(
				function (x) {
					return x > 0;
				}),
			$elm$core$Result$fromMaybe('Error'))),
	bP: $author$project$Pages$Util$ValidatedInput$partialFloat,
	mx: '1',
	ig: 1
};
var $author$project$Pages$ComplexFoods$ComplexFoodUpdateClientInput$from = function (complexFood) {
	return {
		fq: A2(
			$author$project$Pages$Util$ValidatedInput$lenses.mx.eW,
			$elm$core$String$fromFloat(complexFood.fq),
			A2($author$project$Pages$Util$ValidatedInput$lenses.ig.eW, complexFood.fq, $author$project$Pages$Util$ValidatedInput$positive)),
		fr: A2(
			$author$project$Pages$Util$ValidatedInput$lenses.mx.eW,
			A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$String$fromFloat, complexFood.fr),
			A2($author$project$Pages$Util$ValidatedInput$lenses.ig.eW, complexFood.fr, $author$project$Pages$Util$ValidatedInput$maybePositive))
	};
};
var $author$project$Pages$ComplexFoods$ComplexFoodCreationClientInput$to = function (input) {
	return {fq: input.fq.ig, fr: input.fr.ig, hk: input.hk};
};
var $author$project$Pages$ComplexFoods$ComplexFoodUpdateClientInput$to = function (input) {
	return {fq: input.fq.ig, fr: input.fr.ig};
};
var $author$project$Pages$Util$Choice$Page$GotSaveEditResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Types$ComplexFoodUpdate$encoderComplexFoodUpdate = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'amountGrams',
				$elm$json$Json$Encode$float(obj.fq)),
				_Utils_Tuple2(
				'amountMilliLitres',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$float, obj.fr)))
			]));
};
var $author$project$Pages$ComplexFoods$Foods$Requests$updateComplexFood = F3(
	function (authorizedAccess, complexFoodId, complexFoodUpdate) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$complexFoods.ac(complexFoodId),
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$ComplexFoodUpdate$encoderComplexFoodUpdate(complexFoodUpdate)),
				cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$Util$Choice$Page$GotSaveEditResponse, $author$project$Api$Types$ComplexFood$decoderComplexFood)
			});
	});
var $arturopala$elm_monocle$Monocle$Lens$modify = F2(
	function (lens, f) {
		var mf = function (a) {
			return function (b) {
				return A2(lens.eW, b, a);
			}(
				f(
					lens.jY(a)));
		};
		return mf;
	});
var $arturopala$elm_monocle$Monocle$Compose$lensWithOptional = F2(
	function (inner, outer) {
		var set = function (c) {
			return A2(
				$arturopala$elm_monocle$Monocle$Lens$modify,
				outer,
				inner.eW(c));
		};
		var getOption = A2($elm$core$Basics$composeR, outer.jY, inner.jZ);
		return A2($arturopala$elm_monocle$Monocle$Optional$Optional, getOption, set);
	});
var $author$project$Util$EditState$setToggle = F2(
	function (value, editState) {
		if (!editState.$) {
			return $author$project$Util$EditState$View(value);
		} else {
			var e = editState;
			return e;
		}
	});
var $author$project$Util$EditState$Update = function (a) {
	return {$: 1, a: a};
};
var $author$project$Util$EditState$setUpdate = F2(
	function (update, editState) {
		if (editState.$ === 1) {
			return $author$project$Util$EditState$Update(update);
		} else {
			var e = editState;
			return e;
		}
	});
var $author$project$Util$EditState$toToggle = function (editState) {
	if (!editState.$) {
		var toggle = editState.a;
		return $elm$core$Maybe$Just(toggle);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Util$EditState$toUpdate = function (editState) {
	if (editState.$ === 1) {
		var update = editState.a;
		return $elm$core$Maybe$Just(update);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Util$EditState$lenses = {
	h2: A2($arturopala$elm_monocle$Monocle$Optional$Optional, $author$project$Util$EditState$toToggle, $author$project$Util$EditState$setToggle),
	ac: A2($arturopala$elm_monocle$Monocle$Optional$Optional, $author$project$Util$EditState$toUpdate, $author$project$Util$EditState$setUpdate)
};
var $author$project$Util$Editing$lenses = function () {
	var editState = A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.J;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{J: b});
			}));
	return {
		J: editState,
		ln: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.ln;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{ln: b});
				})),
		ac: A2($arturopala$elm_monocle$Monocle$Compose$lensWithOptional, $author$project$Util$EditState$lenses.ac, editState)
	};
}();
var $author$project$Util$EditState$unpack = F2(
	function (fs, editState) {
		switch (editState.$) {
			case 0:
				var showControls = editState.a;
				return fs.lk(showControls);
			case 1:
				var update = editState.a;
				return fs.lh(update);
			default:
				return fs.la;
		}
	});
var $author$project$Util$Editing$asViewWithElement = function (element) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Util$Editing$lenses.ln.eW(element),
		A2(
			$arturopala$elm_monocle$Monocle$Lens$modify,
			$author$project$Util$Editing$lenses.J,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Util$EditState$unpack(
					{
						la: true,
						lh: $elm$core$Basics$always(true),
						lk: $elm$core$Basics$identity
					}),
				$author$project$Util$EditState$View)));
};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm_community$list_extra$List$Extra$filterNot = F2(
	function (pred, list) {
		return A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, pred),
			list);
	});
var $author$project$Util$DictList$remove = function (key) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Util$DictList$toList,
		A2(
			$elm$core$Basics$composeR,
			$elm_community$list_extra$List$Extra$filterNot(
				function (_v0) {
					var k = _v0.a;
					return _Utils_eq(k, key);
				}),
			$author$project$Util$DictList$fromList));
};
var $author$project$Util$LensUtil$deleteAtId = F2(
	function (id, lens) {
		return A2(
			$arturopala$elm_monocle$Monocle$Lens$modify,
			lens,
			$author$project$Util$DictList$remove(id));
	});
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $author$project$Util$DictList$get = function (key) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Util$DictList$toList,
		A2(
			$elm$core$Basics$composeR,
			$elm_community$list_extra$List$Extra$find(
				function (_v0) {
					var k = _v0.a;
					return _Utils_eq(k, key);
				}),
			$elm$core$Maybe$map($elm$core$Tuple$second)));
};
var $author$project$Util$DictList$insert = F2(
	function (key, value) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Util$DictList$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm_community$list_extra$List$Extra$filterNot(
					function (_v0) {
						var k = _v0.a;
						return _Utils_eq(k, key);
					}),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$cons(
						_Utils_Tuple2(key, value)),
					$author$project$Util$DictList$fromList)));
	});
var $author$project$Util$LensUtil$dictByKey = function (k) {
	return {
		jZ: $author$project$Util$DictList$get(k),
		eW: $author$project$Util$DictList$insert(k)
	};
};
var $author$project$Pages$View$Tristate$foldMain = F2(
	function (c, f) {
		return $author$project$Pages$View$Tristate$fold(
			{
				lb: $elm$core$Basics$always(c),
				lc: $elm$core$Basics$always(c),
				ld: f
			});
	});
var $author$project$Util$DictList$fromListWithKey = function (keyOf) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			function (v) {
				return _Utils_Tuple2(
					keyOf(v),
					v);
			}),
		$author$project$Util$DictList$fromList);
};
var $author$project$Util$LensUtil$insertAtId = F2(
	function (id, lens) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Util$DictList$insert(id),
			$arturopala$elm_monocle$Monocle$Lens$modify(lens));
	});
var $arturopala$elm_monocle$Monocle$Lens$compose = F2(
	function (outer, inner) {
		var set = F2(
			function (c, a) {
				return function (b) {
					return A2(outer.eW, b, a);
				}(
					A2(
						inner.eW,
						c,
						outer.jY(a)));
			});
		return A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			A2($elm$core$Basics$composeR, outer.jY, inner.jY),
			set);
	});
var $arturopala$elm_monocle$Monocle$Compose$lensWithLens = F2(
	function (inner, outer) {
		return A2($arturopala$elm_monocle$Monocle$Lens$compose, outer, inner);
	});
var $author$project$Pages$Util$Choice$Page$lenses = {
	ki: {
		i$: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.i$;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{i$: b});
				})),
		jD: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.jD;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{jD: b});
				}))
	},
	kz: {
		i$: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.i$;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{i$: b});
				})),
		i0: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.i0;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{i0: b});
				})),
		jD: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.jD;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{jD: b});
				})),
		jE: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.jE;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{jE: b});
				})),
		lt: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lt;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lt: b});
				}))
	}
};
var $author$project$Pages$Util$Choice$Pagination$lenses = {
	i$: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.i$;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{i$: b});
			})),
	jD: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.jD;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{jD: b});
			}))
};
var $author$project$Pages$View$Tristate$mapMain = F2(
	function (f, t) {
		return A2(
			$author$project$Pages$View$Tristate$fold,
			{
				lb: $elm$core$Basics$always(t),
				lc: $elm$core$Basics$always(t),
				ld: A2(
					$elm$core$Basics$composeR,
					f,
					$author$project$Pages$View$Tristate$createMain(t.o))
			},
			t);
	});
var $arturopala$elm_monocle$Monocle$Optional$flip = F3(
	function (f, b, a) {
		return A2(f, a, b);
	});
var $arturopala$elm_monocle$Monocle$Optional$modifyOption = F2(
	function (opt, fx) {
		var mf = function (a) {
			return A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					fx,
					A2($arturopala$elm_monocle$Monocle$Optional$flip, opt.eW, a)),
				opt.jZ(a));
		};
		return mf;
	});
var $arturopala$elm_monocle$Monocle$Optional$modify = F2(
	function (opt, fx) {
		var mf = function (a) {
			return A2(
				$elm$core$Maybe$withDefault,
				a,
				A3($arturopala$elm_monocle$Monocle$Optional$modifyOption, opt, fx, a));
		};
		return mf;
	});
var $author$project$Util$LensUtil$updateById = function (id) {
	return A2(
		$elm$core$Basics$composeR,
		$arturopala$elm_monocle$Monocle$Compose$lensWithOptional(
			$author$project$Util$LensUtil$dictByKey(id)),
		$arturopala$elm_monocle$Monocle$Optional$modify);
};
var $author$project$Pages$Util$Choice$Handler$mapElementStateById = function (elementId) {
	return A2(
		$elm$core$Basics$composeR,
		A2($author$project$Util$LensUtil$updateById, elementId, $author$project$Pages$Util$Choice$Page$lenses.kz.jD),
		$author$project$Pages$View$Tristate$mapMain);
};
var $author$project$Pages$View$Tristate$mapInitial = F2(
	function (f, t) {
		return A2(
			$author$project$Pages$View$Tristate$fold,
			{
				lb: $elm$core$Basics$always(t),
				lc: A2(
					$elm$core$Basics$composeR,
					f,
					$author$project$Pages$View$Tristate$createInitial(t.o)),
				ld: $elm$core$Basics$always(t)
			},
			t);
	});
var $arturopala$elm_monocle$Monocle$Optional$compose = F2(
	function (outer, inner) {
		var set = F2(
			function (c, a) {
				return A2(
					$elm$core$Maybe$withDefault,
					a,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							inner.eW(c),
							A2($arturopala$elm_monocle$Monocle$Optional$flip, outer.eW, a)),
						outer.jZ(a)));
			});
		var getOption = function (a) {
			var _v0 = outer.jZ(a);
			if (!_v0.$) {
				var x = _v0.a;
				return inner.jZ(x);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		return A2($arturopala$elm_monocle$Monocle$Optional$Optional, getOption, set);
	});
var $arturopala$elm_monocle$Monocle$Compose$optionalWithOptional = F2(
	function (inner, outer) {
		return A2($arturopala$elm_monocle$Monocle$Optional$compose, outer, inner);
	});
var $author$project$Pages$Util$PaginationSettings$lenses = {
	jg: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.jg;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{jg: b});
			})),
	bG: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.bG;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{bG: b});
			}))
};
var $author$project$Pages$Util$PaginationSettings$setSearchStringAndReset = F2(
	function (ls, searchString) {
		return A2(
			$elm$core$Basics$composeR,
			ls.hA.eW(searchString),
			A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$PaginationSettings$lenses.jg, ls.g1).eW(1));
	});
var $author$project$Util$EditState$Delete = {$: 2};
var $author$project$Util$Editing$toDelete = $author$project$Util$Editing$lenses.J.eW($author$project$Util$EditState$Delete);
var $author$project$Util$HttpUtil$errorToExplanation = function (error) {
	switch (error.$) {
		case 0:
			var string = error.a;
			return {iV: 'BadUrl: ' + string, hc: 'Check address. If the error persists, please contact an administrator.', bj: false, ms: true};
		case 1:
			return {iV: 'Timeout', hc: 'Try again later. If the error persists, please contact an administrator.', bj: false, ms: true};
		case 2:
			return {iV: 'Timeout', hc: 'Try again later. If the error persists, please contact an administrator.', bj: false, ms: true};
		case 3:
			var code = error.a;
			var explanation = error.b;
			return {
				iV: 'BadStatus: ' + ($elm$core$String$fromInt(code) + (' - ' + explanation)),
				hc: (code === 401) ? 'Please log in again to continue.' : '',
				bj: code === 401,
				ms: true
			};
		default:
			var string = error.a;
			return {iV: 'Bad body: ' + string, hc: '', bj: false, ms: true};
	}
};
var $author$project$Pages$View$Tristate$toError = F2(
	function (model, error) {
		var errorExplanation = $author$project$Util$HttpUtil$errorToExplanation(error);
		return A2(
			$author$project$Pages$View$Tristate$fold,
			{
				lb: function (errorState) {
					return A2(
						$author$project$Pages$View$Tristate$Model,
						model.o,
						$author$project$Pages$View$Tristate$Error(
							_Utils_update(
								errorState,
								{V: errorExplanation})));
				},
				lc: function (_v0) {
					return A2(
						$author$project$Pages$View$Tristate$Model,
						model.o,
						$author$project$Pages$View$Tristate$Error(
							{V: errorExplanation, df: $elm$core$Maybe$Nothing}));
				},
				ld: function (main) {
					return A2(
						$author$project$Pages$View$Tristate$Model,
						model.o,
						$author$project$Pages$View$Tristate$Error(
							{
								V: errorExplanation,
								df: $elm$core$Maybe$Just(main)
							}));
				}
			},
			model);
	});
var $author$project$Util$Editing$toUpdate = F2(
	function (to, editing) {
		return A2(
			$author$project$Util$Editing$lenses.J.eW,
			$author$project$Util$EditState$Update(
				to(editing.ln)),
			editing);
	});
var $author$project$Util$Editing$toView = $author$project$Util$Editing$lenses.J.eW(
	$author$project$Util$EditState$View(false));
var $author$project$Util$Editing$toggleControls = function (editing) {
	return A3(
		$arturopala$elm_monocle$Monocle$Lens$modify,
		$author$project$Util$Editing$lenses.J,
		$author$project$Util$EditState$unpack(
			{
				la: $author$project$Util$EditState$View(false),
				lh: function (_v0) {
					return $author$project$Util$EditState$View(false);
				},
				lk: A2($elm$core$Basics$composeR, $elm$core$Basics$not, $author$project$Util$EditState$View)
			}),
		editing);
};
var $elm_community$result_extra$Result$Extra$unpack = F3(
	function (errFunc, okFunc, result) {
		if (!result.$) {
			var ok = result.a;
			return okFunc(ok);
		} else {
			var err = result.a;
			return errFunc(err);
		}
	});
var $author$project$Pages$Util$Choice$Handler$updateLogic = F3(
	function (ps, msg, model) {
		var updateCreation = function (elementCreationClientInput) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					A3(
						$author$project$Util$LensUtil$updateById,
						ps.iY(elementCreationClientInput),
						$author$project$Pages$Util$Choice$Page$lenses.kz.i$,
						$author$project$Util$Editing$lenses.ac.eW(elementCreationClientInput)),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var toggleControls = function (elementId) {
			return _Utils_Tuple2(
				A3($author$project$Pages$Util$Choice$Handler$mapElementStateById, elementId, $author$project$Util$Editing$toggleControls, model),
				$elm$core$Platform$Cmd$none);
		};
		var toggleChoiceControls = function (choiceId) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					A3($author$project$Util$LensUtil$updateById, choiceId, $author$project$Pages$Util$Choice$Page$lenses.kz.i$, $author$project$Util$Editing$toggleControls),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var setPagination = function (pagination) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					$author$project$Pages$Util$Choice$Page$lenses.kz.lt.eW(pagination),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var setElementsSearchString = function (string) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					A2(
						$author$project$Pages$Util$PaginationSettings$setSearchStringAndReset,
						{
							g1: A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$Choice$Pagination$lenses.jD, $author$project$Pages$Util$Choice$Page$lenses.kz.lt),
							hA: $author$project$Pages$Util$Choice$Page$lenses.kz.jE
						},
						string),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var setChoicesSearchString = function (string) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					A2(
						$author$project$Pages$Util$PaginationSettings$setSearchStringAndReset,
						{
							g1: A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$Choice$Pagination$lenses.i$, $author$project$Pages$Util$Choice$Page$lenses.kz.lt),
							hA: $author$project$Pages$Util$Choice$Page$lenses.kz.i0
						},
						string),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var selectChoice = function (choice) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					function (main) {
						return A4(
							$author$project$Util$LensUtil$updateById,
							ps.j6(choice),
							$author$project$Pages$Util$Choice$Page$lenses.kz.i$,
							$author$project$Util$Editing$toUpdate(ps.mB),
							main);
					},
					model),
				$elm$core$Platform$Cmd$none);
		};
		var saveEdit = F2(
			function (elementId, elementUpdateClientInput) {
				return _Utils_Tuple2(
					model,
					A3(
						$author$project$Pages$View$Tristate$foldMain,
						$elm$core$Platform$Cmd$none,
						function (main) {
							return A4(
								ps.l1,
								{o: model.o, W: main.W},
								main.eG,
								elementId,
								elementUpdateClientInput);
						},
						model));
			});
		var requestDelete = function (elementId) {
			return _Utils_Tuple2(
				A3($author$project$Pages$Util$Choice$Handler$mapElementStateById, elementId, $author$project$Util$Editing$toDelete, model),
				$elm$core$Platform$Cmd$none);
		};
		var gotSaveEditResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (element) {
						return A3(
							$author$project$Pages$Util$Choice$Handler$mapElementStateById,
							ps.j7(element),
							$author$project$Util$Editing$asViewWithElement(element),
							model);
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		var gotFetchElementsResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (elements) {
						return A2(
							$author$project$Pages$View$Tristate$mapInitial,
							$author$project$Pages$Util$Choice$Page$lenses.ki.jD.eW(
								$elm$core$Maybe$Just(
									A2($author$project$Util$DictList$fromListWithKey, ps.j7, elements))),
							model);
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		var gotFetchChoicesResponse = function (result) {
			return A3(
				$elm_community$result_extra$Result$Extra$unpack,
				function (error) {
					return _Utils_Tuple2(
						A2($author$project$Pages$View$Tristate$toError, model, error),
						$elm$core$Platform$Cmd$none);
				},
				function (choices) {
					return _Utils_Tuple2(
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							$author$project$Pages$Util$Choice$Page$lenses.ki.i$.eW(
								$elm$core$Maybe$Just(
									A2($author$project$Util$DictList$fromListWithKey, ps.j6, choices))),
							model),
						ps.mn(choices));
				},
				result);
		};
		var gotDeleteResponse = F2(
			function (elementId, result) {
				return _Utils_Tuple2(
					A3(
						$elm_community$result_extra$Result$Extra$unpack,
						$author$project$Pages$View$Tristate$toError(model),
						$elm$core$Basics$always(
							A2(
								$author$project$Pages$View$Tristate$mapMain,
								A2($author$project$Util$LensUtil$deleteAtId, elementId, $author$project$Pages$Util$Choice$Page$lenses.kz.jD),
								model)),
						result),
					$elm$core$Platform$Cmd$none);
			});
		var gotCreateResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (element) {
						return A2(
							$author$project$Pages$View$Tristate$mapMain,
							A2(
								$elm$core$Basics$composeR,
								A3(
									$author$project$Util$LensUtil$insertAtId,
									ps.j7(element),
									$author$project$Pages$Util$Choice$Page$lenses.kz.jD,
									$author$project$Util$Editing$asView(element)),
								A3(
									$author$project$Util$LensUtil$updateById,
									ps.iZ(element),
									$author$project$Pages$Util$Choice$Page$lenses.kz.i$,
									$author$project$Util$Editing$toView)),
							model);
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		var exitEdit = function (elementId) {
			return _Utils_Tuple2(
				A3($author$project$Pages$Util$Choice$Handler$mapElementStateById, elementId, $author$project$Util$Editing$toView, model),
				$elm$core$Platform$Cmd$none);
		};
		var enterEdit = function (elementId) {
			return _Utils_Tuple2(
				A3(
					$author$project$Pages$Util$Choice$Handler$mapElementStateById,
					elementId,
					$author$project$Util$Editing$toUpdate(ps.mD),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var edit = F2(
			function (elementId, update) {
				return _Utils_Tuple2(
					A3(
						$author$project$Pages$Util$Choice$Handler$mapElementStateById,
						elementId,
						$author$project$Util$Editing$lenses.ac.eW(update),
						model),
					$elm$core$Platform$Cmd$none);
			});
		var deselectChoice = function (choiceId) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					A3($author$project$Util$LensUtil$updateById, choiceId, $author$project$Pages$Util$Choice$Page$lenses.kz.i$, $author$project$Util$Editing$toView),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var create = function (choiceId) {
			return _Utils_Tuple2(
				model,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$andThen,
						function (main) {
							return A2(
								$elm$core$Maybe$map,
								A2(
									ps.je,
									{o: model.o, W: main.W},
									main.eG),
								A2(
									$arturopala$elm_monocle$Monocle$Compose$optionalWithOptional,
									$author$project$Util$Editing$lenses.ac,
									A2(
										$arturopala$elm_monocle$Monocle$Compose$lensWithOptional,
										$author$project$Util$LensUtil$dictByKey(choiceId),
										$author$project$Pages$Util$Choice$Page$lenses.kz.i$)).jZ(main));
						},
						$author$project$Pages$View$Tristate$lenses.kz.jZ(model))));
		};
		var confirmDelete = function (elementId) {
			return _Utils_Tuple2(
				model,
				A3(
					$author$project$Pages$View$Tristate$foldMain,
					$elm$core$Platform$Cmd$none,
					function (main) {
						return A3(
							ps.jp,
							{o: model.o, W: main.W},
							main.eG,
							elementId);
					},
					model));
		};
		var cancelDelete = function (elementId) {
			return _Utils_Tuple2(
				A3($author$project$Pages$Util$Choice$Handler$mapElementStateById, elementId, $author$project$Util$Editing$toView, model),
				$elm$core$Platform$Cmd$none);
		};
		switch (msg.$) {
			case 0:
				var elementId = msg.a;
				var update = msg.b;
				return A2(edit, elementId, update);
			case 1:
				var elementId = msg.a;
				var update = msg.b;
				return A2(saveEdit, elementId, update);
			case 2:
				var result = msg.a;
				return gotSaveEditResponse(result);
			case 3:
				var elementId = msg.a;
				return toggleControls(elementId);
			case 4:
				var elementId = msg.a;
				return enterEdit(elementId);
			case 5:
				var elementId = msg.a;
				return exitEdit(elementId);
			case 6:
				var elementId = msg.a;
				return requestDelete(elementId);
			case 7:
				var elementId = msg.a;
				return confirmDelete(elementId);
			case 8:
				var elementId = msg.a;
				return cancelDelete(elementId);
			case 9:
				var elementId = msg.a;
				var result = msg.b;
				return A2(gotDeleteResponse, elementId, result);
			case 10:
				var result = msg.a;
				return gotFetchElementsResponse(result);
			case 11:
				var result = msg.a;
				return gotFetchChoicesResponse(result);
			case 12:
				var choiceId = msg.a;
				return toggleChoiceControls(choiceId);
			case 13:
				var choice = msg.a;
				return selectChoice(choice);
			case 14:
				var choiceId = msg.a;
				return deselectChoice(choiceId);
			case 15:
				var choiceId = msg.a;
				return create(choiceId);
			case 16:
				var result = msg.a;
				return gotCreateResponse(result);
			case 17:
				var creation = msg.a;
				return updateCreation(creation);
			case 18:
				var pagination = msg.a;
				return setPagination(pagination);
			case 19:
				var string = msg.a;
				return setElementsSearchString(string);
			default:
				var string = msg.a;
				return setChoicesSearchString(string);
		}
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.b);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.c, offset) < 0,
					0,
					{fK: col, h: s0.h, i: s0.i, c: offset, hs: row, b: s0.b});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.c, s.hs, s.fK, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {fK: col, jc: contextStack, hf: problem, hs: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.hs, s.fK, x, s.h));
	});
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.b),
			s.c) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$ExpectingFloat = {$: 5};
var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var $elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {fK: s.fK + (newOffset - s.c), h: s.h, i: s.i, c: newOffset, hs: s.hs, b: s.b};
	});
var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var $elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var $elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			$elm$parser$Parser$Advanced$consumeExp,
			A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2($elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var $elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _v0, s) {
		var endOffset = _v0.a;
		var n = _v0.b;
		if (handler.$ === 1) {
			var x = handler.a;
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.c, startOffset) < 0,
				A2($elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2($elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2($elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.b);
		if (floatOffset < 0) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A4($elm$parser$Parser$Advanced$fromInfo, s.hs, s.fK - (floatOffset + s.c), invalid, s.h));
		} else {
			if (_Utils_eq(s.c, floatOffset)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5($elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.c, intPair, s);
				} else {
					if (floatSettings.$ === 1) {
						var x = floatSettings.a;
						return A2(
							$elm$parser$Parser$Advanced$Bad,
							true,
							A2($elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _v1 = $elm$core$String$toFloat(
							A3($elm$core$String$slice, s.c, floatOffset, s.b));
						if (_v1.$ === 1) {
							return A2(
								$elm$parser$Parser$Advanced$Bad,
								true,
								A2($elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _v1.a;
							return A3(
								$elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2($elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.c, s.b)) {
			var zeroOffset = s.c + 1;
			var baseOffset = zeroOffset + 1;
			return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.b) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.kn,
				c.j$,
				baseOffset,
				A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.b),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.b) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.kn,
				c.g_,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.b),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.b) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.kn,
				c.fy,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.b),
				s) : A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.kn,
				c.f8,
				c.gu,
				c.gb,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.kn,
				c.f8,
				c.gu,
				c.gb,
				A3($elm$parser$Parser$Advanced$consumeBase, 10, s.c, s.b),
				s);
		}
	};
};
var $elm$parser$Parser$Advanced$float = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				fy: $elm$core$Result$Err(invalid),
				f8: expecting,
				gb: $elm$core$Result$Ok($elm$core$Basics$identity),
				j$: $elm$core$Result$Err(invalid),
				gu: $elm$core$Result$Ok($elm$core$Basics$toFloat),
				kn: invalid,
				g_: $elm$core$Result$Err(invalid)
			});
	});
var $elm$parser$Parser$float = A2($elm$parser$Parser$Advanced$float, $elm$parser$Parser$ExpectingFloat, $elm$parser$Parser$ExpectingFloat);
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.c, s.hs, s.fK, s.b);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{fK: newCol, h: s.h, i: s.i, c: newOffset, hs: newRow, b: s.b});
	};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $author$project$Pages$Recipes$Util$gramsParser = A2(
	$elm$parser$Parser$ignorer,
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$float,
			$elm$parser$Parser$chompWhile(
				$elm$core$Basics$eq(' '))),
		$elm$parser$Parser$symbol('g')),
	$elm$parser$Parser$end);
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {fK: col, hf: problem, hs: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.hs, p.fK, p.hf);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{fK: 1, h: _List_Nil, i: 1, c: 0, hs: 1, b: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $author$project$Pages$ComplexFoods$ComplexFoodCreationClientInput$withSuggestion = function (recipe) {
	var modifier = A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$elm$core$Basics$identity,
		function (value) {
			return A2(
				$elm$core$Basics$composeR,
				$author$project$Pages$Util$ValidatedInput$lenses.ig.eW(value),
				$author$project$Pages$Util$ValidatedInput$lenses.mx.eW(
					$elm$core$String$fromFloat(value)));
		},
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$mul(recipe.gY),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					$elm$parser$Parser$run($author$project$Pages$Recipes$Util$gramsParser),
					$elm$core$Result$toMaybe),
				recipe.hF)));
	return {
		fq: modifier($author$project$Pages$Util$ValidatedInput$positive),
		fr: $author$project$Pages$Util$ValidatedInput$maybePositive,
		hk: recipe.gn
	};
};
var $author$project$Pages$ComplexFoods$Foods$Handler$updateLogic = $author$project$Pages$Util$Choice$Handler$updateLogic(
	{
		iY: function ($) {
			return $.hk;
		},
		iZ: function ($) {
			return $.hk;
		},
		je: F2(
			function (authorizedAccess, _v0) {
				return A2(
					$elm$core$Basics$composeR,
					$author$project$Pages$ComplexFoods$ComplexFoodCreationClientInput$to,
					$author$project$Pages$ComplexFoods$Foods$Requests$createComplexFood(authorizedAccess));
			}),
		jp: F2(
			function (authorizedAccess, _v1) {
				return $author$project$Pages$ComplexFoods$Foods$Requests$deleteComplexFood(authorizedAccess);
			}),
		j6: function ($) {
			return $.gn;
		},
		j7: function ($) {
			return $.hk;
		},
		l1: F3(
			function (authorizedAccess, _v2, complexFoodId) {
				return A2(
					$elm$core$Basics$composeR,
					$author$project$Pages$ComplexFoods$ComplexFoodUpdateClientInput$to,
					A2($author$project$Pages$ComplexFoods$Foods$Requests$updateComplexFood, authorizedAccess, complexFoodId));
			}),
		mn: $elm$core$Basics$always($elm$core$Platform$Cmd$none),
		mB: $author$project$Pages$ComplexFoods$ComplexFoodCreationClientInput$withSuggestion,
		mD: $author$project$Pages$ComplexFoods$ComplexFoodUpdateClientInput$from
	});
var $author$project$Pages$ComplexFoods$Handler$updateLogic = F2(
	function (msg, model) {
		var foodsMsg = msg;
		return A3(
			$author$project$Pages$View$TristateUtil$updateFromSubModel,
			{jW: $author$project$Pages$ComplexFoods$Page$initialToMain, kj: $author$project$Pages$ComplexFoods$Page$lenses.ki.jS, kA: $author$project$Pages$ComplexFoods$Page$lenses.kz.jS, mC: $elm$core$Basics$identity, mM: $author$project$Pages$ComplexFoods$Foods$Handler$updateLogic},
			foodsMsg,
			model);
	});
var $elm$browser$Browser$Navigation$reload = _Browser_reload(false);
var $author$project$Pages$View$Tristate$updateWith = F3(
	function (update, msg, model) {
		if (msg.$ === 1) {
			return A2(
				$author$project$Pages$View$Tristate$fold,
				{
					lb: function (errorState) {
						return A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							_Utils_Tuple2(model, $elm$browser$Browser$Navigation$reload),
							function (main) {
								return _Utils_Tuple2(
									A2(
										$author$project$Pages$View$Tristate$Model,
										model.o,
										$author$project$Pages$View$Tristate$Main(main)),
									$elm$core$Platform$Cmd$none);
							},
							errorState.df);
					},
					lc: function (_v1) {
						return _Utils_Tuple2(model, $elm$browser$Browser$Navigation$reload);
					},
					ld: function (_v2) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				},
				model);
		} else {
			var message = msg.a;
			var _v3 = A2(update, message, model);
			var newModel = _v3.a;
			var cmd = _v3.b;
			return _Utils_Tuple2(
				newModel,
				A2($elm$core$Platform$Cmd$map, $author$project$Pages$View$Tristate$Logic, cmd));
		}
	});
var $author$project$Pages$ComplexFoods$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$ComplexFoods$Handler$updateLogic);
var $author$project$Pages$Deletion$Page$GotConfirmResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Deletion$Requests$deleteUser = F2(
	function (configuration, jwt) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			{o: configuration, W: jwt},
			$author$project$Addresses$Backend$users.jr.d4,
			{
				iO: $elm$http$Http$emptyBody,
				cz: $author$project$Util$HttpUtil$expectWhatever($author$project$Pages$Deletion$Page$GotConfirmResponse)
			});
	});
var $author$project$Pages$Deletion$Handler$confirm = function (model) {
	return _Utils_Tuple2(
		model,
		A3(
			$author$project$Pages$View$Tristate$foldMain,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.js;
				},
				$author$project$Pages$Deletion$Requests$deleteUser(model.o)),
			model));
};
var $author$project$Pages$Deletion$Page$Confirmed = 1;
var $author$project$Ports$doDeleteToken = _Platform_outgoingPort(
	'doDeleteToken',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Pages$Deletion$Page$lenses = {
	kz: {
		gK: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.gK;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{gK: b});
				}))
	}
};
var $author$project$Pages$Deletion$Handler$gotConfirmResponse = F2(
	function (model, result) {
		return A3(
			$elm_community$result_extra$Result$Extra$unpack,
			function (error) {
				return _Utils_Tuple2(
					A2($author$project$Pages$View$Tristate$toError, model, error),
					$elm$core$Platform$Cmd$none);
			},
			function (_v0) {
				return _Utils_Tuple2(
					A2(
						$author$project$Pages$View$Tristate$mapMain,
						$author$project$Pages$Deletion$Page$lenses.kz.gK.eW(1),
						model),
					$author$project$Ports$doDeleteToken(0));
			},
			result);
	});
var $author$project$Pages$Deletion$Handler$updateLogic = F2(
	function (msg, model) {
		if (!msg.$) {
			return $author$project$Pages$Deletion$Handler$confirm(model);
		} else {
			var result = msg.a;
			return A2($author$project$Pages$Deletion$Handler$gotConfirmResponse, model, result);
		}
	});
var $author$project$Pages$Deletion$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Deletion$Handler$updateLogic);
var $author$project$Pages$Ingredients$Page$lenses = {
	ki: {
		fO: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.fO;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{fO: b});
				})),
		em: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.em;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{em: b});
				})),
		lD: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lD;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lD: b});
				}))
	},
	kz: {
		fO: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.fO;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{fO: b});
				})),
		jT: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.jT;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{jT: b});
				})),
		em: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.em;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{em: b});
				})),
		lD: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lD;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lD: b});
				}))
	}
};
var $author$project$Pages$Ingredients$Handler$changeFoodsMode = F2(
	function (model, foodsMode) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				$author$project$Pages$Ingredients$Page$lenses.kz.jT.eW(foodsMode),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Ingredients$Page$Plain = 0;
var $author$project$Pages$Util$Parent$Page$initialToMain = function (i) {
	return A2(
		$elm$core$Maybe$map,
		function (parent) {
			return {
				W: i.W,
				g4: $author$project$Util$Editing$asView(parent)
			};
		},
		i.g4);
};
var $elm$core$Maybe$map3 = F4(
	function (func, ma, mb, mc) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					return $elm$core$Maybe$Just(
						A3(func, a, b, c));
				}
			}
		}
	});
var $author$project$Pages$Ingredients$Page$initialToMain = function (i) {
	return A4(
		$elm$core$Maybe$map3,
		F3(
			function (recipe, ingredientsGroup, complexIngredientsGroup) {
				return {fO: complexIngredientsGroup, jT: 0, em: ingredientsGroup, W: i.W, lD: recipe};
			}),
		$author$project$Pages$Util$Parent$Page$initialToMain(i.lD),
		$author$project$Pages$Util$Choice$Page$initialToMain(i.em),
		$author$project$Pages$Util$Choice$Page$initialToMain(i.fO));
};
var $author$project$Api$Types$Food$Food = F3(
	function (id, name, measures) {
		return {gn: id, kI: measures, gN: name};
	});
var $author$project$Api$Types$Measure$Measure = F2(
	function (id, name) {
		return {gn: id, gN: name};
	});
var $author$project$Api$Types$Measure$decoderMeasure = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Api$Types$Measure$Measure)));
var $author$project$Api$Types$Food$decoderFood = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'measures',
	$elm$json$Json$Decode$list(
		$elm$json$Json$Decode$lazy(
			function (_v0) {
				return $author$project$Api$Types$Measure$decoderMeasure;
			})),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Api$Types$Food$Food))));
var $author$project$Pages$Util$Requests$fetchFoodsWith = F2(
	function (mkMsg, authorizedAccess) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$recipes.jS,
			{
				iO: $elm$http$Http$emptyBody,
				cz: A2(
					$author$project$Util$HttpUtil$expectJson,
					mkMsg,
					$elm$json$Json$Decode$list($author$project$Api$Types$Food$decoderFood))
			});
	});
var $author$project$Pages$Ingredients$Plain$Requests$fetchFoods = $author$project$Pages$Util$Requests$fetchFoodsWith($author$project$Pages$Util$Choice$Page$GotFetchChoicesResponse);
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Util$HttpUtil$jsonErrorToError = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$errorToString, $author$project$Util$HttpUtil$BadBody);
var $author$project$Pages$Ingredients$Handler$updateFoods = function (model) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeString(
			$elm$json$Json$Decode$list($author$project$Api$Types$Food$decoderFood)),
		A2(
			$elm_community$result_extra$Result$Extra$unpack,
			function (error) {
				return _Utils_Tuple2(
					A2(
						$author$project$Pages$View$Tristate$toError,
						model,
						$author$project$Util$HttpUtil$jsonErrorToError(error)),
					$elm$core$Platform$Cmd$none);
			},
			function (foods) {
				return _Utils_Tuple2(
					A2(
						$author$project$Pages$View$Tristate$fromInitToMain,
						$author$project$Pages$Ingredients$Page$initialToMain,
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$Choice$Page$lenses.ki.i$, $author$project$Pages$Ingredients$Page$lenses.ki.em).eW(
								A2(
									$elm$core$Maybe$map,
									$author$project$Util$DictList$fromListWithKey(
										function ($) {
											return $.gn;
										}),
									A2(
										$elm_community$maybe_extra$Maybe$Extra$filter,
										A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not),
										$elm$core$Maybe$Just(foods)))),
							model)),
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						$elm$core$Platform$Cmd$none,
						function (initial) {
							return A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Pages$Ingredients$Page$IngredientMsg,
								$author$project$Pages$Ingredients$Plain$Requests$fetchFoods(
									{o: model.o, W: initial.W}));
						},
						A2(
							$elm_community$maybe_extra$Maybe$Extra$filter,
							$elm$core$Basics$always(
								$elm$core$List$isEmpty(foods)),
							$author$project$Pages$View$Tristate$lenses.ki.jZ(model))));
			}));
};
var $author$project$Api$Types$ScalingMode$toString = function (scalingMode) {
	switch (scalingMode) {
		case 0:
			return 'Recipe';
		case 1:
			return 'Weight';
		default:
			return 'Volume';
	}
};
var $author$project$Api$Types$ScalingMode$encoderScalingMode = A2($elm$core$Basics$composeR, $author$project$Api$Types$ScalingMode$toString, $elm$json$Json$Encode$string);
var $author$project$Api$Types$ComplexIngredientCreation$encoderComplexIngredientCreation = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'complexFoodId',
				$danyx23$elm_uuid$Uuid$encode(obj.fN)),
				_Utils_Tuple2(
				'factor',
				$elm$json$Json$Encode$float(obj.f9)),
				_Utils_Tuple2(
				'scalingMode',
				$author$project$Api$Types$ScalingMode$encoderScalingMode(obj.hv))
			]));
};
var $author$project$Pages$Ingredients$Complex$Requests$createComplexIngredient = F3(
	function (authorizedAccess, recipeId, complexIngredientCreation) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$recipes.i8.ae(recipeId),
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$ComplexIngredientCreation$encoderComplexIngredientCreation(complexIngredientCreation)),
				cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$Util$Choice$Page$GotCreateResponse, $author$project$Api$Types$ComplexIngredient$decoderComplexIngredient)
			});
	});
var $author$project$Pages$Ingredients$Complex$Requests$deleteComplexIngredient = F3(
	function (flags, recipeId, complexIngredientId) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			flags,
			A2($author$project$Addresses$Backend$recipes.i8.af, recipeId, complexIngredientId),
			{
				iO: $elm$http$Http$emptyBody,
				cz: $author$project$Util$HttpUtil$expectWhatever(
					$author$project$Pages$Util$Choice$Page$GotDeleteResponse(complexIngredientId))
			});
	});
var $author$project$Pages$Ingredients$ComplexIngredientCreationClientInput$default = function (complexFoodId) {
	return {fN: complexFoodId, f9: $author$project$Pages$Util$ValidatedInput$positive, hv: 0};
};
var $author$project$Pages$Ingredients$ComplexIngredientCreationClientInput$from = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.hk;
	},
	$author$project$Pages$Ingredients$ComplexIngredientCreationClientInput$default);
var $author$project$Pages$Ingredients$ComplexIngredientUpdateClientInput$from = function (complexIngredient) {
	return {
		f9: A2(
			$author$project$Pages$Util$ValidatedInput$lenses.mx.eW,
			$elm$core$String$fromFloat(complexIngredient.f9),
			A2($author$project$Pages$Util$ValidatedInput$lenses.ig.eW, complexIngredient.f9, $author$project$Pages$Util$ValidatedInput$positive)),
		hv: complexIngredient.hv
	};
};
var $author$project$Api$Types$ComplexIngredientUpdate$encoderComplexIngredientUpdate = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'factor',
				$elm$json$Json$Encode$float(obj.f9)),
				_Utils_Tuple2(
				'scalingMode',
				$author$project$Api$Types$ScalingMode$encoderScalingMode(obj.hv))
			]));
};
var $author$project$Pages$Ingredients$Complex$Requests$saveComplexIngredient = F4(
	function (flags, recipeId, complexFoodId, complexIngredientUpdate) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			flags,
			A2($author$project$Addresses$Backend$recipes.i8.ac, recipeId, complexFoodId),
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$ComplexIngredientUpdate$encoderComplexIngredientUpdate(complexIngredientUpdate)),
				cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$Util$Choice$Page$GotSaveEditResponse, $author$project$Api$Types$ComplexIngredient$decoderComplexIngredient)
			});
	});
var $author$project$Pages$Ingredients$ComplexIngredientCreationClientInput$to = function (input) {
	return {fN: input.fN, f9: input.f9.ig, hv: input.hv};
};
var $author$project$Pages$Ingredients$ComplexIngredientUpdateClientInput$to = function (input) {
	return {f9: input.f9.ig, hv: input.hv};
};
var $author$project$Pages$Ingredients$Complex$Handler$updateLogic = $author$project$Pages$Util$Choice$Handler$updateLogic(
	{
		iY: function ($) {
			return $.fN;
		},
		iZ: function ($) {
			return $.fN;
		},
		je: F2(
			function (authorizedAccess, recipeId) {
				return A2(
					$elm$core$Basics$composeR,
					$author$project$Pages$Ingredients$ComplexIngredientCreationClientInput$to,
					A2($author$project$Pages$Ingredients$Complex$Requests$createComplexIngredient, authorizedAccess, recipeId));
			}),
		jp: $author$project$Pages$Ingredients$Complex$Requests$deleteComplexIngredient,
		j6: function ($) {
			return $.hk;
		},
		j7: function ($) {
			return $.fN;
		},
		l1: F4(
			function (authorizedAccess, recipeId, complexFoodId, updateInput) {
				return A4(
					$author$project$Pages$Ingredients$Complex$Requests$saveComplexIngredient,
					authorizedAccess,
					recipeId,
					complexFoodId,
					$author$project$Pages$Ingredients$ComplexIngredientUpdateClientInput$to(updateInput));
			}),
		mn: function (_v0) {
			return $elm$core$Platform$Cmd$none;
		},
		mB: $author$project$Pages$Ingredients$ComplexIngredientCreationClientInput$from,
		mD: $author$project$Pages$Ingredients$ComplexIngredientUpdateClientInput$from
	});
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$Api$Types$AmountUnit$encoderAmountUnit = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'measureId',
				$elm$json$Json$Encode$int(obj.gH)),
				_Utils_Tuple2(
				'factor',
				$elm$json$Json$Encode$float(obj.f9))
			]));
};
var $author$project$Api$Types$IngredientCreation$encoderIngredientCreation = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'foodId',
				$elm$json$Json$Encode$int(obj.gd)),
				_Utils_Tuple2(
				'amountUnit',
				$author$project$Api$Types$AmountUnit$encoderAmountUnit(obj.fs))
			]));
};
var $author$project$Pages$Ingredients$Plain$Requests$createIngredient = F3(
	function (authorizedAccess, recipeId, ingredientCreation) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$recipes.kg.ae(recipeId),
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$IngredientCreation$encoderIngredientCreation(ingredientCreation)),
				cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$Util$Choice$Page$GotCreateResponse, $author$project$Api$Types$Ingredient$decoderIngredient)
			});
	});
var $author$project$Pages$Ingredients$AmountUnitClientInput$default = function (mId) {
	return {f9: $author$project$Pages$Util$ValidatedInput$positive, gH: mId};
};
var $author$project$Pages$Ingredients$IngredientCreationClientInput$default = F2(
	function (foodId, measureId) {
		return {
			fs: $author$project$Pages$Ingredients$AmountUnitClientInput$default(measureId),
			gd: foodId
		};
	});
var $author$project$Pages$Ingredients$Plain$Requests$deleteIngredient = F3(
	function (flags, recipeId, ingredientId) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			flags,
			A2($author$project$Addresses$Backend$recipes.kg.af, recipeId, ingredientId),
			{
				iO: $elm$http$Http$emptyBody,
				cz: $author$project$Util$HttpUtil$expectWhatever(
					$author$project$Pages$Util$Choice$Page$GotDeleteResponse(ingredientId))
			});
	});
var $author$project$Api$Types$Measure$encoderMeasure = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(obj.gn)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(obj.gN))
			]));
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Api$Types$Food$encoderFood = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(obj.gn)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(obj.gN)),
				_Utils_Tuple2(
				'measures',
				A2($elm$json$Json$Encode$list, $author$project$Api$Types$Measure$encoderMeasure, obj.kI))
			]));
};
var $author$project$Pages$Ingredients$AmountUnitClientInput$from = function (au) {
	return {
		f9: A2(
			$author$project$Pages$Util$ValidatedInput$lenses.mx.eW,
			$elm$core$String$fromFloat(au.f9),
			A2($author$project$Pages$Util$ValidatedInput$lenses.ig.eW, au.f9, $author$project$Pages$Util$ValidatedInput$positive)),
		gH: au.gH
	};
};
var $author$project$Pages$Ingredients$IngredientUpdateClientInput$from = function (ingredient) {
	return {
		fs: $author$project$Pages$Ingredients$AmountUnitClientInput$from(ingredient.fs),
		gp: ingredient.gn
	};
};
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Types$IngredientUpdate$encoderIngredientUpdate = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'amountUnit',
				$author$project$Api$Types$AmountUnit$encoderAmountUnit(obj.fs))
			]));
};
var $author$project$Pages$Ingredients$Plain$Requests$saveIngredient = F4(
	function (flags, recipeId, ingredientId, ingredientUpdate) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			flags,
			A2($author$project$Addresses$Backend$recipes.kg.ac, recipeId, ingredientId),
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$IngredientUpdate$encoderIngredientUpdate(ingredientUpdate)),
				cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$Util$Choice$Page$GotSaveEditResponse, $author$project$Api$Types$Ingredient$decoderIngredient)
			});
	});
var $author$project$Ports$storeFoods = _Platform_outgoingPort('storeFoods', $elm$json$Json$Encode$string);
var $author$project$Pages$Ingredients$AmountUnitClientInput$to = function (input) {
	return {f9: input.f9.ig, gH: input.gH};
};
var $author$project$Pages$Ingredients$IngredientUpdateClientInput$to = function (input) {
	return {
		fs: $author$project$Pages$Ingredients$AmountUnitClientInput$to(input.fs)
	};
};
var $author$project$Pages$Ingredients$IngredientCreationClientInput$toCreation = function (input) {
	return {
		fs: {f9: input.fs.f9.ig, gH: input.fs.gH},
		gd: input.gd
	};
};
var $author$project$Pages$Ingredients$Plain$Handler$updateLogic = $author$project$Pages$Util$Choice$Handler$updateLogic(
	{
		iY: function ($) {
			return $.gd;
		},
		iZ: function ($) {
			return $.gd;
		},
		je: F2(
			function (authorizedAccess, recipeId) {
				return A2(
					$elm$core$Basics$composeR,
					$author$project$Pages$Ingredients$IngredientCreationClientInput$toCreation,
					A2($author$project$Pages$Ingredients$Plain$Requests$createIngredient, authorizedAccess, recipeId));
			}),
		jp: $author$project$Pages$Ingredients$Plain$Requests$deleteIngredient,
		j6: function ($) {
			return $.gn;
		},
		j7: function ($) {
			return $.gn;
		},
		l1: F4(
			function (authorizedAccess, recipeId, ingredientId, updateInput) {
				return A4(
					$author$project$Pages$Ingredients$Plain$Requests$saveIngredient,
					authorizedAccess,
					recipeId,
					ingredientId,
					$author$project$Pages$Ingredients$IngredientUpdateClientInput$to(updateInput));
			}),
		mn: A2(
			$elm$core$Basics$composeR,
			$elm$json$Json$Encode$list($author$project$Api$Types$Food$encoderFood),
			A2(
				$elm$core$Basics$composeR,
				$elm$json$Json$Encode$encode(0),
				$author$project$Ports$storeFoods)),
		mB: function (food) {
			return A2(
				$author$project$Pages$Ingredients$IngredientCreationClientInput$default,
				food.gn,
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					0,
					function ($) {
						return $.gn;
					},
					$elm$core$List$head(food.kI)));
		},
		mD: $author$project$Pages$Ingredients$IngredientUpdateClientInput$from
	});
var $author$project$Pages$Util$Parent$Page$GotDeleteResponse = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Util$Parent$Page$GotDuplicateResponse = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Ingredients$Recipe$Page$GotRescaleResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Util$Parent$Page$GotSaveEditResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Util$Requests$deleteRecipeWith = F3(
	function (mkMsg, authorizedAccess, recipeId) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$recipes.af(recipeId),
			{
				iO: $elm$http$Http$emptyBody,
				cz: $author$project$Util$HttpUtil$expectWhatever(mkMsg)
			});
	});
var $author$project$Api$Types$Date$encoderDate = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'year',
				$elm$json$Json$Encode$int(obj.iq)),
				_Utils_Tuple2(
				'month',
				$elm$json$Json$Encode$int(obj.gL)),
				_Utils_Tuple2(
				'day',
				$elm$json$Json$Encode$int(obj.fS))
			]));
};
var $author$project$Api$Types$Time$encoderTime = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'hour',
				$elm$json$Json$Encode$int(obj.gk)),
				_Utils_Tuple2(
				'minute',
				$elm$json$Json$Encode$int(obj.gJ))
			]));
};
var $author$project$Api$Types$SimpleDate$encoderSimpleDate = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'date',
				$author$project$Api$Types$Date$encoderDate(obj.fR)),
				_Utils_Tuple2(
				'time',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $author$project$Api$Types$Time$encoderTime, obj.h$)))
			]));
};
var $author$project$Pages$Util$DateUtil$monthToNumber = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.eY, posixMinutes) < 0) {
					return posixMinutes + era.c;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		fS: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		gL: month,
		iq: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).fS;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).gL;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).iq;
	});
var $author$project$Pages$Util$DateUtil$fromPosix = function (timestamp) {
	var zone = timestamp.it;
	var time = timestamp.h$;
	return {
		fR: {
			fS: A2($elm$time$Time$toDay, zone, time),
			gL: $author$project$Pages$Util$DateUtil$monthToNumber(
				A2($elm$time$Time$toMonth, zone, time)),
			iq: A2($elm$time$Time$toYear, zone, time)
		},
		h$: $elm$core$Maybe$Just(
			{
				gk: A2($elm$time$Time$toHour, zone, time),
				gJ: A2($elm$time$Time$toMinute, zone, time)
			})
	};
};
var $author$project$Pages$Util$Requests$duplicateRecipeWith = F4(
	function (mkMsg, authorizedAccess, recipeId, timestamp) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$recipes.ea(recipeId),
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$SimpleDate$encoderSimpleDate(
						$author$project$Pages$Util$DateUtil$fromPosix(timestamp))),
				cz: A2($author$project$Util$HttpUtil$expectJson, mkMsg, $author$project$Api$Types$Recipe$decoderRecipe)
			});
	});
var $author$project$Pages$Recipes$RecipeUpdateClientInput$from = function (recipe) {
	return {
		fX: recipe.fX,
		gN: A2(
			$author$project$Pages$Util$ValidatedInput$lenses.mx.eW,
			recipe.gN,
			A2($author$project$Pages$Util$ValidatedInput$lenses.ig.eW, recipe.gN, $author$project$Pages$Util$ValidatedInput$nonEmptyString)),
		gY: A2(
			$author$project$Pages$Util$ValidatedInput$lenses.mx.eW,
			$elm$core$String$fromFloat(recipe.gY),
			A2($author$project$Pages$Util$ValidatedInput$lenses.ig.eW, recipe.gY, $author$project$Pages$Util$ValidatedInput$positive)),
		hF: recipe.hF
	};
};
var $author$project$Pages$Util$Parent$Page$lenses = {
	ki: {
		g4: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.g4;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{g4: b});
				}))
	},
	kz: {
		g4: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.g4;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{g4: b});
				}))
	}
};
var $author$project$Pages$Util$Requests$rescaleRecipeWith = F3(
	function (mkMsg, authorizedAccess, recipeId) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$recipes.lW(recipeId),
			{
				iO: $elm$http$Http$emptyBody,
				cz: A2($author$project$Util$HttpUtil$expectJson, mkMsg, $author$project$Api$Types$Recipe$decoderRecipe)
			});
	});
var $author$project$Api$Types$RecipeUpdate$encoderRecipeUpdate = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(obj.gN)),
				_Utils_Tuple2(
				'description',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, obj.fX))),
				_Utils_Tuple2(
				'numberOfServings',
				$elm$json$Json$Encode$float(obj.gY)),
				_Utils_Tuple2(
				'servingSize',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, obj.hF)))
			]));
};
var $author$project$Pages$Util$Requests$saveRecipeWith = F4(
	function (mkMsg, authorizedAccess, recipeId, recipeUpdate) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$recipes.ac(recipeId),
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$RecipeUpdate$encoderRecipeUpdate(recipeUpdate)),
				cz: A2($author$project$Util$HttpUtil$expectJson, mkMsg, $author$project$Api$Types$Recipe$decoderRecipe)
			});
	});
var $author$project$Pages$Recipes$RecipeUpdateClientInput$to = function (input) {
	return {fX: input.fX, gN: input.gN.ig, gY: input.gY.ig, hF: input.hF};
};
var $author$project$Pages$Util$Parent$Page$GotDuplicationTimestamp = function (a) {
	return {$: 11, a: a};
};
var $author$project$Util$Editing$extractUpdate = A2($arturopala$elm_monocle$Monocle$Compose$lensWithOptional, $author$project$Util$EditState$lenses.ac, $author$project$Util$Editing$lenses.J).jZ;
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Pages$Util$Links$frontendPage = function (pathSteps) {
	return A2($elm$url$Url$Builder$absolute, pathSteps, _List_Nil);
};
var $author$project$Pages$Util$Links$loadFrontendPage = A2($elm$core$Basics$composeR, $author$project$Pages$Util$Links$frontendPage, $elm$browser$Browser$Navigation$load);
var $author$project$Pages$Util$DateUtil$Timestamp = F2(
	function (zone, time) {
		return {h$: time, it: zone};
	});
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$here = _Time_here(0);
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$Pages$Util$DateUtil$now = A3($elm$core$Task$map2, $author$project$Pages$Util$DateUtil$Timestamp, $elm$time$Time$here, $elm$time$Time$now);
var $author$project$Pages$Util$Parent$Handler$updateLogic = F3(
	function (ps, msg, model) {
		var toggleControls = _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				A2($arturopala$elm_monocle$Monocle$Lens$modify, $author$project$Pages$Util$Parent$Page$lenses.kz.g4, $author$project$Util$Editing$toggleControls),
				model),
			$elm$core$Platform$Cmd$none);
		var saveEdit = function (parent) {
			return _Utils_Tuple2(
				model,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$andThen,
						function (main) {
							return A2(
								$elm$core$Maybe$andThen,
								A2(
									ps.l0,
									{o: model.o, W: main.W},
									ps.j5(parent)),
								$author$project$Util$Editing$extractUpdate(
									$author$project$Pages$Util$Parent$Page$lenses.kz.g4.jY(main)));
						},
						$author$project$Pages$View$Tristate$lenses.kz.jZ(model))));
		};
		var requestDelete = _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				A2($arturopala$elm_monocle$Monocle$Lens$modify, $author$project$Pages$Util$Parent$Page$lenses.kz.g4, $author$project$Util$Editing$toDelete),
				model),
			$elm$core$Platform$Cmd$none);
		var gotSaveEditResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (parent) {
						return A2(
							$author$project$Pages$View$Tristate$mapMain,
							$author$project$Pages$Util$Parent$Page$lenses.kz.g4.eW(
								$author$project$Util$Editing$asView(parent)),
							model);
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		var gotFetchResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (parent) {
						return A2(
							$author$project$Pages$View$Tristate$mapInitial,
							$author$project$Pages$Util$Parent$Page$lenses.ki.g4.eW(
								$elm$core$Maybe$Just(parent)),
							model);
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		var gotDuplicationTimestamp = function (timestamp) {
			return _Utils_Tuple2(
				model,
				A3(
					$author$project$Pages$View$Tristate$foldMain,
					$elm$core$Platform$Cmd$none,
					function (main) {
						return A3(
							ps.ea,
							{o: model.o, W: main.W},
							ps.j5(main.g4.ln),
							timestamp);
					},
					model));
		};
		var gotDuplicateResponse = function (result) {
			return A3(
				$elm_community$result_extra$Result$Extra$unpack,
				function (error) {
					return _Utils_Tuple2(
						A2($author$project$Pages$View$Tristate$toError, model, error),
						$elm$core$Platform$Cmd$none);
				},
				function (parent) {
					return _Utils_Tuple2(
						model,
						$author$project$Pages$Util$Links$loadFrontendPage(
							ps.kW(
								ps.j5(parent))));
				},
				result);
		};
		var gotDeleteResponse = function (result) {
			return A3(
				$elm_community$result_extra$Result$Extra$unpack,
				function (error) {
					return _Utils_Tuple2(
						A2($author$project$Pages$View$Tristate$toError, model, error),
						$elm$core$Platform$Cmd$none);
				},
				function (_v1) {
					return _Utils_Tuple2(
						model,
						$author$project$Pages$Util$Links$loadFrontendPage(
							ps.kV(0)));
				},
				result);
		};
		var exitEdit = _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				A2($arturopala$elm_monocle$Monocle$Lens$modify, $author$project$Pages$Util$Parent$Page$lenses.kz.g4, $author$project$Util$Editing$toView),
				model),
			$elm$core$Platform$Cmd$none);
		var enterEdit = _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				A2(
					$arturopala$elm_monocle$Monocle$Lens$modify,
					$author$project$Pages$Util$Parent$Page$lenses.kz.g4,
					$author$project$Util$Editing$toUpdate(ps.mD)),
				model),
			$elm$core$Platform$Cmd$none);
		var edit = function (update) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					A2($arturopala$elm_monocle$Monocle$Compose$lensWithOptional, $author$project$Util$Editing$lenses.ac, $author$project$Pages$Util$Parent$Page$lenses.kz.g4).eW(update),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var duplicate = _Utils_Tuple2(
			model,
			A2($elm$core$Task$perform, $author$project$Pages$Util$Parent$Page$GotDuplicationTimestamp, $author$project$Pages$Util$DateUtil$now));
		var confirmDelete = _Utils_Tuple2(
			model,
			A3(
				$author$project$Pages$View$Tristate$foldMain,
				$elm$core$Platform$Cmd$none,
				function (main) {
					return A2(
						ps.af,
						{o: model.o, W: main.W},
						ps.j5(main.g4.ln));
				},
				model));
		var cancelDelete = _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				A2($arturopala$elm_monocle$Monocle$Lens$modify, $author$project$Pages$Util$Parent$Page$lenses.kz.g4, $author$project$Util$Editing$toView),
				model),
			$elm$core$Platform$Cmd$none);
		switch (msg.$) {
			case 0:
				var result = msg.a;
				return gotFetchResponse(result);
			case 1:
				var update = msg.a;
				return edit(update);
			case 2:
				var parent = msg.a;
				return saveEdit(parent);
			case 3:
				var result = msg.a;
				return gotSaveEditResponse(result);
			case 4:
				return enterEdit;
			case 5:
				return exitEdit;
			case 6:
				return requestDelete;
			case 7:
				return confirmDelete;
			case 8:
				return cancelDelete;
			case 9:
				var result = msg.a;
				return gotDeleteResponse(result);
			case 10:
				return duplicate;
			case 11:
				var timestamp = msg.a;
				return gotDuplicationTimestamp(timestamp);
			case 12:
				var result = msg.a;
				return gotDuplicateResponse(result);
			default:
				return toggleControls;
		}
	});
var $author$project$Pages$Ingredients$Recipe$Handler$updateLogic = F2(
	function (msg, model) {
		var rescale = _Utils_Tuple2(
			model,
			A3(
				$author$project$Pages$View$Tristate$foldMain,
				$elm$core$Platform$Cmd$none,
				function (main) {
					return A3(
						$author$project$Pages$Util$Requests$rescaleRecipeWith,
						$author$project$Pages$Ingredients$Recipe$Page$GotRescaleResponse,
						{o: model.o, W: main.W},
						$author$project$Pages$Util$Parent$Page$lenses.kz.g4.jY(main).ln.gn);
				},
				model));
		var gotRescaleResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (recipe) {
						return A2(
							$author$project$Pages$View$Tristate$mapMain,
							A2(
								$arturopala$elm_monocle$Monocle$Lens$modify,
								$author$project$Pages$Util$Parent$Page$lenses.kz.g4,
								$author$project$Util$Editing$asViewWithElement(recipe)),
							model);
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		switch (msg.$) {
			case 0:
				var parentMsg = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Pages$Ingredients$Recipe$Page$ParentMsg),
					A3(
						$author$project$Pages$Util$Parent$Handler$updateLogic,
						{
							af: $author$project$Pages$Util$Requests$deleteRecipeWith($author$project$Pages$Util$Parent$Page$GotDeleteResponse),
							ea: $author$project$Pages$Util$Requests$duplicateRecipeWith($author$project$Pages$Util$Parent$Page$GotDuplicateResponse),
							j5: function ($) {
								return $.gn;
							},
							kV: $author$project$Addresses$Frontend$recipes.iA,
							kW: $author$project$Addresses$Frontend$ingredientEditor.iA,
							l0: F2(
								function (authorizedAccess, recipeId) {
									return A2(
										$elm$core$Basics$composeR,
										$author$project$Pages$Recipes$RecipeUpdateClientInput$to,
										A2(
											$elm$core$Basics$composeR,
											A3($author$project$Pages$Util$Requests$saveRecipeWith, $author$project$Pages$Util$Parent$Page$GotSaveEditResponse, authorizedAccess, recipeId),
											$elm$core$Maybe$Just));
								}),
							mD: $author$project$Pages$Recipes$RecipeUpdateClientInput$from
						},
						parentMsg,
						model));
			case 1:
				return rescale;
			default:
				var result = msg.a;
				return gotRescaleResponse(result);
		}
	});
var $author$project$Pages$Ingredients$Handler$updateLogic = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var string = msg.a;
				return A2($author$project$Pages$Ingredients$Handler$updateFoods, model, string);
			case 1:
				var foodsMode = msg.a;
				return A2($author$project$Pages$Ingredients$Handler$changeFoodsMode, model, foodsMode);
			case 2:
				var ingredientsGroupMsg = msg.a;
				return A3(
					$author$project$Pages$View$TristateUtil$updateFromSubModel,
					{jW: $author$project$Pages$Ingredients$Page$initialToMain, kj: $author$project$Pages$Ingredients$Page$lenses.ki.em, kA: $author$project$Pages$Ingredients$Page$lenses.kz.em, mC: $author$project$Pages$Ingredients$Page$IngredientMsg, mM: $author$project$Pages$Ingredients$Plain$Handler$updateLogic},
					ingredientsGroupMsg,
					model);
			case 3:
				var complexIngredientsGroupMsg = msg.a;
				return A3(
					$author$project$Pages$View$TristateUtil$updateFromSubModel,
					{jW: $author$project$Pages$Ingredients$Page$initialToMain, kj: $author$project$Pages$Ingredients$Page$lenses.ki.fO, kA: $author$project$Pages$Ingredients$Page$lenses.kz.fO, mC: $author$project$Pages$Ingredients$Page$ComplexIngredientMsg, mM: $author$project$Pages$Ingredients$Complex$Handler$updateLogic},
					complexIngredientsGroupMsg,
					model);
			default:
				var recipeMsg = msg.a;
				return A3(
					$author$project$Pages$View$TristateUtil$updateFromSubModel,
					{jW: $author$project$Pages$Ingredients$Page$initialToMain, kj: $author$project$Pages$Ingredients$Page$lenses.ki.lD, kA: $author$project$Pages$Ingredients$Page$lenses.kz.lD, mC: $author$project$Pages$Ingredients$Page$RecipeMsg, mM: $author$project$Pages$Ingredients$Recipe$Handler$updateLogic},
					recipeMsg,
					model);
		}
	});
var $author$project$Pages$Ingredients$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Ingredients$Handler$updateLogic);
var $author$project$Ports$storeToken = _Platform_outgoingPort('storeToken', $elm$json$Json$Encode$string);
var $author$project$Pages$Login$Handler$gotResponse = F2(
	function (model, remoteData) {
		return A3(
			$elm_community$result_extra$Result$Extra$unpack,
			function (error) {
				return _Utils_Tuple2(
					A2($author$project$Pages$View$Tristate$toError, model, error),
					$elm$core$Platform$Cmd$none);
			},
			function (token) {
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$storeToken(token),
								$elm$browser$Browser$Navigation$load(
								$author$project$Pages$Util$Links$frontendPage(
									$author$project$Addresses$Frontend$overview.iA(0)))
							])));
			},
			remoteData);
	});
var $author$project$Pages$Login$Page$GotResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Types$Credentials$encoderCredentials = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nickname',
				$elm$json$Json$Encode$string(obj.gU)),
				_Utils_Tuple2(
				'password',
				$elm$json$Json$Encode$string(obj.g5))
			]));
};
var $author$project$Pages$Login$Requests$login = F2(
	function (configuration, credentials) {
		return A3(
			$author$project$Util$HttpUtil$runPattern,
			configuration,
			$author$project$Addresses$Backend$users.kw,
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$Credentials$encoderCredentials(credentials)),
				cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$Login$Page$GotResponse, $elm$json$Json$Decode$string),
				W: $elm$core$Maybe$Nothing
			});
	});
var $author$project$Pages$Login$Handler$login = function (model) {
	return _Utils_Tuple2(
		model,
		A3(
			$author$project$Pages$View$Tristate$foldMain,
			$elm$core$Platform$Cmd$none,
			function (main) {
				return A2($author$project$Pages$Login$Requests$login, model.o, main.ct);
			},
			model));
};
var $author$project$Pages$Login$Page$lenses = {
	kz: {
		ct: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.ct;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{ct: b});
				}))
	}
};
var $author$project$Util$CredentialsUtil$nickname = A2(
	$arturopala$elm_monocle$Monocle$Lens$Lens,
	function ($) {
		return $.gU;
	},
	F2(
		function (b, a) {
			return _Utils_update(
				a,
				{gU: b});
		}));
var $author$project$Pages$Login$Handler$setNickname = F2(
	function (model, nickname) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Util$CredentialsUtil$nickname, $author$project$Pages$Login$Page$lenses.kz.ct).eW(nickname),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Util$CredentialsUtil$password = A2(
	$arturopala$elm_monocle$Monocle$Lens$Lens,
	function ($) {
		return $.g5;
	},
	F2(
		function (b, a) {
			return _Utils_update(
				a,
				{g5: b});
		}));
var $author$project$Pages$Login$Handler$setPassword = F2(
	function (model, password) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Util$CredentialsUtil$password, $author$project$Pages$Login$Page$lenses.kz.ct).eW(password),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Login$Handler$updateLogic = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var nickname = msg.a;
				return A2($author$project$Pages$Login$Handler$setNickname, model, nickname);
			case 1:
				var password = msg.a;
				return A2($author$project$Pages$Login$Handler$setPassword, model, password);
			case 2:
				return $author$project$Pages$Login$Handler$login(model);
			default:
				var remoteData = msg.a;
				return A2($author$project$Pages$Login$Handler$gotResponse, model, remoteData);
		}
	});
var $author$project$Pages$Login$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Login$Handler$updateLogic);
var $author$project$Pages$MealEntries$Page$Main = F3(
	function (meal, entries, profile) {
		return {f5: entries, kD: meal, ly: profile};
	});
var $author$project$Pages$MealEntries$Page$initialToMain = function (i) {
	return A4(
		$elm$core$Maybe$map3,
		$author$project$Pages$MealEntries$Page$Main,
		$author$project$Pages$Util$Parent$Page$initialToMain(i.kD),
		$author$project$Pages$Util$Choice$Page$initialToMain(i.f5),
		i.ly);
};
var $author$project$Pages$MealEntries$Page$lenses = {
	ki: {
		f5: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.f5;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{f5: b});
				})),
		kD: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.kD;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{kD: b});
				})),
		ly: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.ly;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{ly: b});
				}))
	},
	kz: {
		f5: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.f5;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{f5: b});
				})),
		kD: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.kD;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{kD: b});
				}))
	}
};
var $author$project$Pages$MealEntries$Page$profileId = $author$project$Pages$View$Tristate$fold(
	{
		lb: $elm$core$Basics$always($elm$core$Maybe$Nothing),
		lc: A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.bS;
			},
			$elm$core$Maybe$Just),
		ld: A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.ly;
			},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.gn;
				},
				$elm$core$Maybe$Just))
	});
var $author$project$Api$Types$MealEntryCreation$encoderMealEntryCreation = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'recipeId',
				$danyx23$elm_uuid$Uuid$encode(obj.hk)),
				_Utils_Tuple2(
				'numberOfServings',
				$elm$json$Json$Encode$float(obj.gY))
			]));
};
var $author$project$Pages$MealEntries$Entries$Requests$createMealEntry = F4(
	function (authorizedAccess, profileId, mealId, mealEntryCreation) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			A2($author$project$Addresses$Backend$meals.f5.ae, profileId, mealId),
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$MealEntryCreation$encoderMealEntryCreation(mealEntryCreation)),
				cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$Util$Choice$Page$GotCreateResponse, $author$project$Api$Types$MealEntry$decoderMealEntry)
			});
	});
var $author$project$Pages$MealEntries$MealEntryCreationClientInput$default = function (recipeId) {
	return {gY: $author$project$Pages$Util$ValidatedInput$positive, hk: recipeId};
};
var $author$project$Pages$MealEntries$Entries$Requests$deleteMealEntry = F4(
	function (authorizedAccess, profileId, mealId, mealEntryId) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			A3($author$project$Addresses$Backend$meals.f5.af, profileId, mealId, mealEntryId),
			{
				iO: $elm$http$Http$emptyBody,
				cz: $author$project$Util$HttpUtil$expectWhatever(
					$author$project$Pages$Util$Choice$Page$GotDeleteResponse(mealEntryId))
			});
	});
var $author$project$Pages$MealEntries$MealEntryUpdateClientInput$from = function (mealEntry) {
	return {
		gY: A2(
			$author$project$Pages$Util$ValidatedInput$lenses.mx.eW,
			$elm$core$String$fromFloat(mealEntry.gY),
			A2($author$project$Pages$Util$ValidatedInput$lenses.ig.eW, mealEntry.gY, $author$project$Pages$Util$ValidatedInput$positive))
	};
};
var $author$project$Api$Types$MealEntryUpdate$encoderMealEntryUpdate = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'numberOfServings',
				$elm$json$Json$Encode$float(obj.gY))
			]));
};
var $author$project$Pages$MealEntries$Entries$Requests$saveMealEntry = F5(
	function (authorizedAccess, profileId, mealId, mealEntryId, mealEntryUpdate) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			A3($author$project$Addresses$Backend$meals.f5.ac, profileId, mealId, mealEntryId),
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$MealEntryUpdate$encoderMealEntryUpdate(mealEntryUpdate)),
				cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$Util$Choice$Page$GotSaveEditResponse, $author$project$Api$Types$MealEntry$decoderMealEntry)
			});
	});
var $author$project$Pages$MealEntries$MealEntryUpdateClientInput$to = function (input) {
	return {gY: input.gY.ig};
};
var $author$project$Pages$MealEntries$MealEntryCreationClientInput$toCreation = function (input) {
	return {gY: input.gY.ig, hk: input.hk};
};
var $author$project$Pages$MealEntries$Entries$Handler$updateLogic = function (profileId) {
	return $author$project$Pages$Util$Choice$Handler$updateLogic(
		{
			iY: function ($) {
				return $.hk;
			},
			iZ: function ($) {
				return $.hk;
			},
			je: F3(
				function (authorizedAccess, mealId, creationInput) {
					return A4(
						$author$project$Pages$MealEntries$Entries$Requests$createMealEntry,
						authorizedAccess,
						profileId,
						mealId,
						$author$project$Pages$MealEntries$MealEntryCreationClientInput$toCreation(creationInput));
				}),
			jp: function (authorizedAccess) {
				return A2($author$project$Pages$MealEntries$Entries$Requests$deleteMealEntry, authorizedAccess, profileId);
			},
			j6: function ($) {
				return $.gn;
			},
			j7: function ($) {
				return $.gn;
			},
			l1: F4(
				function (authorizedAccess, mealId, mealEntryId, updateInput) {
					return A5(
						$author$project$Pages$MealEntries$Entries$Requests$saveMealEntry,
						authorizedAccess,
						profileId,
						mealId,
						mealEntryId,
						$author$project$Pages$MealEntries$MealEntryUpdateClientInput$to(updateInput));
				}),
			mn: function (_v0) {
				return $elm$core$Platform$Cmd$none;
			},
			mB: function (recipe) {
				return $author$project$Pages$MealEntries$MealEntryCreationClientInput$default(recipe.gn);
			},
			mD: $author$project$Pages$MealEntries$MealEntryUpdateClientInput$from
		});
};
var $author$project$Pages$Util$Requests$deleteMealWith = F4(
	function (mkMsg, authorizedAccess, profileId, mealId) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			A2($author$project$Addresses$Backend$meals.af, profileId, mealId),
			{
				iO: $elm$http$Http$emptyBody,
				cz: $author$project$Util$HttpUtil$expectWhatever(mkMsg)
			});
	});
var $author$project$Pages$Util$Requests$duplicateMealWith = F5(
	function (mkMsg, authorizedAccess, profileId, mealId, timestamp) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			A2($author$project$Addresses$Backend$meals.ea, profileId, mealId),
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$SimpleDate$encoderSimpleDate(
						$author$project$Pages$Util$DateUtil$fromPosix(timestamp))),
				cz: A2($author$project$Util$HttpUtil$expectJson, mkMsg, $author$project$Api$Types$Meal$decoderMeal)
			});
	});
var $author$project$Pages$Util$SimpleDateInput$from = function (simpleDate) {
	return {
		fR: $elm$core$Maybe$Just(simpleDate.fR),
		h$: simpleDate.h$
	};
};
var $author$project$Pages$Meals$Editor$MealUpdateClientInput$from = function (meal) {
	return {
		fR: $author$project$Pages$Util$SimpleDateInput$from(meal.fR),
		gN: meal.gN
	};
};
var $author$project$Api$Types$MealUpdate$encoderMealUpdate = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'date',
				$author$project$Api$Types$SimpleDate$encoderSimpleDate(obj.fR)),
				_Utils_Tuple2(
				'name',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, obj.gN)))
			]));
};
var $author$project$Pages$Util$Requests$saveMealWith = F5(
	function (mkMsg, authorizedAccess, profileId, mealId, mealUpdate) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			A2($author$project$Addresses$Backend$meals.ac, profileId, mealId),
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$MealUpdate$encoderMealUpdate(mealUpdate)),
				cz: A2($author$project$Util$HttpUtil$expectJson, mkMsg, $author$project$Api$Types$Meal$decoderMeal)
			});
	});
var $author$project$Pages$Util$SimpleDateInput$to = function (input) {
	return A2(
		$elm$core$Maybe$map,
		A2($elm_community$basics_extra$Basics$Extra$flip, $author$project$Api$Types$SimpleDate$SimpleDate, input.h$),
		input.fR);
};
var $author$project$Pages$Meals$Editor$MealUpdateClientInput$to = function (input) {
	return A2(
		$elm$core$Maybe$map,
		function (simpleDate) {
			return {fR: simpleDate, gN: input.gN};
		},
		$author$project$Pages$Util$SimpleDateInput$to(input.fR));
};
var $author$project$Pages$MealEntries$Meal$Handler$updateLogic = function (profileId) {
	return $author$project$Pages$Util$Parent$Handler$updateLogic(
		{
			af: function (authorizedAccess) {
				return A3($author$project$Pages$Util$Requests$deleteMealWith, $author$project$Pages$Util$Parent$Page$GotDeleteResponse, authorizedAccess, profileId);
			},
			ea: function (authorizedAccess) {
				return A3($author$project$Pages$Util$Requests$duplicateMealWith, $author$project$Pages$Util$Parent$Page$GotDuplicateResponse, authorizedAccess, profileId);
			},
			j5: function ($) {
				return $.gn;
			},
			kV: function (_v0) {
				return $author$project$Addresses$Frontend$meals.iA(profileId);
			},
			kW: function (mealId) {
				return $author$project$Addresses$Frontend$mealEntryEditor.iA(
					_Utils_Tuple2(profileId, mealId));
			},
			l0: F2(
				function (authorizedAccess, mealId) {
					return A2(
						$elm$core$Basics$composeR,
						$author$project$Pages$Meals$Editor$MealUpdateClientInput$to,
						$elm$core$Maybe$map(
							A4($author$project$Pages$Util$Requests$saveMealWith, $author$project$Pages$Util$Parent$Page$GotSaveEditResponse, authorizedAccess, profileId, mealId)));
				}),
			mD: $author$project$Pages$Meals$Editor$MealUpdateClientInput$from
		});
};
var $author$project$Pages$MealEntries$Handler$updateLogic = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				var entriesMsg = msg.a;
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					function (profileId) {
						return A3(
							$author$project$Pages$View$TristateUtil$updateFromSubModel,
							{
								jW: $author$project$Pages$MealEntries$Page$initialToMain,
								kj: $author$project$Pages$MealEntries$Page$lenses.ki.f5,
								kA: $author$project$Pages$MealEntries$Page$lenses.kz.f5,
								mC: $author$project$Pages$MealEntries$Page$EntriesMsg,
								mM: $author$project$Pages$MealEntries$Entries$Handler$updateLogic(profileId)
							},
							entriesMsg,
							model);
					},
					$author$project$Pages$MealEntries$Page$profileId(model));
			case 0:
				var mealMsg = msg.a;
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					function (profileId) {
						return A3(
							$author$project$Pages$View$TristateUtil$updateFromSubModel,
							{
								jW: $author$project$Pages$MealEntries$Page$initialToMain,
								kj: $author$project$Pages$MealEntries$Page$lenses.ki.kD,
								kA: $author$project$Pages$MealEntries$Page$lenses.kz.kD,
								mC: $author$project$Pages$MealEntries$Page$MealMsg,
								mM: $author$project$Pages$MealEntries$Meal$Handler$updateLogic(profileId)
							},
							mealMsg,
							model);
					},
					$author$project$Pages$MealEntries$Page$profileId(model));
			default:
				var result = msg.a;
				return _Utils_Tuple2(
					A3(
						$elm_community$result_extra$Result$Extra$unpack,
						$author$project$Pages$View$Tristate$toError(model),
						function (profile) {
							return A2(
								$author$project$Pages$View$Tristate$fromInitToMain,
								$author$project$Pages$MealEntries$Page$initialToMain,
								A2(
									$author$project$Pages$View$Tristate$mapInitial,
									$author$project$Pages$MealEntries$Page$lenses.ki.ly.eW(
										$elm$core$Maybe$Just(profile)),
									model));
						},
						result),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$MealEntries$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$MealEntries$Handler$updateLogic);
var $author$project$Pages$Util$ParentEditor$Page$GotDuplicateResponse = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Util$ParentEditor$Page$GotCreateResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Types$MealCreation$encoderMealCreation = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'date',
				$author$project$Api$Types$SimpleDate$encoderSimpleDate(obj.fR)),
				_Utils_Tuple2(
				'name',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, obj.gN)))
			]));
};
var $author$project$Pages$Meals$Editor$Requests$createMeal = F3(
	function (authorizedAccess, profileId, mealCreation) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$meals.ae(profileId),
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$MealCreation$encoderMealCreation(mealCreation)),
				cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$Util$ParentEditor$Page$GotCreateResponse, $author$project$Api$Types$Meal$decoderMeal)
			});
	});
var $author$project$Pages$Util$ParentEditor$Page$GotDeleteResponse = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Pages$Meals$Editor$Requests$deleteMeal = F3(
	function (authorizedAccess, profileId, mealId) {
		return A4(
			$author$project$Pages$Util$Requests$deleteMealWith,
			$author$project$Pages$Util$ParentEditor$Page$GotDeleteResponse(mealId),
			authorizedAccess,
			profileId,
			mealId);
	});
var $author$project$Pages$Util$ParentEditor$Pagination$initial = {lu: $author$project$Pages$Util$PaginationSettings$initial};
var $author$project$Pages$Util$ParentEditor$Page$initialToMain = function (i) {
	return A2(
		$elm$core$Maybe$map,
		function (parents) {
			return {W: i.W, lt: $author$project$Pages$Util$ParentEditor$Pagination$initial, dc: $elm$core$Maybe$Nothing, lu: parents, hz: ''};
		},
		i.lu);
};
var $author$project$Pages$Meals$Editor$Page$initialToMain = function (initial) {
	return A3(
		$elm$core$Maybe$map2,
		F2(
			function (parentEditor, profile) {
				return {eF: parentEditor, ly: profile};
			}),
		$author$project$Pages$Util$ParentEditor$Page$initialToMain(initial.eF),
		initial.ly);
};
var $author$project$Pages$Meals$Editor$MealCreationClientInput$lenses = {
	fR: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.fR;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{fR: b});
			})),
	gN: A2(
		$arturopala$elm_monocle$Monocle$Optional$Optional,
		function ($) {
			return $.gN;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{
						gN: A2(
							$elm_community$maybe_extra$Maybe$Extra$filter,
							A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not),
							$elm$core$Maybe$Just(b))
					});
			}))
};
var $author$project$Pages$Meals$Editor$Page$lenses = {
	ki: {
		eF: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.eF;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{eF: b});
				})),
		ly: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.ly;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{ly: b});
				}))
	},
	kz: {
		eF: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.eF;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{eF: b});
				})),
		ly: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.ly;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{ly: b});
				}))
	}
};
var $author$project$Pages$Meals$Editor$Page$profileId = $author$project$Pages$View$Tristate$fold(
	{
		lb: $elm$core$Basics$always($elm$core$Maybe$Nothing),
		lc: A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.bS;
			},
			$elm$core$Maybe$Just),
		ld: A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.ly;
			},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.gn;
				},
				$elm$core$Maybe$Just))
	});
var $author$project$Pages$Util$ParentEditor$Page$GotSaveEditResponse = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Meals$Editor$Requests$saveMeal = $author$project$Pages$Util$Requests$saveMealWith($author$project$Pages$Util$ParentEditor$Page$GotSaveEditResponse);
var $author$project$Pages$Meals$Editor$MealCreationClientInput$toCreation = function (input) {
	return A2(
		$elm$core$Maybe$map,
		function (date) {
			return {fR: date, gN: input.gN};
		},
		$author$project$Pages$Util$SimpleDateInput$to(input.fR));
};
var $author$project$Pages$Util$ParentEditor$Page$FinishUpdateCreation = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Util$ParentEditor$Page$GotDuplicateTimestamp = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Pages$Util$ParentEditor$Page$lenses = {
	ki: {
		lu: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lu;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lu: b});
				}))
	},
	kz: {
		lt: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lt;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lt: b});
				})),
		dc: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.dc;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{dc: b});
				})),
		lu: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lu;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lu: b});
				})),
		hz: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.hz;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{hz: b});
				}))
	}
};
var $author$project$Pages$Util$ParentEditor$Pagination$lenses = {
	lu: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.lu;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{lu: b});
			}))
};
var $author$project$Pages$Util$ParentEditor$Handler$mapParentStateById = function (parentId) {
	return A2(
		$elm$core$Basics$composeR,
		A2($author$project$Util$LensUtil$updateById, parentId, $author$project$Pages$Util$ParentEditor$Page$lenses.kz.lu),
		$author$project$Pages$View$Tristate$mapMain);
};
var $author$project$Pages$Util$ParentEditor$Handler$updateLogic = F3(
	function (ps, msg, model) {
		var toggleControls = function (parentId) {
			return _Utils_Tuple2(
				A3($author$project$Pages$Util$ParentEditor$Handler$mapParentStateById, parentId, $author$project$Util$Editing$toggleControls, model),
				$elm$core$Platform$Cmd$none);
		};
		var setSearchString = function (string) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					A2(
						$author$project$Pages$Util$PaginationSettings$setSearchStringAndReset,
						{
							g1: A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$ParentEditor$Pagination$lenses.lu, $author$project$Pages$Util$ParentEditor$Page$lenses.kz.lt),
							hA: $author$project$Pages$Util$ParentEditor$Page$lenses.kz.hz
						},
						string),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var setPagination = function (pagination) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					$author$project$Pages$Util$ParentEditor$Page$lenses.kz.lt.eW(pagination),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var saveEdit = function (parentId) {
			return _Utils_Tuple2(
				model,
				A3(
					$author$project$Pages$View$Tristate$foldMain,
					$elm$core$Platform$Cmd$none,
					function (main) {
						return A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$elm$core$Platform$Cmd$none,
							A2(
								ps.l0,
								{o: model.o, W: main.W},
								parentId),
							A2(
								$elm$core$Maybe$andThen,
								$author$project$Util$Editing$extractUpdate,
								A2(
									$author$project$Util$DictList$get,
									parentId,
									$author$project$Pages$Util$ParentEditor$Page$lenses.kz.lu.jY(main))));
					},
					model));
		};
		var requestDelete = function (parentId) {
			return _Utils_Tuple2(
				A3($author$project$Pages$Util$ParentEditor$Handler$mapParentStateById, parentId, $author$project$Util$Editing$toDelete, model),
				$elm$core$Platform$Cmd$none);
		};
		var prepareDuplicate = function (parentId) {
			return _Utils_Tuple2(
				model,
				A2(
					$elm$core$Task$perform,
					$author$project$Pages$Util$ParentEditor$Page$GotDuplicateTimestamp(parentId),
					$author$project$Pages$Util$DateUtil$now));
		};
		var onFetch = ps.iK ? $author$project$Pages$View$Tristate$fromInitToMain($author$project$Pages$Util$ParentEditor$Page$initialToMain) : $elm$core$Basics$identity;
		var gotSaveEditResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (parent) {
						return A3(
							$author$project$Pages$Util$ParentEditor$Handler$mapParentStateById,
							ps.j8(parent),
							$author$project$Util$Editing$asViewWithElement(parent),
							model);
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		var gotFetchResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (parents) {
						return onFetch(
							A2(
								$author$project$Pages$View$Tristate$mapInitial,
								$author$project$Pages$Util$ParentEditor$Page$lenses.ki.lu.eW(
									$elm$core$Maybe$Just(
										A2(
											$author$project$Util$DictList$fromListWithKey,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.ln;
												},
												ps.j8),
											A2($elm$core$List$map, $author$project$Util$Editing$asView, parents)))),
								model));
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		var gotDuplicateTimestamp = F2(
			function (parentId, timestamp) {
				return _Utils_Tuple2(
					model,
					A3(
						$author$project$Pages$View$Tristate$foldMain,
						$elm$core$Platform$Cmd$none,
						function (main) {
							return A3(
								ps.ea,
								{o: model.o, W: main.W},
								parentId,
								timestamp);
						},
						model));
			});
		var gotDeleteResponse = F2(
			function (deletedId, result) {
				return _Utils_Tuple2(
					A3(
						$elm_community$result_extra$Result$Extra$unpack,
						$author$project$Pages$View$Tristate$toError(model),
						$elm$core$Basics$always(
							A2(
								$author$project$Pages$View$Tristate$mapMain,
								A2($author$project$Util$LensUtil$deleteAtId, deletedId, $author$project$Pages$Util$ParentEditor$Page$lenses.kz.lu),
								model)),
						result),
					$elm$core$Platform$Cmd$none);
			});
		var gotCreationResponseWith = F2(
			function (params, result) {
				return A3(
					$elm_community$result_extra$Result$Extra$unpack,
					function (error) {
						return _Utils_Tuple2(
							A2($author$project$Pages$View$Tristate$toError, model, error),
							$elm$core$Platform$Cmd$none);
					},
					function (parent) {
						var parentId = ps.j8(parent);
						var parentCreationHandling = params.eV ? $author$project$Pages$Util$ParentEditor$Page$lenses.kz.dc.eW($elm$core$Maybe$Nothing) : $elm$core$Basics$identity;
						return _Utils_Tuple2(
							A2(
								$author$project$Pages$View$Tristate$mapMain,
								A2(
									$elm$core$Basics$composeR,
									A3(
										$author$project$Util$LensUtil$insertAtId,
										parentId,
										$author$project$Pages$Util$ParentEditor$Page$lenses.kz.lu,
										$author$project$Util$Editing$asView(parent)),
									parentCreationHandling),
								model),
							$author$project$Pages$Util$Links$loadFrontendPage(
								ps.kX(parentId)));
					},
					result);
			});
		var gotDuplicateResponse = gotCreationResponseWith(
			{eV: false});
		var gotCreateResponse = gotCreationResponseWith(
			{eV: true});
		var finishUpdateCreation = function (creation) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					$author$project$Pages$Util$ParentEditor$Page$lenses.kz.dc.eW(creation),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var prepareUpdateCreation = function (creation) {
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				_Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Util$ParentEditor$Page$FinishUpdateCreation,
						A2(
							$elm$core$Task$map,
							function (timestamp) {
								return A2(
									$elm$core$Maybe$map,
									ps.mH(timestamp),
									creation);
							},
							$author$project$Pages$Util$DateUtil$now))),
				function (_v1) {
					return finishUpdateCreation(creation);
				},
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Pages$Util$ParentEditor$Page$lenses.kz.dc.jY,
					$author$project$Pages$View$Tristate$lenses.kz.jZ(model)));
		};
		var exitEdit = function (parentId) {
			return _Utils_Tuple2(
				A3($author$project$Pages$Util$ParentEditor$Handler$mapParentStateById, parentId, $author$project$Util$Editing$toView, model),
				$elm$core$Platform$Cmd$none);
		};
		var enterEdit = function (parentId) {
			return _Utils_Tuple2(
				A3(
					$author$project$Pages$Util$ParentEditor$Handler$mapParentStateById,
					parentId,
					$author$project$Util$Editing$toUpdate(ps.mD),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var edit = F2(
			function (parentId, update) {
				return _Utils_Tuple2(
					A3(
						$author$project$Pages$Util$ParentEditor$Handler$mapParentStateById,
						parentId,
						$author$project$Util$Editing$lenses.ac.eW(update),
						model),
					$elm$core$Platform$Cmd$none);
			});
		var create = _Utils_Tuple2(
			model,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Cmd$none,
				A2(
					$elm$core$Maybe$andThen,
					function (main) {
						return A2(
							$elm$core$Maybe$map,
							ps.ae(
								{o: model.o, W: main.W}),
							main.dc);
					},
					$author$project$Pages$View$Tristate$lenses.kz.jZ(model))));
		var confirmDelete = function (parentId) {
			return _Utils_Tuple2(
				model,
				A3(
					$author$project$Pages$View$Tristate$foldMain,
					$elm$core$Platform$Cmd$none,
					function (main) {
						return A2(
							ps.af,
							{o: model.o, W: main.W},
							parentId);
					},
					model));
		};
		var cancelDelete = function (parentId) {
			return _Utils_Tuple2(
				A3($author$project$Pages$Util$ParentEditor$Handler$mapParentStateById, parentId, $author$project$Util$Editing$toView, model),
				$elm$core$Platform$Cmd$none);
		};
		switch (msg.$) {
			case 0:
				var creation = msg.a;
				return prepareUpdateCreation(creation);
			case 2:
				return create;
			case 1:
				var creation = msg.a;
				return finishUpdateCreation(creation);
			case 3:
				var result = msg.a;
				return gotCreateResponse(result);
			case 4:
				var parentId = msg.a;
				var update = msg.b;
				return A2(edit, parentId, update);
			case 5:
				var parentId = msg.a;
				return saveEdit(parentId);
			case 6:
				var result = msg.a;
				return gotSaveEditResponse(result);
			case 7:
				var parentId = msg.a;
				return toggleControls(parentId);
			case 8:
				var parentId = msg.a;
				return enterEdit(parentId);
			case 9:
				var parentId = msg.a;
				return exitEdit(parentId);
			case 10:
				var parentId = msg.a;
				return requestDelete(parentId);
			case 11:
				var parentId = msg.a;
				return confirmDelete(parentId);
			case 12:
				var parentId = msg.a;
				return cancelDelete(parentId);
			case 13:
				var parentId = msg.a;
				var result = msg.b;
				return A2(gotDeleteResponse, parentId, result);
			case 14:
				var result = msg.a;
				return gotFetchResponse(result);
			case 15:
				var parentId = msg.a;
				return prepareDuplicate(parentId);
			case 16:
				var parentId = msg.a;
				var posix = msg.b;
				return A2(gotDuplicateTimestamp, parentId, posix);
			case 17:
				var result = msg.a;
				return gotDuplicateResponse(result);
			case 18:
				var pagination = msg.a;
				return setPagination(pagination);
			default:
				var string = msg.a;
				return setSearchString(string);
		}
	});
var $author$project$Pages$Meals$Editor$Handler$updateLogic = F2(
	function (msg, model) {
		if (!msg.$) {
			var parentEditorMsg = msg.a;
			return A3(
				$author$project$Pages$View$TristateUtil$updateFromSubModel,
				{
					jW: $author$project$Pages$Meals$Editor$Page$initialToMain,
					kj: $author$project$Pages$Meals$Editor$Page$lenses.ki.eF,
					kA: $author$project$Pages$Meals$Editor$Page$lenses.kz.eF,
					mC: $author$project$Pages$Meals$Editor$Page$ParentEditorMsg,
					mM: F2(
						function (subModelMsg, subModel) {
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								_Utils_Tuple2(subModel, $elm$core$Platform$Cmd$none),
								function (profileId) {
									return A3(
										$author$project$Pages$Util$ParentEditor$Handler$updateLogic,
										{
											iK: false,
											ae: function (authorizedAccess) {
												return A2(
													$elm$core$Basics$composeR,
													$author$project$Pages$Meals$Editor$MealCreationClientInput$toCreation,
													A2(
														$elm_community$maybe_extra$Maybe$Extra$unwrap,
														$elm$core$Platform$Cmd$none,
														A2($author$project$Pages$Meals$Editor$Requests$createMeal, authorizedAccess, profileId)));
											},
											af: function (authorizedAccess) {
												return A2($author$project$Pages$Meals$Editor$Requests$deleteMeal, authorizedAccess, profileId);
											},
											ea: function (authorizedAccess) {
												return A3($author$project$Pages$Util$Requests$duplicateMealWith, $author$project$Pages$Util$ParentEditor$Page$GotDuplicateResponse, authorizedAccess, profileId);
											},
											j8: function ($) {
												return $.gn;
											},
											kX: function (mealId) {
												return $author$project$Addresses$Frontend$mealEntryEditor.iA(
													_Utils_Tuple2(profileId, mealId));
											},
											l0: F2(
												function (authorizedAccess, mealId) {
													return A2(
														$elm$core$Basics$composeR,
														$author$project$Pages$Meals$Editor$MealUpdateClientInput$to,
														A2(
															$elm_community$maybe_extra$Maybe$Extra$unwrap,
															$elm$core$Platform$Cmd$none,
															A3($author$project$Pages$Meals$Editor$Requests$saveMeal, authorizedAccess, profileId, mealId)));
												}),
											mD: $author$project$Pages$Meals$Editor$MealUpdateClientInput$from,
											mH: A2(
												$elm$core$Basics$composeR,
												$author$project$Pages$Util$DateUtil$fromPosix,
												A2($elm$core$Basics$composeR, $author$project$Pages$Util$SimpleDateInput$from, $author$project$Pages$Meals$Editor$MealCreationClientInput$lenses.fR.eW))
										},
										subModelMsg,
										subModel);
								},
								$author$project$Pages$Meals$Editor$Page$profileId(model));
						})
				},
				parentEditorMsg,
				model);
		} else {
			var result = msg.a;
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (profile) {
						return A2(
							$author$project$Pages$View$Tristate$fromInitToMain,
							$author$project$Pages$Meals$Editor$Page$initialToMain,
							A2(
								$author$project$Pages$View$Tristate$mapInitial,
								$author$project$Pages$Meals$Editor$Page$lenses.ki.ly.eW(
									$elm$core$Maybe$Just(profile)),
								model));
					},
					result),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Meals$Editor$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Meals$Editor$Handler$updateLogic);
var $author$project$Pages$Util$ProfileChoice$Page$initialToMain = function (i) {
	return A2(
		$elm$core$Maybe$map,
		function (p) {
			return {eM: p};
		},
		i.eM);
};
var $author$project$Pages$Util$ProfileChoice$Page$lenses = {
	ki: {
		eM: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.eM;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{eM: b});
				}))
	},
	kz: {
		eM: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.eM;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{eM: b});
				}))
	}
};
var $author$project$Pages$Util$ProfileChoice$Handler$updateLogic = F2(
	function (msg, model) {
		var result = msg;
		return A3(
			$elm_community$result_extra$Result$Extra$unpack,
			function (error) {
				return _Utils_Tuple2(
					A2($author$project$Pages$View$Tristate$toError, model, error),
					$elm$core$Platform$Cmd$none);
			},
			function (profiles) {
				return _Utils_Tuple2(
					A2(
						$author$project$Pages$View$Tristate$fromInitToMain,
						$author$project$Pages$Util$ProfileChoice$Page$initialToMain,
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							$author$project$Pages$Util$ProfileChoice$Page$lenses.ki.eM.eW(
								$elm$core$Maybe$Just(profiles)),
							model)),
					$elm$core$Platform$Cmd$none);
			},
			result);
	});
var $author$project$Pages$Util$ProfileChoice$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Util$ProfileChoice$Handler$updateLogic);
var $author$project$Pages$Meals$ProfileChoice$Handler$update = $author$project$Pages$Util$ProfileChoice$Handler$update;
var $author$project$Pages$Overview$Handler$update = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Api$Types$ProfileCreation$encoderProfileCreation = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(obj.gN))
			]));
};
var $author$project$Pages$Profiles$Requests$createProfile = F2(
	function (authorizedAccess, referenceMapCreation) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$profiles.ae,
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$ProfileCreation$encoderProfileCreation(referenceMapCreation)),
				cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$Util$ParentEditor$Page$GotCreateResponse, $author$project$Api$Types$Profile$decoderProfile)
			});
	});
var $author$project$Pages$Util$Requests$deleteProfileWith = F3(
	function (mkMsg, authorizedAccess, profileId) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$profiles.af(profileId),
			{
				iO: $elm$http$Http$emptyBody,
				cz: $author$project$Util$HttpUtil$expectWhatever(mkMsg)
			});
	});
var $author$project$Pages$Profiles$Requests$deleteProfile = F2(
	function (authorizedAccess, referenceMapId) {
		return A3(
			$author$project$Pages$Util$Requests$deleteProfileWith,
			$author$project$Pages$Util$ParentEditor$Page$GotDeleteResponse(referenceMapId),
			authorizedAccess,
			referenceMapId);
	});
var $author$project$Pages$Profiles$ProfileUpdateClientInput$fromProfile = function (profile) {
	return {
		gN: A2(
			$author$project$Pages$Util$ValidatedInput$lenses.mx.eW,
			profile.gN,
			A2($author$project$Pages$Util$ValidatedInput$lenses.ig.eW, profile.gN, $author$project$Pages$Util$ValidatedInput$nonEmptyString))
	};
};
var $author$project$Api$Types$ProfileUpdate$encoderProfileUpdate = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(obj.gN))
			]));
};
var $author$project$Pages$Util$Requests$saveProfileWith = F4(
	function (mkMsg, authorizedAccess, profileId, profileUpdate) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$profiles.ac(profileId),
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$ProfileUpdate$encoderProfileUpdate(profileUpdate)),
				cz: A2($author$project$Util$HttpUtil$expectJson, mkMsg, $author$project$Api$Types$Profile$decoderProfile)
			});
	});
var $author$project$Pages$Profiles$Requests$saveProfile = $author$project$Pages$Util$Requests$saveProfileWith($author$project$Pages$Util$ParentEditor$Page$GotSaveEditResponse);
var $author$project$Pages$Profiles$ProfileCreationClientInput$toCreation = function (input) {
	return {gN: input.gN.ig};
};
var $author$project$Pages$Profiles$ProfileUpdateClientInput$toUpdate = function (input) {
	return {gN: input.gN.ig};
};
var $author$project$Pages$Profiles$Handler$updateLogic = $author$project$Pages$Util$ParentEditor$Handler$updateLogic(
	{
		iK: true,
		ae: function (authorizedAccess) {
			return A2(
				$elm$core$Basics$composeR,
				$author$project$Pages$Profiles$ProfileCreationClientInput$toCreation,
				$author$project$Pages$Profiles$Requests$createProfile(authorizedAccess));
		},
		af: $author$project$Pages$Profiles$Requests$deleteProfile,
		ea: F3(
			function (_v0, _v1, _v2) {
				return $elm$core$Platform$Cmd$none;
			}),
		j8: function ($) {
			return $.gn;
		},
		kX: function (_v3) {
			return $author$project$Addresses$Frontend$profiles.iA(0);
		},
		l0: F2(
			function (authorizedAccess, profileId) {
				return A2(
					$elm$core$Basics$composeR,
					$author$project$Pages$Profiles$ProfileUpdateClientInput$toUpdate,
					A2($author$project$Pages$Profiles$Requests$saveProfile, authorizedAccess, profileId));
			}),
		mD: $author$project$Pages$Profiles$ProfileUpdateClientInput$fromProfile,
		mH: $elm$core$Basics$always($elm$core$Basics$identity)
	});
var $author$project$Pages$Profiles$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Profiles$Handler$updateLogic);
var $author$project$Pages$Recipes$Page$GotRescaleResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Types$RecipeCreation$encoderRecipeCreation = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(obj.gN)),
				_Utils_Tuple2(
				'description',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, obj.fX))),
				_Utils_Tuple2(
				'numberOfServings',
				$elm$json$Json$Encode$float(obj.gY)),
				_Utils_Tuple2(
				'servingSize',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, obj.hF)))
			]));
};
var $author$project$Pages$Recipes$Requests$createRecipe = F2(
	function (authorizedAccess, recipeCreation) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$recipes.ae,
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$RecipeCreation$encoderRecipeCreation(recipeCreation)),
				cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$Util$ParentEditor$Page$GotCreateResponse, $author$project$Api$Types$Recipe$decoderRecipe)
			});
	});
var $author$project$Pages$Recipes$Requests$deleteRecipe = F2(
	function (authorizedAccess, recipeId) {
		return A3(
			$author$project$Pages$Util$Requests$deleteRecipeWith,
			$author$project$Pages$Util$ParentEditor$Page$GotDeleteResponse(recipeId),
			authorizedAccess,
			recipeId);
	});
var $author$project$Pages$Recipes$Requests$saveRecipe = $author$project$Pages$Util$Requests$saveRecipeWith($author$project$Pages$Util$ParentEditor$Page$GotSaveEditResponse);
var $author$project$Pages$Recipes$RecipeCreationClientInput$toCreation = function (input) {
	return {fX: input.fX, gN: input.gN.ig, gY: input.gY.ig, hF: input.hF};
};
var $author$project$Pages$Recipes$Handler$updateLogic = F2(
	function (msg, model) {
		var rescale = function (recipeId) {
			return _Utils_Tuple2(
				model,
				A3(
					$author$project$Pages$View$Tristate$foldMain,
					$elm$core$Platform$Cmd$none,
					function (main) {
						return A3(
							$author$project$Pages$Util$Requests$rescaleRecipeWith,
							$author$project$Pages$Recipes$Page$GotRescaleResponse,
							{o: model.o, W: main.W},
							recipeId);
					},
					model));
		};
		var gotRescaleResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (recipe) {
						return A2(
							$author$project$Pages$View$Tristate$mapMain,
							A3(
								$author$project$Util$LensUtil$updateById,
								recipe.gn,
								$author$project$Pages$Util$ParentEditor$Page$lenses.kz.lu,
								$author$project$Util$Editing$asViewWithElement(recipe)),
							model);
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		switch (msg.$) {
			case 0:
				var parentMsg = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Pages$Recipes$Page$ParentMsg),
					A3(
						$author$project$Pages$Util$ParentEditor$Handler$updateLogic,
						{
							iK: true,
							ae: function (authorizedAccess) {
								return A2(
									$elm$core$Basics$composeR,
									$author$project$Pages$Recipes$RecipeCreationClientInput$toCreation,
									$author$project$Pages$Recipes$Requests$createRecipe(authorizedAccess));
							},
							af: $author$project$Pages$Recipes$Requests$deleteRecipe,
							ea: $author$project$Pages$Util$Requests$duplicateRecipeWith($author$project$Pages$Util$ParentEditor$Page$GotDuplicateResponse),
							j8: function ($) {
								return $.gn;
							},
							kX: $author$project$Addresses$Frontend$ingredientEditor.iA,
							l0: F2(
								function (authorizedAccess, recipeId) {
									return A2(
										$elm$core$Basics$composeR,
										$author$project$Pages$Recipes$RecipeUpdateClientInput$to,
										A2($author$project$Pages$Recipes$Requests$saveRecipe, authorizedAccess, recipeId));
								}),
							mD: $author$project$Pages$Recipes$RecipeUpdateClientInput$from,
							mH: $elm$core$Basics$always($elm$core$Basics$identity)
						},
						parentMsg,
						model));
			case 1:
				var recipeId = msg.a;
				return rescale(recipeId);
			default:
				var result = msg.a;
				return gotRescaleResponse(result);
		}
	});
var $author$project$Pages$Recipes$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Recipes$Handler$updateLogic);
var $author$project$Pages$Recovery$Confirm$Page$GotConfirmResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Types$PasswordChangeRequest$encoderPasswordChangeRequest = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'password',
				$elm$json$Json$Encode$string(obj.g5))
			]));
};
var $author$project$Pages$Recovery$Confirm$Requests$confirm = function (params) {
	return A3(
		$author$project$Util$HttpUtil$runPatternWithJwt,
		{o: params.o, W: params.lK},
		$author$project$Addresses$Backend$users.lJ.d4,
		{
			iO: $elm$http$Http$jsonBody(
				$author$project$Api$Types$PasswordChangeRequest$encoderPasswordChangeRequest(
					{g5: params.g5})),
			cz: $author$project$Util$HttpUtil$expectWhatever($author$project$Pages$Recovery$Confirm$Page$GotConfirmResponse)
		});
};
var $author$project$Pages$Recovery$Confirm$Handler$confirm = function (model) {
	return _Utils_Tuple2(
		model,
		A3(
			$author$project$Pages$View$Tristate$foldMain,
			$elm$core$Platform$Cmd$none,
			function (main) {
				return $author$project$Pages$Recovery$Confirm$Requests$confirm(
					{o: model.o, g5: main.eH.lw, lK: main.lK});
			},
			model));
};
var $author$project$Pages$Recovery$Confirm$Page$Confirmed = 1;
var $author$project$Pages$Recovery$Confirm$Page$lenses = {
	kz: {
		gK: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.gK;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{gK: b});
				})),
		eH: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.eH;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{eH: b});
				}))
	}
};
var $author$project$Pages$Recovery$Confirm$Handler$gotConfirmResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (_v0) {
					return A2(
						$author$project$Pages$View$Tristate$mapMain,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Pages$Recovery$Confirm$Page$lenses.kz.gK.eW(1),
							$author$project$Pages$Recovery$Confirm$Page$lenses.kz.eH.eW($author$project$Pages$Util$PasswordInput$initial)),
						model);
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Recovery$Confirm$Handler$setPasswordInput = F2(
	function (model, passwordInput) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				$author$project$Pages$Recovery$Confirm$Page$lenses.kz.eH.eW(passwordInput),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Recovery$Confirm$Handler$updateLogic = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var passwordInput = msg.a;
				return A2($author$project$Pages$Recovery$Confirm$Handler$setPasswordInput, model, passwordInput);
			case 1:
				return $author$project$Pages$Recovery$Confirm$Handler$confirm(model);
			default:
				var result = msg.a;
				return A2($author$project$Pages$Recovery$Confirm$Handler$gotConfirmResponse, model, result);
		}
	});
var $author$project$Pages$Recovery$Confirm$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Recovery$Confirm$Handler$updateLogic);
var $author$project$Pages$Recovery$Request$Page$GotFindResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Recovery$Request$Requests$find = F2(
	function (configuration, searchString) {
		return A3(
			$author$project$Util$HttpUtil$runPattern,
			configuration,
			$author$project$Addresses$Backend$users.lJ.jQ(searchString),
			{
				iO: $elm$http$Http$emptyBody,
				cz: A2(
					$author$project$Util$HttpUtil$expectJson,
					$author$project$Pages$Recovery$Request$Page$GotFindResponse,
					$elm$json$Json$Decode$list($author$project$Api$Types$User$decoderUser)),
				W: $elm$core$Maybe$Nothing
			});
	});
var $author$project$Pages$Recovery$Request$Handler$find = function (model) {
	return _Utils_Tuple2(
		model,
		A3(
			$author$project$Pages$View$Tristate$foldMain,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.hz;
				},
				$author$project$Pages$Recovery$Request$Requests$find(model.o)),
			model));
};
var $author$project$Pages$Recovery$Request$Page$Requesting = 1;
var $author$project$Pages$Recovery$Request$Page$lenses = {
	kz: {
		gK: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.gK;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{gK: b});
				})),
		hz: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.hz;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{hz: b});
				})),
		mN: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.mN;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{mN: b});
				}))
	}
};
var $author$project$Pages$Recovery$Request$Page$GotRequestRecoveryResponse = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Types$RecoveryRequest$encoderRecoveryRequest = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'userId',
				$danyx23$elm_uuid$Uuid$encode(obj.$8))
			]));
};
var $author$project$Pages$Recovery$Request$Requests$requestRecovery = F2(
	function (configuration, userId) {
		return A3(
			$author$project$Util$HttpUtil$runPattern,
			configuration,
			$author$project$Addresses$Backend$users.lJ.eS,
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$RecoveryRequest$encoderRecoveryRequest(
						{$8: userId})),
				cz: $author$project$Util$HttpUtil$expectWhatever($author$project$Pages$Recovery$Request$Page$GotRequestRecoveryResponse),
				W: $elm$core$Maybe$Nothing
			});
	});
var $author$project$Pages$Recovery$Request$Handler$requestRecovery = F2(
	function (model, userId) {
		return _Utils_Tuple2(
			model,
			A2($author$project$Pages$Recovery$Request$Requests$requestRecovery, model.o, userId));
	});
var $author$project$Pages$Recovery$Request$Handler$gotFindResponse = F2(
	function (model, result) {
		return A3(
			$elm_community$result_extra$Result$Extra$unpack,
			function (error) {
				return _Utils_Tuple2(
					A2($author$project$Pages$View$Tristate$toError, model, error),
					$elm$core$Platform$Cmd$none);
			},
			function (users) {
				if (users.b && (!users.b.b)) {
					var user = users.a;
					return A2($author$project$Pages$Recovery$Request$Handler$requestRecovery, model, user.gn);
				} else {
					return _Utils_Tuple2(
						A2(
							$author$project$Pages$View$Tristate$mapMain,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Pages$Recovery$Request$Page$lenses.kz.mN.eW(users),
								$author$project$Pages$Recovery$Request$Page$lenses.kz.gK.eW(1)),
							model),
						$elm$core$Platform$Cmd$none);
				}
			},
			result);
	});
var $author$project$Pages$Recovery$Request$Page$Requested = 2;
var $author$project$Pages$Recovery$Request$Handler$gotRequestRecoveryResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (_v0) {
					return A2(
						$author$project$Pages$View$Tristate$mapMain,
						$author$project$Pages$Recovery$Request$Page$lenses.kz.gK.eW(2),
						model);
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Recovery$Request$Handler$setSearchString = F2(
	function (model, string) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pages$Recovery$Request$Page$lenses.kz.hz.eW(string),
					$author$project$Pages$Recovery$Request$Page$lenses.kz.gK.eW(0)),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Recovery$Request$Handler$updateLogic = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return $author$project$Pages$Recovery$Request$Handler$find(model);
			case 1:
				var result = msg.a;
				return A2($author$project$Pages$Recovery$Request$Handler$gotFindResponse, model, result);
			case 2:
				var string = msg.a;
				return A2($author$project$Pages$Recovery$Request$Handler$setSearchString, model, string);
			case 3:
				var userId = msg.a;
				return A2($author$project$Pages$Recovery$Request$Handler$requestRecovery, model, userId);
			default:
				var result = msg.a;
				return A2($author$project$Pages$Recovery$Request$Handler$gotRequestRecoveryResponse, model, result);
		}
	});
var $author$project$Pages$Recovery$Request$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Recovery$Request$Handler$updateLogic);
var $author$project$Pages$ReferenceEntries$Page$initialToMain = function (i) {
	return A2(
		$elm$core$Maybe$andThen,
		function (entries) {
			return A2(
				$elm$core$Maybe$map,
				function (map) {
					return {f5: entries, W: i.W, gE: map};
				},
				$author$project$Pages$Util$Parent$Page$initialToMain(i.gE));
		},
		$author$project$Pages$Util$Choice$Page$initialToMain(i.f5));
};
var $author$project$Pages$ReferenceEntries$Page$lenses = {
	ki: {
		f5: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.f5;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{f5: b});
				})),
		gE: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.gE;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{gE: b});
				}))
	},
	kz: {
		f5: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.f5;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{f5: b});
				})),
		gE: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.gE;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{gE: b});
				}))
	}
};
var $author$project$Api$Types$ReferenceEntryCreation$encoderReferenceEntryCreation = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nutrientCode',
				$elm$json$Json$Encode$int(obj.gZ)),
				_Utils_Tuple2(
				'amount',
				$elm$json$Json$Encode$float(obj.fp))
			]));
};
var $author$project$Pages$ReferenceEntries$Entries$Requests$createReferenceEntry = F3(
	function (authorizedAccess, referenceMapId, referenceNutrientCreation) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$references.f5.ae(referenceMapId),
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$ReferenceEntryCreation$encoderReferenceEntryCreation(referenceNutrientCreation)),
				cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$Util$Choice$Page$GotCreateResponse, $author$project$Api$Types$ReferenceEntry$decoderReferenceEntry)
			});
	});
var $author$project$Pages$ReferenceEntries$ReferenceEntryCreationClientInput$default = function (nutrientCode) {
	return {fp: $author$project$Pages$Util$ValidatedInput$positive, gZ: nutrientCode};
};
var $author$project$Pages$ReferenceEntries$Entries$Requests$deleteReferenceEntry = F3(
	function (authorizedAccess, referenceMapId, nutrientCode) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			A2($author$project$Addresses$Backend$references.f5.af, referenceMapId, nutrientCode),
			{
				iO: $elm$http$Http$emptyBody,
				cz: $author$project$Util$HttpUtil$expectWhatever(
					$author$project$Pages$Util$Choice$Page$GotDeleteResponse(nutrientCode))
			});
	});
var $author$project$Api$Types$NutrientUnit$toString = function (nutrientUnit) {
	switch (nutrientUnit) {
		case 0:
			return 'g';
		case 1:
			return 'IU';
		case 2:
			return 'kCal';
		case 3:
			return 'kJ';
		case 4:
			return 'µg';
		case 5:
			return 'mg';
		default:
			return 'NE';
	}
};
var $author$project$Api$Types$NutrientUnit$encoderNutrientUnit = A2($elm$core$Basics$composeR, $author$project$Api$Types$NutrientUnit$toString, $elm$json$Json$Encode$string);
var $author$project$Api$Types$Nutrient$encoderNutrient = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(obj.gn)),
				_Utils_Tuple2(
				'code',
				$elm$json$Json$Encode$int(obj.fJ)),
				_Utils_Tuple2(
				'symbol',
				$elm$json$Json$Encode$string(obj.hV)),
				_Utils_Tuple2(
				'unit',
				$author$project$Api$Types$NutrientUnit$encoderNutrientUnit(obj.ib)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(obj.gN)),
				_Utils_Tuple2(
				'nameFrench',
				$elm$json$Json$Encode$string(obj.gO)),
				_Utils_Tuple2(
				'tagName',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, obj.hW))),
				_Utils_Tuple2(
				'decimals',
				$elm$json$Json$Encode$int(obj.fT))
			]));
};
var $author$project$Pages$ReferenceEntries$ReferenceEntryUpdateClientInput$from = function (referenceEntry) {
	return {
		fp: A2(
			$author$project$Pages$Util$ValidatedInput$lenses.mx.eW,
			$elm$core$String$fromFloat(referenceEntry.fp),
			A2($author$project$Pages$Util$ValidatedInput$lenses.ig.eW, referenceEntry.fp, $author$project$Pages$Util$ValidatedInput$positive))
	};
};
var $author$project$Api$Types$ReferenceEntryUpdate$encoderReferenceEntryUpdate = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'amount',
				$elm$json$Json$Encode$float(obj.fp))
			]));
};
var $author$project$Pages$ReferenceEntries$Entries$Requests$saveReferenceEntry = F4(
	function (authorizedAccess, referenceMapId, nutrientCode, referenceEntryUpdate) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			A2($author$project$Addresses$Backend$references.f5.ac, referenceMapId, nutrientCode),
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$ReferenceEntryUpdate$encoderReferenceEntryUpdate(referenceEntryUpdate)),
				cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$Util$Choice$Page$GotSaveEditResponse, $author$project$Api$Types$ReferenceEntry$decoderReferenceEntry)
			});
	});
var $author$project$Ports$storeNutrients = _Platform_outgoingPort('storeNutrients', $elm$json$Json$Encode$string);
var $author$project$Pages$ReferenceEntries$ReferenceEntryUpdateClientInput$to = function (input) {
	return {fp: input.fp.ig};
};
var $author$project$Pages$ReferenceEntries$ReferenceEntryCreationClientInput$toCreation = function (input) {
	return {fp: input.fp.ig, gZ: input.gZ};
};
var $author$project$Pages$ReferenceEntries$Entries$Handler$updateLogic = $author$project$Pages$Util$Choice$Handler$updateLogic(
	{
		iY: function ($) {
			return $.gZ;
		},
		iZ: function ($) {
			return $.gZ;
		},
		je: F3(
			function (authorizedAccess, referenceMapId, creation) {
				return A3(
					$author$project$Pages$ReferenceEntries$Entries$Requests$createReferenceEntry,
					authorizedAccess,
					referenceMapId,
					$author$project$Pages$ReferenceEntries$ReferenceEntryCreationClientInput$toCreation(creation));
			}),
		jp: $author$project$Pages$ReferenceEntries$Entries$Requests$deleteReferenceEntry,
		j6: function ($) {
			return $.fJ;
		},
		j7: function ($) {
			return $.gZ;
		},
		l1: F4(
			function (authorizedAccess, referenceMapId, nutrientCode, update) {
				return A4(
					$author$project$Pages$ReferenceEntries$Entries$Requests$saveReferenceEntry,
					authorizedAccess,
					referenceMapId,
					nutrientCode,
					$author$project$Pages$ReferenceEntries$ReferenceEntryUpdateClientInput$to(update));
			}),
		mn: A2(
			$elm$core$Basics$composeR,
			$elm$json$Json$Encode$list($author$project$Api$Types$Nutrient$encoderNutrient),
			A2(
				$elm$core$Basics$composeR,
				$elm$json$Json$Encode$encode(0),
				$author$project$Ports$storeNutrients)),
		mB: function (nutrient) {
			return $author$project$Pages$ReferenceEntries$ReferenceEntryCreationClientInput$default(nutrient.fJ);
		},
		mD: $author$project$Pages$ReferenceEntries$ReferenceEntryUpdateClientInput$from
	});
var $author$project$Pages$Util$Requests$deleteReferenceMapWith = F3(
	function (mkMsg, authorizedAccess, referenceMapId) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$references.af(referenceMapId),
			{
				iO: $elm$http$Http$emptyBody,
				cz: $author$project$Util$HttpUtil$expectWhatever(mkMsg)
			});
	});
var $author$project$Pages$Util$Requests$duplicateReferenceMapWith = F4(
	function (mkMsg, authorizedAccess, referenceMapId, timestamp) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$references.ea(referenceMapId),
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$SimpleDate$encoderSimpleDate(
						$author$project$Pages$Util$DateUtil$fromPosix(timestamp))),
				cz: A2($author$project$Util$HttpUtil$expectJson, mkMsg, $author$project$Api$Types$ReferenceMap$decoderReferenceMap)
			});
	});
var $author$project$Pages$ReferenceMaps$ReferenceMapUpdateClientInput$from = function (referenceMap) {
	return {
		gN: A2(
			$author$project$Pages$Util$ValidatedInput$lenses.mx.eW,
			referenceMap.gN,
			A2($author$project$Pages$Util$ValidatedInput$lenses.ig.eW, referenceMap.gN, $author$project$Pages$Util$ValidatedInput$nonEmptyString))
	};
};
var $author$project$Api$Types$ReferenceMapUpdate$encoderReferenceMapUpdate = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(obj.gN))
			]));
};
var $author$project$Pages$Util$Requests$saveReferenceMapWith = F4(
	function (mkMsg, authorizedAccess, referenceMapId, referenceMapUpdate) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$references.ac(referenceMapId),
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$ReferenceMapUpdate$encoderReferenceMapUpdate(referenceMapUpdate)),
				cz: A2($author$project$Util$HttpUtil$expectJson, mkMsg, $author$project$Api$Types$ReferenceMap$decoderReferenceMap)
			});
	});
var $author$project$Pages$ReferenceMaps$ReferenceMapUpdateClientInput$to = function (input) {
	return {gN: input.gN.ig};
};
var $author$project$Pages$ReferenceEntries$Map$Handler$updateLogic = $author$project$Pages$Util$Parent$Handler$updateLogic(
	{
		af: $author$project$Pages$Util$Requests$deleteReferenceMapWith($author$project$Pages$Util$Parent$Page$GotDeleteResponse),
		ea: $author$project$Pages$Util$Requests$duplicateReferenceMapWith($author$project$Pages$Util$Parent$Page$GotDuplicateResponse),
		j5: function ($) {
			return $.gn;
		},
		kV: $author$project$Addresses$Frontend$referenceMaps.iA,
		kW: $author$project$Addresses$Frontend$referenceEntries.iA,
		l0: F2(
			function (authorizedAccess, referenceMapId) {
				return A2(
					$elm$core$Basics$composeR,
					$author$project$Pages$ReferenceMaps$ReferenceMapUpdateClientInput$to,
					A2(
						$elm$core$Basics$composeR,
						A3($author$project$Pages$Util$Requests$saveReferenceMapWith, $author$project$Pages$Util$Parent$Page$GotSaveEditResponse, authorizedAccess, referenceMapId),
						$elm$core$Maybe$Just));
			}),
		mD: $author$project$Pages$ReferenceMaps$ReferenceMapUpdateClientInput$from
	});
var $author$project$Api$Types$Nutrient$Nutrient = F8(
	function (id, code, symbol, unit, name, nameFrench, tagName, decimals) {
		return {fJ: code, fT: decimals, gn: id, gN: name, gO: nameFrench, hV: symbol, hW: tagName, ib: unit};
	});
var $author$project$Api$Types$Nutrient$decoderNutrient = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'decimals',
	$elm$json$Json$Decode$int,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'tagName',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'nameFrench',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'unit',
					$author$project$Api$Types$NutrientUnit$decoderNutrientUnit,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'symbol',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'code',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$int,
								$elm$json$Json$Decode$succeed($author$project$Api$Types$Nutrient$Nutrient)))))))));
var $author$project$Pages$ReferenceEntries$Entries$Requests$fetchNutrients = function (authorizedAccess) {
	return A3(
		$author$project$Util$HttpUtil$runPatternWithJwt,
		authorizedAccess,
		$author$project$Addresses$Backend$stats.k8,
		{
			iO: $elm$http$Http$emptyBody,
			cz: A2(
				$author$project$Util$HttpUtil$expectJson,
				$author$project$Pages$Util$Choice$Page$GotFetchChoicesResponse,
				$elm$json$Json$Decode$list($author$project$Api$Types$Nutrient$decoderNutrient))
		});
};
var $author$project$Util$DictList$isEmpty = A2($elm$core$Basics$composeR, $author$project$Util$DictList$toList, $elm$core$List$isEmpty);
var $author$project$Pages$ReferenceEntries$Handler$updateNutrients = function (model) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeString(
			$elm$json$Json$Decode$list($author$project$Api$Types$Nutrient$decoderNutrient)),
		A2(
			$elm_community$result_extra$Result$Extra$unpack,
			function (error) {
				return _Utils_Tuple2(
					A2(
						$author$project$Pages$View$Tristate$toError,
						model,
						$author$project$Util$HttpUtil$jsonErrorToError(error)),
					$elm$core$Platform$Cmd$none);
			},
			function (nutrients) {
				return _Utils_Tuple2(
					A2(
						$author$project$Pages$View$Tristate$fromInitToMain,
						$author$project$Pages$ReferenceEntries$Page$initialToMain,
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$Choice$Page$lenses.ki.i$, $author$project$Pages$ReferenceEntries$Page$lenses.ki.f5).eW(
								A2(
									$elm_community$maybe_extra$Maybe$Extra$filter,
									A2($elm$core$Basics$composeR, $author$project$Util$DictList$isEmpty, $elm$core$Basics$not),
									$elm$core$Maybe$Just(
										A2(
											$author$project$Util$DictList$fromListWithKey,
											function ($) {
												return $.fJ;
											},
											nutrients)))),
							model)),
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						$elm$core$Platform$Cmd$none,
						function (initial) {
							return A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Pages$ReferenceEntries$Page$EntriesMsg,
								$author$project$Pages$ReferenceEntries$Entries$Requests$fetchNutrients(
									{o: model.o, W: initial.W}));
						},
						A2(
							$elm_community$maybe_extra$Maybe$Extra$filter,
							$elm$core$Basics$always(
								$elm$core$List$isEmpty(nutrients)),
							$author$project$Pages$View$Tristate$lenses.ki.jZ(model))));
			}));
};
var $author$project$Pages$ReferenceEntries$Handler$updateLogic = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var mapMsg = msg.a;
				return A3(
					$author$project$Pages$View$TristateUtil$updateFromSubModel,
					{jW: $author$project$Pages$ReferenceEntries$Page$initialToMain, kj: $author$project$Pages$ReferenceEntries$Page$lenses.ki.gE, kA: $author$project$Pages$ReferenceEntries$Page$lenses.kz.gE, mC: $author$project$Pages$ReferenceEntries$Page$MapMsg, mM: $author$project$Pages$ReferenceEntries$Map$Handler$updateLogic},
					mapMsg,
					model);
			case 1:
				var entriesMsg = msg.a;
				return A3(
					$author$project$Pages$View$TristateUtil$updateFromSubModel,
					{jW: $author$project$Pages$ReferenceEntries$Page$initialToMain, kj: $author$project$Pages$ReferenceEntries$Page$lenses.ki.f5, kA: $author$project$Pages$ReferenceEntries$Page$lenses.kz.f5, mC: $author$project$Pages$ReferenceEntries$Page$EntriesMsg, mM: $author$project$Pages$ReferenceEntries$Entries$Handler$updateLogic},
					entriesMsg,
					model);
			default:
				var string = msg.a;
				return A2($author$project$Pages$ReferenceEntries$Handler$updateNutrients, model, string);
		}
	});
var $author$project$Pages$ReferenceEntries$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$ReferenceEntries$Handler$updateLogic);
var $author$project$Api$Types$ReferenceMapCreation$encoderReferenceMapCreation = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(obj.gN))
			]));
};
var $author$project$Pages$ReferenceMaps$Requests$createReferenceMap = F2(
	function (authorizedAccess, referenceMapCreation) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$references.ae,
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$ReferenceMapCreation$encoderReferenceMapCreation(referenceMapCreation)),
				cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$Util$ParentEditor$Page$GotCreateResponse, $author$project$Api$Types$ReferenceMap$decoderReferenceMap)
			});
	});
var $author$project$Pages$ReferenceMaps$Requests$deleteReferenceMap = F2(
	function (authorizedAccess, referenceMapId) {
		return A3(
			$author$project$Pages$Util$Requests$deleteReferenceMapWith,
			$author$project$Pages$Util$ParentEditor$Page$GotDeleteResponse(referenceMapId),
			authorizedAccess,
			referenceMapId);
	});
var $author$project$Pages$ReferenceMaps$Requests$saveReferenceMap = $author$project$Pages$Util$Requests$saveReferenceMapWith($author$project$Pages$Util$ParentEditor$Page$GotSaveEditResponse);
var $author$project$Pages$ReferenceMaps$ReferenceMapCreationClientInput$toCreation = function (input) {
	return {gN: input.gN.ig};
};
var $author$project$Pages$ReferenceMaps$Handler$updateLogic = $author$project$Pages$Util$ParentEditor$Handler$updateLogic(
	{
		iK: true,
		ae: function (authorizedAccess) {
			return A2(
				$elm$core$Basics$composeR,
				$author$project$Pages$ReferenceMaps$ReferenceMapCreationClientInput$toCreation,
				$author$project$Pages$ReferenceMaps$Requests$createReferenceMap(authorizedAccess));
		},
		af: $author$project$Pages$ReferenceMaps$Requests$deleteReferenceMap,
		ea: $author$project$Pages$Util$Requests$duplicateReferenceMapWith($author$project$Pages$Util$ParentEditor$Page$GotDuplicateResponse),
		j8: function ($) {
			return $.gn;
		},
		kX: $author$project$Addresses$Frontend$referenceEntries.iA,
		l0: F2(
			function (authorizedAccess, referenceMapId) {
				return A2(
					$elm$core$Basics$composeR,
					$author$project$Pages$ReferenceMaps$ReferenceMapUpdateClientInput$to,
					A2($author$project$Pages$ReferenceMaps$Requests$saveReferenceMap, authorizedAccess, referenceMapId));
			}),
		mD: $author$project$Pages$ReferenceMaps$ReferenceMapUpdateClientInput$from,
		mH: $elm$core$Basics$always($elm$core$Basics$identity)
	});
var $author$project$Pages$ReferenceMaps$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$ReferenceMaps$Handler$updateLogic);
var $author$project$Pages$Registration$Confirm$Page$Confirmed = 1;
var $author$project$Pages$Registration$Confirm$Page$lenses = {
	kz: {
		d2: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.d2;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{d2: b});
				})),
		gK: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.gK;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{gK: b});
				}))
	}
};
var $author$project$Pages$Registration$Confirm$Handler$gotResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (_v0) {
					return A2(
						$author$project$Pages$View$Tristate$mapMain,
						$author$project$Pages$Registration$Confirm$Page$lenses.kz.gK.eW(1),
						model);
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Registration$Confirm$Page$GotResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Types$CreationComplement$encoderCreationComplement = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'displayName',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, obj.fZ))),
				_Utils_Tuple2(
				'password',
				$elm$json$Json$Encode$string(obj.g5))
			]));
};
var $author$project$Pages$Registration$Confirm$Requests$request = F3(
	function (configuration, jwt, complement) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			{o: configuration, W: jwt},
			$author$project$Addresses$Backend$users.lR.d4,
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$CreationComplement$encoderCreationComplement(complement)),
				cz: $author$project$Util$HttpUtil$expectWhatever($author$project$Pages$Registration$Confirm$Page$GotResponse)
			});
	});
var $author$project$Pages$Registration$Confirm$Handler$request = function (model) {
	return _Utils_Tuple2(
		model,
		A3(
			$author$project$Pages$View$Tristate$foldMain,
			$elm$core$Platform$Cmd$none,
			function (main) {
				return A3(
					$author$project$Pages$Registration$Confirm$Requests$request,
					model.o,
					main.lS,
					{fZ: main.d2.fZ, g5: main.d2.eH.lw});
			},
			model));
};
var $author$project$Pages$Registration$Confirm$Handler$setComplementInput = F2(
	function (model, complementInput) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				$author$project$Pages$Registration$Confirm$Page$lenses.kz.d2.eW(complementInput),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Registration$Confirm$Handler$updateLogic = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var complementInput = msg.a;
				return A2($author$project$Pages$Registration$Confirm$Handler$setComplementInput, model, complementInput);
			case 1:
				return $author$project$Pages$Registration$Confirm$Handler$request(model);
			default:
				var result = msg.a;
				return A2($author$project$Pages$Registration$Confirm$Handler$gotResponse, model, result);
		}
	});
var $author$project$Pages$Registration$Confirm$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Registration$Confirm$Handler$updateLogic);
var $author$project$Pages$Registration$Request$Page$Confirmed = 1;
var $author$project$Pages$Registration$Request$Page$lenses = {
	kz: {
		f2: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.f2;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{f2: b});
				})),
		gK: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.gK;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{gK: b});
				})),
		gU: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.gU;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{gU: b});
				}))
	}
};
var $author$project$Pages$Registration$Request$Handler$gotRequestResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (_v0) {
					return A2(
						$author$project$Pages$View$Tristate$mapMain,
						$author$project$Pages$Registration$Request$Page$lenses.kz.gK.eW(1),
						model);
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Registration$Request$Page$GotRequestResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Types$UserIdentifier$encoderUserIdentifier = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nickname',
				$elm$json$Json$Encode$string(obj.gU)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(obj.f2))
			]));
};
var $author$project$Pages$Registration$Request$Requests$request = F2(
	function (configuration, userIdentifier) {
		return A3(
			$author$project$Util$HttpUtil$runPattern,
			configuration,
			$author$project$Addresses$Backend$users.lR.eS,
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$UserIdentifier$encoderUserIdentifier(userIdentifier)),
				cz: $author$project$Util$HttpUtil$expectWhatever($author$project$Pages$Registration$Request$Page$GotRequestResponse),
				W: $elm$core$Maybe$Nothing
			});
	});
var $author$project$Pages$Registration$Request$Handler$request = function (model) {
	return _Utils_Tuple2(
		model,
		A3(
			$author$project$Pages$View$Tristate$foldMain,
			$elm$core$Platform$Cmd$none,
			function (main) {
				return A2(
					$author$project$Pages$Registration$Request$Requests$request,
					model.o,
					{f2: main.f2.ig, gU: main.gU.ig});
			},
			model));
};
var $author$project$Pages$Registration$Request$Handler$setEmail = F2(
	function (model, email) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				$author$project$Pages$Registration$Request$Page$lenses.kz.f2.eW(email),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Registration$Request$Handler$setNickname = F2(
	function (model, nickname) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				$author$project$Pages$Registration$Request$Page$lenses.kz.gU.eW(nickname),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Registration$Request$Handler$updateLogic = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var nickname = msg.a;
				return A2($author$project$Pages$Registration$Request$Handler$setNickname, model, nickname);
			case 1:
				var email = msg.a;
				return A2($author$project$Pages$Registration$Request$Handler$setEmail, model, email);
			case 2:
				return $author$project$Pages$Registration$Request$Handler$request(model);
			default:
				var result = msg.a;
				return A2($author$project$Pages$Registration$Request$Handler$gotRequestResponse, model, result);
		}
	});
var $author$project$Pages$Registration$Request$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Registration$Request$Handler$updateLogic);
var $author$project$Addresses$StatisticsVariant$ComplexFood = 1;
var $author$project$Pages$Statistics$ComplexFood$Search$Pagination$initial = {d3: $author$project$Pages$Util$PaginationSettings$initial};
var $author$project$Pages$Statistics$ComplexFood$Search$Page$initialToMain = function (i) {
	return A2(
		$elm$core$Maybe$map,
		function (complexFoods) {
			return {d3: complexFoods, i7: '', W: i.W, lt: $author$project$Pages$Statistics$ComplexFood$Search$Pagination$initial, ii: 1};
		},
		i.d3);
};
var $author$project$Pages$Statistics$ComplexFood$Search$Page$lenses = {
	ki: {
		d3: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.d3;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{d3: b});
				}))
	},
	kz: {
		d3: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.d3;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{d3: b});
				})),
		i7: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.i7;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{i7: b});
				})),
		lt: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lt;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lt: b});
				}))
	}
};
var $author$project$Pages$Statistics$ComplexFood$Search$Handler$gotFetchComplexFoodsResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (complexFoods) {
					return A2(
						$author$project$Pages$View$Tristate$fromInitToMain,
						$author$project$Pages$Statistics$ComplexFood$Search$Page$initialToMain,
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							$author$project$Pages$Statistics$ComplexFood$Search$Page$lenses.ki.d3.eW(
								$elm$core$Maybe$Just(complexFoods)),
							model));
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$ComplexFood$Search$Handler$setComplexFoodsPagination = F2(
	function (model, pagination) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				$author$project$Pages$Statistics$ComplexFood$Search$Page$lenses.kz.lt.eW(pagination),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$ComplexFood$Search$Handler$setSearchString = F2(
	function (model, string) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				$author$project$Pages$Statistics$ComplexFood$Search$Page$lenses.kz.i7.eW(string),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$ComplexFood$Search$Handler$updateLogic = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var string = msg.a;
				return A2($author$project$Pages$Statistics$ComplexFood$Search$Handler$setSearchString, model, string);
			case 1:
				var pagination = msg.a;
				return A2($author$project$Pages$Statistics$ComplexFood$Search$Handler$setComplexFoodsPagination, model, pagination);
			default:
				var result = msg.a;
				return A2($author$project$Pages$Statistics$ComplexFood$Search$Handler$gotFetchComplexFoodsResponse, model, result);
		}
	});
var $author$project$Pages$Statistics$ComplexFood$Search$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Statistics$ComplexFood$Search$Handler$updateLogic);
var $author$project$Pages$Statistics$StatisticsUtil$initialWith = function (referenceTrees) {
	return {k9: '', ds: $elm$core$Maybe$Nothing, lO: referenceTrees};
};
var $author$project$Pages$Statistics$ComplexFood$Select$Page$initialToMain = function (i) {
	return A4(
		$elm$core$Maybe$map3,
		F3(
			function (referenceTrees, complexFood, complexFoodStats) {
				return {
					i4: complexFood,
					bB: complexFoodStats,
					W: i.W,
					hO: $author$project$Pages$Statistics$StatisticsUtil$initialWith(referenceTrees),
					ii: 1
				};
			}),
		i.lO,
		i.i4,
		i.i6);
};
var $author$project$Pages$Statistics$ComplexFood$Select$Page$lenses = {
	ki: {
		i4: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.i4;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{i4: b});
				})),
		i6: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.i6;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{i6: b});
				})),
		lO: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lO;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lO: b});
				}))
	},
	kz: {
		i4: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.i4;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{i4: b});
				})),
		bB: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.bB;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{bB: b});
				})),
		hO: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.hO;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{hO: b});
				}))
	}
};
var $author$project$Pages$Statistics$ComplexFood$Select$Handler$gotFetchComplexFoodResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (complexFood) {
					return A2(
						$author$project$Pages$View$Tristate$fromInitToMain,
						$author$project$Pages$Statistics$ComplexFood$Select$Page$initialToMain,
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							$author$project$Pages$Statistics$ComplexFood$Select$Page$lenses.ki.i4.eW(
								$elm$core$Maybe$Just(complexFood)),
							model));
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $author$project$Pages$Statistics$StatisticsRequests$gotFetchReferenceTreesResponseWith = F3(
	function (ps, model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (referenceTrees) {
					var referenceNutrientTrees = A2(
						$author$project$Util$DictList$fromListWithKey,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.gE;
							},
							function ($) {
								return $.gn;
							}),
						A2(
							$elm$core$List$map,
							function (referenceTree) {
								return {
									gE: referenceTree.hm,
									ih: $elm$core$Dict$fromList(
										A2(
											$elm$core$List$map,
											function (referenceValue) {
												return _Utils_Tuple2(referenceValue.gZ, referenceValue.hl);
											},
											referenceTree.k8))
								};
							},
							referenceTrees));
					return A2(
						$author$project$Pages$View$Tristate$fromInitToMain,
						ps.kk,
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							ps.lP.eW(
								$elm$core$Maybe$Just(referenceNutrientTrees)),
							model));
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$ComplexFood$Select$Handler$gotFetchReferenceTreesResponse = $author$project$Pages$Statistics$StatisticsRequests$gotFetchReferenceTreesResponseWith(
	{kk: $author$project$Pages$Statistics$ComplexFood$Select$Page$initialToMain, lP: $author$project$Pages$Statistics$ComplexFood$Select$Page$lenses.ki.lO});
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$Pages$Statistics$StatisticsLenses$totalOnlyStatsNutrients = A2(
	$arturopala$elm_monocle$Monocle$Lens$Lens,
	function ($) {
		return $.k8;
	},
	F2(
		function (b, a) {
			return _Utils_update(
				a,
				{k8: b});
		}));
var $author$project$Pages$Statistics$ComplexFood$Select$Handler$gotFetchStatsResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (complexFoodStats) {
					return A2(
						$author$project$Pages$View$Tristate$fromInitToMain,
						$author$project$Pages$Statistics$ComplexFood$Select$Page$initialToMain,
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							$author$project$Pages$Statistics$ComplexFood$Select$Page$lenses.ki.i6.eW(
								$elm$core$Maybe$Just(
									A3(
										$arturopala$elm_monocle$Monocle$Lens$modify,
										$author$project$Pages$Statistics$StatisticsLenses$totalOnlyStatsNutrients,
										$elm$core$List$sortBy(
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.fx;
												},
												function ($) {
													return $.gN;
												})),
										complexFoodStats))),
							model));
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$StatisticsUtil$lenses = {
	k9: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.k9;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{k9: b});
			})),
	ds: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.ds;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{ds: b});
			})),
	lO: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.lO;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{lO: b});
			}))
};
var $author$project$Pages$Statistics$StatisticsRequests$selectReferenceMapWith = F3(
	function (ps, model, referenceMapId) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				function (main) {
					return A3(
						$elm$core$Basics$apR,
						A2(
							$elm$core$Maybe$andThen,
							A2(
								$elm_community$basics_extra$Basics$Extra$flip,
								$author$project$Util$DictList$get,
								A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Statistics$StatisticsUtil$lenses.lO, ps.hP).jY(main)),
							referenceMapId),
						A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Statistics$StatisticsUtil$lenses.ds, ps.hP).eW,
						main);
				},
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$ComplexFood$Select$Handler$selectReferenceMap = $author$project$Pages$Statistics$StatisticsRequests$selectReferenceMapWith(
	{hP: $author$project$Pages$Statistics$ComplexFood$Select$Page$lenses.kz.hO});
var $author$project$Pages$Statistics$StatisticsRequests$setNutrientsSearchStringWith = F3(
	function (ps, model, string) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Statistics$StatisticsUtil$lenses.k9, ps.hP).eW(string),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$ComplexFood$Select$Handler$setNutrientsSearchString = $author$project$Pages$Statistics$StatisticsRequests$setNutrientsSearchStringWith(
	{hP: $author$project$Pages$Statistics$ComplexFood$Select$Page$lenses.kz.hO});
var $author$project$Pages$Statistics$ComplexFood$Select$Handler$updateLogic = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var result = msg.a;
				return A2($author$project$Pages$Statistics$ComplexFood$Select$Handler$gotFetchStatsResponse, model, result);
			case 1:
				var result = msg.a;
				return A2($author$project$Pages$Statistics$ComplexFood$Select$Handler$gotFetchReferenceTreesResponse, model, result);
			case 2:
				var result = msg.a;
				return A2($author$project$Pages$Statistics$ComplexFood$Select$Handler$gotFetchComplexFoodResponse, model, result);
			case 3:
				var maybeReferenceMapId = msg.a;
				return A2($author$project$Pages$Statistics$ComplexFood$Select$Handler$selectReferenceMap, model, maybeReferenceMapId);
			default:
				var string = msg.a;
				return A2($author$project$Pages$Statistics$ComplexFood$Select$Handler$setNutrientsSearchString, model, string);
		}
	});
var $author$project$Pages$Statistics$ComplexFood$Select$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Statistics$ComplexFood$Select$Handler$updateLogic);
var $author$project$Pages$Statistics$Food$Search$Page$lenses = {
	ki: {
		jS: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.jS;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{jS: b});
				}))
	},
	kz: {
		jS: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.jS;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{jS: b});
				})),
		jU: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.jU;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{jU: b});
				})),
		lt: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lt;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lt: b});
				}))
	}
};
var $author$project$Pages$Statistics$Food$Search$Handler$gotFetchFoodsResponse = F2(
	function (model, result) {
		return A3(
			$elm_community$result_extra$Result$Extra$unpack,
			function (error) {
				return _Utils_Tuple2(
					A2($author$project$Pages$View$Tristate$toError, model, error),
					$elm$core$Platform$Cmd$none);
			},
			function (foods) {
				return _Utils_Tuple2(
					A2(
						$author$project$Pages$View$Tristate$mapInitial,
						$author$project$Pages$Statistics$Food$Search$Page$lenses.ki.jS.eW(
							$elm$core$Maybe$Just(foods)),
						model),
					$author$project$Ports$storeFoods(
						A2(
							$elm$json$Json$Encode$encode,
							0,
							A2($elm$json$Json$Encode$list, $author$project$Api$Types$Food$encoderFood, foods))));
			},
			result);
	});
var $author$project$Pages$Statistics$Food$Search$Handler$setFoodsPagination = F2(
	function (model, pagination) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				$author$project$Pages$Statistics$Food$Search$Page$lenses.kz.lt.eW(pagination),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$Food$Search$Handler$setSearchString = F2(
	function (model, string) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				$author$project$Pages$Statistics$Food$Search$Page$lenses.kz.jU.eW(string),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$Food$Search$Page$GotFetchFoodsResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Statistics$Food$Search$Requests$fetchFoods = $author$project$Pages$Util$Requests$fetchFoodsWith($author$project$Pages$Statistics$Food$Search$Page$GotFetchFoodsResponse);
var $author$project$Addresses$StatisticsVariant$Food = 0;
var $author$project$Pages$Statistics$Food$Search$Pagination$initial = {jS: $author$project$Pages$Util$PaginationSettings$initial};
var $author$project$Pages$Statistics$Food$Search$Page$initialToMain = function (i) {
	return A2(
		$elm$core$Maybe$map,
		function (foods) {
			return {jS: foods, jU: '', W: i.W, lt: $author$project$Pages$Statistics$Food$Search$Pagination$initial, ii: 0};
		},
		i.jS);
};
var $author$project$Pages$Statistics$Food$Search$Handler$updateFoods = function (model) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeString(
			$elm$json$Json$Decode$list($author$project$Api$Types$Food$decoderFood)),
		A2(
			$elm_community$result_extra$Result$Extra$unpack,
			function (error) {
				return _Utils_Tuple2(
					A2(
						$author$project$Pages$View$Tristate$toError,
						model,
						$author$project$Util$HttpUtil$jsonErrorToError(error)),
					$elm$core$Platform$Cmd$none);
			},
			function (foods) {
				return _Utils_Tuple2(
					A2(
						$author$project$Pages$View$Tristate$fromInitToMain,
						$author$project$Pages$Statistics$Food$Search$Page$initialToMain,
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							$author$project$Pages$Statistics$Food$Search$Page$lenses.ki.jS.eW(
								A2(
									$elm_community$maybe_extra$Maybe$Extra$filter,
									A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not),
									$elm$core$Maybe$Just(foods))),
							model)),
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						$elm$core$Platform$Cmd$none,
						function (initial) {
							return $author$project$Pages$Statistics$Food$Search$Requests$fetchFoods(
								{o: model.o, W: initial.W});
						},
						A2(
							$elm_community$maybe_extra$Maybe$Extra$filter,
							$elm$core$Basics$always(
								$elm$core$List$isEmpty(foods)),
							$author$project$Pages$View$Tristate$lenses.ki.jZ(model))));
			}));
};
var $author$project$Pages$Statistics$Food$Search$Handler$updateLogic = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var string = msg.a;
				return A2($author$project$Pages$Statistics$Food$Search$Handler$setSearchString, model, string);
			case 1:
				var pagination = msg.a;
				return A2($author$project$Pages$Statistics$Food$Search$Handler$setFoodsPagination, model, pagination);
			case 2:
				var result = msg.a;
				return A2($author$project$Pages$Statistics$Food$Search$Handler$gotFetchFoodsResponse, model, result);
			default:
				var string = msg.a;
				return A2($author$project$Pages$Statistics$Food$Search$Handler$updateFoods, model, string);
		}
	});
var $author$project$Pages$Statistics$Food$Search$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Statistics$Food$Search$Handler$updateLogic);
var $author$project$Pages$Statistics$Food$Select$Page$initialToMain = function (i) {
	return A4(
		$elm$core$Maybe$map3,
		F3(
			function (referenceTrees, foodInfo, foodStats) {
				return {
					jR: foodInfo,
					bB: foodStats,
					W: i.W,
					hO: $author$project$Pages$Statistics$StatisticsUtil$initialWith(referenceTrees),
					ii: 0
				};
			}),
		i.lO,
		i.jR,
		i.bB);
};
var $author$project$Pages$Statistics$Food$Select$Page$lenses = {
	ki: {
		jR: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.jR;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{jR: b});
				})),
		bB: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.bB;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{bB: b});
				})),
		lO: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lO;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lO: b});
				}))
	},
	kz: {
		jR: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.jR;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{jR: b});
				})),
		bB: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.bB;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{bB: b});
				})),
		hO: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.hO;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{hO: b});
				}))
	}
};
var $author$project$Pages$Statistics$Food$Select$Handler$gotFetchFoodInfoResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (foodInfo) {
					return A2(
						$author$project$Pages$View$Tristate$fromInitToMain,
						$author$project$Pages$Statistics$Food$Select$Page$initialToMain,
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							$author$project$Pages$Statistics$Food$Select$Page$lenses.ki.jR.eW(
								$elm$core$Maybe$Just(foodInfo)),
							model));
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$Food$Select$Handler$gotFetchReferenceTreesResponse = $author$project$Pages$Statistics$StatisticsRequests$gotFetchReferenceTreesResponseWith(
	{kk: $author$project$Pages$Statistics$Food$Select$Page$initialToMain, lP: $author$project$Pages$Statistics$Food$Select$Page$lenses.ki.lO});
var $author$project$Pages$Statistics$StatisticsLenses$foodStatsNutrients = A2(
	$arturopala$elm_monocle$Monocle$Lens$Lens,
	function ($) {
		return $.k8;
	},
	F2(
		function (b, a) {
			return _Utils_update(
				a,
				{k8: b});
		}));
var $author$project$Pages$Statistics$Food$Select$Handler$gotFetchStatsResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (foodStats) {
					return A2(
						$author$project$Pages$View$Tristate$fromInitToMain,
						$author$project$Pages$Statistics$Food$Select$Page$initialToMain,
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							$author$project$Pages$Statistics$Food$Select$Page$lenses.ki.bB.eW(
								$elm$core$Maybe$Just(
									A3(
										$arturopala$elm_monocle$Monocle$Lens$modify,
										$author$project$Pages$Statistics$StatisticsLenses$foodStatsNutrients,
										$elm$core$List$sortBy(
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.fx;
												},
												function ($) {
													return $.gN;
												})),
										foodStats))),
							model));
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$Food$Select$Handler$selectReferenceMap = $author$project$Pages$Statistics$StatisticsRequests$selectReferenceMapWith(
	{hP: $author$project$Pages$Statistics$Food$Select$Page$lenses.kz.hO});
var $author$project$Pages$Statistics$Food$Select$Handler$setNutrientsSearchString = $author$project$Pages$Statistics$StatisticsRequests$setNutrientsSearchStringWith(
	{hP: $author$project$Pages$Statistics$Food$Select$Page$lenses.kz.hO});
var $author$project$Pages$Statistics$Food$Select$Handler$updateLogic = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var result = msg.a;
				return A2($author$project$Pages$Statistics$Food$Select$Handler$gotFetchStatsResponse, model, result);
			case 1:
				var result = msg.a;
				return A2($author$project$Pages$Statistics$Food$Select$Handler$gotFetchReferenceTreesResponse, model, result);
			case 2:
				var result = msg.a;
				return A2($author$project$Pages$Statistics$Food$Select$Handler$gotFetchFoodInfoResponse, model, result);
			case 3:
				var maybeReferenceMapId = msg.a;
				return A2($author$project$Pages$Statistics$Food$Select$Handler$selectReferenceMap, model, maybeReferenceMapId);
			default:
				var string = msg.a;
				return A2($author$project$Pages$Statistics$Food$Select$Handler$setNutrientsSearchString, model, string);
		}
	});
var $author$project$Pages$Statistics$Food$Select$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Statistics$Food$Select$Handler$updateLogic);
var $author$project$Pages$Statistics$Meal$ProfileChoice$Handler$update = $author$project$Pages$Util$ProfileChoice$Handler$update;
var $author$project$Addresses$StatisticsVariant$Meal = 3;
var $author$project$Pages$Statistics$Meal$Search$Pagination$initial = {gG: $author$project$Pages$Util$PaginationSettings$initial};
var $author$project$Pages$Statistics$Meal$Search$Page$initialToMain = function (i) {
	return A3(
		$elm$core$Maybe$map2,
		F2(
			function (profile, meals) {
				return {W: i.W, gG: meals, kH: '', lt: $author$project$Pages$Statistics$Meal$Search$Pagination$initial, ly: profile, ii: 3};
			}),
		i.ly,
		i.gG);
};
var $author$project$Pages$Statistics$Meal$Search$Page$lenses = {
	ki: {
		gG: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.gG;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{gG: b});
				})),
		ly: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.ly;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{ly: b});
				}))
	},
	kz: {
		gG: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.gG;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{gG: b});
				})),
		kH: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.kH;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{kH: b});
				})),
		lt: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lt;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lt: b});
				}))
	}
};
var $author$project$Pages$Statistics$Meal$Search$Handler$gotFetchMealsResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (meals) {
					return A2(
						$author$project$Pages$View$Tristate$fromInitToMain,
						$author$project$Pages$Statistics$Meal$Search$Page$initialToMain,
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							$author$project$Pages$Statistics$Meal$Search$Page$lenses.ki.gG.eW(
								$elm$core$Maybe$Just(meals)),
							model));
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$Meal$Search$Handler$gotFetchProfileResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (profile) {
					return A2(
						$author$project$Pages$View$Tristate$fromInitToMain,
						$author$project$Pages$Statistics$Meal$Search$Page$initialToMain,
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							$author$project$Pages$Statistics$Meal$Search$Page$lenses.ki.ly.eW(
								$elm$core$Maybe$Just(profile)),
							model));
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$Meal$Search$Handler$setMealsPagination = F2(
	function (model, pagination) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				$author$project$Pages$Statistics$Meal$Search$Page$lenses.kz.lt.eW(pagination),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$Meal$Search$Handler$setSearchString = F2(
	function (model, string) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				$author$project$Pages$Statistics$Meal$Search$Page$lenses.kz.kH.eW(string),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$Meal$Search$Handler$updateLogic = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var string = msg.a;
				return A2($author$project$Pages$Statistics$Meal$Search$Handler$setSearchString, model, string);
			case 1:
				var pagination = msg.a;
				return A2($author$project$Pages$Statistics$Meal$Search$Handler$setMealsPagination, model, pagination);
			case 2:
				var result = msg.a;
				return A2($author$project$Pages$Statistics$Meal$Search$Handler$gotFetchMealsResponse, model, result);
			default:
				var result = msg.a;
				return A2($author$project$Pages$Statistics$Meal$Search$Handler$gotFetchProfileResponse, model, result);
		}
	});
var $author$project$Pages$Statistics$Meal$Search$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Statistics$Meal$Search$Handler$updateLogic);
var $elm$core$Maybe$map4 = F5(
	function (func, ma, mb, mc, md) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					if (md.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var d = md.a;
						return $elm$core$Maybe$Just(
							A4(func, a, b, c, d));
					}
				}
			}
		}
	});
var $author$project$Pages$Statistics$Meal$Select$Page$initialToMain = function (i) {
	return A5(
		$elm$core$Maybe$map4,
		F4(
			function (referenceTrees, meal, mealStats, profile) {
				return {
					W: i.W,
					kD: meal,
					kG: mealStats,
					ly: profile,
					hO: $author$project$Pages$Statistics$StatisticsUtil$initialWith(referenceTrees),
					ii: 3
				};
			}),
		i.lO,
		i.kD,
		i.kG,
		i.ly);
};
var $author$project$Pages$Statistics$Meal$Select$Page$lenses = {
	ki: {
		kD: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.kD;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{kD: b});
				})),
		kG: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.kG;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{kG: b});
				})),
		ly: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.ly;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{ly: b});
				})),
		lO: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lO;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lO: b});
				}))
	},
	kz: {
		kD: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.kD;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{kD: b});
				})),
		kG: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.kG;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{kG: b});
				})),
		hO: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.hO;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{hO: b});
				}))
	}
};
var $author$project$Pages$Statistics$Meal$Select$Handler$gotFetchMealResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (meal) {
					return A2(
						$author$project$Pages$View$Tristate$fromInitToMain,
						$author$project$Pages$Statistics$Meal$Select$Page$initialToMain,
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							$author$project$Pages$Statistics$Meal$Select$Page$lenses.ki.kD.eW(
								$elm$core$Maybe$Just(meal)),
							model));
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$Meal$Select$Handler$gotFetchProfileResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (profile) {
					return A2(
						$author$project$Pages$View$Tristate$fromInitToMain,
						$author$project$Pages$Statistics$Meal$Select$Page$initialToMain,
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							$author$project$Pages$Statistics$Meal$Select$Page$lenses.ki.ly.eW(
								$elm$core$Maybe$Just(profile)),
							model));
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$Meal$Select$Handler$gotFetchReferenceTreesResponse = $author$project$Pages$Statistics$StatisticsRequests$gotFetchReferenceTreesResponseWith(
	{kk: $author$project$Pages$Statistics$Meal$Select$Page$initialToMain, lP: $author$project$Pages$Statistics$Meal$Select$Page$lenses.ki.lO});
var $author$project$Pages$Statistics$Meal$Select$Handler$gotFetchStatsResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (mealStats) {
					return A2(
						$author$project$Pages$View$Tristate$fromInitToMain,
						$author$project$Pages$Statistics$Meal$Select$Page$initialToMain,
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							$author$project$Pages$Statistics$Meal$Select$Page$lenses.ki.kG.eW(
								$elm$core$Maybe$Just(
									A3(
										$arturopala$elm_monocle$Monocle$Lens$modify,
										$author$project$Pages$Statistics$StatisticsLenses$totalOnlyStatsNutrients,
										$elm$core$List$sortBy(
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.fx;
												},
												function ($) {
													return $.gN;
												})),
										mealStats))),
							model));
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$Meal$Select$Handler$selectReferenceMap = $author$project$Pages$Statistics$StatisticsRequests$selectReferenceMapWith(
	{hP: $author$project$Pages$Statistics$Meal$Select$Page$lenses.kz.hO});
var $author$project$Pages$Statistics$Meal$Select$Handler$setNutrientsSearchString = $author$project$Pages$Statistics$StatisticsRequests$setNutrientsSearchStringWith(
	{hP: $author$project$Pages$Statistics$Meal$Select$Page$lenses.kz.hO});
var $author$project$Pages$Statistics$Meal$Select$Handler$updateLogic = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var result = msg.a;
				return A2($author$project$Pages$Statistics$Meal$Select$Handler$gotFetchStatsResponse, model, result);
			case 1:
				var result = msg.a;
				return A2($author$project$Pages$Statistics$Meal$Select$Handler$gotFetchReferenceTreesResponse, model, result);
			case 2:
				var result = msg.a;
				return A2($author$project$Pages$Statistics$Meal$Select$Handler$gotFetchMealResponse, model, result);
			case 3:
				var result = msg.a;
				return A2($author$project$Pages$Statistics$Meal$Select$Handler$gotFetchProfileResponse, model, result);
			case 4:
				var maybeReferenceMapId = msg.a;
				return A2($author$project$Pages$Statistics$Meal$Select$Handler$selectReferenceMap, model, maybeReferenceMapId);
			default:
				var string = msg.a;
				return A2($author$project$Pages$Statistics$Meal$Select$Handler$setNutrientsSearchString, model, string);
		}
	});
var $author$project$Pages$Statistics$Meal$Select$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Statistics$Meal$Select$Handler$updateLogic);
var $author$project$Addresses$StatisticsVariant$Recipe = 2;
var $author$project$Pages$Statistics$Recipe$Search$Pagination$initial = {eO: $author$project$Pages$Util$PaginationSettings$initial};
var $author$project$Pages$Statistics$Recipe$Search$Page$initialToMain = function (i) {
	return A2(
		$elm$core$Maybe$map,
		function (recipes) {
			return {W: i.W, lt: $author$project$Pages$Statistics$Recipe$Search$Pagination$initial, eO: recipes, lI: '', ii: 2};
		},
		i.eO);
};
var $author$project$Pages$Statistics$Recipe$Search$Page$lenses = {
	ki: {
		eO: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.eO;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{eO: b});
				}))
	},
	kz: {
		lt: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lt;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lt: b});
				})),
		eO: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.eO;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{eO: b});
				})),
		lI: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lI;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lI: b});
				}))
	}
};
var $author$project$Pages$Statistics$Recipe$Search$Handler$gotFetchRecipesResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (recipes) {
					return A2(
						$author$project$Pages$View$Tristate$fromInitToMain,
						$author$project$Pages$Statistics$Recipe$Search$Page$initialToMain,
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							$author$project$Pages$Statistics$Recipe$Search$Page$lenses.ki.eO.eW(
								$elm$core$Maybe$Just(recipes)),
							model));
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$Recipe$Search$Handler$setRecipesPagination = F2(
	function (model, pagination) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				$author$project$Pages$Statistics$Recipe$Search$Page$lenses.kz.lt.eW(pagination),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$Recipe$Search$Handler$setSearchString = F2(
	function (model, string) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				$author$project$Pages$Statistics$Recipe$Search$Page$lenses.kz.lI.eW(string),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$Recipe$Search$Handler$updateLogic = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var string = msg.a;
				return A2($author$project$Pages$Statistics$Recipe$Search$Handler$setSearchString, model, string);
			case 1:
				var pagination = msg.a;
				return A2($author$project$Pages$Statistics$Recipe$Search$Handler$setRecipesPagination, model, pagination);
			default:
				var result = msg.a;
				return A2($author$project$Pages$Statistics$Recipe$Search$Handler$gotFetchRecipesResponse, model, result);
		}
	});
var $author$project$Pages$Statistics$Recipe$Search$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Statistics$Recipe$Search$Handler$updateLogic);
var $author$project$Pages$Statistics$Recipe$Select$Page$initialToMain = function (i) {
	return A4(
		$elm$core$Maybe$map3,
		F3(
			function (referenceTrees, recipe, recipeStats) {
				return {
					W: i.W,
					lD: recipe,
					lH: recipeStats,
					hO: $author$project$Pages$Statistics$StatisticsUtil$initialWith(referenceTrees),
					ii: 2
				};
			}),
		i.lO,
		i.lD,
		i.lH);
};
var $author$project$Pages$Statistics$Recipe$Select$Page$lenses = {
	ki: {
		lD: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lD;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lD: b});
				})),
		lH: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lH;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lH: b});
				})),
		lO: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lO;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lO: b});
				}))
	},
	kz: {
		lD: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lD;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lD: b});
				})),
		lH: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lH;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lH: b});
				})),
		hO: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.hO;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{hO: b});
				}))
	}
};
var $author$project$Pages$Statistics$Recipe$Select$Handler$gotFetchRecipeResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (recipe) {
					return A2(
						$author$project$Pages$View$Tristate$fromInitToMain,
						$author$project$Pages$Statistics$Recipe$Select$Page$initialToMain,
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							$author$project$Pages$Statistics$Recipe$Select$Page$lenses.ki.lD.eW(
								$elm$core$Maybe$Just(recipe)),
							model));
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$Recipe$Select$Handler$gotFetchReferenceTreesResponse = $author$project$Pages$Statistics$StatisticsRequests$gotFetchReferenceTreesResponseWith(
	{kk: $author$project$Pages$Statistics$Recipe$Select$Page$initialToMain, lP: $author$project$Pages$Statistics$Recipe$Select$Page$lenses.ki.lO});
var $author$project$Pages$Statistics$Recipe$Select$Handler$gotFetchStatsResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (recipeStats) {
					return A2(
						$author$project$Pages$View$Tristate$fromInitToMain,
						$author$project$Pages$Statistics$Recipe$Select$Page$initialToMain,
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							$author$project$Pages$Statistics$Recipe$Select$Page$lenses.ki.lH.eW(
								$elm$core$Maybe$Just(
									A3(
										$arturopala$elm_monocle$Monocle$Lens$modify,
										$author$project$Pages$Statistics$StatisticsLenses$totalOnlyStatsNutrients,
										$elm$core$List$sortBy(
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.fx;
												},
												function ($) {
													return $.gN;
												})),
										recipeStats))),
							model));
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$Recipe$Select$Handler$selectReferenceMap = $author$project$Pages$Statistics$StatisticsRequests$selectReferenceMapWith(
	{hP: $author$project$Pages$Statistics$Recipe$Select$Page$lenses.kz.hO});
var $author$project$Pages$Statistics$Recipe$Select$Handler$setNutrientsSearchString = $author$project$Pages$Statistics$StatisticsRequests$setNutrientsSearchStringWith(
	{hP: $author$project$Pages$Statistics$Recipe$Select$Page$lenses.kz.hO});
var $author$project$Pages$Statistics$Recipe$Select$Handler$updateLogic = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var result = msg.a;
				return A2($author$project$Pages$Statistics$Recipe$Select$Handler$gotFetchStatsResponse, model, result);
			case 1:
				var result = msg.a;
				return A2($author$project$Pages$Statistics$Recipe$Select$Handler$gotFetchReferenceTreesResponse, model, result);
			case 2:
				var result = msg.a;
				return A2($author$project$Pages$Statistics$Recipe$Select$Handler$gotFetchRecipeResponse, model, result);
			case 3:
				var maybeReferenceMapId = msg.a;
				return A2($author$project$Pages$Statistics$Recipe$Select$Handler$selectReferenceMap, model, maybeReferenceMapId);
			default:
				var string = msg.a;
				return A2($author$project$Pages$Statistics$Recipe$Select$Handler$setNutrientsSearchString, model, string);
		}
	});
var $author$project$Pages$Statistics$Recipe$Select$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Statistics$Recipe$Select$Handler$updateLogic);
var $author$project$Pages$Statistics$RecipeOccurrences$ProfileChoice$Handler$update = $author$project$Pages$Util$ProfileChoice$Handler$update;
var $author$project$Pages$Statistics$RecipeOccurrences$Search$Page$RecipeName = 0;
var $author$project$Addresses$StatisticsVariant$RecipeOccurrences = 5;
var $author$project$Pages$Statistics$RecipeOccurrences$Search$Pagination$initial = {lG: $author$project$Pages$Util$PaginationSettings$initial};
var $author$project$Pages$Statistics$RecipeOccurrences$Search$Page$initialToMain = function (i) {
	return A3(
		$elm$core$Maybe$map2,
		F2(
			function (recipeOccurrences, profile) {
				return {W: i.W, lt: $author$project$Pages$Statistics$RecipeOccurrences$Search$Pagination$initial, ly: profile, lG: recipeOccurrences, lI: '', mi: 0, ii: 5};
			}),
		i.lG,
		i.ly);
};
var $author$project$Pages$Statistics$RecipeOccurrences$Search$Page$lenses = {
	ki: {
		ly: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.ly;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{ly: b});
				})),
		lG: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lG;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lG: b});
				}))
	},
	kz: {
		lt: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lt;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lt: b});
				})),
		lG: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lG;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lG: b});
				})),
		lI: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lI;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lI: b});
				})),
		mi: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.mi;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{mi: b});
				}))
	}
};
var $author$project$Pages$Statistics$RecipeOccurrences$Search$Handler$gotFetchProfileResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (profile) {
					return A2(
						$author$project$Pages$View$Tristate$fromInitToMain,
						$author$project$Pages$Statistics$RecipeOccurrences$Search$Page$initialToMain,
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							$author$project$Pages$Statistics$RecipeOccurrences$Search$Page$lenses.ki.ly.eW(
								$elm$core$Maybe$Just(profile)),
							model));
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$RecipeOccurrences$Search$Handler$gotFetchRecipeOccurrencesResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (recipes) {
					return A2(
						$author$project$Pages$View$Tristate$fromInitToMain,
						$author$project$Pages$Statistics$RecipeOccurrences$Search$Page$initialToMain,
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							$author$project$Pages$Statistics$RecipeOccurrences$Search$Page$lenses.ki.lG.eW(
								$elm$core$Maybe$Just(recipes)),
							model));
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$RecipeOccurrences$Search$Handler$setRecipesPagination = F2(
	function (model, pagination) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				$author$project$Pages$Statistics$RecipeOccurrences$Search$Page$lenses.kz.lt.eW(pagination),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$RecipeOccurrences$Search$Handler$setSearchString = F2(
	function (model, string) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				$author$project$Pages$Statistics$RecipeOccurrences$Search$Page$lenses.kz.lI.eW(string),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$RecipeOccurrences$Search$Handler$sortBy = F2(
	function (model, sortType) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				$author$project$Pages$Statistics$RecipeOccurrences$Search$Page$lenses.kz.mi.eW(sortType),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$RecipeOccurrences$Search$Handler$updateLogic = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var string = msg.a;
				return A2($author$project$Pages$Statistics$RecipeOccurrences$Search$Handler$setSearchString, model, string);
			case 1:
				var pagination = msg.a;
				return A2($author$project$Pages$Statistics$RecipeOccurrences$Search$Handler$setRecipesPagination, model, pagination);
			case 2:
				var result = msg.a;
				return A2($author$project$Pages$Statistics$RecipeOccurrences$Search$Handler$gotFetchRecipeOccurrencesResponse, model, result);
			case 3:
				var result = msg.a;
				return A2($author$project$Pages$Statistics$RecipeOccurrences$Search$Handler$gotFetchProfileResponse, model, result);
			default:
				var sortType = msg.a;
				return A2($author$project$Pages$Statistics$RecipeOccurrences$Search$Handler$sortBy, model, sortType);
		}
	});
var $author$project$Pages$Statistics$RecipeOccurrences$Search$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Statistics$RecipeOccurrences$Search$Handler$updateLogic);
var $author$project$Pages$Statistics$Time$Page$Fetch = 1;
var $author$project$Pages$Statistics$Time$Page$GotFetchStatsResponse = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Util$DateUtil$padToTwo = function (i) {
	return ((i >= 0) && (i <= 9)) ? $elm$core$String$concat(
		_List_fromArray(
			[
				'0',
				$elm$core$String$fromInt(i)
			])) : $elm$core$String$fromInt(i);
};
var $author$project$Pages$Util$DateUtil$dateToString = function (date) {
	return A2(
		$elm$core$String$join,
		'-',
		A2(
			$elm$core$List$map,
			$author$project$Pages$Util$DateUtil$padToTwo,
			_List_fromArray(
				[date.iq, date.gL, date.fS])));
};
var $author$project$Api$Types$Stats$Stats = F3(
	function (meals, nutrients, weightInGrams) {
		return {gG: meals, k8: nutrients, ik: weightInGrams};
	});
var $author$project$Api$Types$NutrientInformation$NutrientInformation = F2(
	function (base, amounts) {
		return {ft: amounts, fx: base};
	});
var $author$project$Api$Types$Amounts$Amounts = F3(
	function (values, numberOfIngredients, numberOfDefinedValues) {
		return {gW: numberOfDefinedValues, gX: numberOfIngredients, ih: values};
	});
var $author$project$Api$Types$Values$Values = F2(
	function (total, dailyAverage) {
		return {fQ: dailyAverage, h6: total};
	});
var $author$project$Api$Types$Values$decoderValues = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'dailyAverage',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'total',
		$elm$json$Json$Decode$float,
		$elm$json$Json$Decode$succeed($author$project$Api$Types$Values$Values)));
var $author$project$Api$Types$Amounts$decoderAmounts = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'numberOfDefinedValues',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'numberOfIngredients',
		$elm$json$Json$Decode$int,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'values',
			$elm$json$Json$Decode$maybe(
				$elm$json$Json$Decode$lazy(
					function (_v0) {
						return $author$project$Api$Types$Values$decoderValues;
					})),
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$Api$Types$Amounts$Amounts))));
var $author$project$Api$Types$NutrientInformation$decoderNutrientInformation = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'amounts',
	$elm$json$Json$Decode$lazy(
		function (_v1) {
			return $author$project$Api$Types$Amounts$decoderAmounts;
		}),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'base',
		$elm$json$Json$Decode$lazy(
			function (_v0) {
				return $author$project$Api$Types$NutrientInformationBase$decoderNutrientInformationBase;
			}),
		$elm$json$Json$Decode$succeed($author$project$Api$Types$NutrientInformation$NutrientInformation)));
var $author$project$Api$Types$Stats$decoderStats = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'weightInGrams',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'nutrients',
		$elm$json$Json$Decode$list(
			$elm$json$Json$Decode$lazy(
				function (_v1) {
					return $author$project$Api$Types$NutrientInformation$decoderNutrientInformation;
				})),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'meals',
			$elm$json$Json$Decode$list(
				$elm$json$Json$Decode$lazy(
					function (_v0) {
						return $author$project$Api$Types$Meal$decoderMeal;
					})),
			$elm$json$Json$Decode$succeed($author$project$Api$Types$Stats$Stats))));
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Pages$Statistics$Time$Requests$fetchStats = F3(
	function (authorizedAccess, profileId, requestInterval) {
		var toQuery = function (name) {
			return $elm$core$Maybe$map(
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pages$Util$DateUtil$dateToString,
					$elm$url$Url$Builder$string(name)));
		};
		var interval = {
			jV: A2(toQuery, 'from', requestInterval.jV),
			mA: A2(toQuery, 'to', requestInterval.mA)
		};
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			A2($author$project$Addresses$Backend$stats.aW, profileId, interval),
			{
				iO: $elm$http$Http$emptyBody,
				cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$Statistics$Time$Page$GotFetchStatsResponse, $author$project$Api$Types$Stats$decoderStats)
			});
	});
var $author$project$Api$Lenses$RequestIntervalLens$from = A2(
	$arturopala$elm_monocle$Monocle$Lens$Lens,
	function ($) {
		return $.jV;
	},
	F2(
		function (b, a) {
			return _Utils_update(
				a,
				{jV: b});
		}));
var $author$project$Api$Lenses$RequestIntervalLens$to = A2(
	$arturopala$elm_monocle$Monocle$Lens$Lens,
	function ($) {
		return $.mA;
	},
	F2(
		function (b, a) {
			return _Utils_update(
				a,
				{mA: b});
		}));
var $author$project$Pages$Statistics$Time$Page$lenses = function () {
	var requestInterval = A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.lV;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{lV: b});
			}));
	return {
		ki: {
			eM: A2(
				$arturopala$elm_monocle$Monocle$Lens$Lens,
				function ($) {
					return $.eM;
				},
				F2(
					function (b, a) {
						return _Utils_update(
							a,
							{eM: b});
					})),
			lO: A2(
				$arturopala$elm_monocle$Monocle$Lens$Lens,
				function ($) {
					return $.lO;
				},
				F2(
					function (b, a) {
						return _Utils_update(
							a,
							{lO: b});
					}))
		},
		kz: {
			jV: A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Api$Lenses$RequestIntervalLens$from, requestInterval),
			lt: A2(
				$arturopala$elm_monocle$Monocle$Lens$Lens,
				function ($) {
					return $.lt;
				},
				F2(
					function (b, a) {
						return _Utils_update(
							a,
							{lt: b});
					})),
			eM: A2(
				$arturopala$elm_monocle$Monocle$Lens$Lens,
				function ($) {
					return $.eM;
				},
				F2(
					function (b, a) {
						return _Utils_update(
							a,
							{eM: b});
					})),
			lV: requestInterval,
			hD: A2(
				$arturopala$elm_monocle$Monocle$Lens$Lens,
				function ($) {
					return $.hD;
				},
				F2(
					function (b, a) {
						return _Utils_update(
							a,
							{hD: b});
					})),
			hO: A2(
				$arturopala$elm_monocle$Monocle$Lens$Lens,
				function ($) {
					return $.hO;
				},
				F2(
					function (b, a) {
						return _Utils_update(
							a,
							{hO: b});
					})),
			mk: A2(
				$arturopala$elm_monocle$Monocle$Lens$Lens,
				function ($) {
					return $.mk;
				},
				F2(
					function (b, a) {
						return _Utils_update(
							a,
							{mk: b});
					})),
			bU: A2(
				$arturopala$elm_monocle$Monocle$Lens$Lens,
				function ($) {
					return $.bU;
				},
				F2(
					function (b, a) {
						return _Utils_update(
							a,
							{bU: b});
					})),
			mA: A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Api$Lenses$RequestIntervalLens$to, requestInterval)
		}
	};
}();
var $author$project$Pages$Statistics$Time$Handler$fetchStats = function (model) {
	return _Utils_Tuple2(
		A2(
			$author$project$Pages$View$Tristate$mapMain,
			$author$project$Pages$Statistics$Time$Page$lenses.kz.bU.eW(1),
			model),
		A3(
			$author$project$Pages$View$Tristate$foldMain,
			$elm$core$Platform$Cmd$none,
			function (main) {
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Platform$Cmd$none,
					function (profile) {
						return A3(
							$author$project$Pages$Statistics$Time$Requests$fetchStats,
							{o: model.o, W: main.W},
							profile.gn,
							main.lV);
					},
					main.hD);
			},
			model));
};
var $author$project$Pages$Statistics$StatisticsRequests$gotFetchProfilesResponseWith = F3(
	function (ps, model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (profiles) {
					return A2(
						$author$project$Pages$View$Tristate$fromInitToMain,
						ps.kk,
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							ps.lA.eW(
								$elm$core$Maybe$Just(profiles)),
							model));
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$Time$Page$Select = 0;
var $author$project$Addresses$StatisticsVariant$Time = 4;
var $author$project$Api$Lenses$RequestIntervalLens$default = {jV: $elm$core$Maybe$Nothing, mA: $elm$core$Maybe$Nothing};
var $author$project$Pages$Statistics$Time$Page$defaultStats = {gG: _List_Nil, k8: _List_Nil, ik: 0};
var $author$project$Pages$Statistics$Time$Pagination$initial = {gG: $author$project$Pages$Util$PaginationSettings$initial};
var $author$project$Pages$Statistics$Time$Page$initialToMain = function (i) {
	return A3(
		$elm$core$Maybe$map2,
		F2(
			function (referenceTrees, profiles) {
				return {
					W: i.W,
					lt: $author$project$Pages$Statistics$Time$Pagination$initial,
					eM: A2(
						$author$project$Util$DictList$fromListWithKey,
						function ($) {
							return $.gn;
						},
						profiles),
					lV: $author$project$Api$Lenses$RequestIntervalLens$default,
					hD: $elm$core$Maybe$Nothing,
					hO: $author$project$Pages$Statistics$StatisticsUtil$initialWith(referenceTrees),
					mk: $author$project$Pages$Statistics$Time$Page$defaultStats,
					bU: 0,
					ii: 4
				};
			}),
		i.lO,
		i.eM);
};
var $author$project$Pages$Statistics$Time$Handler$gotFetchProfilesResponse = $author$project$Pages$Statistics$StatisticsRequests$gotFetchProfilesResponseWith(
	{kk: $author$project$Pages$Statistics$Time$Page$initialToMain, lA: $author$project$Pages$Statistics$Time$Page$lenses.ki.eM});
var $author$project$Pages$Statistics$Time$Handler$gotFetchReferenceTreesResponse = $author$project$Pages$Statistics$StatisticsRequests$gotFetchReferenceTreesResponseWith(
	{kk: $author$project$Pages$Statistics$Time$Page$initialToMain, lP: $author$project$Pages$Statistics$Time$Page$lenses.ki.lO});
var $author$project$Pages$Statistics$Time$Page$Display = 2;
var $author$project$Api$Lenses$StatsLens$nutrients = A2(
	$arturopala$elm_monocle$Monocle$Lens$Lens,
	function ($) {
		return $.k8;
	},
	F2(
		function (b, a) {
			return _Utils_update(
				a,
				{k8: b});
		}));
var $author$project$Pages$Statistics$Time$Handler$gotFetchStatsResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (stats) {
					return A2(
						$author$project$Pages$View$Tristate$mapMain,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Pages$Statistics$Time$Page$lenses.kz.mk.eW(
								A3(
									$arturopala$elm_monocle$Monocle$Lens$modify,
									$author$project$Api$Lenses$StatsLens$nutrients,
									$elm$core$List$sortBy(
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.fx;
											},
											function ($) {
												return $.gN;
											})),
									stats)),
							$author$project$Pages$Statistics$Time$Page$lenses.kz.bU.eW(2)),
						model);
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$Time$Handler$selectProfile = F2(
	function (model, maybeProfileId) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				A2(
					$elm$core$Basics$composeR,
					function (main) {
						return A3(
							$elm_community$basics_extra$Basics$Extra$flip,
							$author$project$Pages$Statistics$Time$Page$lenses.kz.hD.eW,
							main,
							A2(
								$elm$core$Maybe$andThen,
								A2($elm_community$basics_extra$Basics$Extra$flip, $author$project$Util$DictList$get, main.eM),
								maybeProfileId));
					},
					$author$project$Pages$Statistics$Time$Page$lenses.kz.bU.eW(0)),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$Time$Handler$selectReferenceMap = $author$project$Pages$Statistics$StatisticsRequests$selectReferenceMapWith(
	{hP: $author$project$Pages$Statistics$Time$Page$lenses.kz.hO});
var $author$project$Pages$Statistics$Time$Handler$setFromDate = F2(
	function (model, maybeDate) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pages$Statistics$Time$Page$lenses.kz.jV.eW(maybeDate),
					$author$project$Pages$Statistics$Time$Page$lenses.kz.bU.eW(0)),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$Time$Handler$setNutrientsSearchString = $author$project$Pages$Statistics$StatisticsRequests$setNutrientsSearchStringWith(
	{hP: $author$project$Pages$Statistics$Time$Page$lenses.kz.hO});
var $author$project$Pages$Statistics$Time$Handler$setPagination = F2(
	function (model, pagination) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				$author$project$Pages$Statistics$Time$Page$lenses.kz.lt.eW(pagination),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$Time$Handler$setToDate = F2(
	function (model, maybeDate) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pages$Statistics$Time$Page$lenses.kz.mA.eW(maybeDate),
					$author$project$Pages$Statistics$Time$Page$lenses.kz.bU.eW(0)),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Statistics$Time$Handler$updateLogic = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var maybeDate = msg.a;
				return A2($author$project$Pages$Statistics$Time$Handler$setFromDate, model, maybeDate);
			case 1:
				var maybeDate = msg.a;
				return A2($author$project$Pages$Statistics$Time$Handler$setToDate, model, maybeDate);
			case 3:
				return $author$project$Pages$Statistics$Time$Handler$fetchStats(model);
			case 4:
				var result = msg.a;
				return A2($author$project$Pages$Statistics$Time$Handler$gotFetchStatsResponse, model, result);
			case 5:
				var result = msg.a;
				return A2($author$project$Pages$Statistics$Time$Handler$gotFetchReferenceTreesResponse, model, result);
			case 6:
				var result = msg.a;
				return A2($author$project$Pages$Statistics$Time$Handler$gotFetchProfilesResponse, model, result);
			case 7:
				var pagination = msg.a;
				return A2($author$project$Pages$Statistics$Time$Handler$setPagination, model, pagination);
			case 8:
				var referenceMapId = msg.a;
				return A2($author$project$Pages$Statistics$Time$Handler$selectReferenceMap, model, referenceMapId);
			case 9:
				var string = msg.a;
				return A2($author$project$Pages$Statistics$Time$Handler$setNutrientsSearchString, model, string);
			default:
				var maybeProfileId = msg.a;
				return A2($author$project$Pages$Statistics$Time$Handler$selectProfile, model, maybeProfileId);
		}
	});
var $author$project$Pages$Statistics$Time$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Statistics$Time$Handler$updateLogic);
var $author$project$Pages$UserSettings$Page$Regular = 0;
var $author$project$Pages$UserSettings$Page$initialToMain = function (i) {
	return A2(
		$elm$core$Maybe$map,
		function (user) {
			return {d2: $author$project$Pages$Util$ComplementInput$initial, W: i.W, gK: 0, ie: user};
		},
		i.ie);
};
var $author$project$Pages$UserSettings$Page$lenses = {
	ki: {
		ie: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.ie;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{ie: b});
				}))
	},
	kz: {
		d2: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.d2;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{d2: b});
				})),
		gK: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.gK;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{gK: b});
				})),
		ie: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.ie;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{ie: b});
				}))
	}
};
var $author$project$Pages$Util$ComplementInput$lenses = {
	fZ: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.fZ;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{fZ: b});
			})),
	eH: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.eH;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{eH: b});
			}))
};
var $author$project$Pages$UserSettings$Handler$gotFetchUserResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (user) {
					return A2(
						$author$project$Pages$View$Tristate$mapMain,
						A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$ComplementInput$lenses.fZ, $author$project$Pages$UserSettings$Page$lenses.kz.d2).eW(user.fZ),
						A2(
							$author$project$Pages$View$Tristate$fromInitToMain,
							$author$project$Pages$UserSettings$Page$initialToMain,
							A2(
								$author$project$Pages$View$Tristate$mapInitial,
								$author$project$Pages$UserSettings$Page$lenses.ki.ie.eW(
									$elm$core$Maybe$Just(user)),
								model)));
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$UserSettings$Handler$gotLogoutResponse = F2(
	function (model, result) {
		return A3(
			$elm_community$result_extra$Result$Extra$unpack,
			function (error) {
				return _Utils_Tuple2(
					A2($author$project$Pages$View$Tristate$toError, model, error),
					$elm$core$Platform$Cmd$none);
			},
			function (_v0) {
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$doDeleteToken(0),
								$elm$browser$Browser$Navigation$load(
								$author$project$Pages$Util$Links$frontendPage(
									$author$project$Addresses$Frontend$login.iA(0)))
							])));
			},
			result);
	});
var $author$project$Pages$UserSettings$Page$RequestedDeletion = 1;
var $author$project$Pages$UserSettings$Handler$gotRequestDeletionResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (_v0) {
					return A2(
						$author$project$Pages$View$Tristate$mapMain,
						$author$project$Pages$UserSettings$Page$lenses.kz.gK.eW(1),
						model);
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$UserSettings$Handler$gotUpdatePasswordResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (_v0) {
					return A2(
						$author$project$Pages$View$Tristate$mapMain,
						A2(
							$arturopala$elm_monocle$Monocle$Lens$modify,
							$author$project$Pages$UserSettings$Page$lenses.kz.d2,
							$author$project$Pages$Util$ComplementInput$lenses.eH.eW($author$project$Pages$Util$PasswordInput$initial)),
						model);
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$UserSettings$Handler$gotUpdateSettingsResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (user) {
					return A2(
						$author$project$Pages$View$Tristate$mapMain,
						$author$project$Pages$UserSettings$Page$lenses.kz.ie.eW(user),
						model);
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$UserSettings$Page$GotLogoutResponse = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Types$Mode$toString = function (mode) {
	if (!mode) {
		return 'All';
	} else {
		return 'This';
	}
};
var $author$project$Api$Types$Mode$encoderMode = A2($elm$core$Basics$composeR, $author$project$Api$Types$Mode$toString, $elm$json$Json$Encode$string);
var $author$project$Api$Types$LogoutRequest$encoderLogoutRequest = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'mode',
				$author$project$Api$Types$Mode$encoderMode(obj.gK))
			]));
};
var $author$project$Pages$UserSettings$Requests$logout = F2(
	function (authorizedAccess, mode) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$users.kx,
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$LogoutRequest$encoderLogoutRequest(
						{gK: mode})),
				cz: $author$project$Util$HttpUtil$expectWhatever($author$project$Pages$UserSettings$Page$GotLogoutResponse)
			});
	});
var $author$project$Pages$UserSettings$Handler$logout = F2(
	function (model, mode) {
		return _Utils_Tuple2(
			model,
			A3(
				$author$project$Pages$View$Tristate$foldMain,
				$elm$core$Platform$Cmd$none,
				function (main) {
					return A2(
						$author$project$Pages$UserSettings$Requests$logout,
						{o: model.o, W: main.W},
						mode);
				},
				model));
	});
var $author$project$Pages$UserSettings$Page$GotRequestDeletionResponse = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$UserSettings$Requests$requestDeletion = function (authorizedAccess) {
	return A3(
		$author$project$Util$HttpUtil$runPatternWithJwt,
		authorizedAccess,
		$author$project$Addresses$Backend$users.jr.eS,
		{
			iO: $elm$http$Http$emptyBody,
			cz: $author$project$Util$HttpUtil$expectWhatever($author$project$Pages$UserSettings$Page$GotRequestDeletionResponse)
		});
};
var $author$project$Pages$UserSettings$Handler$requestDeletion = function (model) {
	return _Utils_Tuple2(
		model,
		A3(
			$author$project$Pages$View$Tristate$foldMain,
			$elm$core$Platform$Cmd$none,
			function (main) {
				return $author$project$Pages$UserSettings$Requests$requestDeletion(
					{o: model.o, W: main.W});
			},
			model));
};
var $author$project$Pages$UserSettings$Handler$setComplementInput = F2(
	function (model, complementInput) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				$author$project$Pages$UserSettings$Page$lenses.kz.d2.eW(complementInput),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$UserSettings$Page$GotUpdatePasswordResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$UserSettings$Requests$updatePassword = F2(
	function (authorizedAccess, passwordChangeRequest) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$users.mL,
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$PasswordChangeRequest$encoderPasswordChangeRequest(passwordChangeRequest)),
				cz: $author$project$Util$HttpUtil$expectWhatever($author$project$Pages$UserSettings$Page$GotUpdatePasswordResponse)
			});
	});
var $author$project$Pages$UserSettings$Handler$updatePassword = function (model) {
	return _Utils_Tuple2(
		model,
		A3(
			$author$project$Pages$View$Tristate$foldMain,
			$elm$core$Platform$Cmd$none,
			function (main) {
				return A2(
					$author$project$Pages$UserSettings$Requests$updatePassword,
					{o: model.o, W: main.W},
					{g5: main.d2.eH.lw});
			},
			model));
};
var $author$project$Pages$UserSettings$Page$GotUpdateSettingsResponse = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Types$UserUpdate$encoderUserUpdate = function (obj) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'displayName',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, obj.fZ)))
			]));
};
var $author$project$Pages$UserSettings$Requests$updateSettings = F2(
	function (authorizedAccess, userUpdate) {
		return A3(
			$author$project$Util$HttpUtil$runPatternWithJwt,
			authorizedAccess,
			$author$project$Addresses$Backend$users.ac,
			{
				iO: $elm$http$Http$jsonBody(
					$author$project$Api$Types$UserUpdate$encoderUserUpdate(userUpdate)),
				cz: A2($author$project$Util$HttpUtil$expectJson, $author$project$Pages$UserSettings$Page$GotUpdateSettingsResponse, $author$project$Api$Types$User$decoderUser)
			});
	});
var $author$project$Pages$UserSettings$Handler$updateSettings = function (model) {
	return _Utils_Tuple2(
		model,
		A3(
			$author$project$Pages$View$Tristate$foldMain,
			$elm$core$Platform$Cmd$none,
			function (main) {
				return A2(
					$author$project$Pages$UserSettings$Requests$updateSettings,
					{o: model.o, W: main.W},
					{fZ: main.d2.fZ});
			},
			model));
};
var $author$project$Pages$UserSettings$Handler$updateLogic = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var result = msg.a;
				return A2($author$project$Pages$UserSettings$Handler$gotFetchUserResponse, model, result);
			case 1:
				return $author$project$Pages$UserSettings$Handler$updatePassword(model);
			case 2:
				var result = msg.a;
				return A2($author$project$Pages$UserSettings$Handler$gotUpdatePasswordResponse, model, result);
			case 3:
				return $author$project$Pages$UserSettings$Handler$updateSettings(model);
			case 4:
				var result = msg.a;
				return A2($author$project$Pages$UserSettings$Handler$gotUpdateSettingsResponse, model, result);
			case 5:
				return $author$project$Pages$UserSettings$Handler$requestDeletion(model);
			case 6:
				var result = msg.a;
				return A2($author$project$Pages$UserSettings$Handler$gotRequestDeletionResponse, model, result);
			case 7:
				var complementInput = msg.a;
				return A2($author$project$Pages$UserSettings$Handler$setComplementInput, model, complementInput);
			case 8:
				var logoutKind = msg.a;
				return A2($author$project$Pages$UserSettings$Handler$logout, model, logoutKind);
			default:
				var result = msg.a;
				return A2($author$project$Pages$UserSettings$Handler$gotLogoutResponse, model, result);
		}
	});
var $author$project$Pages$UserSettings$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$UserSettings$Handler$updateLogic);
var $author$project$Main$update = F2(
	function (msg, model) {
		var _v0 = _Utils_Tuple2(msg, model.N);
		_v0$36:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					var urlRequest = _v0.a.a;
					if (!urlRequest.$) {
						var url = urlRequest.a;
						return _Utils_Tuple2(
							model,
							A2(
								$elm$browser$Browser$Navigation$pushUrl,
								model.eo,
								$elm$url$Url$toString(url)));
					} else {
						var href = urlRequest.a;
						return _Utils_Tuple2(
							model,
							$elm$browser$Browser$Navigation$load(href));
					}
				case 1:
					var url = _v0.a.a;
					return $author$project$Main$followRoute(
						A2(
							$author$project$Main$lenses.aI.eW,
							$author$project$Main$parsePage(url),
							model));
				case 6:
					if (_v0.b.$ === 1) {
						var loginMsg = _v0.a.a;
						var login = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.kw,
							model,
							A2($author$project$Pages$Login$Handler$update, loginMsg, login));
					} else {
						break _v0$36;
					}
				case 2:
					var token = _v0.a.a;
					return $author$project$Main$followRoute(
						A2(
							$author$project$Main$lenses.W.eW,
							A2(
								$elm_community$maybe_extra$Maybe$Extra$filter,
								A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not),
								$elm$core$Maybe$Just(token)),
							model));
				case 3:
					return _Utils_Tuple2(
						A2($author$project$Main$lenses.W.eW, $elm$core$Maybe$Nothing, model),
						$elm$core$Platform$Cmd$none);
				case 4:
					switch (_v0.b.$) {
						case 4:
							var foods = _v0.a.a;
							var ingredients = _v0.b.a;
							return A3(
								$author$project$Main$stepThrough,
								$author$project$Main$steps.kg,
								model,
								A2(
									$author$project$Pages$Ingredients$Handler$update,
									$author$project$Pages$View$Tristate$Logic(
										$author$project$Pages$Ingredients$Page$UpdateFoods(foods)),
									ingredients));
						case 9:
							var foods = _v0.a.a;
							var statisticsFoodSearch = _v0.b.a;
							return A3(
								$author$project$Main$stepThrough,
								$author$project$Main$steps.dG,
								model,
								A2(
									$author$project$Pages$Statistics$Food$Search$Handler$update,
									$author$project$Pages$View$Tristate$Logic(
										$author$project$Pages$Statistics$Food$Search$Page$UpdateFoods(foods)),
									statisticsFoodSearch));
						default:
							break _v0$36;
					}
				case 5:
					if (_v0.b.$ === 21) {
						var nutrients = _v0.a.a;
						var referenceEntries = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.dr,
							model,
							A2(
								$author$project$Pages$ReferenceEntries$Handler$update,
								$author$project$Pages$View$Tristate$Logic(
									$author$project$Pages$ReferenceEntries$Page$UpdateNutrients(nutrients)),
								referenceEntries));
					} else {
						break _v0$36;
					}
				case 7:
					if (_v0.b.$ === 2) {
						var overviewMsg = _v0.a.a;
						var overview = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.eD,
							model,
							A2($author$project$Pages$Overview$Handler$update, overviewMsg, overview));
					} else {
						break _v0$36;
					}
				case 8:
					if (_v0.b.$ === 3) {
						var recipesMsg = _v0.a.a;
						var recipes = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.eO,
							model,
							A2($author$project$Pages$Recipes$Handler$update, recipesMsg, recipes));
					} else {
						break _v0$36;
					}
				case 9:
					if (_v0.b.$ === 4) {
						var ingredientsMsg = _v0.a.a;
						var ingredients = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.kg,
							model,
							A2($author$project$Pages$Ingredients$Handler$update, ingredientsMsg, ingredients));
					} else {
						break _v0$36;
					}
				case 10:
					if (_v0.b.$ === 5) {
						var profileChoiceMsg = _v0.a.a;
						var profileChoice = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.eL,
							model,
							A2($author$project$Pages$Meals$ProfileChoice$Handler$update, profileChoiceMsg, profileChoice));
					} else {
						break _v0$36;
					}
				case 11:
					if (_v0.b.$ === 6) {
						var mealsMsg = _v0.a.a;
						var meals = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.gG,
							model,
							A2($author$project$Pages$Meals$Editor$Handler$update, mealsMsg, meals));
					} else {
						break _v0$36;
					}
				case 12:
					if (_v0.b.$ === 7) {
						var mealEntryMsg = _v0.a.a;
						var mealEntry = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.es,
							model,
							A2($author$project$Pages$MealEntries$Handler$update, mealEntryMsg, mealEntry));
					} else {
						break _v0$36;
					}
				case 13:
					if (_v0.b.$ === 8) {
						var statisticsTimeMsg = _v0.a.a;
						var statisticsTime = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.e7,
							model,
							A2($author$project$Pages$Statistics$Time$Handler$update, statisticsTimeMsg, statisticsTime));
					} else {
						break _v0$36;
					}
				case 14:
					if (_v0.b.$ === 9) {
						var statisticsFoodSearchMsg = _v0.a.a;
						var statisticsFoodSearch = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.dG,
							model,
							A2($author$project$Pages$Statistics$Food$Search$Handler$update, statisticsFoodSearchMsg, statisticsFoodSearch));
					} else {
						break _v0$36;
					}
				case 15:
					if (_v0.b.$ === 10) {
						var statisticsFoodSelectMsg = _v0.a.a;
						var statisticsFoodSelect = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.e$,
							model,
							A2($author$project$Pages$Statistics$Food$Select$Handler$update, statisticsFoodSelectMsg, statisticsFoodSelect));
					} else {
						break _v0$36;
					}
				case 16:
					if (_v0.b.$ === 11) {
						var statisticsComplexFoodSearchMsg = _v0.a.a;
						var statisticsComplexFoodSearch = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.eZ,
							model,
							A2($author$project$Pages$Statistics$ComplexFood$Search$Handler$update, statisticsComplexFoodSearchMsg, statisticsComplexFoodSearch));
					} else {
						break _v0$36;
					}
				case 17:
					if (_v0.b.$ === 12) {
						var statisticsComplexFoodSelectMsg = _v0.a.a;
						var statisticsComplexFoodSelect = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.e_,
							model,
							A2($author$project$Pages$Statistics$ComplexFood$Select$Handler$update, statisticsComplexFoodSelectMsg, statisticsComplexFoodSelect));
					} else {
						break _v0$36;
					}
				case 18:
					if (_v0.b.$ === 13) {
						var statisticsRecipeSearchMsg = _v0.a.a;
						var statisticsRecipeSearch = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.e5,
							model,
							A2($author$project$Pages$Statistics$Recipe$Search$Handler$update, statisticsRecipeSearchMsg, statisticsRecipeSearch));
					} else {
						break _v0$36;
					}
				case 19:
					if (_v0.b.$ === 14) {
						var statisticsRecipeSelectMsg = _v0.a.a;
						var statisticsRecipeSelect = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.e6,
							model,
							A2($author$project$Pages$Statistics$Recipe$Select$Handler$update, statisticsRecipeSelectMsg, statisticsRecipeSelect));
					} else {
						break _v0$36;
					}
				case 20:
					if (_v0.b.$ === 15) {
						var statisticsProfileChoiceMsg = _v0.a.a;
						var statisticsProfileChoice = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.e0,
							model,
							A2($author$project$Pages$Statistics$Meal$ProfileChoice$Handler$update, statisticsProfileChoiceMsg, statisticsProfileChoice));
					} else {
						break _v0$36;
					}
				case 21:
					if (_v0.b.$ === 16) {
						var statisticsMealSearchMsg = _v0.a.a;
						var statisticsMealSearch = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.e1,
							model,
							A2($author$project$Pages$Statistics$Meal$Search$Handler$update, statisticsMealSearchMsg, statisticsMealSearch));
					} else {
						break _v0$36;
					}
				case 22:
					if (_v0.b.$ === 17) {
						var statisticsMealSelectMsg = _v0.a.a;
						var statisticsMealSelect = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.e2,
							model,
							A2($author$project$Pages$Statistics$Meal$Select$Handler$update, statisticsMealSelectMsg, statisticsMealSelect));
					} else {
						break _v0$36;
					}
				case 23:
					if (_v0.b.$ === 18) {
						var statisticsRecipeOccurrencesProfileChoiceMsg = _v0.a.a;
						var statisticsRecipeOccurrencesProfileChoice = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.e4,
							model,
							A2($author$project$Pages$Statistics$RecipeOccurrences$ProfileChoice$Handler$update, statisticsRecipeOccurrencesProfileChoiceMsg, statisticsRecipeOccurrencesProfileChoice));
					} else {
						break _v0$36;
					}
				case 24:
					if (_v0.b.$ === 19) {
						var statisticsRecipeOccurrencesMsg = _v0.a.a;
						var statisticsRecipeOccurrences = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.e3,
							model,
							A2($author$project$Pages$Statistics$RecipeOccurrences$Search$Handler$update, statisticsRecipeOccurrencesMsg, statisticsRecipeOccurrences));
					} else {
						break _v0$36;
					}
				case 25:
					if (_v0.b.$ === 20) {
						var referenceMapsMsg = _v0.a.a;
						var referenceMaps = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.eR,
							model,
							A2($author$project$Pages$ReferenceMaps$Handler$update, referenceMapsMsg, referenceMaps));
					} else {
						break _v0$36;
					}
				case 26:
					if (_v0.b.$ === 21) {
						var referenceEntriesMsg = _v0.a.a;
						var referenceEntries = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.dr,
							model,
							A2($author$project$Pages$ReferenceEntries$Handler$update, referenceEntriesMsg, referenceEntries));
					} else {
						break _v0$36;
					}
				case 27:
					if (_v0.b.$ === 22) {
						var requestRegistrationMsg = _v0.a.a;
						var requestRegistration = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.eU,
							model,
							A2($author$project$Pages$Registration$Request$Handler$update, requestRegistrationMsg, requestRegistration));
					} else {
						break _v0$36;
					}
				case 28:
					if (_v0.b.$ === 23) {
						var confirmRegistrationMsg = _v0.a.a;
						var confirmRegistration = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.d6,
							model,
							A2($author$project$Pages$Registration$Confirm$Handler$update, confirmRegistrationMsg, confirmRegistration));
					} else {
						break _v0$36;
					}
				case 29:
					if (_v0.b.$ === 24) {
						var userSettingsMsg = _v0.a.a;
						var userSettings = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.ff,
							model,
							A2($author$project$Pages$UserSettings$Handler$update, userSettingsMsg, userSettings));
					} else {
						break _v0$36;
					}
				case 30:
					if (_v0.b.$ === 25) {
						var deletionMsg = _v0.a.a;
						var deletion = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.jr,
							model,
							A2($author$project$Pages$Deletion$Handler$update, deletionMsg, deletion));
					} else {
						break _v0$36;
					}
				case 31:
					if (_v0.b.$ === 26) {
						var requestRecoveryMsg = _v0.a.a;
						var requestRecovery = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.eT,
							model,
							A2($author$project$Pages$Recovery$Request$Handler$update, requestRecoveryMsg, requestRecovery));
					} else {
						break _v0$36;
					}
				case 32:
					if (_v0.b.$ === 27) {
						var confirmRecoveryMsg = _v0.a.a;
						var confirmRecovery = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.d5,
							model,
							A2($author$project$Pages$Recovery$Confirm$Handler$update, confirmRecoveryMsg, confirmRecovery));
					} else {
						break _v0$36;
					}
				case 33:
					if (_v0.b.$ === 28) {
						var complexFoodsMsg = _v0.a.a;
						var complexFoods = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.d3,
							model,
							A2($author$project$Pages$ComplexFoods$Handler$update, complexFoodsMsg, complexFoods));
					} else {
						break _v0$36;
					}
				default:
					if (_v0.b.$ === 29) {
						var profilesMsg = _v0.a.a;
						var profiles = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.eM,
							model,
							A2($author$project$Pages$Profiles$Handler$update, profilesMsg, profiles));
					} else {
						break _v0$36;
					}
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Pages$View$Tristate$HandleError = {$: 1};
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $author$project$Pages$Util$Style$classes = {
	iu: $elm$html$Html$Attributes$class('add-element'),
	iz: $elm$html$Html$Attributes$class('add-view'),
	a0: {
		fk: $elm$html$Html$Attributes$class('add-button'),
		fo: $elm$html$Html$Attributes$class('alternative-button'),
		iR: $elm$html$Html$Attributes$class('cancel-button'),
		d4: $elm$html$Html$Attributes$class('confirm-button'),
		af: $elm$html$Html$Attributes$class('delete-button'),
		eb: $elm$html$Html$Attributes$class('edit-button'),
		jy: $elm$html$Html$Attributes$class('editor-button'),
		f6: $elm$html$Html$Attributes$class('error-button'),
		kx: $elm$html$Html$Attributes$class('logout-button'),
		kJ: $elm$html$Html$Attributes$class('menu-button'),
		kY: $elm$html$Html$Attributes$class('navigation-button'),
		k8: $elm$html$Html$Attributes$class('nutrients-button'),
		eD: $elm$html$Html$Attributes$class('overview-button'),
		ls: $elm$html$Html$Attributes$class('pager-button'),
		lW: $elm$html$Html$Attributes$class('rescale-button'),
		l6: $elm$html$Html$Attributes$class('select-button')
	},
	i_: $elm$html$Html$Attributes$class('choice-table'),
	i$: $elm$html$Html$Attributes$class('choices'),
	d4: $elm$html$Html$Attributes$class('confirm'),
	H: $elm$html$Html$Attributes$class('controls'),
	jd: $elm$html$Html$Attributes$class('controls-group'),
	fR: $elm$html$Html$Attributes$class('date'),
	cw: $elm$html$Html$Attributes$class('description-column'),
	ju: $elm$html$Html$Attributes$class('disabled'),
	f0: $elm$html$Html$Attributes$class('edit-line'),
	ec: $elm$html$Html$Attributes$class('editable'),
	jx: $elm$html$Html$Attributes$class('editing'),
	jB: $elm$html$Html$Attributes$class('element-edit-table'),
	jD: $elm$html$Html$Attributes$class('elements'),
	jF: $elm$html$Html$Attributes$class('elements-with-controls-table'),
	jG: $elm$html$Html$Attributes$class('ellipsis'),
	kb: $elm$html$Html$Attributes$class('incomplete'),
	kd: $elm$html$Html$Attributes$class('info'),
	km: $elm$html$Html$Attributes$class('interval-section'),
	kE: $elm$html$Html$Attributes$class('meal-edit-table'),
	gG: $elm$html$Html$Attributes$class('meals'),
	cW: $elm$html$Html$Attributes$class('number-cell'),
	M: $elm$html$Html$Attributes$class('number-label'),
	k8: $elm$html$Html$Attributes$class('nutrients'),
	lt: $elm$html$Html$Attributes$class('pagination'),
	lv: $elm$html$Html$Attributes$class('partial-statistics'),
	lz: $elm$html$Html$Attributes$class('profile-edit-table'),
	eN: {
		jJ: $elm$html$Html$Attributes$class('exact'),
		j1: $elm$html$Html$Attributes$class('high'),
		ky: $elm$html$Html$Attributes$class('low')
	},
	lE: $elm$html$Html$Attributes$class('recipe-edit-table'),
	lM: $elm$html$Html$Attributes$class('reference-map-edit-table'),
	eS: $elm$html$Html$Attributes$class('request'),
	hy: {
		iI: $elm$html$Html$Attributes$class('search-area'),
		jP: $elm$html$Html$Attributes$class('search-field'),
		kd: $elm$html$Html$Attributes$class('search-info')
	},
	mh: $elm$html$Html$Attributes$class('sort-controls'),
	mt: $elm$html$Html$Attributes$class('table-header'),
	h$: $elm$html$Html$Attributes$class('time'),
	h2: $elm$html$Html$Attributes$class('toggle')
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $author$project$Pages$Util$Style$ids = {
	fk: $elm$html$Html$Attributes$id('add'),
	iv: $elm$html$Html$Attributes$id('add-meal-view'),
	iw: $elm$html$Html$Attributes$id('add-profile-view'),
	ix: $elm$html$Html$Attributes$id('add-recipe-view'),
	iy: $elm$html$Html$Attributes$id('add-reference-map-view'),
	i5: $elm$html$Html$Attributes$id('complex-food-editor'),
	f6: $elm$html$Html$Attributes$id('error'),
	kf: $elm$html$Html$Attributes$id('ingredient-editor'),
	kF: $elm$html$Html$Attributes$id('meal-entry-editor'),
	kY: $elm$html$Html$Attributes$id('navigation'),
	lp: $elm$html$Html$Attributes$id('overview-main'),
	lL: $elm$html$Html$Attributes$id('reference-entry-editor'),
	mj: {
		i4: $elm$html$Html$Attributes$id('statistics-complex-food'),
		gc: $elm$html$Html$Attributes$id('statistics-food'),
		kD: $elm$html$Html$Attributes$id('statistics-meal'),
		lD: $elm$html$Html$Attributes$id('statistics-recipe'),
		lF: $elm$html$Html$Attributes$id('statistics-recipe-occurrence'),
		h$: $elm$html$Html$Attributes$id('statistics')
	}
};
var $elm$html$Html$label = _VirtualDom_node('label');
var $perzanko$elm_loading$Loading$On = 0;
var $perzanko$elm_loading$Loading$Spinner = 1;
var $perzanko$elm_loading$Loading$defaultConfig = {fI: '', fL: '#74b4c9', hJ: 30, hN: 1};
var $elm$core$String$cons = _String_cons;
var $robinheghan$murmur3$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {a1: charsProcessed, a9: hash, hB: seed, bk: shift};
	});
var $robinheghan$murmur3$Murmur3$c1 = 3432918353;
var $robinheghan$murmur3$Murmur3$c2 = 461845907;
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $robinheghan$murmur3$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $robinheghan$murmur3$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $robinheghan$murmur3$Murmur3$finalize = function (data) {
	var acc = (!(!data.a9)) ? (data.hB ^ A2(
		$robinheghan$murmur3$Murmur3$multiplyBy,
		$robinheghan$murmur3$Murmur3$c2,
		A2(
			$robinheghan$murmur3$Murmur3$rotlBy,
			15,
			A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, data.a9)))) : data.hB;
	var h0 = acc ^ data.a1;
	var h1 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $elm$core$String$foldl = _String_foldl;
var $robinheghan$murmur3$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$robinheghan$murmur3$Murmur3$multiplyBy,
			5,
			A2(
				$robinheghan$murmur3$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$robinheghan$murmur3$Murmur3$multiplyBy,
					$robinheghan$murmur3$Murmur3$c2,
					A2(
						$robinheghan$murmur3$Murmur3$rotlBy,
						15,
						A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, k1))))) + 3864292196;
	});
var $robinheghan$murmur3$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.a9 | ((255 & $elm$core$Char$toCode(c)) << data.bk);
		var _v0 = data.bk;
		if (_v0 === 24) {
			return {
				a1: data.a1 + 1,
				a9: 0,
				hB: A2($robinheghan$murmur3$Murmur3$mix, data.hB, res),
				bk: 0
			};
		} else {
			return {a1: data.a1 + 1, a9: res, hB: data.hB, bk: data.bk + 8};
		}
	});
var $robinheghan$murmur3$Murmur3$hashString = F2(
	function (seed, str) {
		return $robinheghan$murmur3$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$robinheghan$murmur3$Murmur3$hashFold,
				A4($robinheghan$murmur3$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $rtfeldman$elm_css$Hash$initialSeed = 15739;
var $elm$core$String$fromList = _String_fromList;
var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return '0';
			case 1:
				return '1';
			case 2:
				return '2';
			case 3:
				return '3';
			case 4:
				return '4';
			case 5:
				return '5';
			case 6:
				return '6';
			case 7:
				return '7';
			case 8:
				return '8';
			case 9:
				return '9';
			case 10:
				return 'a';
			case 11:
				return 'b';
			case 12:
				return 'c';
			case 13:
				return 'd';
			case 14:
				return 'e';
			case 15:
				return 'f';
			default:
				var $temp$num = num;
				num = $temp$num;
				continue unsafeToDigit;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (num < 16) {
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(num),
					digits);
			} else {
				var $temp$digits = A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(
						A2($elm$core$Basics$modBy, 16, num)),
					digits),
					$temp$num = (num / 16) | 0;
				digits = $temp$digits;
				num = $temp$num;
				continue unsafePositiveToDigits;
			}
		}
	});
var $rtfeldman$elm_hex$Hex$toString = function (num) {
	return $elm$core$String$fromList(
		(num < 0) ? A2(
			$elm$core$List$cons,
			'-',
			A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
};
var $rtfeldman$elm_css$Hash$fromString = function (str) {
	return A2(
		$elm$core$String$cons,
		'_',
		$rtfeldman$elm_hex$Hex$toString(
			A2($robinheghan$murmur3$Murmur3$hashString, $rtfeldman$elm_css$Hash$initialSeed, str)));
};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
	function (_v0, styles) {
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				return styles;
			} else {
				return A3(
					$elm$core$Dict$insert,
					cssTemplate,
					$rtfeldman$elm_css$Hash$fromString(cssTemplate),
					styles);
			}
		} else {
			return styles;
		}
	});
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlJson(value));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = F2(
	function (styles, _v0) {
		var val = _v0.a;
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				var classname = _v1.a;
				return A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string(classname));
			} else {
				return A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string('_unstyled'));
			}
		} else {
			return val;
		}
	});
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS = F2(
	function (styles, _v0) {
		var val = _v0.a;
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				var classname = _v1.a;
				return A2($elm$virtual_dom$VirtualDom$attribute, 'class', classname);
			} else {
				return A2($elm$virtual_dom$VirtualDom$attribute, 'class', '_unstyled');
			}
		} else {
			return val;
		}
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_keyedNodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$nodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_nodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
	function (_v6, _v7) {
		var key = _v6.a;
		var html = _v6.b;
		var pairs = _v7.a;
		var styles = _v7.b;
		switch (html.$) {
			case 4:
				var vdom = html.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v9 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v9.a;
				var finalStyles = _v9.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v10 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v10.a;
				var finalStyles = _v10.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v11 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v11.a;
				var finalStyles = _v11.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v12 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v12.a;
				var finalStyles = _v12.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
	function (html, _v0) {
		var nodes = _v0.a;
		var styles = _v0.b;
		switch (html.$) {
			case 4:
				var vdomNode = html.a;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v2 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v2.a;
				var finalStyles = _v2.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v3 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v3.a;
				var finalStyles = _v3.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v4 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v4.a;
				var finalStyles = _v4.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v5 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v5.a;
				var finalStyles = _v5.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
		}
	});
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin = '\u0007';
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration = F3(
	function (template, classname, declaration) {
		return declaration + ('\n' + A3($elm$core$String$replace, $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin, classname, template));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
	return A3($elm$core$Dict$foldl, $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration, '', dict);
};
var $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = F2(
	function (maybeNonce, styles) {
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			'span',
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'style', 'display: none;'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'class', 'elm-css-style-wrapper')
				]),
			_List_fromArray(
				[
					A3(
					$elm$virtual_dom$VirtualDom$node,
					'style',
					function () {
						if (!maybeNonce.$) {
							var nonce = maybeNonce.a;
							return _List_fromArray(
								[
									A2($elm$virtual_dom$VirtualDom$attribute, 'nonce', nonce)
								]);
						} else {
							return _List_Nil;
						}
					}(),
					$elm$core$List$singleton(
						$elm$virtual_dom$VirtualDom$text(
							$rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))))
				]));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyle = F4(
	function (maybeNonce, elemType, properties, children) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toStyleNode, maybeNonce, styles);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles),
			properties);
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
	function (key, pairs) {
		containsKey:
		while (true) {
			if (!pairs.b) {
				return false;
			} else {
				var _v1 = pairs.a;
				var str = _v1.a;
				var rest = pairs.b;
				if (_Utils_eq(key, str)) {
					return true;
				} else {
					var $temp$key = key,
						$temp$pairs = rest;
					key = $temp$key;
					pairs = $temp$pairs;
					continue containsKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
	function (_default, pairs) {
		getUnusedKey:
		while (true) {
			if (!pairs.b) {
				return _default;
			} else {
				var _v1 = pairs.a;
				var firstKey = _v1.a;
				var rest = pairs.b;
				var newKey = '_' + firstKey;
				if (A2($rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
					var $temp$default = newKey,
						$temp$pairs = rest;
					_default = $temp$default;
					pairs = $temp$pairs;
					continue getUnusedKey;
				} else {
					return newKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F3(
	function (maybeNonce, allStyles, keyedChildNodes) {
		var styleNodeKey = A2($rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
		var finalNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toStyleNode, maybeNonce, allStyles);
		return _Utils_Tuple2(styleNodeKey, finalNode);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F4(
	function (maybeNonce, elemType, properties, keyedChildren) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A3($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, maybeNonce, styles, keyedChildNodes);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles),
			properties);
		return A3(
			$elm$virtual_dom$VirtualDom$keyedNode,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F5(
	function (maybeNonce, ns, elemType, properties, keyedChildren) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A3($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, maybeNonce, styles, keyedChildNodes);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles),
			properties);
		return A4(
			$elm$virtual_dom$VirtualDom$keyedNodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F5(
	function (maybeNonce, ns, elemType, properties, children) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toStyleNode, maybeNonce, styles);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles),
			properties);
		return A4(
			$elm$virtual_dom$VirtualDom$nodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
	switch (vdom.$) {
		case 4:
			var plainNode = vdom.a;
			return plainNode;
		case 0:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyle, $elm$core$Maybe$Nothing, elemType, properties, children);
		case 1:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A5($rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, $elm$core$Maybe$Nothing, ns, elemType, properties, children);
		case 2:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, $elm$core$Maybe$Nothing, elemType, properties, children);
		default:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A5($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, $elm$core$Maybe$Nothing, ns, elemType, properties, children);
	}
};
var $rtfeldman$elm_css$Html$Styled$toUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
var $rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$Property = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Internal$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
	function (functionName, desiredKey, style) {
		getOverloadedProperty:
		while (true) {
			switch (style.$) {
				case 0:
					var str = style.a;
					var key = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2($elm$core$String$split, ':', str)));
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
				case 1:
					var selector = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
				case 2:
					var combinator = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
				case 3:
					var pseudoElement = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
				case 4:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
				case 5:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
				default:
					if (!style.a.b) {
						return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
					} else {
						if (!style.a.b.b) {
							var _v1 = style.a;
							var only = _v1.a;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = only;
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						} else {
							var _v2 = style.a;
							var first = _v2.a;
							var rest = _v2.b;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						}
					}
			}
		}
	});
var $rtfeldman$elm_css$Css$Internal$IncompatibleUnits = 0;
var $rtfeldman$elm_css$Css$Structure$Compatible = 0;
var $rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
	function (units, unitLabel, numericValue) {
		return {
			fi: 0,
			fD: 0,
			a6: 0,
			C: 0,
			s: 0,
			bd: 0,
			at: 0,
			be: 0,
			bf: 0,
			aM: 0,
			aN: 0,
			ag: 0,
			av: numericValue,
			bn: 0,
			bp: unitLabel,
			b$: units,
			ig: _Utils_ap(
				$elm$core$String$fromFloat(numericValue),
				unitLabel)
		};
	});
var $rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '', 0);
var $rtfeldman$elm_css$Css$alignItems = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'alignItems',
		'align-items',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$Preprocess$WithKeyframes = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$prop1 = F2(
	function (key, arg) {
		return A2($rtfeldman$elm_css$Css$property, key, arg.ig);
	});
var $rtfeldman$elm_css$Css$animationName = function (arg) {
	return ((arg.ig === 'none') || ((arg.ig === 'inherit') || ((arg.ig === 'unset') || (arg.ig === 'initial')))) ? A2($rtfeldman$elm_css$Css$prop1, 'animation-name', arg) : $rtfeldman$elm_css$Css$Preprocess$WithKeyframes(arg.ig);
};
var $rtfeldman$elm_css$Css$auto = {iC: 0, d: 0, a6: 0, cN: 0, kp: 0, bd: 0, at: 0, ag: 0, bh: 0, aa: 0, dL: 0, bo: 0, O: 0, ig: 'auto'};
var $rtfeldman$elm_css$Css$backgroundColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'background-color', c.ig);
};
var $rtfeldman$elm_css$Css$borderRadius = $rtfeldman$elm_css$Css$prop1('border-radius');
var $rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$property = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$property, key, value),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$class = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $rtfeldman$elm_css$Css$Structure$compactHelp = F2(
	function (declaration, _v0) {
		var keyframesByName = _v0.a;
		var declarations = _v0.b;
		switch (declaration.$) {
			case 0:
				var _v2 = declaration.a;
				var properties = _v2.c;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 1:
				var styleBlocks = declaration.b;
				return A2(
					$elm$core$List$all,
					function (_v3) {
						var properties = _v3.c;
						return $elm$core$List$isEmpty(properties);
					},
					styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 2:
				var otherDeclarations = declaration.b;
				return $elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 3:
				return _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 4:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 5:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 6:
				var record = declaration.a;
				return $elm$core$String$isEmpty(record.jj) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					A3($elm$core$Dict$insert, record.gN, record.jj, keyframesByName),
					declarations);
			case 7:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 8:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			default:
				var tuples = declaration.a;
				return A2(
					$elm$core$List$all,
					function (_v4) {
						var properties = _v4.b;
						return $elm$core$List$isEmpty(properties);
					},
					tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
		}
	});
var $rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
	function (keyframesByName, compactedDeclarations) {
		return A2(
			$elm$core$List$append,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var name = _v0.a;
					var decl = _v0.b;
					return $rtfeldman$elm_css$Css$Structure$Keyframes(
						{jj: decl, gN: name});
				},
				$elm$core$Dict$toList(keyframesByName)),
			compactedDeclarations);
	});
var $rtfeldman$elm_css$Css$Structure$compactDeclarations = function (declarations) {
	var _v0 = A3(
		$elm$core$List$foldr,
		$rtfeldman$elm_css$Css$Structure$compactHelp,
		_Utils_Tuple2($elm$core$Dict$empty, _List_Nil),
		declarations);
	var keyframesByName = _v0.a;
	var compactedDeclarations = _v0.b;
	return A2($rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
};
var $rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_v0) {
	var charset = _v0.fG;
	var imports = _v0.go;
	var namespaces = _v0.gP;
	var declarations = _v0.jk;
	return {
		fG: charset,
		jk: $rtfeldman$elm_css$Css$Structure$compactDeclarations(declarations),
		go: imports,
		gP: namespaces
	};
};
var $rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (str) {
				return '@charset \"' + (str + '\"');
			},
			charset));
};
var $rtfeldman$elm_css$Css$String$mapJoinHelp = F4(
	function (map, sep, strs, result) {
		mapJoinHelp:
		while (true) {
			if (!strs.b) {
				return result;
			} else {
				if (!strs.b.b) {
					var first = strs.a;
					return result + (map(first) + '');
				} else {
					var first = strs.a;
					var rest = strs.b;
					var $temp$map = map,
						$temp$sep = sep,
						$temp$strs = rest,
						$temp$result = result + (map(first) + (sep + ''));
					map = $temp$map;
					sep = $temp$sep;
					strs = $temp$strs;
					result = $temp$result;
					continue mapJoinHelp;
				}
			}
		}
	});
var $rtfeldman$elm_css$Css$String$mapJoin = F3(
	function (map, sep, strs) {
		return A4($rtfeldman$elm_css$Css$String$mapJoinHelp, map, sep, strs, '');
	});
var $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
	return '(' + (expression.ga + (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append(': '),
			expression.ig)) + ')'));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
	switch (mediaType) {
		case 0:
			return 'print';
		case 1:
			return 'screen';
		default:
			return 'speech';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
	var prefixWith = F3(
		function (str, mediaType, expressions) {
			return str + (' ' + A2(
				$elm$core$String$join,
				' and ',
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
		});
	switch (mediaQuery.$) {
		case 0:
			var expressions = mediaQuery.a;
			return A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, ' and ', expressions);
		case 1:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'only', mediaType, expressions);
		case 2:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'not', mediaType, expressions);
		default:
			var str = mediaQuery.a;
			return str;
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
	function (name, mediaQuery) {
		return '@import \"' + (name + ($rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
	});
var $rtfeldman$elm_css$Css$Structure$Output$importToString = function (_v0) {
	var name = _v0.a;
	var mediaQueries = _v0.b;
	return A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		$rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
		'\n',
		mediaQueries);
};
var $rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_v0) {
	var prefix = _v0.a;
	var str = _v0.b;
	return '@namespace ' + (prefix + ('\"' + (str + '\"')));
};
var $rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
	return A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		function (_v0) {
			var prop = _v0;
			return prop + ';';
		},
		'',
		properties);
};
var $elm$core$String$append = _String_append;
var $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_v0) {
	var str = _v0;
	return '::' + str;
};
var $rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
	switch (combinator) {
		case 0:
			return '+';
		case 1:
			return '~';
		case 2:
			return '>';
		default:
			return '';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
	switch (repeatableSimpleSelector.$) {
		case 0:
			var str = repeatableSimpleSelector.a;
			return '.' + str;
		case 1:
			var str = repeatableSimpleSelector.a;
			return '#' + str;
		case 2:
			var str = repeatableSimpleSelector.a;
			return ':' + str;
		default:
			var str = repeatableSimpleSelector.a;
			return '[' + (str + ']');
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
	switch (simpleSelectorSequence.$) {
		case 0:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return _Utils_ap(
				str,
				A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors));
		case 1:
			var repeatableSimpleSelectors = simpleSelectorSequence.a;
			return $elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors);
		default:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return _Utils_ap(
				str,
				A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors));
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_v0) {
	var combinator = _v0.a;
	var sequence = _v0.b;
	return $rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator) + (' ' + $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence));
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_v0) {
	var simpleSelectorSequence = _v0.a;
	var chain = _v0.b;
	var pseudoElement = _v0.c;
	var segments = A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
	var pseudoElementsString = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement));
	return A2(
		$elm$core$String$append,
		A2($elm$core$String$join, ' ', segments),
		pseudoElementsString);
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = function (_v0) {
	var firstSelector = _v0.a;
	var otherSelectors = _v0.b;
	var properties = _v0.c;
	var selectorStr = A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		$rtfeldman$elm_css$Css$Structure$Output$selectorToString,
		',',
		A2($elm$core$List$cons, firstSelector, otherSelectors));
	return selectorStr + ('{' + ($rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties) + '}'));
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
	switch (decl.$) {
		case 0:
			var styleBlock = decl.a;
			return $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(styleBlock);
		case 1:
			var mediaQueries = decl.a;
			var styleBlocks = decl.b;
			var query = A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, ', ', mediaQueries);
			var blocks = A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, '\n', styleBlocks);
			return '@media ' + (query + ('{' + (blocks + '}')));
		case 2:
			return 'TODO';
		case 3:
			return 'TODO';
		case 4:
			return 'TODO';
		case 5:
			return 'TODO';
		case 6:
			var name = decl.a.gN;
			var declaration = decl.a.jj;
			return '@keyframes ' + (name + ('{' + (declaration + '}')));
		case 7:
			return 'TODO';
		case 8:
			return 'TODO';
		default:
			return 'TODO';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_v0) {
	var charset = _v0.fG;
	var imports = _v0.go;
	var namespaces = _v0.gP;
	var declarations = _v0.jk;
	return $rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$importToString, '\n', imports) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$namespaceToString, '\n', namespaces) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, '\n', declarations) + '')));
};
var $rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
	return {$: 8, a: a};
};
var $rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$Structure$PageRule = function (a) {
	return {$: 4, a: a};
};
var $rtfeldman$elm_css$Css$Structure$Selector = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
	return {$: 7, a: a};
};
var $rtfeldman$elm_css$Css$Structure$MediaRule = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$mapLast = F2(
	function (update, list) {
		if (!list.b) {
			return list;
		} else {
			if (!list.b.b) {
				var only = list.a;
				return _List_fromArray(
					[
						update(only)
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
	function (property, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		return A3(
			$rtfeldman$elm_css$Css$Structure$StyleBlock,
			firstSelector,
			otherSelectors,
			_Utils_ap(
				properties,
				_List_fromArray(
					[property])));
	});
var $rtfeldman$elm_css$Css$Structure$appendProperty = F2(
	function (property, declarations) {
		if (!declarations.b) {
			return declarations;
		} else {
			if (!declarations.b.b) {
				switch (declarations.a.$) {
					case 0:
						var styleBlock = declarations.a.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
								A2($rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
							]);
					case 1:
						var _v1 = declarations.a;
						var mediaQueries = _v1.a;
						var styleBlocks = _v1.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Structure$MediaRule,
								mediaQueries,
								A2(
									$rtfeldman$elm_css$Css$Structure$mapLast,
									$rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
									styleBlocks))
							]);
					default:
						return declarations;
				}
			} else {
				var first = declarations.a;
				var rest = declarations.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
	function (f, styleBlock) {
		if (!styleBlock.b.b) {
			var only = styleBlock.a;
			var properties = styleBlock.c;
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
					A3(
					$rtfeldman$elm_css$Css$Structure$StyleBlock,
					f(only),
					_List_Nil,
					_List_Nil)
				]);
		} else {
			var first = styleBlock.a;
			var rest = styleBlock.b;
			var properties = styleBlock.c;
			var newRest = A2($elm$core$List$map, f, rest);
			var newFirst = f(first);
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
				]);
		}
	});
var $rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
	function (pseudo, _v0) {
		var sequence = _v0.a;
		var selectors = _v0.b;
		return A3(
			$rtfeldman$elm_css$Css$Structure$Selector,
			sequence,
			selectors,
			$elm$core$Maybe$Just(pseudo));
	});
var $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
	function (pseudo, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
	function (selector, sequence) {
		switch (sequence.$) {
			case 0:
				var typeSelector = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
					typeSelector,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			case 1:
				var list = sequence.a;
				return $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			default:
				var str = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$CustomSelector,
					str,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
	function (selector, list) {
		if (!list.b) {
			return _List_Nil;
		} else {
			if (!list.b.b) {
				var _v1 = list.a;
				var combinator = _v1.a;
				var sequence = _v1.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						combinator,
						A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
	function (repeatableSimpleSelector, selector) {
		if (!selector.b.b) {
			var sequence = selector.a;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
				_List_Nil,
				pseudoElement);
		} else {
			var firstSelector = selector.a;
			var tuples = selector.b;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				firstSelector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
				pseudoElement);
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
	function (selector, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
	collectSelectors:
	while (true) {
		if (!declarations.b) {
			return _List_Nil;
		} else {
			if (!declarations.a.$) {
				var _v1 = declarations.a.a;
				var firstSelector = _v1.a;
				var otherSelectors = _v1.b;
				var rest = declarations.b;
				return _Utils_ap(
					A2($elm$core$List$cons, firstSelector, otherSelectors),
					$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
			} else {
				var rest = declarations.b;
				var $temp$declarations = rest;
				declarations = $temp$declarations;
				continue collectSelectors;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
	function (a, b, c, d, e) {
		return {$: 3, a: a, b: b, c: c, d: d, e: e};
	});
var $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
	function (update, declarations) {
		_v0$12:
		while (true) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 0:
							var styleBlock = declarations.a.a;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
								update(styleBlock));
						case 1:
							if (declarations.a.b.b) {
								if (!declarations.a.b.b.b) {
									var _v1 = declarations.a;
									var mediaQueries = _v1.a;
									var _v2 = _v1.b;
									var styleBlock = _v2.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$Structure$MediaRule,
											mediaQueries,
											update(styleBlock))
										]);
								} else {
									var _v3 = declarations.a;
									var mediaQueries = _v3.a;
									var _v4 = _v3.b;
									var first = _v4.a;
									var rest = _v4.b;
									var _v5 = A2(
										$rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
										update,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
											]));
									if ((_v5.b && (_v5.a.$ === 1)) && (!_v5.b.b)) {
										var _v6 = _v5.a;
										var newMediaQueries = _v6.a;
										var newStyleBlocks = _v6.b;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Css$Structure$MediaRule,
												newMediaQueries,
												A2($elm$core$List$cons, first, newStyleBlocks))
											]);
									} else {
										var newDeclarations = _v5;
										return newDeclarations;
									}
								}
							} else {
								break _v0$12;
							}
						case 2:
							var _v7 = declarations.a;
							var str = _v7.a;
							var nestedDeclarations = _v7.b;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$Structure$SupportsRule,
									str,
									A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
								]);
						case 3:
							var _v8 = declarations.a;
							var str1 = _v8.a;
							var str2 = _v8.b;
							var str3 = _v8.c;
							var str4 = _v8.d;
							var styleBlock = _v8.e;
							return A2(
								$elm$core$List$map,
								A4($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
								update(styleBlock));
						case 4:
							return declarations;
						case 5:
							return declarations;
						case 6:
							return declarations;
						case 7:
							return declarations;
						case 8:
							return declarations;
						default:
							return declarations;
					}
				} else {
					break _v0$12;
				}
			}
		}
		var first = declarations.a;
		var rest = declarations.b;
		return A2(
			$elm$core$List$cons,
			first,
			A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
	last:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!list.b.b) {
				var singleton = list.a;
				return $elm$core$Maybe$Just(singleton);
			} else {
				var rest = list.b;
				var $temp$list = rest;
				list = $temp$list;
				continue last;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
	lastDeclaration:
	while (true) {
		if (!declarations.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!declarations.b.b) {
				var x = declarations.a;
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[x]));
			} else {
				var xs = declarations.b;
				var $temp$declarations = xs;
				declarations = $temp$declarations;
				continue lastDeclaration;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
	oneOf:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var maybe = maybes.a;
			var rest = maybes.b;
			if (maybe.$ === 1) {
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue oneOf;
			} else {
				return maybe;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
	return {$: 9, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
	var expandTuples = function (tuplesToExpand) {
		if (!tuplesToExpand.b) {
			return _List_Nil;
		} else {
			var properties = tuplesToExpand.a;
			var rest = tuplesToExpand.b;
			return A2(
				$elm$core$List$cons,
				properties,
				expandTuples(rest));
		}
	};
	var newTuples = expandTuples(tuples);
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
		]);
};
var $rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
	function (mediaQueries, declaration) {
		if (!declaration.$) {
			var styleBlock = declaration.a;
			return A2(
				$rtfeldman$elm_css$Css$Structure$MediaRule,
				mediaQueries,
				_List_fromArray(
					[styleBlock]));
		} else {
			return declaration;
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
	function (str1, str2, str3, str4, declaration) {
		if (!declaration.$) {
			var structureStyleBlock = declaration.a;
			return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
	function (mediaQueries, declaration) {
		switch (declaration.$) {
			case 0:
				var structureStyleBlock = declaration.a;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[structureStyleBlock]));
			case 1:
				var newMediaQueries = declaration.a;
				var structureStyleBlocks = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					_Utils_ap(mediaQueries, newMediaQueries),
					structureStyleBlocks);
			case 2:
				var str = declaration.a;
				var declarations = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$SupportsRule,
					str,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
						declarations));
			case 3:
				var str1 = declaration.a;
				var str2 = declaration.b;
				var str3 = declaration.c;
				var str4 = declaration.d;
				var structureStyleBlock = declaration.e;
				return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			case 4:
				return declaration;
			case 5:
				return declaration;
			case 6:
				return declaration;
			case 7:
				return declaration;
			case 8:
				return declaration;
			default:
				return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_v0) {
	var declarations = _v0;
	return declarations;
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
	function (nestedStyles, rest, f, declarations) {
		var withoutParent = function (decls) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(decls));
		};
		var nextResult = A2(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			rest,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		var newDeclarations = function () {
			var _v14 = _Utils_Tuple2(
				$elm$core$List$head(nextResult),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
			if ((!_v14.a.$) && (!_v14.b.$)) {
				var nextResultParent = _v14.a.a;
				var originalParent = _v14.b.a;
				return _Utils_ap(
					A2(
						$elm$core$List$take,
						$elm$core$List$length(declarations) - 1,
						declarations),
					_List_fromArray(
						[
							(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
						]));
			} else {
				return declarations;
			}
		}();
		var insertStylesToNestedDecl = function (lastDecl) {
			return $elm$core$List$concat(
				A2(
					$rtfeldman$elm_css$Css$Structure$mapLast,
					$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
					A2(
						$elm$core$List$map,
						$elm$core$List$singleton,
						A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
		};
		var initialResult = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				insertStylesToNestedDecl,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		return _Utils_ap(
			newDeclarations,
			_Utils_ap(
				withoutParent(initialResult),
				withoutParent(nextResult)));
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
	function (styles, declarations) {
		if (!styles.b) {
			return declarations;
		} else {
			switch (styles.a.$) {
				case 0:
					var property = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
				case 1:
					var _v4 = styles.a;
					var selector = _v4.a;
					var nestedStyles = _v4.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
						declarations);
				case 2:
					var _v5 = styles.a;
					var selectorCombinator = _v5.a;
					var snippets = _v5.b;
					var rest = styles.b;
					var chain = F2(
						function (_v9, _v10) {
							var originalSequence = _v9.a;
							var originalTuples = _v9.b;
							var originalPseudoElement = _v9.c;
							var newSequence = _v10.a;
							var newTuples = _v10.b;
							var newPseudoElement = _v10.c;
							return A3(
								$rtfeldman$elm_css$Css$Structure$Selector,
								originalSequence,
								_Utils_ap(
									originalTuples,
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(selectorCombinator, newSequence),
										newTuples)),
								$rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
									_List_fromArray(
										[newPseudoElement, originalPseudoElement])));
						});
					var expandDeclaration = function (declaration) {
						switch (declaration.$) {
							case 0:
								var _v7 = declaration.a;
								var firstSelector = _v7.a;
								var otherSelectors = _v7.b;
								var nestedStyles = _v7.c;
								var newSelectors = A2(
									$elm$core$List$concatMap,
									function (originalSelector) {
										return A2(
											$elm$core$List$map,
											chain(originalSelector),
											A2($elm$core$List$cons, firstSelector, otherSelectors));
									},
									$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
								var newDeclarations = function () {
									if (!newSelectors.b) {
										return _List_Nil;
									} else {
										var first = newSelectors.a;
										var remainder = newSelectors.b;
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
											]);
									}
								}();
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
							case 1:
								var mediaQueries = declaration.a;
								var styleBlocks = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
							case 2:
								var str = declaration.a;
								var otherSnippets = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
							case 3:
								var str1 = declaration.a;
								var str2 = declaration.b;
								var str3 = declaration.c;
								var str4 = declaration.d;
								var styleBlock = declaration.e;
								return A2(
									$elm$core$List$map,
									A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
									$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
							case 4:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$PageRule(properties)
									]);
							case 5:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$FontFace(properties)
									]);
							case 6:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$Viewport(properties)
									]);
							case 7:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
									]);
							default:
								var tuples = declaration.a;
								return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
						}
					};
					return $elm$core$List$concat(
						_Utils_ap(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
								]),
							A2(
								$elm$core$List$map,
								expandDeclaration,
								A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
				case 3:
					var _v11 = styles.a;
					var pseudoElement = _v11.a;
					var nestedStyles = _v11.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
						declarations);
				case 5:
					var str = styles.a.a;
					var rest = styles.b;
					var name = $rtfeldman$elm_css$Hash$fromString(str);
					var newProperty = 'animation-name:' + name;
					var newDeclarations = A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
					return A2(
						$elm$core$List$append,
						newDeclarations,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$Keyframes(
								{jj: str, gN: name})
							]));
				case 4:
					var _v12 = styles.a;
					var mediaQueries = _v12.a;
					var nestedStyles = _v12.b;
					var rest = styles.b;
					var extraDeclarations = function () {
						var _v13 = $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
						if (!_v13.b) {
							return _List_Nil;
						} else {
							var firstSelector = _v13.a;
							var otherSelectors = _v13.b;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
								A2(
									$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
									nestedStyles,
									$elm$core$List$singleton(
										$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
											A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
						}
					}();
					return _Utils_ap(
						A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
						extraDeclarations);
				default:
					var otherStyles = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						_Utils_ap(otherStyles, rest),
						declarations);
			}
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_v2) {
	var firstSelector = _v2.a;
	var otherSelectors = _v2.b;
	var styles = _v2.c;
	return A2(
		$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
		styles,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
			]));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
	if (!snippetDeclarations.b) {
		return _List_Nil;
	} else {
		var first = snippetDeclarations.a;
		var rest = snippetDeclarations.b;
		return _Utils_ap(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
			$rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
	function (mediaQueries, styleBlocks) {
		var handleStyleBlock = function (styleBlock) {
			return A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		};
		return A2($elm$core$List$concatMap, handleStyleBlock, styleBlocks);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
	function (str, snippets) {
		var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return _List_fromArray(
			[
				A2($rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
	switch (snippetDeclaration.$) {
		case 0:
			var styleBlock = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
		case 1:
			var mediaQueries = snippetDeclaration.a;
			var styleBlocks = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
		case 2:
			var str = snippetDeclaration.a;
			var snippets = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
		case 3:
			var str1 = snippetDeclaration.a;
			var str2 = snippetDeclaration.b;
			var str3 = snippetDeclaration.c;
			var str4 = snippetDeclaration.d;
			var styleBlock = snippetDeclaration.e;
			return A2(
				$elm$core$List$map,
				A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		case 4:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$PageRule(properties)
				]);
		case 5:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$FontFace(properties)
				]);
		case 6:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Viewport(properties)
				]);
		case 7:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
				]);
		default:
			var tuples = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_v0) {
	var charset = _v0.fG;
	var imports = _v0.go;
	var namespaces = _v0.gP;
	var snippets = _v0.hL;
	var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
		A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
	return {fG: charset, jk: declarations, go: imports, gP: namespaces};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (sheet) {
	return $rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
		$rtfeldman$elm_css$Css$Structure$compactStylesheet(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
};
var $rtfeldman$elm_css$Css$Preprocess$Snippet = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
	function (styles, sequence) {
		var selector = A3($rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, $elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
	return {fG: $elm$core$Maybe$Nothing, go: _List_Nil, gP: _List_Nil, hL: snippets};
};
var $rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$templateSelector = $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$ClassSelector($rtfeldman$elm_css$VirtualDom$Styled$classnameStandin)
		]));
var $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate = function (styles) {
	if (!styles.b) {
		return '';
	} else {
		var otherwise = styles;
		return $rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
			$rtfeldman$elm_css$Css$Preprocess$stylesheet(
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$VirtualDom$Styled$makeSnippet, styles, $rtfeldman$elm_css$VirtualDom$Styled$templateSelector)
					])));
	}
};
var $rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
	var cssTemplate = $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate(styles);
	var classProperty = A2($elm$virtual_dom$VirtualDom$attribute, '', '');
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, true, cssTemplate);
};
var $rtfeldman$elm_css$Html$Styled$Attributes$css = $rtfeldman$elm_css$Html$Styled$Internal$css;
var $rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$Node;
var $rtfeldman$elm_css$Html$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$node;
var $rtfeldman$elm_css$Html$Styled$div = $rtfeldman$elm_css$Html$Styled$node('div');
var $rtfeldman$elm_css$Css$flexEnd = $rtfeldman$elm_css$Css$prop1('flex-end');
var $rtfeldman$elm_css$Css$height = $rtfeldman$elm_css$Css$prop1('height');
var $rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
	return A2($elm$core$String$startsWith, '#', str) ? str : A2($elm$core$String$cons, '#', str);
};
var $rtfeldman$elm_css$Css$erroneousHex = function (str) {
	return {
		aX: 1,
		d1: 0,
		fL: 0,
		ei: 0,
		eQ: 0,
		ig: $rtfeldman$elm_css$Css$withPrecedingHash(str)
	};
};
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $rtfeldman$elm_css$Css$validHex = F5(
	function (str, _v0, _v1, _v2, _v3) {
		var r1 = _v0.a;
		var r2 = _v0.b;
		var g1 = _v1.a;
		var g2 = _v1.b;
		var b1 = _v2.a;
		var b2 = _v2.b;
		var a1 = _v3.a;
		var a2 = _v3.b;
		var toResult = A2(
			$elm$core$Basics$composeR,
			$elm$core$String$fromList,
			A2($elm$core$Basics$composeR, $elm$core$String$toLower, $rtfeldman$elm_hex$Hex$fromString));
		var results = _Utils_Tuple2(
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[r1, r2])),
				toResult(
					_List_fromArray(
						[g1, g2]))),
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[b1, b2])),
				toResult(
					_List_fromArray(
						[a1, a2]))));
		if ((((!results.a.a.$) && (!results.a.b.$)) && (!results.b.a.$)) && (!results.b.b.$)) {
			var _v5 = results.a;
			var red = _v5.a.a;
			var green = _v5.b.a;
			var _v6 = results.b;
			var blue = _v6.a.a;
			var alpha = _v6.b.a;
			return {
				aX: alpha / 255,
				d1: blue,
				fL: 0,
				ei: green,
				eQ: red,
				ig: $rtfeldman$elm_css$Css$withPrecedingHash(str)
			};
		} else {
			return $rtfeldman$elm_css$Css$erroneousHex(str);
		}
	});
var $rtfeldman$elm_css$Css$hex = function (str) {
	var withoutHash = A2($elm$core$String$startsWith, '#', str) ? A2($elm$core$String$dropLeft, 1, str) : str;
	var _v0 = $elm$core$String$toList(withoutHash);
	_v0$4:
	while (true) {
		if ((_v0.b && _v0.b.b) && _v0.b.b.b) {
			if (!_v0.b.b.b.b) {
				var r = _v0.a;
				var _v1 = _v0.b;
				var g = _v1.a;
				var _v2 = _v1.b;
				var b = _v2.a;
				return A5(
					$rtfeldman$elm_css$Css$validHex,
					str,
					_Utils_Tuple2(r, r),
					_Utils_Tuple2(g, g),
					_Utils_Tuple2(b, b),
					_Utils_Tuple2('f', 'f'));
			} else {
				if (!_v0.b.b.b.b.b) {
					var r = _v0.a;
					var _v3 = _v0.b;
					var g = _v3.a;
					var _v4 = _v3.b;
					var b = _v4.a;
					var _v5 = _v4.b;
					var a = _v5.a;
					return A5(
						$rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(a, a));
				} else {
					if (_v0.b.b.b.b.b.b) {
						if (!_v0.b.b.b.b.b.b.b) {
							var r1 = _v0.a;
							var _v6 = _v0.b;
							var r2 = _v6.a;
							var _v7 = _v6.b;
							var g1 = _v7.a;
							var _v8 = _v7.b;
							var g2 = _v8.a;
							var _v9 = _v8.b;
							var b1 = _v9.a;
							var _v10 = _v9.b;
							var b2 = _v10.a;
							return A5(
								$rtfeldman$elm_css$Css$validHex,
								str,
								_Utils_Tuple2(r1, r2),
								_Utils_Tuple2(g1, g2),
								_Utils_Tuple2(b1, b2),
								_Utils_Tuple2('f', 'f'));
						} else {
							if (_v0.b.b.b.b.b.b.b.b && (!_v0.b.b.b.b.b.b.b.b.b)) {
								var r1 = _v0.a;
								var _v11 = _v0.b;
								var r2 = _v11.a;
								var _v12 = _v11.b;
								var g1 = _v12.a;
								var _v13 = _v12.b;
								var g2 = _v13.a;
								var _v14 = _v13.b;
								var b1 = _v14.a;
								var _v15 = _v14.b;
								var b2 = _v15.a;
								var _v16 = _v15.b;
								var a1 = _v16.a;
								var _v17 = _v16.b;
								var a2 = _v17.a;
								return A5(
									$rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(a1, a2));
							} else {
								break _v0$4;
							}
						}
					} else {
						break _v0$4;
					}
				}
			}
		} else {
			break _v0$4;
		}
	}
	return $rtfeldman$elm_css$Css$erroneousHex(str);
};
var $rtfeldman$elm_css$Css$justifyContent = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'justifyContent',
		'justify-content',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$Internal$printKeyframeSelector = function (_v0) {
	var percentage = _v0.a;
	var properties = _v0.b;
	var propertiesStr = A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		function (_v1) {
			var prop = _v1;
			return prop + ';';
		},
		'',
		properties);
	var percentageStr = $elm$core$String$fromInt(percentage) + '%';
	return percentageStr + ('{' + (propertiesStr + '}'));
};
var $rtfeldman$elm_css$Css$Internal$compileKeyframes = function (tuples) {
	return A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Internal$printKeyframeSelector, '', tuples);
};
var $rtfeldman$elm_css$Css$Animations$keyframes = function (tuples) {
	return $elm$core$List$isEmpty(tuples) ? {ep: 0, ez: 0, ig: 'none'} : {
		ep: 0,
		ez: 0,
		ig: $rtfeldman$elm_css$Css$Internal$compileKeyframes(tuples)
	};
};
var $rtfeldman$elm_css$Css$prop2 = F3(
	function (key, argA, argB) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.ig + (' ' + argB.ig));
	});
var $rtfeldman$elm_css$Css$margin2 = $rtfeldman$elm_css$Css$prop2('margin');
var $rtfeldman$elm_css$Css$position = $rtfeldman$elm_css$Css$prop1('position');
var $rtfeldman$elm_css$Css$Internal$Property = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Animations$property = F2(
	function (key, value) {
		return key + (':' + value);
	});
var $rtfeldman$elm_css$Css$PxUnits = 0;
var $rtfeldman$elm_css$Css$px = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'px');
var $rtfeldman$elm_css$Css$relative = {bR: 0, ig: 'relative'};
var $rtfeldman$elm_css$Css$spaceBetween = $rtfeldman$elm_css$Css$prop1('space-between');
var $rtfeldman$elm_css$Css$width = $rtfeldman$elm_css$Css$prop1('width');
var $perzanko$elm_loading$Loading$Bars$view = function (config) {
	var withSpeed = function (x) {
		return $elm$core$String$fromFloat(x / config.hN);
	};
	var outerStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.hJ)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.hJ)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$auto),
			A2($rtfeldman$elm_css$Css$property, 'display', 'flex'),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexEnd)
		]);
	var childStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.hJ / 3.5)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.hJ / 3.5)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex(config.fL)),
			A2(
			$rtfeldman$elm_css$Css$property,
			'animation-duration',
			withSpeed(1.5) + 's'),
			A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite'),
			A2($rtfeldman$elm_css$Css$property, 'animation-timing-function', 'ease-in-out'),
			$rtfeldman$elm_css$Css$animationName(
			$rtfeldman$elm_css$Css$Animations$keyframes(
				_List_fromArray(
					[
						_Utils_Tuple2(
						0,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Animations$property,
								'height',
								$elm$core$String$fromFloat(config.hJ / 3.5) + 'px'),
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate3d(0,0,0)')
							])),
						_Utils_Tuple2(
						50,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Animations$property,
								'height',
								$elm$core$String$fromFloat(config.hJ) + 'px'),
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate3d(0,0,0)')
							])),
						_Utils_Tuple2(
						100,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Animations$property,
								'height',
								$elm$core$String$fromFloat(config.hJ / 3.5) + 'px'),
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate3d(0,0,0)')
							]))
					])))
		]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
				$rtfeldman$elm_css$Html$Styled$Attributes$class(config.fI)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							childStyle,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$property,
									'animation-delay',
									withSpeed(1) + 's')
								])))
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							childStyle,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$property,
									'animation-delay',
									withSpeed(0.5) + 's')
								])))
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							childStyle,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$property,
									'animation-delay',
									withSpeed(0.0000001) + 's')
								])))
					]),
				_List_Nil)
			]));
};
var $rtfeldman$elm_css$Css$block = {d8: 0, ig: 'block'};
var $rtfeldman$elm_css$Css$center = $rtfeldman$elm_css$Css$prop1('center');
var $rtfeldman$elm_css$Css$display = $rtfeldman$elm_css$Css$prop1('display');
var $rtfeldman$elm_css$Css$PercentageUnits = 0;
var $rtfeldman$elm_css$Css$pct = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '%');
var $perzanko$elm_loading$Loading$BouncingBalls$view = function (config) {
	var withSpeed = function (x) {
		return $elm$core$String$fromFloat(x / config.hN);
	};
	var outerStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.hJ)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.hJ)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$auto),
			A2($rtfeldman$elm_css$Css$property, 'display', 'flex'),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]);
	var childStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.hJ / 3.5)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.hJ / 3.5)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex(config.fL)),
			A2(
			$rtfeldman$elm_css$Css$property,
			'animation-duration',
			withSpeed(0.6) + 's'),
			A2(
			$rtfeldman$elm_css$Css$property,
			'animation-delay',
			withSpeed(0.1) + 's'),
			A2($rtfeldman$elm_css$Css$property, 'animation-timing-function', 'linear'),
			A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite'),
			$rtfeldman$elm_css$Css$animationName(
			$rtfeldman$elm_css$Css$Animations$keyframes(
				_List_fromArray(
					[
						_Utils_Tuple2(
						0,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate3d(0,0,0) translateZ(0) translate(0,0)')
							])),
						_Utils_Tuple2(
						50,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Animations$property,
								'transform',
								'translate3d(0,0,0) translateZ(0) translate(0,' + ($elm$core$String$fromFloat(config.hJ / 3.5) + 'px)'))
							])),
						_Utils_Tuple2(
						100,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate3d(0,0,0) translateZ(0) translate(0,0)')
							]))
					])))
		]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
				$rtfeldman$elm_css$Html$Styled$Attributes$class(config.fI)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							childStyle,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$property,
									'animation-delay',
									withSpeed(0.1) + 's')
								])))
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							childStyle,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$property,
									'animation-delay',
									withSpeed(0.2) + 's')
								])))
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							childStyle,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$property,
									'animation-delay',
									withSpeed(0.3) + 's')
								])))
					]),
				_List_Nil)
			]));
};
var $rtfeldman$elm_css$Css$absolute = {bR: 0, ig: 'absolute'};
var $rtfeldman$elm_css$Css$left = $rtfeldman$elm_css$Css$prop1('left');
var $rtfeldman$elm_css$Css$UnitlessFloat = 0;
var $rtfeldman$elm_css$Css$num = function (val) {
	return {
		aN: 0,
		ag: 0,
		k5: 0,
		cX: 0,
		av: val,
		bp: '',
		b$: 0,
		ig: $elm$core$String$fromFloat(val)
	};
};
var $rtfeldman$elm_css$Css$opacity = $rtfeldman$elm_css$Css$prop1('opacity');
var $rtfeldman$elm_css$Css$top = $rtfeldman$elm_css$Css$prop1('top');
var $perzanko$elm_loading$Loading$Circle$view = function (config) {
	var withSpeed = function (x) {
		return $elm$core$String$fromFloat(x / config.hN);
	};
	var outerStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.hJ)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.hJ * 0.95)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$auto)
		]);
	var childStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.hJ - (2 * (config.hJ * 0.17)))),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.hJ - (2 * (config.hJ * 0.17)))),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(0)),
			A2(
			$rtfeldman$elm_css$Css$property,
			'animation-duration',
			withSpeed(1.33) + 's'),
			A2($rtfeldman$elm_css$Css$property, 'animation-timing-function', 'cubic-bezier(.51,.92,.24,1.15)'),
			A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite'),
			$rtfeldman$elm_css$Css$animationName(
			$rtfeldman$elm_css$Css$Animations$keyframes(
				_List_fromArray(
					[
						_Utils_Tuple2(
						0,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate3d(0,0,0) rotate(0deg)')
							])),
						_Utils_Tuple2(
						100,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate3d(0,0,0) rotate(720deg)')
							]))
					])))
		]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
				$rtfeldman$elm_css$Html$Styled$Attributes$class(config.fI)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						$elm$core$List$concat(
							_List_fromArray(
								[
									childStyle,
									_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Css$property,
										'border',
										$elm$core$String$fromFloat(config.hJ * 0.17) + ('px ' + (config.fL + ' solid'))),
										$rtfeldman$elm_css$Css$opacity(
										$rtfeldman$elm_css$Css$num(0.25))
									])
								])))
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						$elm$core$List$concat(
							_List_fromArray(
								[
									childStyle,
									_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Css$property,
										'border',
										$elm$core$String$fromFloat(config.hJ * 0.17) + 'px transparent solid'),
										A2(
										$rtfeldman$elm_css$Css$property,
										'border-top',
										$elm$core$String$fromFloat(config.hJ * 0.17) + ('px ' + (config.fL + ' solid'))),
										$rtfeldman$elm_css$Css$opacity(
										$rtfeldman$elm_css$Css$num(0.8))
									])
								])))
					]),
				_List_Nil)
			]));
};
var $perzanko$elm_loading$Loading$DoubleBounce$view = function (config) {
	var outerStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.hJ)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.hJ)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$auto)
		]);
	var innerStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex(config.fL)),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.6)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$animationName(
			$rtfeldman$elm_css$Css$Animations$keyframes(
				_List_fromArray(
					[
						_Utils_Tuple2(
						0,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(0.0)')
							])),
						_Utils_Tuple2(
						50,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(1.0)')
							])),
						_Utils_Tuple2(
						100,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(0.0)')
							]))
					]))),
			A2(
			$rtfeldman$elm_css$Css$property,
			'animation-duration',
			$elm$core$String$fromFloat(2 / config.hN) + 's'),
			A2($rtfeldman$elm_css$Css$property, 'animation-timing-function', 'ease-in-out'),
			A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite')
		]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
				$rtfeldman$elm_css$Html$Styled$Attributes$class(config.fI)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(innerStyle)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						$elm$core$List$concat(
							_List_fromArray(
								[
									innerStyle,
									_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Css$property,
										'animation-delay',
										'-' + ($elm$core$String$fromFloat(1 / config.hN) + 's'))
									])
								])))
					]),
				_List_Nil)
			]));
};
var $rtfeldman$elm_css$Css$Structure$PseudoElement = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$pseudoElement = function (element) {
	return $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement(element);
};
var $rtfeldman$elm_css$Css$after = $rtfeldman$elm_css$Css$pseudoElement('after');
var $rtfeldman$elm_css$Css$before = $rtfeldman$elm_css$Css$pseudoElement('before');
var $rtfeldman$elm_css$Css$prop3 = F4(
	function (key, argA, argB, argC) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.ig + (' ' + (argB.ig + (' ' + argC.ig))));
	});
var $rtfeldman$elm_css$Css$border3 = $rtfeldman$elm_css$Css$prop3('border');
var $rtfeldman$elm_css$Css$Animations$opacity = function (_v0) {
	var value = _v0.ig;
	return 'opacity:' + value;
};
var $rtfeldman$elm_css$Css$solid = {G: 0, aQ: 0, ig: 'solid'};
var $perzanko$elm_loading$Loading$Sonar$view = function (config) {
	var outerStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.hJ)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.hJ)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$auto),
			$rtfeldman$elm_css$Css$before(
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$property, 'content', '\' \''),
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$pct(50)),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$px(config.hJ / 3)),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(config.hJ / 3)),
					A2(
					$rtfeldman$elm_css$Css$property,
					'top',
					'calc(50% - ' + ($elm$core$String$fromFloat(config.hJ / 6) + 'px)')),
					A2(
					$rtfeldman$elm_css$Css$property,
					'left',
					'calc(50% - ' + ($elm$core$String$fromFloat(config.hJ / 6) + 'px)')),
					$rtfeldman$elm_css$Css$backgroundColor(
					$rtfeldman$elm_css$Css$hex(config.fL)),
					A2(
					$rtfeldman$elm_css$Css$property,
					'animation-duration',
					$elm$core$String$fromFloat(3 / config.hN) + 's'),
					A2($rtfeldman$elm_css$Css$property, 'animation-timing-funtion', 'linear'),
					A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite'),
					$rtfeldman$elm_css$Css$animationName(
					$rtfeldman$elm_css$Css$Animations$keyframes(
						_List_fromArray(
							[
								_Utils_Tuple2(
								0,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(1))
									])),
								_Utils_Tuple2(
								15,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(1)),
										A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(0.5)')
									])),
								_Utils_Tuple2(
								60,
								_List_fromArray(
									[
										A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(4)'),
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(0))
									])),
								_Utils_Tuple2(
								90,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(0)),
										A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(3)')
									])),
								_Utils_Tuple2(
								95,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(1))
									])),
								_Utils_Tuple2(
								100,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(1)),
										A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(1)')
									]))
							])))
				])),
			$rtfeldman$elm_css$Css$after(
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$property, 'content', '\' \''),
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$pct(50)),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$px(config.hJ / 3)),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(config.hJ / 3)),
					A2(
					$rtfeldman$elm_css$Css$property,
					'top',
					'calc(50% - ' + ($elm$core$String$fromFloat(config.hJ / 6) + 'px)')),
					A2(
					$rtfeldman$elm_css$Css$property,
					'left',
					'calc(50% - ' + ($elm$core$String$fromFloat(config.hJ / 6) + 'px)')),
					A3(
					$rtfeldman$elm_css$Css$border3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					$rtfeldman$elm_css$Css$hex(config.fL)),
					$rtfeldman$elm_css$Css$opacity(
					$rtfeldman$elm_css$Css$num(0)),
					A2(
					$rtfeldman$elm_css$Css$property,
					'animation-duration',
					$elm$core$String$fromFloat(3 / config.hN) + 's'),
					A2($rtfeldman$elm_css$Css$property, 'animation-timing-funtion', 'linear'),
					A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite'),
					$rtfeldman$elm_css$Css$animationName(
					$rtfeldman$elm_css$Css$Animations$keyframes(
						_List_fromArray(
							[
								_Utils_Tuple2(
								0,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(0)),
										A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(1)')
									])),
								_Utils_Tuple2(
								30,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(0)),
										A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(1)')
									])),
								_Utils_Tuple2(
								60,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(0.3))
									])),
								_Utils_Tuple2(
								90,
								_List_fromArray(
									[
										A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(3)')
									])),
								_Utils_Tuple2(
								100,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(0))
									]))
							])))
				]))
		]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
				$rtfeldman$elm_css$Html$Styled$Attributes$class(config.fI)
			]),
		_List_Nil);
};
var $perzanko$elm_loading$Loading$Spinner$view = function (config) {
	var outerStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.hJ)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.hJ)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$auto)
		]);
	var childs = A2($elm$core$List$range, 1, 12);
	var childStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100))
		]);
	var calcAnimationDelay = function (x) {
		return (x === 1) ? '0s' : ($elm$core$String$fromFloat(-((1.1 - (x / 10)) / config.hN)) + 's');
	};
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
				$rtfeldman$elm_css$Html$Styled$Attributes$class(config.fI)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
					]),
				A2(
					$elm$core$List$map,
					function (x) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$width(
											$rtfeldman$elm_css$Css$pct(100)),
											$rtfeldman$elm_css$Css$height(
											$rtfeldman$elm_css$Css$pct(100)),
											$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
											$rtfeldman$elm_css$Css$left(
											$rtfeldman$elm_css$Css$px(0)),
											$rtfeldman$elm_css$Css$top(
											$rtfeldman$elm_css$Css$px(0)),
											A2(
											$rtfeldman$elm_css$Css$property,
											'transform',
											'rotate(' + ($elm$core$String$fromInt((30 * x) - 30) + 'deg)')),
											$rtfeldman$elm_css$Css$before(
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Css$property,
													'animation-delay',
													calcAnimationDelay(x)),
													A2($rtfeldman$elm_css$Css$property, 'content', '\' \''),
													$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
													A2(
													$rtfeldman$elm_css$Css$margin2,
													$rtfeldman$elm_css$Css$px(0),
													$rtfeldman$elm_css$Css$auto),
													$rtfeldman$elm_css$Css$width(
													$rtfeldman$elm_css$Css$pct(15)),
													$rtfeldman$elm_css$Css$height(
													$rtfeldman$elm_css$Css$pct(15)),
													$rtfeldman$elm_css$Css$backgroundColor(
													$rtfeldman$elm_css$Css$hex(config.fL)),
													$rtfeldman$elm_css$Css$borderRadius(
													$rtfeldman$elm_css$Css$pct(100)),
													A2(
													$rtfeldman$elm_css$Css$property,
													'animation-duration',
													$elm$core$String$fromFloat(1.2 / config.hN) + 's'),
													A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite'),
													A2($rtfeldman$elm_css$Css$property, 'animation-fill-mode', 'both'),
													$rtfeldman$elm_css$Css$animationName(
													$rtfeldman$elm_css$Css$Animations$keyframes(
														_List_fromArray(
															[
																_Utils_Tuple2(
																0,
																_List_fromArray(
																	[
																		A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(0.0)')
																	])),
																_Utils_Tuple2(
																40,
																_List_fromArray(
																	[
																		A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(1.0)')
																	])),
																_Utils_Tuple2(
																80,
																_List_fromArray(
																	[
																		A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(0.0)')
																	])),
																_Utils_Tuple2(
																100,
																_List_fromArray(
																	[
																		A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(0.0)')
																	]))
															])))
												]))
										]))
								]),
							_List_Nil);
					},
					childs))
			]));
};
var $perzanko$elm_loading$Loading$render = F3(
	function (loaderType, config, loadingState) {
		var loader = function () {
			switch (loaderType) {
				case 0:
					return $rtfeldman$elm_css$Html$Styled$toUnstyled(
						$perzanko$elm_loading$Loading$DoubleBounce$view(config));
				case 1:
					return $rtfeldman$elm_css$Html$Styled$toUnstyled(
						$perzanko$elm_loading$Loading$Spinner$view(config));
				case 2:
					return $rtfeldman$elm_css$Html$Styled$toUnstyled(
						$perzanko$elm_loading$Loading$BouncingBalls$view(config));
				case 3:
					return $rtfeldman$elm_css$Html$Styled$toUnstyled(
						$perzanko$elm_loading$Loading$Bars$view(config));
				case 4:
					return $rtfeldman$elm_css$Html$Styled$toUnstyled(
						$perzanko$elm_loading$Loading$Circle$view(config));
				default:
					return $rtfeldman$elm_css$Html$Styled$toUnstyled(
						$perzanko$elm_loading$Loading$Sonar$view(config));
			}
		}();
		if (!loadingState) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('loading')
					]),
				_List_fromArray(
					[loader]));
		} else {
			return $elm$html$Html$text(' ');
		}
	});
var $author$project$Pages$Util$Links$loadingSymbol = A3($perzanko$elm_loading$Loading$render, 1, $perzanko$elm_loading$Loading$defaultConfig, 0);
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$td = _VirtualDom_node('td');
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$Attrs = function (a) {
	return {$: 4, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Button$attrs = function (attrs_) {
	return $rundis$elm_bootstrap$Bootstrap$Internal$Button$Attrs(attrs_);
};
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$applyModifier = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 0:
				var size = modifier.a;
				return _Utils_update(
					options,
					{
						hJ: $elm$core$Maybe$Just(size)
					});
			case 1:
				var coloring = modifier.a;
				return _Utils_update(
					options,
					{
						ao: $elm$core$Maybe$Just(coloring)
					});
			case 2:
				return _Utils_update(
					options,
					{cm: true});
			case 3:
				var val = modifier.a;
				return _Utils_update(
					options,
					{ju: val});
			default:
				var attrs = modifier.a;
				return _Utils_update(
					options,
					{
						S: _Utils_ap(options.S, attrs)
					});
		}
	});
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$defaultOptions = {S: _List_Nil, cm: false, ao: $elm$core$Maybe$Nothing, ju: false, hJ: $elm$core$Maybe$Nothing};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$roleClass = function (role) {
	switch (role) {
		case 0:
			return 'primary';
		case 1:
			return 'secondary';
		case 2:
			return 'success';
		case 3:
			return 'info';
		case 4:
			return 'warning';
		case 5:
			return 'danger';
		case 6:
			return 'dark';
		case 7:
			return 'light';
		default:
			return 'link';
	}
};
var $rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption = function (size) {
	switch (size) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just('sm');
		case 2:
			return $elm$core$Maybe$Just('md');
		case 3:
			return $elm$core$Maybe$Just('lg');
		default:
			return $elm$core$Maybe$Just('xl');
	}
};
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$buttonAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $rundis$elm_bootstrap$Bootstrap$Internal$Button$applyModifier, $rundis$elm_bootstrap$Bootstrap$Internal$Button$defaultOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('btn', true),
						_Utils_Tuple2('btn-block', options.cm),
						_Utils_Tuple2('disabled', options.ju)
					])),
				$elm$html$Html$Attributes$disabled(options.ju)
			]),
		_Utils_ap(
			function () {
				var _v0 = A2($elm$core$Maybe$andThen, $rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption, options.hJ);
				if (!_v0.$) {
					var s = _v0.a;
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('btn-' + s)
						]);
				} else {
					return _List_Nil;
				}
			}(),
			_Utils_ap(
				function () {
					var _v1 = options.ao;
					if (!_v1.$) {
						if (!_v1.a.$) {
							var role = _v1.a.a;
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$class(
									'btn-' + $rundis$elm_bootstrap$Bootstrap$Internal$Button$roleClass(role))
								]);
						} else {
							var role = _v1.a.a;
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$class(
									'btn-outline-' + $rundis$elm_bootstrap$Bootstrap$Internal$Button$roleClass(role))
								]);
						}
					} else {
						return _List_Nil;
					}
				}(),
				options.S)));
};
var $rundis$elm_bootstrap$Bootstrap$Button$linkButton = F2(
	function (options, children) {
		return A2(
			$elm$html$Html$a,
			A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
				$rundis$elm_bootstrap$Bootstrap$Internal$Button$buttonAttributes(options)),
			children);
	});
var $author$project$Pages$Util$Links$linkButton = function (params) {
	return A2(
		$rundis$elm_bootstrap$Bootstrap$Button$linkButton,
		_List_fromArray(
			[
				$rundis$elm_bootstrap$Bootstrap$Button$attrs(
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$href(params.id),
					params.S))
			]),
		params.T);
};
var $author$project$Pages$Util$Links$toLoginButtonWith = function (params) {
	return $author$project$Pages$Util$Links$linkButton(
		{
			S: params.S,
			T: _List_fromArray(
				[
					$elm$html$Html$text(params.fC)
				]),
			id: $author$project$Pages$Util$Links$frontendPage(
				$author$project$Addresses$Frontend$login.iA(0))
		});
};
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$Pages$View$Tristate$view = F2(
	function (ps, t) {
		var _v0 = t.bU;
		switch (_v0.$) {
			case 0:
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[$author$project$Pages$Util$Links$loadingSymbol]));
			case 1:
				var main = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$View$Tristate$Logic,
					ps.mT(main));
			default:
				var errorState = _v0.a;
				var solutionBlock = $elm$core$String$isEmpty(errorState.V.hc) ? _List_Nil : _List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Try the following:')
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(errorState.V.hc)
									]))
							]))
					]);
				var reloadRow = A2(
					$elm$core$List$filter,
					$elm$core$Basics$always(errorState.V.ms),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick($author$project$Pages$View$Tristate$HandleError),
													$author$project$Pages$Util$Style$classes.a0.f6
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Retry')
												]))
										]))
								]))
						]));
				var redirectRow = _List_fromArray(
					[
						A2(
						$elm$html$Html$tr,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$td,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Pages$Util$Links$toLoginButtonWith(
										{
											S: _List_fromArray(
												[$author$project$Pages$Util$Style$classes.a0.f6]),
											fC: 'Login'
										})
									]))
							]))
					]);
				return A2(
					$elm$html$Html$table,
					_List_fromArray(
						[$author$project$Pages$Util$Style$ids.f6]),
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('An error occurred:')
													]))
											])),
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(errorState.V.iV)
													]))
											]))
									])),
								A2($elm$html$Html$tr, _List_Nil, solutionBlock)
							]),
						_Utils_ap(redirectRow, reloadRow)));
		}
	});
var $author$project$Pages$Util$ViewUtil$ComplexFoods = 7;
var $author$project$Pages$Util$Choice$Page$Edit = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Pages$Util$Choice$Page$EnterEdit = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Util$Choice$Page$RequestDelete = function (a) {
	return {$: 6, a: a};
};
var $elm$html$Html$input = _VirtualDom_node('input');
var $author$project$Pages$Util$ValidatedInput$isValid = function (validatedInput) {
	var _v0 = validatedInput.bi(validatedInput.mx);
	if (!_v0.$) {
		var v = _v0.a;
		return _Utils_eq(v, validatedInput.ig);
	} else {
		return false;
	}
};
var $author$project$Pages$ComplexFoods$ComplexFoodUpdateClientInput$lenses = {
	fq: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.fq;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{fq: b});
			})),
	fr: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.fr;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{fr: b});
			}))
};
var $author$project$Pages$Util$ValidatedInput$setWithLens = F3(
	function (lens, txt, model) {
		var validatedInput = lens.jY(model);
		var possiblyValid = ($elm$core$String$isEmpty(txt) || validatedInput.bP(txt)) ? A2($author$project$Pages$Util$ValidatedInput$lenses.mx.eW, txt, validatedInput) : validatedInput;
		var _v0 = validatedInput.bi(txt);
		if (!_v0.$) {
			var v = _v0.a;
			return A3(
				$elm_community$basics_extra$Basics$Extra$flip,
				lens.eW,
				model,
				A2($author$project$Pages$Util$ValidatedInput$lenses.ig.eW, v, possiblyValid));
		} else {
			return A2(lens.eW, possiblyValid, model);
		}
	});
var $author$project$Pages$Util$ValidatedInput$lift = function (lens) {
	return A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		A2(
			$elm$core$Basics$composeR,
			lens.jY,
			function ($) {
				return $.mx;
			}),
		$author$project$Pages$Util$ValidatedInput$setWithLens(lens));
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $author$project$Pages$Util$NavigationUtil$recipeEditorLinkButton = function (recipeId) {
	return $author$project$Pages$Util$Links$linkButton(
		{
			S: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.a0.jy]),
			T: _List_fromArray(
				[
					$elm$html$Html$text('Recipe')
				]),
			id: $author$project$Pages$Util$Links$frontendPage(
				$author$project$Addresses$Frontend$ingredientEditor.iA(recipeId))
		});
};
var $author$project$Pages$Util$NavigationUtil$nutrientButtonWith = function (ps) {
	return $author$project$Pages$Util$Links$linkButton(
		{
			S: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.a0.k8]),
			T: _List_fromArray(
				[
					$elm$html$Html$text('Nutrients')
				]),
			id: ps.iA
		});
};
var $author$project$Pages$Util$NavigationUtil$recipeNutrientsLinkButton = function (recipeId) {
	return $author$project$Pages$Util$NavigationUtil$nutrientButtonWith(
		{
			iA: $author$project$Pages$Util$Links$frontendPage(
				$author$project$Addresses$Frontend$statisticsRecipeSelect.iA(recipeId))
		});
};
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Pages$Util$Choice$Page$SetElementsSearchString = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Util$Choice$Page$SetPagination = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Util$Choice$Page$CancelDelete = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Util$Choice$Page$ConfirmDelete = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Util$Choice$Page$ToggleControls = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Attributes$colspan = function (n) {
	return A2(
		_VirtualDom_attribute,
		'colspan',
		$elm$core$String$fromInt(n));
};
var $icidasset$elm_material_icons$Material$Icons$Types$Inherit = {$: 1};
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $icidasset$elm_material_icons$Material$Icons$Internal$f = $elm$svg$Svg$Attributes$fill;
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$core$Basics$round = _Basics_round;
var $avh4$elm_color$Color$toCssString = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var roundTo = function (x) {
		return $elm$core$Basics$round(x * 1000) / 1000;
	};
	var pct = function (x) {
		return $elm$core$Basics$round(x * 10000) / 100;
	};
	return $elm$core$String$concat(
		_List_fromArray(
			[
				'rgba(',
				$elm$core$String$fromFloat(
				pct(r)),
				'%,',
				$elm$core$String$fromFloat(
				pct(g)),
				'%,',
				$elm$core$String$fromFloat(
				pct(b)),
				'%,',
				$elm$core$String$fromFloat(
				roundTo(a)),
				')'
			]));
};
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $icidasset$elm_material_icons$Material$Icons$Internal$icon = F4(
	function (attributes, nodes, size, coloring) {
		var sizeAsString = $elm$core$String$fromInt(size);
		return A2(
			$elm$svg$Svg$svg,
			_Utils_ap(
				attributes,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$height(sizeAsString),
						$elm$svg$Svg$Attributes$width(sizeAsString)
					])),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							function () {
							if (!coloring.$) {
								var color = coloring.a;
								return $elm$svg$Svg$Attributes$fill(
									$avh4$elm_color$Color$toCssString(color));
							} else {
								return $elm$svg$Svg$Attributes$fill('currentColor');
							}
						}()
						]),
					nodes)
				]));
	});
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $icidasset$elm_material_icons$Material$Icons$Internal$p = $elm$svg$Svg$path;
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $icidasset$elm_material_icons$Material$Icons$Internal$v = $elm$svg$Svg$Attributes$viewBox;
var $icidasset$elm_material_icons$Material$Icons$list = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z')
				]),
			_List_Nil)
		]));
var $author$project$Pages$Util$HtmlUtil$menuIcon = A2($icidasset$elm_material_icons$Material$Icons$list, 20, $icidasset$elm_material_icons$Material$Icons$Types$Inherit);
var $author$project$Pages$Util$HtmlUtil$toggleControlsCell = function (msg) {
	return A2(
		$elm$html$Html$td,
		_List_fromArray(
			[
				$author$project$Pages$Util$Style$classes.h2,
				$elm$html$Html$Events$onClick(msg)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.a0.kJ]),
				_List_fromArray(
					[$author$project$Pages$Util$HtmlUtil$menuIcon]))
			]));
};
var $author$project$Pages$Util$HtmlUtil$withExtraAttributes = F2(
	function (extra, column) {
		return A2(
			$elm$html$Html$td,
			_Utils_ap(column.S, extra),
			column.T);
	});
var $author$project$Pages$Util$Choice$View$elementLineWith = F2(
	function (ps, element) {
		var toggleCommand = $author$project$Pages$Util$Choice$Page$ToggleControls(
			ps.j7(element));
		var info = ps.kd(element);
		var displayColumns = info.d8;
		var infoCells = A2(
			$elm$core$List$map,
			$author$project$Pages$Util$HtmlUtil$withExtraAttributes(
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(toggleCommand)
					])),
			displayColumns);
		var infoRow = A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.jx]),
			_Utils_ap(
				infoCells,
				_List_fromArray(
					[
						$author$project$Pages$Util$HtmlUtil$toggleControlsCell(toggleCommand)
					])));
		var controlsRow = A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$colspan(
							$elm$core$List$length(displayColumns))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$table,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.jF]),
							_List_fromArray(
								[
									A2($elm$html$Html$tr, _List_Nil, info.H)
								]))
						]))
				]));
		return A2(
			$elm$core$List$cons,
			infoRow,
			ps.hH ? _List_fromArray(
				[controlsRow]) : _List_Nil);
	});
var $author$project$Pages$Util$Choice$View$deleteElementLine = function (ps) {
	return $author$project$Pages$Util$Choice$View$elementLineWith(
		{
			j7: ps.j7,
			kd: function (element) {
				return {
					H: function () {
						var elementId = ps.j7(element);
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.H]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$author$project$Pages$Util$Style$classes.a0.af,
												$elm$html$Html$Events$onClick(
												$author$project$Pages$Util$Choice$Page$ConfirmDelete(elementId))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Delete?')
											]))
									])),
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.H]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$author$project$Pages$Util$Style$classes.a0.d4,
												$elm$html$Html$Events$onClick(
												$author$project$Pages$Util$Choice$Page$CancelDelete(elementId))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									]))
							]);
					}(),
					d8: ps.kd(element)
				};
			},
			hH: true
		});
};
var $author$project$Pages$Util$Choice$Page$ExitEdit = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Util$Choice$Page$SaveEdit = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Util$MaybeUtil$defined = $elm$core$Maybe$Just;
var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $elm_community$html_extra$Html$Events$Extra$onEnter = function (onEnterAction) {
	return A2(
		$elm$html$Html$Events$on,
		'keyup',
		A2(
			$elm$json$Json$Decode$andThen,
			function (keyCode) {
				return (keyCode === 13) ? $elm$json$Json$Decode$succeed(onEnterAction) : $elm$json$Json$Decode$fail(
					$elm$core$String$fromInt(keyCode));
			},
			$elm$html$Html$Events$keyCode));
};
var $Gizra$elm_keyboard_event$Keyboard$Event$KeyboardEvent = F7(
	function (altKey, ctrlKey, key, keyCode, metaKey, repeat, shiftKey) {
		return {iF: altKey, jf: ctrlKey, eo: key, kq: keyCode, kK: metaKey, lU: repeat, mb: shiftKey};
	});
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $Gizra$elm_keyboard_event$Keyboard$Event$decodeKey = $elm$json$Json$Decode$maybe(
	A2(
		$elm$json$Json$Decode$andThen,
		function (key) {
			return $elm$core$String$isEmpty(key) ? $elm$json$Json$Decode$fail('empty key') : $elm$json$Json$Decode$succeed(key);
		},
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)));
var $Gizra$elm_keyboard_event$Keyboard$Event$decodeNonZero = A2(
	$elm$json$Json$Decode$andThen,
	function (code) {
		return (!code) ? $elm$json$Json$Decode$fail('code was zero') : $elm$json$Json$Decode$succeed(code);
	},
	$elm$json$Json$Decode$int);
var $Gizra$elm_keyboard_event$Keyboard$Event$decodeKeyCode = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$field, 'keyCode', $Gizra$elm_keyboard_event$Keyboard$Event$decodeNonZero),
			A2($elm$json$Json$Decode$field, 'which', $Gizra$elm_keyboard_event$Keyboard$Event$decodeNonZero),
			A2($elm$json$Json$Decode$field, 'charCode', $Gizra$elm_keyboard_event$Keyboard$Event$decodeNonZero),
			$elm$json$Json$Decode$succeed(0)
		]));
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$A = {$: 0};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Add = {$: 85};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Alt = {$: 32};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Ambiguous = function (a) {
	return {$: 89, a: a};
};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$B = {$: 1};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Backspace = {$: 38};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$C = {$: 2};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$CapsLock = {$: 34};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$ChromeSearch = {$: 59};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Command = {$: 58};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Ctrl = function (a) {
	return {$: 31, a: a};
};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$D = {$: 3};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Decimal = {$: 87};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Delete = {$: 39};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Divide = {$: 88};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Down = {$: 29};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$E = {$: 4};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Eight = {$: 52};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$End = {$: 42};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Enter = {$: 37};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Escape = {$: 36};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F = {$: 5};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F1 = {$: 62};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F10 = {$: 71};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F11 = {$: 72};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F12 = {$: 73};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F2 = {$: 63};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F3 = {$: 64};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F4 = {$: 65};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F5 = {$: 66};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F6 = {$: 67};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F7 = {$: 68};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F8 = {$: 69};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F9 = {$: 70};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Five = {$: 49};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Four = {$: 48};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$G = {$: 6};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$H = {$: 7};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Home = {$: 43};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$I = {$: 8};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Insert = {$: 54};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$J = {$: 9};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$K = {$: 10};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$L = {$: 11};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Left = {$: 26};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$M = {$: 12};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Multiply = {$: 84};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$N = {$: 13};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Nine = {$: 53};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumLock = {$: 60};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadEight = {$: 82};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadFive = {$: 79};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadFour = {$: 78};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadNine = {$: 83};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadOne = {$: 75};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadSeven = {$: 81};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadSix = {$: 80};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadThree = {$: 77};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadTwo = {$: 76};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadZero = {$: 74};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$O = {$: 14};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$One = {$: 45};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$P = {$: 15};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$PageDown = {$: 41};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$PageUp = {$: 40};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$PauseBreak = {$: 56};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$PrintScreen = {$: 55};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Q = {$: 16};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$R = {$: 17};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Right = {$: 27};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$S = {$: 18};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$ScrollLock = {$: 61};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Seven = {$: 51};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Shift = function (a) {
	return {$: 30, a: a};
};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Six = {$: 50};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Spacebar = {$: 35};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Subtract = {$: 86};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$T = {$: 19};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Tab = {$: 33};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Three = {$: 47};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Two = {$: 46};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$U = {$: 20};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Unknown = function (a) {
	return {$: 90, a: a};
};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Up = {$: 28};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$V = {$: 21};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$W = {$: 22};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Windows = {$: 57};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$X = {$: 23};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Y = {$: 24};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Z = {$: 25};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Zero = {$: 44};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$fromCode = function (keyCode) {
	switch (keyCode) {
		case 8:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Backspace;
		case 9:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Tab;
		case 13:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Enter;
		case 16:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Shift($elm$core$Maybe$Nothing);
		case 17:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Ctrl($elm$core$Maybe$Nothing);
		case 18:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Alt;
		case 19:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$PauseBreak;
		case 20:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$CapsLock;
		case 27:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Escape;
		case 32:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Spacebar;
		case 33:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$PageUp;
		case 34:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$PageDown;
		case 35:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$End;
		case 36:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Home;
		case 37:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Left;
		case 38:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Up;
		case 39:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Right;
		case 40:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Down;
		case 44:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$PrintScreen;
		case 45:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Insert;
		case 46:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Delete;
		case 48:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Zero;
		case 49:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$One;
		case 50:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Two;
		case 51:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Three;
		case 52:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Four;
		case 53:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Five;
		case 54:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Six;
		case 55:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Seven;
		case 56:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Eight;
		case 57:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Nine;
		case 65:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$A;
		case 66:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$B;
		case 67:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$C;
		case 68:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$D;
		case 69:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$E;
		case 70:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F;
		case 71:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$G;
		case 72:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$H;
		case 73:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$I;
		case 74:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$J;
		case 75:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$K;
		case 76:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$L;
		case 77:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$M;
		case 78:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$N;
		case 79:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$O;
		case 80:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$P;
		case 81:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Q;
		case 82:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$R;
		case 83:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$S;
		case 84:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$T;
		case 85:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$U;
		case 86:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$V;
		case 87:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$W;
		case 88:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$X;
		case 89:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Y;
		case 90:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Z;
		case 91:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Ambiguous(
				_List_fromArray(
					[$SwiftsNamesake$proper_keyboard$Keyboard$Key$Windows, $SwiftsNamesake$proper_keyboard$Keyboard$Key$Command, $SwiftsNamesake$proper_keyboard$Keyboard$Key$ChromeSearch]));
		case 96:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadZero;
		case 97:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadOne;
		case 98:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadTwo;
		case 99:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadThree;
		case 100:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadFour;
		case 101:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadFive;
		case 102:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadSix;
		case 103:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadSeven;
		case 104:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadEight;
		case 105:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadNine;
		case 106:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Multiply;
		case 107:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Add;
		case 109:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Subtract;
		case 110:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Decimal;
		case 111:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Divide;
		case 112:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F1;
		case 113:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F2;
		case 114:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F3;
		case 115:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F4;
		case 116:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F5;
		case 117:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F6;
		case 118:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F7;
		case 119:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F8;
		case 120:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F9;
		case 121:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F10;
		case 122:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F11;
		case 123:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F12;
		case 144:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumLock;
		case 145:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$ScrollLock;
		default:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Unknown(keyCode);
	}
};
var $elm$json$Json$Decode$map7 = _Json_map7;
var $Gizra$elm_keyboard_event$Keyboard$Event$decodeKeyboardEvent = A8(
	$elm$json$Json$Decode$map7,
	$Gizra$elm_keyboard_event$Keyboard$Event$KeyboardEvent,
	A2($elm$json$Json$Decode$field, 'altKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool),
	$Gizra$elm_keyboard_event$Keyboard$Event$decodeKey,
	A2($elm$json$Json$Decode$map, $SwiftsNamesake$proper_keyboard$Keyboard$Key$fromCode, $Gizra$elm_keyboard_event$Keyboard$Event$decodeKeyCode),
	A2($elm$json$Json$Decode$field, 'metaKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'repeat', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool));
var $Gizra$elm_keyboard_event$Keyboard$Event$considerKeyboardEvent = function (func) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (event) {
			var _v0 = func(event);
			if (!_v0.$) {
				var msg = _v0.a;
				return $elm$json$Json$Decode$succeed(msg);
			} else {
				return $elm$json$Json$Decode$fail('Ignoring keyboard event');
			}
		},
		$Gizra$elm_keyboard_event$Keyboard$Event$decodeKeyboardEvent);
};
var $author$project$Pages$Util$HtmlUtil$mkEscapeEventMsg = F2(
	function (msg, keyboardEvent) {
		return A2(
			$elm_community$maybe_extra$Maybe$Extra$filter,
			$elm$core$Basics$always(
				_Utils_eq(keyboardEvent.kq, $SwiftsNamesake$proper_keyboard$Keyboard$Key$Escape)),
			$elm$core$Maybe$Just(msg));
	});
var $author$project$Pages$Util$HtmlUtil$onEscape = A2(
	$elm$core$Basics$composeR,
	$author$project$Pages$Util$HtmlUtil$mkEscapeEventMsg,
	A2(
		$elm$core$Basics$composeR,
		$Gizra$elm_keyboard_event$Keyboard$Event$considerKeyboardEvent,
		$elm$html$Html$Events$on('keydown')));
var $author$project$Util$MaybeUtil$optional = function (isDefined) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$Just,
		$elm_community$maybe_extra$Maybe$Extra$filter(
			$elm$core$Basics$always(isDefined)));
};
var $author$project$Pages$Util$Choice$View$editElementLine = F3(
	function (ps, element, elementUpdateClientInput) {
		var validInput = ps.ko(elementUpdateClientInput);
		var elementId = ps.j7(element);
		var saveMsg = A2($author$project$Pages$Util$Choice$Page$SaveEdit, elementId, elementUpdateClientInput);
		var editCells = A2(ps.eb, element, elementUpdateClientInput);
		var cancelMsg = $author$project$Pages$Util$Choice$Page$ExitEdit(elementId);
		var cells = _Utils_ap(
			A2(
				$elm$core$List$map,
				$author$project$Pages$Util$HtmlUtil$withExtraAttributes(
					$elm_community$maybe_extra$Maybe$Extra$values(
						_List_fromArray(
							[
								A2(
								$author$project$Util$MaybeUtil$optional,
								validInput,
								$elm_community$html_extra$Html$Events$Extra$onEnter(saveMsg)),
								$author$project$Util$MaybeUtil$defined(
								$author$project$Pages$Util$HtmlUtil$onEscape(cancelMsg))
							]))),
				editCells),
			_List_fromArray(
				[
					$author$project$Pages$Util$HtmlUtil$toggleControlsCell(
					$author$project$Pages$Util$Choice$Page$ToggleControls(elementId))
				]));
		var editRow = A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.f0]),
			cells);
		var controlsRow = A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$colspan(
							$elm$core$List$length(editCells))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$table,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.jF]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[$author$project$Pages$Util$Style$classes.H]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$button,
													$elm_community$maybe_extra$Maybe$Extra$values(
														_List_fromArray(
															[
																$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.a0.d4),
																$author$project$Util$MaybeUtil$defined(
																$elm$html$Html$Attributes$disabled(!validInput)),
																A2(
																$author$project$Util$MaybeUtil$optional,
																validInput,
																$elm$html$Html$Events$onClick(saveMsg))
															])),
													_List_fromArray(
														[
															$elm$html$Html$text('Save')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[$author$project$Pages$Util$Style$classes.H]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$author$project$Pages$Util$Style$classes.a0.iR,
															$elm$html$Html$Events$onClick(cancelMsg)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Cancel')
														]))
												]))
										]))
								]))
						]))
				]));
		return _List_fromArray(
			[editRow, controlsRow]);
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $jschomay$elm_bounded_number$Number$Bounded$value = function (_v0) {
	var n = _v0.au;
	return n;
};
var $jschomay$elm_paginate$Paginate$Custom$page = F2(
	function (sliceFn, _v0) {
		var itemsPerPage_ = _v0.cQ;
		var currentPage_ = _v0.v;
		var items = _v0.gy;
		var from = ($jschomay$elm_bounded_number$Number$Bounded$value(currentPage_) - 1) * itemsPerPage_;
		var to = from + itemsPerPage_;
		return A3(sliceFn, from, to, items);
	});
var $jschomay$elm_paginate$Paginate$page = $jschomay$elm_paginate$Paginate$Custom$page(
	F2(
		function (from, to) {
			return A2(
				$elm$core$Basics$composeR,
				$elm$core$List$drop(from),
				$elm$core$List$take(to - from));
		}));
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $jschomay$elm_paginate$Paginate$Custom$accumulateWindowGroups = F2(
	function (page_, windows) {
		if (!windows.b) {
			return _List_fromArray(
				[
					_Utils_Tuple2(page_, _List_Nil)
				]);
		} else {
			var currentWindow = windows.a;
			var remainingWindows = windows.b;
			var prevPage = function () {
				var _v1 = $elm$core$List$head(currentWindow.b);
				if (!_v1.$) {
					var prevPage_ = _v1.a;
					return prevPage_;
				} else {
					return currentWindow.a;
				}
			}();
			return ((page_ - prevPage) > 1) ? A2(
				$elm$core$List$cons,
				_Utils_Tuple2(page_, _List_Nil),
				windows) : A2(
				$elm$core$List$cons,
				A2(
					$elm$core$Tuple$mapSecond,
					function (list) {
						return A2($elm$core$List$cons, page_, list);
					},
					currentWindow),
				remainingWindows);
		}
	});
var $jschomay$elm_paginate$Paginate$Custom$groupWindows = function (pages) {
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var x = _v0.a;
			var xs = _v0.b;
			return A2($elm$core$List$cons, x, xs);
		},
		$elm$core$List$reverse(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapSecond($elm$core$List$reverse),
				A3($elm$core$List$foldl, $jschomay$elm_paginate$Paginate$Custom$accumulateWindowGroups, _List_Nil, pages))));
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $jschomay$elm_bounded_number$Number$Bounded$maxBound = function (_v0) {
	var max = _v0.ah;
	return max;
};
var $jschomay$elm_bounded_number$Number$Bounded$minBound = function (_v0) {
	var min = _v0.ai;
	return min;
};
var $jschomay$elm_bounded_number$Number$Bounded$Bounded = $elm$core$Basics$identity;
var $jschomay$elm_bounded_number$Number$Bounded$set = F2(
	function (n, _v0) {
		var min = _v0.ai;
		var max = _v0.ah;
		return {
			ah: max,
			ai: min,
			au: A3($elm$core$Basics$clamp, min, max, n)
		};
	});
var $jschomay$elm_paginate$Paginate$Custom$elidedPager = F2(
	function (options, _v0) {
		var currentPage_ = _v0.v;
		var rightWindow = (options.lo <= 0) ? _List_Nil : A2(
			$elm$core$List$range,
			$jschomay$elm_bounded_number$Number$Bounded$value(
				A2(
					$jschomay$elm_bounded_number$Number$Bounded$set,
					$jschomay$elm_bounded_number$Number$Bounded$maxBound(currentPage_) - (options.lo - 1),
					currentPage_)),
			$jschomay$elm_bounded_number$Number$Bounded$maxBound(currentPage_));
		var leftWindow = (options.lo <= 0) ? _List_Nil : A2(
			$elm$core$List$range,
			$jschomay$elm_bounded_number$Number$Bounded$minBound(currentPage_),
			$jschomay$elm_bounded_number$Number$Bounded$value(
				A2(
					$jschomay$elm_bounded_number$Number$Bounded$set,
					$jschomay$elm_bounded_number$Number$Bounded$minBound(currentPage_) + (options.lo - 1),
					currentPage_)));
		var currentPageNumber = $jschomay$elm_bounded_number$Number$Bounded$value(currentPage_);
		var innerWindow = A2(
			$elm$core$List$range,
			A3(
				$elm$core$Basics$clamp,
				$jschomay$elm_bounded_number$Number$Bounded$minBound(currentPage_),
				currentPageNumber,
				currentPageNumber - options.kl),
			A3(
				$elm$core$Basics$clamp,
				currentPageNumber,
				$jschomay$elm_bounded_number$Number$Bounded$maxBound(currentPage_),
				currentPageNumber + options.kl));
		return $elm$core$List$concat(
			A2(
				$elm$core$List$intersperse,
				_List_fromArray(
					[options.jX]),
				A2(
					$elm$core$List$map,
					$elm$core$List$map(
						function (i) {
							return A2(
								options.lq,
								i,
								_Utils_eq(i, currentPageNumber));
						}),
					$jschomay$elm_paginate$Paginate$Custom$groupWindows(
						$elm$core$Set$toList(
							$elm$core$Set$fromList(
								_Utils_ap(
									leftWindow,
									_Utils_ap(innerWindow, rightWindow))))))));
	});
var $jschomay$elm_paginate$Paginate$elidedPager = $jschomay$elm_paginate$Paginate$Custom$elidedPager;
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $jschomay$elm_paginate$Paginate$Custom$totalPages = function (_v0) {
	var currentPage_ = _v0.v;
	return $jschomay$elm_bounded_number$Number$Bounded$maxBound(currentPage_);
};
var $jschomay$elm_paginate$Paginate$totalPages = $jschomay$elm_paginate$Paginate$Custom$totalPages;
var $author$project$Pages$Util$ViewUtil$pagerButtons = function (ps) {
	var pagerButton = F2(
		function (pageNum, isCurrentPage) {
			return A2(
				$elm$html$Html$button,
				$elm_community$maybe_extra$Maybe$Extra$values(
					_List_fromArray(
						[
							$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.a0.ls),
							$author$project$Util$MaybeUtil$defined(
							$elm$html$Html$Events$onClick(
								ps.gM(pageNum))),
							A2(
							$author$project$Util$MaybeUtil$optional,
							isCurrentPage,
							$elm$html$Html$Attributes$disabled(true)),
							A2($author$project$Util$MaybeUtil$optional, isCurrentPage, $author$project$Pages$Util$Style$classes.ju)
						])),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(pageNum))
					]));
		});
	var cells = A2(
		$elm$core$List$filter,
		$elm$core$Basics$always(
			$jschomay$elm_paginate$Paginate$totalPages(ps.jD) > 1),
		A2(
			$elm$core$List$map,
			function (elt) {
				return A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[elt]));
			},
			A2(
				$jschomay$elm_paginate$Paginate$elidedPager,
				{
					jX: A2(
						$elm$html$Html$button,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.jG]),
						_List_fromArray(
							[
								$elm$html$Html$text('...')
							])),
					kl: 5,
					lo: 1,
					lq: pagerButton
				},
				ps.jD)));
	return A2(
		$elm$html$Html$table,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$tbody,
				_List_Nil,
				_List_fromArray(
					[
						A2($elm$html$Html$tr, _List_Nil, cells)
					]))
			]));
};
var $jschomay$elm_paginate$Paginate$Custom$Paginated = $elm$core$Basics$identity;
var $jschomay$elm_bounded_number$Number$Bounded$between = F2(
	function (a, b) {
		return (_Utils_cmp(a, b) < 0) ? {ah: b, ai: a, au: a} : {ah: a, ai: b, au: b};
	});
var $jschomay$elm_paginate$Paginate$Custom$init = F3(
	function (lengthFn, itemsPerPage_, items) {
		var max = (!lengthFn(items)) ? 1 : $elm$core$Basics$ceiling(
			lengthFn(items) / A2($elm$core$Basics$max, 1, itemsPerPage_));
		return {
			v: A2($jschomay$elm_bounded_number$Number$Bounded$between, 1, max),
			gy: items,
			cQ: A2($elm$core$Basics$max, 1, itemsPerPage_)
		};
	});
var $jschomay$elm_paginate$Paginate$fromList = F2(
	function (a, b) {
		return A3($jschomay$elm_paginate$Paginate$Custom$init, $elm$core$List$length, a, b);
	});
var $jschomay$elm_paginate$Paginate$Custom$goTo = F2(
	function (i, _v0) {
		var p = _v0;
		return _Utils_update(
			p,
			{
				v: A2($jschomay$elm_bounded_number$Number$Bounded$set, i, p.v)
			});
	});
var $jschomay$elm_paginate$Paginate$goTo = $jschomay$elm_paginate$Paginate$Custom$goTo;
var $author$project$Pages$Util$ViewUtil$paginate = F2(
	function (ps, model) {
		return A2(
			$elm$core$Basics$composeR,
			$jschomay$elm_paginate$Paginate$fromList(
				A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$PaginationSettings$lenses.bG, ps.lt).jY(model)),
			$jschomay$elm_paginate$Paginate$goTo(
				A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$PaginationSettings$lenses.jg, ps.lt).jY(model)));
	});
var $elm_community$list_extra$List$Extra$andThen = $elm$core$List$concatMap;
var $elm_community$list_extra$List$Extra$dropWhile = F2(
	function (predicate, list) {
		dropWhile:
		while (true) {
			if (!list.b) {
				return _List_Nil;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					var $temp$predicate = predicate,
						$temp$list = xs;
					predicate = $temp$predicate;
					list = $temp$list;
					continue dropWhile;
				} else {
					return list;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$isSubsequenceOf = F2(
	function (subseq, list) {
		isSubsequenceOf:
		while (true) {
			var _v0 = _Utils_Tuple2(subseq, list);
			if (!_v0.a.b) {
				return true;
			} else {
				if (!_v0.b.b) {
					return false;
				} else {
					var _v1 = _v0.a;
					var x = _v1.a;
					var xs = _v1.b;
					var _v2 = _v0.b;
					var y = _v2.a;
					var ys = _v2.b;
					if (_Utils_eq(x, y)) {
						var $temp$subseq = xs,
							$temp$list = ys;
						subseq = $temp$subseq;
						list = $temp$list;
						continue isSubsequenceOf;
					} else {
						var $temp$subseq = subseq,
							$temp$list = ys;
						subseq = $temp$subseq;
						list = $temp$list;
						continue isSubsequenceOf;
					}
				}
			}
		}
	});
var $author$project$Util$SearchUtil$searchByInitials = function (ps) {
	return A2(
		$elm_community$list_extra$List$Extra$isSubsequenceOf,
		$elm$core$String$toList(
			$elm$core$String$toLower(ps.cx)),
		A2(
			$elm_community$list_extra$List$Extra$andThen,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$toList,
				A2(
					$elm$core$Basics$composeR,
					$elm_community$list_extra$List$Extra$dropWhile(
						A2($elm$core$Basics$composeR, $elm$core$Char$isAlpha, $elm$core$Basics$not)),
					A2($elm$core$Basics$composeR, $elm$core$List$head, $elm_community$maybe_extra$Maybe$Extra$toList))),
			A2(
				$elm$core$List$concatMap,
				$elm$core$String$split('-'),
				A2(
					$elm$core$String$split,
					' ',
					$elm$core$String$toLower(ps.ca)))));
};
var $author$project$Util$SearchUtil$searchByWords = function (ps) {
	return A2(
		$elm$core$List$all,
		A2(
			$elm_community$basics_extra$Basics$Extra$flip,
			$elm$core$String$contains,
			$elm$core$String$toLower(ps.ca)),
		A2(
			$elm$core$String$split,
			' ',
			$elm$core$String$toLower(ps.cx)));
};
var $author$project$Util$SearchUtil$search = F2(
	function (desired, actual) {
		var searchParameters = {ca: actual, cx: desired};
		return A2(
			$elm$core$List$any,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$author$project$Util$SearchUtil$searchByWords(searchParameters),
					$author$project$Util$SearchUtil$searchByInitials(searchParameters)
				]));
	});
var $elm$html$Html$form = _VirtualDom_node('form');
var $elm$core$Char$fromCode = _Char_fromCode;
var $author$project$Pages$Util$Links$special = A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar);
var $author$project$Pages$Util$Links$lookingGlass = $author$project$Pages$Util$Links$special(128269);
var $author$project$Pages$Util$HtmlUtil$searchAreaWith = function (ps) {
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[$author$project$Pages$Util$Style$classes.hy.iI]),
		_List_fromArray(
			[
				$elm$html$Html$text($author$project$Pages$Util$Links$lookingGlass),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(ps.gM),
						$elm$html$Html$Attributes$value(ps.hz),
						$author$project$Pages$Util$Style$classes.hy.jP
					]),
				_List_Nil),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$author$project$Pages$Util$Style$classes.a0.iR,
						$elm$html$Html$Events$onClick(
						ps.gM('')),
						$elm$html$Html$Attributes$disabled(
						$elm$core$String$isEmpty(ps.hz))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Clear')
					]))
			]));
};
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $author$project$Util$Editing$unpack = F2(
	function (fs, editing) {
		return A2(
			$author$project$Util$EditState$unpack,
			{
				la: fs.la(editing.ln),
				lh: fs.lh(editing.ln),
				lk: fs.lk(editing.ln)
			},
			editing.J);
	});
var $author$project$Pages$Util$PaginationSettings$updateCurrentPage = F3(
	function (ps, model, currentPage) {
		return A2(
			A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$PaginationSettings$lenses.jg, ps.gy).eW,
			currentPage,
			ps.lt.jY(model));
	});
var $author$project$Util$DictList$values = A2(
	$elm$core$Basics$composeR,
	$author$project$Util$DictList$toList,
	$elm$core$List$map($elm$core$Tuple$second));
var $author$project$Pages$Util$Choice$View$viewElementLine = F3(
	function (ps, element, showControls) {
		return A2(
			$author$project$Pages$Util$Choice$View$elementLineWith,
			{j7: ps.j7, kd: ps.kd, hH: showControls},
			element);
	});
var $author$project$Pages$Util$Choice$View$viewElements = F2(
	function (ps, main) {
		var viewElementState = $author$project$Util$Editing$unpack(
			{
				la: $author$project$Pages$Util$Choice$View$deleteElementLine(
					{
						j7: ps.j7,
						kd: A2(
							$elm$core$Basics$composeR,
							ps.kd,
							function ($) {
								return $.d8;
							})
					}),
				lh: $author$project$Pages$Util$Choice$View$editElementLine(
					{eb: ps.eb, j7: ps.j7, ko: ps.ko}),
				lk: $author$project$Pages$Util$Choice$View$viewElementLine(
					{j7: ps.j7, kd: ps.kd})
			});
		var extractedName = A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.ln;
			},
			A2(
				$elm$core$Basics$composeR,
				ps.iZ,
				A2(
					$elm$core$Basics$composeR,
					A2($elm_community$basics_extra$Basics$Extra$flip, $author$project$Util$DictList$get, main.i$),
					A2(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.ln;
							},
							ps.kT)))));
		var paginatedElements = A3(
			$author$project$Pages$Util$ViewUtil$paginate,
			{
				lt: A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$Choice$Pagination$lenses.jD, $author$project$Pages$Util$Choice$Page$lenses.kz.lt)
			},
			main,
			A2(
				$elm$core$List$sortBy,
				A2($elm$core$Basics$composeR, extractedName, $elm$core$String$toLower),
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						extractedName,
						$author$project$Util$SearchUtil$search(main.jE)),
					$author$project$Util$DictList$values(main.jD))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.i$]),
			_List_fromArray(
				[
					$author$project$Pages$Util$HtmlUtil$searchAreaWith(
					{gM: $author$project$Pages$Util$Choice$Page$SetElementsSearchString, hz: main.jE}),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.jF, $author$project$Pages$Util$Style$classes.jB]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.mt]),
									_Utils_ap(
										ps.jC,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$th,
												_List_fromArray(
													[$author$project$Pages$Util$Style$classes.h2]),
												_List_Nil)
											])))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							A2(
								$elm$core$List$concatMap,
								viewElementState,
								$jschomay$elm_paginate$Paginate$page(paginatedElements)))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.lt]),
					_List_fromArray(
						[
							$author$project$Pages$Util$ViewUtil$pagerButtons(
							{
								jD: paginatedElements,
								gM: A2(
									$elm$core$Basics$composeR,
									A2(
										$author$project$Pages$Util$PaginationSettings$updateCurrentPage,
										{gy: $author$project$Pages$Util$Choice$Pagination$lenses.jD, lt: $author$project$Pages$Util$Choice$Page$lenses.kz.lt},
										main),
									$author$project$Pages$Util$Choice$Page$SetPagination)
							})
						]))
				]));
	});
var $author$project$Pages$ComplexFoods$Foods$View$viewComplexFoods = function (main) {
	return A2(
		$author$project$Pages$Util$Choice$View$viewElements,
		{
			iZ: function ($) {
				return $.hk;
			},
			eb: F2(
				function (complexFood, complexFoodUpdateClientInput) {
					return _List_fromArray(
						[
							{
							S: _List_Nil,
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(complexFood.gN)
										]))
								])
						},
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.cW]),
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(complexFoodUpdateClientInput.fq.mx),
											$elm$html$Html$Events$onInput(
											A2(
												$elm$core$Basics$composeR,
												A2(
													$elm_community$basics_extra$Basics$Extra$flip,
													$author$project$Pages$Util$ValidatedInput$lift($author$project$Pages$ComplexFoods$ComplexFoodUpdateClientInput$lenses.fq).eW,
													complexFoodUpdateClientInput),
												$author$project$Pages$Util$Choice$Page$Edit(complexFood.hk))),
											$author$project$Pages$Util$Style$classes.M
										]),
									_List_Nil)
								])
						},
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.cW]),
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(complexFoodUpdateClientInput.fr.mx),
											$elm$html$Html$Events$onInput(
											A2(
												$elm$core$Basics$composeR,
												A2(
													$elm_community$basics_extra$Basics$Extra$flip,
													$author$project$Pages$Util$ValidatedInput$lift($author$project$Pages$ComplexFoods$ComplexFoodUpdateClientInput$lenses.fr).eW,
													complexFoodUpdateClientInput),
												$author$project$Pages$Util$Choice$Page$Edit(complexFood.hk))),
											$author$project$Pages$Util$Style$classes.M
										]),
									_List_Nil)
								])
						}
						]);
				}),
			jC: _List_fromArray(
				[
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Name')
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.M]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Amount in g')
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.M]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Amount in ml')
								]))
						]))
				]),
			j7: function ($) {
				return $.hk;
			},
			kd: function (complexFood) {
				return {
					H: _List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.a0.eb,
											$elm$html$Html$Events$onClick(
											$author$project$Pages$Util$Choice$Page$EnterEdit(complexFood.hk))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.a0.af,
											$elm$html$Html$Events$onClick(
											$author$project$Pages$Util$Choice$Page$RequestDelete(complexFood.hk))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									$author$project$Pages$Util$NavigationUtil$recipeEditorLinkButton(complexFood.hk)
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									$author$project$Pages$Util$NavigationUtil$recipeNutrientsLinkButton(complexFood.hk)
								]))
						]),
					d8: _List_fromArray(
						[
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.ec]),
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(complexFood.gN)
										]))
								])
						},
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.M]),
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromFloat(complexFood.fq))
										]))
								])
						},
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.M]),
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$String$fromFloat, complexFood.fr))
										]))
								])
						}
						])
				};
			},
			ko: function (complexFoodUpdateClientInput) {
				return A2(
					$elm$core$List$all,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$author$project$Pages$Util$ValidatedInput$isValid(complexFoodUpdateClientInput.fq),
							$author$project$Pages$Util$ValidatedInput$isValid(complexFoodUpdateClientInput.fr)
						]));
			},
			kT: function ($) {
				return $.gN;
			}
		},
		main);
};
var $elm$html$Html$main_ = _VirtualDom_node('main');
var $author$project$Pages$Util$ViewUtil$navigationBarWith = function (ps) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[$author$project$Pages$Util$Style$ids.kY]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$table,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (page) {
										return A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													ps.lr(page)
												]));
									},
									ps.kZ))
							]))
					]))
			]));
};
var $author$project$Pages$Util$ViewUtil$MealsProfileChoice = 1;
var $author$project$Pages$Util$ViewUtil$Profiles = 8;
var $author$project$Pages$Util$ViewUtil$Recipes = 0;
var $author$project$Pages$Util$ViewUtil$ReferenceMaps = 3;
var $author$project$Pages$Util$ViewUtil$Statistics = 2;
var $author$project$Pages$Util$ViewUtil$UserSettings = 4;
var $author$project$Pages$Util$ViewUtil$navigationPages = _List_fromArray(
	[0, 1, 7, 2, 3, 8, 4]);
var $author$project$Pages$Util$ViewUtil$addressSuffix = function (page) {
	var parts = function () {
		switch (page) {
			case 0:
				return $author$project$Addresses$Frontend$recipes.iA(0);
			case 1:
				return $author$project$Addresses$Frontend$mealBranch.iA(0);
			case 2:
				return $author$project$Addresses$Frontend$statisticsTime.iA(0);
			case 3:
				return $author$project$Addresses$Frontend$referenceMaps.iA(0);
			case 4:
				return $author$project$Addresses$Frontend$userSettings.iA(0);
			case 5:
				return $author$project$Addresses$Frontend$login.iA(0);
			case 6:
				return $author$project$Addresses$Frontend$overview.iA(0);
			case 7:
				return $author$project$Addresses$Frontend$complexFoods.iA(0);
			default:
				return $author$project$Addresses$Frontend$profiles.iA(0);
		}
	}();
	return $elm$core$String$concat(parts);
};
var $author$project$Pages$Util$ViewUtil$nameOf = function (page) {
	switch (page) {
		case 0:
			return 'Recipes';
		case 1:
			return 'Meals';
		case 2:
			return 'Statistics';
		case 3:
			return 'Reference maps';
		case 4:
			return 'Settings';
		case 5:
			return 'Login';
		case 6:
			return 'Overview';
		case 7:
			return 'Complex foods';
		default:
			return 'Profiles';
	}
};
var $author$project$Pages$Util$ViewUtil$navigationLink = function (ps) {
	return A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[ps.N]),
		_List_Nil);
};
var $author$project$Pages$Util$ViewUtil$navigationToPageButtonWith = function (ps) {
	var isDisabled = A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		false,
		function (current) {
			return _Utils_eq(current, ps.N);
		},
		ps.jg);
	return isDisabled ? A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$author$project$Pages$Util$Style$classes.a0.kY,
				$author$project$Pages$Util$Style$classes.ju,
				$elm$html$Html$Attributes$disabled(true)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				ps.kS(ps.N))
			])) : $author$project$Pages$Util$Links$linkButton(
		{
			S: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.a0.kY]),
			T: _List_fromArray(
				[
					$elm$html$Html$text(
					ps.kS(ps.N))
				]),
			id: $author$project$Pages$Util$ViewUtil$navigationLink(
				{
					N: ps.iB(ps.N)
				})
		});
};
var $author$project$Pages$Util$ViewUtil$navigationToPageButton = function (ps) {
	return $author$project$Pages$Util$ViewUtil$navigationToPageButtonWith(
		{iB: $author$project$Pages$Util$ViewUtil$addressSuffix, jg: ps.jg, kS: $author$project$Pages$Util$ViewUtil$nameOf, N: ps.N});
};
var $author$project$Pages$Util$ViewUtil$navigationBar = function (ps) {
	return $author$project$Pages$Util$ViewUtil$navigationBarWith(
		{
			kZ: $author$project$Pages$Util$ViewUtil$navigationPages,
			lr: function (page) {
				return $author$project$Pages$Util$ViewUtil$navigationToPageButton(
					{jg: ps.jg, N: page});
			}
		});
};
var $author$project$Pages$Util$ViewUtil$viewMainWith = F2(
	function (params, html) {
		var navigation = A2(
			$elm$core$List$filter,
			$elm$core$Basics$always(params.me),
			_List_fromArray(
				[
					$author$project$Pages$Util$ViewUtil$navigationBar(
					{jg: params.jg})
				]));
		return A2(
			$elm$html$Html$main_,
			_List_Nil,
			_Utils_ap(
				navigation,
				_List_fromArray(
					[html])));
	});
var $author$project$Pages$Util$Choice$Page$Create = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Util$Choice$Page$DeselectChoice = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Util$Choice$Page$SelectChoice = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Util$Choice$Page$UpdateCreation = function (a) {
	return {$: 17, a: a};
};
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $elm_community$basics_extra$Basics$Extra$uncurry = F2(
	function (f, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		return A2(f, a, b);
	});
var $author$project$Util$DictList$any = function (p) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Util$DictList$toList,
		A2(
			$elm$core$Basics$composeR,
			$elm_community$list_extra$List$Extra$find(
				$elm_community$basics_extra$Basics$Extra$uncurry(p)),
			$elm_community$maybe_extra$Maybe$Extra$isJust));
};
var $author$project$Pages$Util$DictListUtil$existsValue = function (p) {
	return $author$project$Util$DictList$any(
		$elm$core$Basics$always(p));
};
var $author$project$Util$Editing$isUpdate = $author$project$Util$Editing$unpack(
	{
		la: function (_v0) {
			return false;
		},
		lh: F2(
			function (_v1, _v2) {
				return true;
			}),
		lk: F2(
			function (_v3, _v4) {
				return false;
			})
	});
var $author$project$Pages$ComplexFoods$ComplexFoodCreationClientInput$lenses = {
	fq: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.fq;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{fq: b});
			})),
	fr: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.fr;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{fr: b});
			}))
};
var $author$project$Pages$Recipes$View$recipeInfoColumns = function (recipe) {
	return _List_fromArray(
		[
			{
			S: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.ec]),
			T: _List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(recipe.gN)
						]))
				])
		},
			{
			S: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.ec]),
			T: _List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($elm$core$Maybe$withDefault, '', recipe.fX))
						]))
				])
		},
			{
			S: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.M]),
			T: _List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromFloat(recipe.gY))
						]))
				])
		},
			{
			S: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.M]),
			T: _List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($elm$core$Maybe$withDefault, '', recipe.hF))
						]))
				])
		}
		]);
};
var $author$project$Pages$Util$Choice$Page$SetChoicesSearchString = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$Util$Choice$Page$ToggleChoiceControls = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Util$Choice$View$editElementCreation = F3(
	function (ps, choice, creation) {
		var rowWithControls = A2(ps.jA, choice, creation);
		var controlsRow = A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$colspan(
							1 + $elm$core$List$length(rowWithControls.d8))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$table,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.jF]),
							_List_fromArray(
								[
									A2($elm$html$Html$tr, _List_Nil, rowWithControls.H)
								]))
						]))
				]));
		var choiceId = ps.j6(choice);
		var toggleMsg = $author$project$Pages$Util$Choice$Page$ToggleChoiceControls(choiceId);
		var creationRow = A2(
			$elm$html$Html$tr,
			_List_Nil,
			_Utils_ap(
				A2(
					$elm$core$List$map,
					$author$project$Pages$Util$HtmlUtil$withExtraAttributes(_List_Nil),
					rowWithControls.d8),
				_List_fromArray(
					[
						$author$project$Pages$Util$HtmlUtil$toggleControlsCell(toggleMsg)
					])));
		return _List_fromArray(
			[creationRow, controlsRow]);
	});
var $author$project$Pages$Util$Choice$View$viewChoiceLine = F3(
	function (ps, choice, showControls) {
		var toggleCommand = $author$project$Pages$Util$Choice$Page$ToggleChoiceControls(
			ps.j6(choice));
		var rowWithControls = ps.fH(choice);
		var columns = A2(
			$elm$core$List$map,
			$author$project$Pages$Util$HtmlUtil$withExtraAttributes(
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(toggleCommand)
					])),
			rowWithControls.d8);
		var controlsRow = A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$colspan(
							$elm$core$List$length(columns))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$table,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.jF]),
							_List_fromArray(
								[
									A2($elm$html$Html$tr, _List_Nil, rowWithControls.H)
								]))
						]))
				]));
		var infoRow = A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.jx]),
			_Utils_ap(
				columns,
				_List_fromArray(
					[
						$author$project$Pages$Util$HtmlUtil$toggleControlsCell(toggleCommand)
					])));
		return A2(
			$elm$core$List$cons,
			infoRow,
			showControls ? _List_fromArray(
				[controlsRow]) : _List_Nil);
	});
var $author$project$Pages$Util$Choice$View$viewChoices = F2(
	function (ps, main) {
		var paginatedChoices = A3(
			$author$project$Pages$Util$ViewUtil$paginate,
			{
				lt: A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$Choice$Pagination$lenses.i$, $author$project$Pages$Util$Choice$Page$lenses.kz.lt)
			},
			main,
			A2(
				$elm$core$List$sortBy,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ln;
					},
					ps.mg),
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.ln;
						},
						ps.kC(main.i0)),
					$author$project$Util$DictList$values(main.i$))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.iz]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.iu]),
					_List_fromArray(
						[
							$author$project$Pages$Util$HtmlUtil$searchAreaWith(
							{gM: $author$project$Pages$Util$Choice$Page$SetChoicesSearchString, hz: main.i0}),
							A2(
							$elm$html$Html$table,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.jF]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$thead,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$tr,
											_List_fromArray(
												[$author$project$Pages$Util$Style$classes.mt]),
											_Utils_ap(
												ps.iX,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$th,
														_List_fromArray(
															[$author$project$Pages$Util$Style$classes.h2]),
														_List_Nil)
													])))
										])),
									A2(
									$elm$html$Html$tbody,
									_List_Nil,
									A2(
										$elm$core$List$concatMap,
										$author$project$Util$Editing$unpack(
											{
												la: $elm$core$Basics$always(_List_Nil),
												lh: $author$project$Pages$Util$Choice$View$editElementCreation(
													{jA: ps.jA, j6: ps.j6}),
												lk: $author$project$Pages$Util$Choice$View$viewChoiceLine(
													{fH: ps.mR, j6: ps.j6})
											}),
										$jschomay$elm_paginate$Paginate$page(paginatedChoices)))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.lt]),
							_List_fromArray(
								[
									$author$project$Pages$Util$ViewUtil$pagerButtons(
									{
										jD: paginatedChoices,
										gM: A2(
											$elm$core$Basics$composeR,
											A2(
												$author$project$Pages$Util$PaginationSettings$updateCurrentPage,
												{gy: $author$project$Pages$Util$Choice$Pagination$lenses.i$, lt: $author$project$Pages$Util$Choice$Page$lenses.kz.lt},
												main),
											$author$project$Pages$Util$Choice$Page$SetPagination)
									})
								]))
						]))
				]));
	});
var $author$project$Pages$ComplexFoods$Foods$View$viewRecipes = function (main) {
	var anySelection = A2($author$project$Pages$Util$DictListUtil$existsValue, $author$project$Util$Editing$isUpdate, main.i$);
	var _v0 = anySelection ? _Utils_Tuple2('Amount in g', 'Amount in ml') : _Utils_Tuple2('', '');
	var amountGrams = _v0.a;
	var amountMillilitres = _v0.b;
	return A2(
		$author$project$Pages$Util$Choice$View$viewChoices,
		{
			iX: _List_fromArray(
				[
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Name')
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Description')
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.M]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Servings')
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.M]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Serving size')
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.M]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(amountGrams)
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.M]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(amountMillilitres)
								]))
						]))
				]),
			jA: F2(
				function (recipe, complexFoodClientInput) {
					var validInput = A2(
						$elm$core$List$all,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$author$project$Pages$Util$ValidatedInput$isValid(complexFoodClientInput.fq),
								$author$project$Pages$Util$ValidatedInput$isValid(complexFoodClientInput.fr)
							]));
					var createMsg = $author$project$Pages$Util$Choice$Page$Create(recipe.gn);
					var cancelMsg = $author$project$Pages$Util$Choice$Page$DeselectChoice(recipe.gn);
					var inputCells = _List_fromArray(
						[
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.cW]),
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									$elm_community$maybe_extra$Maybe$Extra$values(
										_List_fromArray(
											[
												$author$project$Util$MaybeUtil$defined(
												$elm$html$Html$Attributes$value(complexFoodClientInput.fq.mx)),
												$author$project$Util$MaybeUtil$defined(
												$elm$html$Html$Events$onInput(
													A2(
														$elm$core$Basics$composeR,
														A2(
															$elm_community$basics_extra$Basics$Extra$flip,
															$author$project$Pages$Util$ValidatedInput$lift($author$project$Pages$ComplexFoods$ComplexFoodCreationClientInput$lenses.fq).eW,
															complexFoodClientInput),
														$author$project$Pages$Util$Choice$Page$UpdateCreation))),
												$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.M),
												$author$project$Util$MaybeUtil$defined(
												$author$project$Pages$Util$HtmlUtil$onEscape(cancelMsg)),
												A2(
												$author$project$Util$MaybeUtil$optional,
												validInput,
												$elm_community$html_extra$Html$Events$Extra$onEnter(createMsg))
											])),
									_List_Nil)
								])
						},
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.cW]),
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									$elm_community$maybe_extra$Maybe$Extra$values(
										_List_fromArray(
											[
												$author$project$Util$MaybeUtil$defined(
												$elm$html$Html$Attributes$value(complexFoodClientInput.fr.mx)),
												$author$project$Util$MaybeUtil$defined(
												$elm$html$Html$Events$onInput(
													A2(
														$elm$core$Basics$composeR,
														A2(
															$elm_community$basics_extra$Basics$Extra$flip,
															$author$project$Pages$Util$ValidatedInput$lift($author$project$Pages$ComplexFoods$ComplexFoodCreationClientInput$lenses.fr).eW,
															complexFoodClientInput),
														$author$project$Pages$Util$Choice$Page$UpdateCreation))),
												$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.M),
												$author$project$Util$MaybeUtil$defined(
												$author$project$Pages$Util$HtmlUtil$onEscape(cancelMsg)),
												A2(
												$author$project$Util$MaybeUtil$optional,
												validInput,
												$elm_community$html_extra$Html$Events$Extra$onEnter(createMsg))
											])),
									_List_Nil)
								])
						}
						]);
					return {
						H: _List_fromArray(
							[
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.H]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										$elm_community$maybe_extra$Maybe$Extra$values(
											_List_fromArray(
												[
													$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.a0.d4),
													$author$project$Util$MaybeUtil$defined(
													$elm$html$Html$Attributes$disabled(!validInput)),
													A2(
													$author$project$Util$MaybeUtil$optional,
													validInput,
													$elm$html$Html$Events$onClick(createMsg))
												])),
										_List_fromArray(
											[
												$elm$html$Html$text('Add')
											]))
									])),
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.H]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$author$project$Pages$Util$Style$classes.a0.iR,
												$elm$html$Html$Events$onClick(cancelMsg)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									]))
							]),
						d8: _Utils_ap(
							$author$project$Pages$Recipes$View$recipeInfoColumns(recipe),
							inputCells)
					};
				}),
			j6: function ($) {
				return $.gn;
			},
			kC: F2(
				function (string, recipe) {
					return A2($author$project$Util$SearchUtil$search, string, recipe.gN) || A2(
						$author$project$Util$SearchUtil$search,
						string,
						A2($elm$core$Maybe$withDefault, '', recipe.fX));
				}),
			mg: function ($) {
				return $.gN;
			},
			mR: function (recipe) {
				var exists = A2(
					$author$project$Pages$Util$DictListUtil$existsValue,
					function (complexFood) {
						return _Utils_eq(complexFood.ln.hk, recipe.gn);
					},
					main.jD);
				var _v1 = exists ? _Utils_Tuple2(
					'Added',
					_List_fromArray(
						[
							$author$project$Pages$Util$Style$classes.a0.eb,
							$elm$html$Html$Attributes$disabled(true)
						])) : _Utils_Tuple2(
					'Select',
					_List_fromArray(
						[
							$author$project$Pages$Util$Style$classes.a0.l6,
							$elm$html$Html$Events$onClick(
							$author$project$Pages$Util$Choice$Page$SelectChoice(recipe))
						]));
				var buttonText = _v1.a;
				var buttonAttributes = _v1.b;
				return {
					H: _List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									buttonAttributes,
									_List_fromArray(
										[
											$elm$html$Html$text(buttonText)
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									$author$project$Pages$Util$NavigationUtil$recipeEditorLinkButton(recipe.gn)
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									$author$project$Pages$Util$NavigationUtil$recipeNutrientsLinkButton(recipe.gn)
								]))
						]),
					d8: _Utils_ap(
						$author$project$Pages$Recipes$View$recipeInfoColumns(recipe),
						_List_fromArray(
							[
								{S: _List_Nil, T: _List_Nil},
								{S: _List_Nil, T: _List_Nil}
							]))
				};
			}
		},
		main);
};
var $author$project$Pages$ComplexFoods$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{
			jg: $elm$core$Maybe$Just(7),
			me: true
		},
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[$author$project$Pages$Util$Style$ids.i5]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.jD]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Complex foods')
								]))
						])),
					A2(
					$elm$html$Html$map,
					$elm$core$Basics$identity,
					$author$project$Pages$ComplexFoods$Foods$View$viewComplexFoods(main.jS)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.jD]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Recipes')
								]))
						])),
					A2(
					$elm$html$Html$map,
					$elm$core$Basics$identity,
					$author$project$Pages$ComplexFoods$Foods$View$viewRecipes(main.jS))
				])));
};
var $author$project$Pages$ComplexFoods$View$view = $author$project$Pages$View$Tristate$view(
	{md: true, mT: $author$project$Pages$ComplexFoods$View$viewMain});
var $author$project$Pages$Deletion$Page$Confirm = {$: 0};
var $author$project$Pages$Util$Links$toLoginButton = function (params) {
	return $author$project$Pages$Util$Links$toLoginButtonWith(
		{
			S: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.a0.kY]),
			fC: params.fC
		});
};
var $author$project$Pages$Deletion$View$viewChecking = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[$author$project$Pages$Util$Style$classes.d4]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.kd]),
				_List_fromArray(
					[
						$elm$html$Html$text('Confirm deletion')
					])),
				A2(
				$elm$html$Html$table,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Nickname')
													]))
											])),
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(model.fe.gU)
													]))
											]))
									])),
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Email')
													]))
											])),
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(model.fe.f2)
													]))
											]))
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$Pages$Deletion$Page$Confirm),
								$author$project$Pages$Util$Style$classes.a0.af
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Delete')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Util$Links$toLoginButton(
						{fC: 'Back to main'})
					]))
			]));
};
var $author$project$Pages$Deletion$View$viewConfirmed = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[$author$project$Pages$Util$Style$classes.d4]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('User deletion successful.')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Pages$Util$Links$toLoginButton(
					{fC: 'Main page'})
				]))
		]));
var $author$project$Pages$Deletion$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{jg: $elm$core$Maybe$Nothing, me: false},
		function () {
			var _v0 = main.gK;
			if (!_v0) {
				return $author$project$Pages$Deletion$View$viewChecking(main);
			} else {
				return $author$project$Pages$Deletion$View$viewConfirmed;
			}
		}());
};
var $author$project$Pages$Deletion$View$view = $author$project$Pages$View$Tristate$view(
	{md: true, mT: $author$project$Pages$Deletion$View$viewMain});
var $author$project$Pages$Ingredients$Page$ChangeFoodsMode = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Ingredients$Page$Complex = 1;
var $author$project$Pages$Ingredients$Complex$View$amountInfoOf = function (complexFood) {
	return $elm$core$String$concat(
		_List_fromArray(
			[
				$elm$core$String$fromFloat(complexFood.fq),
				'g',
				A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				'',
				function (amountMillilitres) {
					return $elm$core$String$concat(
						_List_fromArray(
							[
								' = ',
								$elm$core$String$fromFloat(amountMillilitres),
								'ml'
							]));
				},
				complexFood.fr)
			]));
};
var $author$project$Pages$Util$NavigationUtil$complexFoodNutrientLinkButton = function (recipeId) {
	return $author$project$Pages$Util$NavigationUtil$nutrientButtonWith(
		{
			iA: $author$project$Pages$Util$Links$frontendPage(
				$author$project$Addresses$Frontend$statisticsComplexFoodSelect.iA(recipeId))
		});
};
var $abadi199$elm_input_extra$Dropdown$onChange = F2(
	function (emptyItem, tagger) {
		var textToMaybe = function (string) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.ig;
						},
						$elm$core$Basics$eq(string)),
					emptyItem)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
		};
		return A2(
			$elm$html$Html$Events$on,
			'change',
			A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeR, textToMaybe, tagger),
				$elm$html$Html$Events$targetValue));
	});
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$html$Html$select = _VirtualDom_node('select');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $abadi199$elm_input_extra$Dropdown$dropdown = F3(
	function (options, attributes, currentValue) {
		var itemsWithEmptyItems = function () {
			var _v1 = options.f3;
			if (!_v1.$) {
				var emptyItem = _v1.a;
				return A2($elm$core$List$cons, emptyItem, options.gy);
			} else {
				return options.gy;
			}
		}();
		var isSelected = function (value) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$eq(value),
					currentValue));
		};
		var toOption = function (_v0) {
			var value = _v0.ig;
			var text = _v0.mx;
			var enabled = _v0.jH;
			return A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(value),
						$elm$html$Html$Attributes$selected(
						isSelected(value)),
						$elm$html$Html$Attributes$disabled(!enabled)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(text)
					]));
		};
		return A2(
			$elm$html$Html$select,
			_Utils_ap(
				attributes,
				_List_fromArray(
					[
						A2($abadi199$elm_input_extra$Dropdown$onChange, options.f3, options.g0)
					])),
			A2($elm$core$List$map, toOption, itemsWithEmptyItems));
	});
var $author$project$Api$Types$ScalingMode$fromString = function (string) {
	switch (string) {
		case 'Recipe':
			return $elm$core$Maybe$Just(0);
		case 'Weight':
			return $elm$core$Maybe$Just(1);
		case 'Volume':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Ingredients$ComplexIngredientUpdateClientInput$lenses = {
	f9: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.f9;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{f9: b});
			})),
	hv: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.hv;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{hv: b});
			}))
};
var $author$project$Pages$Ingredients$Complex$View$scalingModeName = F2(
	function (fullSize, scalingMode) {
		switch (scalingMode) {
			case 0:
				return 'Full recipe (' + (fullSize + ')');
			case 1:
				return '100g';
			default:
				return '100ml';
		}
	});
var $author$project$Pages$Ingredients$Complex$View$unitDropdownItem = F2(
	function (sizeText, scalingMode) {
		return {
			jH: true,
			mx: sizeText,
			ig: $author$project$Api$Types$ScalingMode$toString(scalingMode)
		};
	});
var $author$project$Pages$Ingredients$Complex$View$unitDropdownItems = function (complexFood) {
	var volumeMode = A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		_List_Nil,
		$elm$core$Basics$always(
			_List_fromArray(
				[2])),
		complexFood.fr);
	var scalingModes = _Utils_ap(
		_List_fromArray(
			[0, 1]),
		volumeMode);
	var amountInfo = $author$project$Pages$Ingredients$Complex$View$amountInfoOf(complexFood);
	return A2(
		$elm$core$List$map,
		function (scalingMode) {
			return A3(
				$elm_community$basics_extra$Basics$Extra$flip,
				$author$project$Pages$Ingredients$Complex$View$unitDropdownItem,
				scalingMode,
				A2($author$project$Pages$Ingredients$Complex$View$scalingModeName, amountInfo, scalingMode));
		},
		scalingModes);
};
var $author$project$Pages$Ingredients$Complex$View$viewComplexIngredients = function (main) {
	return A2(
		$author$project$Pages$Util$Choice$View$viewElements,
		{
			iZ: function ($) {
				return $.fN;
			},
			eb: F2(
				function (complexIngredient, complexIngredientUpdateClientInput) {
					var complexFood = A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.ln;
						},
						A2($author$project$Util$DictList$get, complexIngredient.fN, main.i$));
					return _List_fromArray(
						[
							{
							S: _List_Nil,
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3(
												$elm_community$maybe_extra$Maybe$Extra$unwrap,
												'',
												function ($) {
													return $.gN;
												},
												complexFood))
										]))
								])
						},
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.cW]),
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(complexIngredientUpdateClientInput.f9.mx),
											$elm$html$Html$Events$onInput(
											A2(
												$elm$core$Basics$composeR,
												A2(
													$elm_community$basics_extra$Basics$Extra$flip,
													$author$project$Pages$Util$ValidatedInput$lift($author$project$Pages$Ingredients$ComplexIngredientUpdateClientInput$lenses.f9).eW,
													complexIngredientUpdateClientInput),
												$author$project$Pages$Util$Choice$Page$Edit(complexIngredient.fN))),
											$author$project$Pages$Util$Style$classes.M
										]),
									_List_Nil)
								])
						},
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.M]),
							T: _List_fromArray(
								[
									A3(
									$abadi199$elm_input_extra$Dropdown$dropdown,
									{
										f3: $elm$core$Maybe$Nothing,
										gy: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, $author$project$Pages$Ingredients$Complex$View$unitDropdownItems, complexFood),
										g0: function (unit) {
											return A2(
												$author$project$Pages$Util$Choice$Page$Edit,
												complexIngredient.fN,
												A3(
													$elm$core$Basics$apR,
													A2($elm$core$Maybe$andThen, $author$project$Api$Types$ScalingMode$fromString, unit),
													A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$core$Basics$identity, $author$project$Pages$Ingredients$ComplexIngredientUpdateClientInput$lenses.hv.eW),
													complexIngredientUpdateClientInput));
										}
									},
									_List_Nil,
									$elm$core$Maybe$Just(
										$author$project$Api$Types$ScalingMode$toString(complexIngredient.hv)))
								])
						}
						]);
				}),
			jC: _List_fromArray(
				[
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Name')
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.M]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Factor')
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.M]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Unit')
								]))
						]))
				]),
			j7: function ($) {
				return $.fN;
			},
			kd: function (complexIngredient) {
				var editMsg = $elm$html$Html$Events$onClick(
					$author$project$Pages$Util$Choice$Page$EnterEdit(complexIngredient.fN));
				var complexFood = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.ln;
					},
					A2($author$project$Util$DictList$get, complexIngredient.fN, main.i$));
				var amountInfo = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $author$project$Pages$Ingredients$Complex$View$amountInfoOf, complexFood);
				return {
					H: _List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.a0.eb, editMsg]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.a0.af,
											$elm$html$Html$Events$onClick(
											$author$project$Pages$Util$Choice$Page$RequestDelete(complexIngredient.fN))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									$author$project$Pages$Util$NavigationUtil$recipeEditorLinkButton(complexIngredient.fN)
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									$author$project$Pages$Util$NavigationUtil$complexFoodNutrientLinkButton(complexIngredient.fN)
								]))
						]),
					d8: _List_fromArray(
						[
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.ec]),
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3(
												$elm_community$maybe_extra$Maybe$Extra$unwrap,
												'',
												function ($) {
													return $.gN;
												},
												complexFood))
										]))
								])
						},
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.M]),
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromFloat(complexIngredient.f9))
										]))
								])
						},
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.M]),
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($author$project$Pages$Ingredients$Complex$View$scalingModeName, amountInfo, complexIngredient.hv))
										]))
								])
						}
						])
				};
			},
			ko: A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.f9;
				},
				$author$project$Pages$Util$ValidatedInput$isValid),
			kT: function ($) {
				return $.gN;
			}
		},
		main);
};
var $author$project$Pages$Ingredients$ComplexIngredientCreationClientInput$lenses = {
	f9: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.f9;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{f9: b});
			})),
	hv: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.hv;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{hv: b});
			}))
};
var $author$project$Pages$Ingredients$Complex$View$viewFoods = function (main) {
	var _v0 = A2($author$project$Pages$Util$DictListUtil$existsValue, $author$project$Util$Editing$isUpdate, main.i$) ? _Utils_Tuple2('Factor', 'Unit') : _Utils_Tuple2('', '');
	var factor = _v0.a;
	var unit = _v0.b;
	return A2(
		$author$project$Pages$Util$Choice$View$viewChoices,
		{
			iX: _List_fromArray(
				[
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Name')
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.M]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(factor)
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.M]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(unit)
								]))
						]))
				]),
			jA: F2(
				function (complexFood, creation) {
					var validInput = $author$project$Pages$Util$ValidatedInput$isValid(creation.f9);
					var cancelMsg = $author$project$Pages$Util$Choice$Page$DeselectChoice(complexFood.hk);
					var addMsg = $author$project$Pages$Util$Choice$Page$Create(complexFood.hk);
					return {
						H: _List_fromArray(
							[
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.H]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										$elm_community$maybe_extra$Maybe$Extra$values(
											_List_fromArray(
												[
													$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.a0.d4),
													$author$project$Util$MaybeUtil$defined(
													$elm$html$Html$Attributes$disabled(!validInput)),
													A2(
													$author$project$Util$MaybeUtil$optional,
													validInput,
													$elm$html$Html$Events$onClick(addMsg))
												])),
										_List_fromArray(
											[
												$elm$html$Html$text('Add')
											]))
									])),
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.H]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$author$project$Pages$Util$Style$classes.a0.iR,
												$elm$html$Html$Events$onClick(cancelMsg)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									]))
							]),
						d8: _List_fromArray(
							[
								{
								S: _List_fromArray(
									[$author$project$Pages$Util$Style$classes.ec]),
								T: _List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(complexFood.gN)
											]))
									])
							},
								{
								S: _List_fromArray(
									[$author$project$Pages$Util$Style$classes.cW]),
								T: _List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										$elm_community$maybe_extra$Maybe$Extra$values(
											_List_fromArray(
												[
													$author$project$Util$MaybeUtil$defined(
													$elm$html$Html$Attributes$value(creation.f9.mx)),
													$author$project$Util$MaybeUtil$defined(
													$elm$html$Html$Events$onInput(
														A2(
															$elm$core$Basics$composeR,
															A2(
																$elm_community$basics_extra$Basics$Extra$flip,
																$author$project$Pages$Util$ValidatedInput$lift($author$project$Pages$Ingredients$ComplexIngredientCreationClientInput$lenses.f9).eW,
																creation),
															$author$project$Pages$Util$Choice$Page$UpdateCreation))),
													$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.M),
													$author$project$Util$MaybeUtil$defined(
													$author$project$Pages$Util$HtmlUtil$onEscape(cancelMsg)),
													A2(
													$author$project$Util$MaybeUtil$optional,
													validInput,
													$elm_community$html_extra$Html$Events$Extra$onEnter(addMsg))
												])),
										_List_Nil)
									])
							},
								{
								S: _List_fromArray(
									[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.M]),
								T: _List_fromArray(
									[
										A3(
										$abadi199$elm_input_extra$Dropdown$dropdown,
										{
											f3: $elm$core$Maybe$Nothing,
											gy: $author$project$Pages$Ingredients$Complex$View$unitDropdownItems(complexFood),
											g0: function (u) {
												return $author$project$Pages$Util$Choice$Page$UpdateCreation(
													A3(
														$elm$core$Basics$apR,
														A2($elm$core$Maybe$andThen, $author$project$Api$Types$ScalingMode$fromString, u),
														A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$core$Basics$identity, $author$project$Pages$Ingredients$ComplexIngredientCreationClientInput$lenses.hv.eW),
														creation));
											}
										},
										_List_Nil,
										$elm$core$Maybe$Just(
											$author$project$Api$Types$ScalingMode$toString(creation.hv)))
									])
							}
							])
					};
				}),
			j6: function ($) {
				return $.hk;
			},
			kC: function (string) {
				return A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.gN;
					},
					$author$project$Util$SearchUtil$search(string));
			},
			mg: function ($) {
				return $.gN;
			},
			mR: function (complexFood) {
				var exists = A2(
					$author$project$Pages$Util$DictListUtil$existsValue,
					function (complexIngredient) {
						return _Utils_eq(complexIngredient.ln.fN, complexFood.hk);
					},
					main.jD);
				var _v1 = exists ? _Utils_Tuple2(
					'Added',
					_List_fromArray(
						[
							$author$project$Pages$Util$Style$classes.a0.eb,
							$elm$html$Html$Attributes$disabled(true)
						])) : _Utils_Tuple2(
					'Select',
					_List_fromArray(
						[
							$author$project$Pages$Util$Style$classes.a0.d4,
							$elm$html$Html$Events$onClick(
							$author$project$Pages$Util$Choice$Page$SelectChoice(complexFood))
						]));
				var selectName = _v1.a;
				var selectStyles = _v1.b;
				return {
					H: _List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									selectStyles,
									_List_fromArray(
										[
											$elm$html$Html$text(selectName)
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									$author$project$Pages$Util$NavigationUtil$recipeEditorLinkButton(complexFood.hk)
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									$author$project$Pages$Util$NavigationUtil$recipeNutrientsLinkButton(complexFood.hk)
								]))
						]),
					d8: _List_fromArray(
						[
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.ec]),
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(complexFood.gN)
										]))
								])
						},
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.cW]),
							T: _List_Nil
						},
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.cW]),
							T: _List_Nil
						}
						])
				};
			}
		},
		main);
};
var $author$project$Pages$Ingredients$IngredientCreationClientInput$amountUnit = A2(
	$arturopala$elm_monocle$Monocle$Lens$Lens,
	function ($) {
		return $.fs;
	},
	F2(
		function (b, a) {
			return _Utils_update(
				a,
				{fs: b});
		}));
var $author$project$Pages$Ingredients$AmountUnitClientInput$lenses = {
	f9: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.f9;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{f9: b});
			})),
	gH: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.gH;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{gH: b});
			}))
};
var $author$project$Pages$Ingredients$Plain$View$onChangeDropdown = function (ps) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$andThen($elm$core$String$toInt),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$withDefault(
				ps.et(ps.cM)),
			A2(
				$elm$core$Basics$composeR,
				A2(
					$elm_community$basics_extra$Basics$Extra$flip,
					A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Ingredients$AmountUnitClientInput$lenses.gH, ps.d_).eW,
					ps.cM),
				ps.ev)));
};
var $author$project$Pages$Ingredients$Plain$View$startingDropdownUnit = function (measure) {
	return {
		jH: true,
		mx: measure.gN,
		ig: $elm$core$String$fromInt(measure.gn)
	};
};
var $author$project$Pages$Ingredients$Plain$View$viewFoods = function (main) {
	var _v0 = A2($author$project$Pages$Util$DictListUtil$existsValue, $author$project$Util$Editing$isUpdate, main.i$) ? _Utils_Tuple2('Amount', 'Unit') : _Utils_Tuple2('', '');
	var amount = _v0.a;
	var unit = _v0.b;
	return A2(
		$author$project$Pages$Util$Choice$View$viewChoices,
		{
			iX: _List_fromArray(
				[
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Name')
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.M]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(amount)
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.M]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(unit)
								]))
						]))
				]),
			jA: F2(
				function (food, creation) {
					var validInput = $author$project$Pages$Util$ValidatedInput$isValid(creation.fs.f9);
					var cancelMsg = $author$project$Pages$Util$Choice$Page$DeselectChoice(food.gn);
					var addMsg = $author$project$Pages$Util$Choice$Page$Create(food.gn);
					var _v1 = A2(
						$author$project$Pages$Util$DictListUtil$existsValue,
						function (ingredient) {
							return _Utils_eq(ingredient.ln.gd, creation.gd);
						},
						main.jD) ? _Utils_Tuple2('Add again', $author$project$Pages$Util$Style$classes.a0.eb) : _Utils_Tuple2('Add', $author$project$Pages$Util$Style$classes.a0.d4);
					var confirmName = _v1.a;
					var confirmStyle = _v1.b;
					return {
						H: _List_fromArray(
							[
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.H]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												confirmStyle,
												$elm$html$Html$Attributes$disabled(!validInput),
												$elm$html$Html$Events$onClick(addMsg)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(confirmName)
											]))
									])),
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.H]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$author$project$Pages$Util$Style$classes.a0.iR,
												$elm$html$Html$Events$onClick(cancelMsg)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									]))
							]),
						d8: _List_fromArray(
							[
								{
								S: _List_fromArray(
									[$author$project$Pages$Util$Style$classes.ec]),
								T: _List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(food.gN)
											]))
									])
							},
								{
								S: _List_fromArray(
									[$author$project$Pages$Util$Style$classes.cW]),
								T: _List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										$elm_community$maybe_extra$Maybe$Extra$values(
											_List_fromArray(
												[
													$author$project$Util$MaybeUtil$defined(
													$elm$html$Html$Attributes$value(creation.fs.f9.mx)),
													$author$project$Util$MaybeUtil$defined(
													$elm$html$Html$Events$onInput(
														A2(
															$elm$core$Basics$composeR,
															A2(
																$elm_community$basics_extra$Basics$Extra$flip,
																$author$project$Pages$Util$ValidatedInput$lift(
																	A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Ingredients$AmountUnitClientInput$lenses.f9, $author$project$Pages$Ingredients$IngredientCreationClientInput$amountUnit)).eW,
																creation),
															$author$project$Pages$Util$Choice$Page$UpdateCreation))),
													$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.M),
													$author$project$Util$MaybeUtil$defined(
													$author$project$Pages$Util$HtmlUtil$onEscape(cancelMsg)),
													A2(
													$author$project$Util$MaybeUtil$optional,
													validInput,
													$elm_community$html_extra$Html$Events$Extra$onEnter(addMsg))
												])),
										_List_Nil)
									])
							},
								{
								S: _List_fromArray(
									[$author$project$Pages$Util$Style$classes.cW]),
								T: _List_fromArray(
									[
										A3(
										$abadi199$elm_input_extra$Dropdown$dropdown,
										{
											f3: $elm$core$Maybe$Nothing,
											gy: A2($elm$core$List$map, $author$project$Pages$Ingredients$Plain$View$startingDropdownUnit, food.kI),
											g0: $author$project$Pages$Ingredients$Plain$View$onChangeDropdown(
												{
													d_: $author$project$Pages$Ingredients$IngredientCreationClientInput$amountUnit,
													cM: creation,
													et: A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.fs;
														},
														function ($) {
															return $.gH;
														}),
													ev: $author$project$Pages$Util$Choice$Page$UpdateCreation
												})
										},
										_List_fromArray(
											[
												$author$project$Pages$Util$Style$classes.M,
												$author$project$Pages$Util$HtmlUtil$onEscape(cancelMsg)
											]),
										$elm$core$Maybe$Just(
											$elm$core$String$fromInt(creation.fs.gH)))
									])
							}
							])
					};
				}),
			j6: function ($) {
				return $.gn;
			},
			kC: function (string) {
				return A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.gN;
					},
					$author$project$Util$SearchUtil$search(string));
			},
			mg: function ($) {
				return $.gN;
			},
			mR: function (food) {
				return {
					H: _List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.a0.l6,
											$elm$html$Html$Events$onClick(
											$author$project$Pages$Util$Choice$Page$SelectChoice(food))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Select')
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									$author$project$Pages$Util$Links$linkButton(
									{
										S: _List_fromArray(
											[$author$project$Pages$Util$Style$classes.a0.k8]),
										T: _List_fromArray(
											[
												$elm$html$Html$text('Nutrients')
											]),
										id: $author$project$Pages$Util$Links$frontendPage(
											$author$project$Addresses$Frontend$statisticsFoodSelect.iA(food.gn))
									})
								]))
						]),
					d8: _List_fromArray(
						[
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.ec]),
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(food.gN)
										]))
								])
						},
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.cW]),
							T: _List_Nil
						},
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.cW]),
							T: _List_Nil
						}
						])
				};
			}
		},
		main);
};
var $author$project$Pages$Ingredients$IngredientUpdateClientInput$lenses = {
	fs: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.fs;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{fs: b});
			}))
};
var $author$project$Pages$Ingredients$Plain$View$measureOfFood = F2(
	function (measureId, food) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			function (measure) {
				return _Utils_eq(measure.gn, measureId);
			},
			food.kI);
	});
var $author$project$Pages$Ingredients$Plain$View$viewIngredients = function (main) {
	var unitDropdown = function (foodId) {
		return A2(
			$elm$core$List$map,
			$author$project$Pages$Ingredients$Plain$View$startingDropdownUnit,
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				_List_Nil,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ln;
					},
					function ($) {
						return $.kI;
					}),
				A2($author$project$Util$DictList$get, foodId, main.i$)));
	};
	return A2(
		$author$project$Pages$Util$Choice$View$viewElements,
		{
			iZ: function ($) {
				return $.gd;
			},
			eb: F2(
				function (ingredient, ingredientUpdateClientInput) {
					var food = A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.ln;
						},
						A2($author$project$Util$DictList$get, ingredient.gd, main.i$));
					var maybeMeasure = A2(
						$elm$core$Maybe$andThen,
						$author$project$Pages$Ingredients$Plain$View$measureOfFood(ingredient.fs.gH),
						food);
					return _List_fromArray(
						[
							{
							S: _List_Nil,
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3(
												$elm_community$maybe_extra$Maybe$Extra$unwrap,
												'',
												function ($) {
													return $.gN;
												},
												food))
										]))
								])
						},
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.cW]),
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(ingredientUpdateClientInput.fs.f9.mx),
											$elm$html$Html$Events$onInput(
											A2(
												$elm$core$Basics$composeR,
												A2(
													$elm_community$basics_extra$Basics$Extra$flip,
													$author$project$Pages$Util$ValidatedInput$lift(
														A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Ingredients$AmountUnitClientInput$lenses.f9, $author$project$Pages$Ingredients$IngredientUpdateClientInput$lenses.fs)).eW,
													ingredientUpdateClientInput),
												$author$project$Pages$Util$Choice$Page$Edit(ingredient.gn))),
											$author$project$Pages$Util$Style$classes.M
										]),
									_List_Nil)
								])
						},
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.cW]),
							T: _List_fromArray(
								[
									A3(
									$abadi199$elm_input_extra$Dropdown$dropdown,
									{
										f3: A2($elm$core$Maybe$map, $author$project$Pages$Ingredients$Plain$View$startingDropdownUnit, maybeMeasure),
										gy: unitDropdown(ingredient.gd),
										g0: $author$project$Pages$Ingredients$Plain$View$onChangeDropdown(
											{
												d_: $author$project$Pages$Ingredients$IngredientUpdateClientInput$lenses.fs,
												cM: ingredientUpdateClientInput,
												et: A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.fs;
													},
													function ($) {
														return $.gH;
													}),
												ev: $author$project$Pages$Util$Choice$Page$Edit(ingredient.gn)
											})
									},
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.M]),
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.gN;
										},
										maybeMeasure))
								])
						}
						]);
				}),
			jC: _List_fromArray(
				[
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Name')
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.M]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Amount')
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.M]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Unit')
								]))
						]))
				]),
			j7: function ($) {
				return $.gn;
			},
			kd: function (ingredient) {
				var food = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.ln;
					},
					A2($author$project$Util$DictList$get, ingredient.gd, main.i$));
				return {
					H: _List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.a0.eb,
											$elm$html$Html$Events$onClick(
											$author$project$Pages$Util$Choice$Page$EnterEdit(ingredient.gn))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.a0.af,
											$elm$html$Html$Events$onClick(
											$author$project$Pages$Util$Choice$Page$RequestDelete(ingredient.gn))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									$author$project$Pages$Util$Links$linkButton(
									{
										S: _List_fromArray(
											[$author$project$Pages$Util$Style$classes.a0.k8]),
										T: _List_fromArray(
											[
												$elm$html$Html$text('Nutrients')
											]),
										id: $author$project$Pages$Util$Links$frontendPage(
											$author$project$Addresses$Frontend$statisticsFoodSelect.iA(ingredient.gd))
									})
								]))
						]),
					d8: _List_fromArray(
						[
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.ec]),
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3(
												$elm_community$maybe_extra$Maybe$Extra$unwrap,
												'',
												function ($) {
													return $.gN;
												},
												food))
										]))
								])
						},
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.M]),
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromFloat(ingredient.fs.f9))
										]))
								])
						},
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.M]),
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3(
												$elm_community$maybe_extra$Maybe$Extra$unwrap,
												'',
												function ($) {
													return $.gN;
												},
												A2(
													$elm$core$Maybe$andThen,
													$author$project$Pages$Ingredients$Plain$View$measureOfFood(ingredient.fs.gH),
													food)))
										]))
								])
						}
						])
				};
			},
			ko: A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.fs;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.f9;
					},
					$author$project$Pages$Util$ValidatedInput$isValid)),
			kT: function ($) {
				return $.gN;
			}
		},
		main);
};
var $author$project$Pages$Util$Parent$Page$CancelDelete = {$: 8};
var $author$project$Pages$Util$Parent$Page$ConfirmDelete = {$: 7};
var $author$project$Pages$Util$Parent$Page$Duplicate = {$: 10};
var $author$project$Pages$Util$Parent$Page$Edit = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Util$Parent$Page$EnterEdit = {$: 4};
var $author$project$Pages$Util$Parent$Page$ExitEdit = {$: 5};
var $author$project$Pages$Util$Parent$Page$RequestDelete = {$: 6};
var $author$project$Pages$Ingredients$Recipe$Page$Rescale = {$: 1};
var $author$project$Pages$Util$Parent$Page$SaveEdit = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Util$Parent$Page$ToggleControls = {$: 13};
var $author$project$Pages$Util$ParentEditor$View$controlsRowWith = function (ps) {
	return A2(
		$elm$html$Html$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$colspan(ps.i1)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$table,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.jF]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_fromArray(
											[$author$project$Pages$Util$Style$classes.H]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												$elm_community$maybe_extra$Maybe$Extra$values(
													_List_fromArray(
														[
															$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.a0.d4),
															$author$project$Util$MaybeUtil$defined(
															$elm$html$Html$Attributes$disabled(!ps.mO)),
															A2(
															$author$project$Util$MaybeUtil$optional,
															ps.mO,
															$elm$html$Html$Events$onClick(ps.d4.gM))
														])),
												_List_fromArray(
													[
														$elm$html$Html$text(ps.d4.gN)
													]))
											])),
										A2(
										$elm$html$Html$td,
										_List_fromArray(
											[$author$project$Pages$Util$Style$classes.H]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$author$project$Pages$Util$Style$classes.a0.iR,
														$elm$html$Html$Events$onClick(ps.iR.gM)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(ps.iR.gN)
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Recipes$View$editRecipeLineWith = F2(
	function (handling, editedValue) {
		var validInput = A2(
			$elm$core$List$all,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$author$project$Pages$Util$ValidatedInput$isValid(
					handling.kR.jY(editedValue)),
					$author$project$Pages$Util$ValidatedInput$isValid(
					handling.k6.jY(editedValue))
				]));
		var validatedSaveAction = A2(
			$author$project$Util$MaybeUtil$optional,
			validInput,
			$elm_community$html_extra$Html$Events$Extra$onEnter(handling.l2));
		var infoColumns = _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.ec]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						$elm_community$maybe_extra$Maybe$Extra$values(
							_List_fromArray(
								[
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Attributes$value(
										handling.kR.jY(editedValue).mx)),
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Events$onInput(
										A2(
											$elm$core$Basics$composeR,
											A2(
												$elm_community$basics_extra$Basics$Extra$flip,
												$author$project$Pages$Util$ValidatedInput$lift(handling.kR).eW,
												editedValue),
											handling.mK))),
									$author$project$Util$MaybeUtil$defined(
									$author$project$Pages$Util$HtmlUtil$onEscape(handling.iS)),
									validatedSaveAction
								])),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.ec]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						$elm_community$maybe_extra$Maybe$Extra$values(
							_List_fromArray(
								[
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Attributes$value(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											handling.jt.jY(editedValue)))),
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Events$onInput(
										A2(
											$elm$core$Basics$composeR,
											A2(
												$elm_community$basics_extra$Basics$Extra$flip,
												A2(
													$elm$core$Basics$composeR,
													$elm$core$Maybe$Just,
													A2(
														$elm$core$Basics$composeR,
														$elm_community$maybe_extra$Maybe$Extra$filter(
															A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)),
														handling.jt.eW)),
												editedValue),
											handling.mK))),
									$author$project$Util$MaybeUtil$defined(
									$author$project$Pages$Util$HtmlUtil$onEscape(handling.iS)),
									validatedSaveAction
								])),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.cW]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						$elm_community$maybe_extra$Maybe$Extra$values(
							_List_fromArray(
								[
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Attributes$value(
										handling.k6.jY(editedValue).mx)),
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Events$onInput(
										A2(
											$elm$core$Basics$composeR,
											A2(
												$elm_community$basics_extra$Basics$Extra$flip,
												$author$project$Pages$Util$ValidatedInput$lift(handling.k6).eW,
												editedValue),
											handling.mK))),
									$author$project$Util$MaybeUtil$defined(
									$author$project$Pages$Util$HtmlUtil$onEscape(handling.iS)),
									$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.M),
									validatedSaveAction
								])),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.cW]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						$elm_community$maybe_extra$Maybe$Extra$values(
							_List_fromArray(
								[
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Attributes$value(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											handling.l8.jY(editedValue)))),
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Events$onInput(
										A2(
											$elm$core$Basics$composeR,
											A2(
												$elm_community$basics_extra$Basics$Extra$flip,
												A2(
													$elm$core$Basics$composeR,
													$elm$core$Maybe$Just,
													A2(
														$elm$core$Basics$composeR,
														$elm_community$maybe_extra$Maybe$Extra$filter(
															A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)),
														handling.l8.eW)),
												editedValue),
											handling.mK))),
									$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.M),
									$author$project$Util$MaybeUtil$defined(
									$author$project$Pages$Util$HtmlUtil$onEscape(handling.iS)),
									validatedSaveAction
								])),
						_List_Nil)
					]))
			]);
		var controlsRow = $author$project$Pages$Util$ParentEditor$View$controlsRowWith(
			{
				iR: {gM: handling.iS, gN: handling.iT},
				i1: $elm$core$List$length(infoColumns),
				d4: {gM: handling.l2, gN: handling.ja},
				mO: validInput
			});
		var commandToggle = A2(
			$elm$core$List$map,
			$author$project$Pages$Util$HtmlUtil$toggleControlsCell,
			$elm_community$maybe_extra$Maybe$Extra$toList(handling.mE));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				handling.l_,
				_Utils_ap(infoColumns, commandToggle)),
				controlsRow
			]);
	});
var $elm_community$result_extra$Result$Extra$isOk = function (x) {
	if (!x.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$Recipes$Util$isRescalableServingSize = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run($author$project$Pages$Recipes$Util$gramsParser),
	$elm_community$result_extra$Result$Extra$isOk);
var $author$project$Pages$Recipes$RecipeUpdateClientInput$lenses = {
	fX: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.fX;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{fX: b});
			})),
	gN: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.gN;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{gN: b});
			})),
	gY: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.gY;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{gY: b});
			})),
	hF: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.hF;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{hF: b});
			}))
};
var $author$project$Pages$Util$ParentEditor$View$lineWith = F2(
	function (ps, parent) {
		var row = ps.l$(parent);
		var displayColumns = A2(
			$elm$core$List$map,
			$author$project$Pages$Util$HtmlUtil$withExtraAttributes(
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(ps.h4)
					])),
			row.d8);
		var infoRow = A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.jx]),
			_Utils_ap(
				displayColumns,
				_List_fromArray(
					[
						$author$project$Pages$Util$HtmlUtil$toggleControlsCell(ps.h4)
					])));
		var controlsRow = A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$colspan(
							$elm$core$List$length(displayColumns))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$table,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.jF]),
							_List_fromArray(
								[
									A2($elm$html$Html$tr, _List_Nil, row.H)
								]))
						]))
				]));
		return A2(
			$elm$core$List$cons,
			infoRow,
			ps.hH ? _List_fromArray(
				[controlsRow]) : _List_Nil);
	});
var $author$project$Pages$Recipes$View$recipeLineWith = function (ps) {
	return $author$project$Pages$Util$ParentEditor$View$lineWith(
		{
			l$: function (recipe) {
				return {
					H: ps.H,
					d8: $author$project$Pages$Recipes$View$recipeInfoColumns(recipe)
				};
			},
			hH: ps.hH,
			h4: ps.h4
		});
};
var $author$project$Pages$Util$ParentEditor$View$tableHeaderWith = function (ps) {
	return A2(
		$elm$html$Html$thead,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.mt, ps.mo]),
				_Utils_ap(
					ps.i2,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$th,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.h2]),
							_List_Nil)
						])))
			]));
};
var $author$project$Pages$Recipes$View$tableHeader = $author$project$Pages$Util$ParentEditor$View$tableHeaderWith(
	{
		i2: _List_fromArray(
			[
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Name')
							]))
					])),
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Description')
							]))
					])),
				A2(
				$elm$html$Html$th,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.M]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Servings')
							]))
					])),
				A2(
				$elm$html$Html$th,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.M]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Serving size')
							]))
					]))
			]),
		mo: $author$project$Pages$Util$Style$classes.lE
	});
var $author$project$Pages$Util$Parent$View$viewMain = F2(
	function (ps, main) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.jF]),
			A2(
				$elm$core$List$cons,
				ps.mt,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$author$project$Util$Editing$unpack,
							{la: ps.la, lh: ps.lh, lk: ps.lk},
							main.g4))
					])));
	});
var $author$project$Pages$Ingredients$Recipe$View$viewMain = function (main) {
	var rescalable = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, false, $author$project$Pages$Recipes$Util$isRescalableServingSize, main.g4.ln.hF);
	var rescalableCmd = rescalable ? _List_fromArray(
		[
			$elm$html$Html$Events$onClick($author$project$Pages$Ingredients$Recipe$Page$Rescale)
		]) : _List_Nil;
	return A2(
		$author$project$Pages$Util$Parent$View$viewMain,
		{
			la: $author$project$Pages$Recipes$View$recipeLineWith(
				{
					H: _List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.a0.af,
											$elm$html$Html$Events$onClick(
											$author$project$Pages$Ingredients$Recipe$Page$ParentMsg($author$project$Pages$Util$Parent$Page$ConfirmDelete))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete?')
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.a0.d4,
											$elm$html$Html$Events$onClick(
											$author$project$Pages$Ingredients$Recipe$Page$ParentMsg($author$project$Pages$Util$Parent$Page$CancelDelete))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Cancel')
										]))
								]))
						]),
					hH: true,
					h4: $author$project$Pages$Ingredients$Recipe$Page$ParentMsg($author$project$Pages$Util$Parent$Page$ToggleControls)
				}),
			lh: $elm$core$Basics$always(
				$author$project$Pages$Recipes$View$editRecipeLineWith(
					{
						iS: $author$project$Pages$Ingredients$Recipe$Page$ParentMsg($author$project$Pages$Util$Parent$Page$ExitEdit),
						iT: 'Cancel',
						ja: 'Save',
						jt: $author$project$Pages$Recipes$RecipeUpdateClientInput$lenses.fX,
						kR: $author$project$Pages$Recipes$RecipeUpdateClientInput$lenses.gN,
						k6: $author$project$Pages$Recipes$RecipeUpdateClientInput$lenses.gY,
						l_: _List_Nil,
						l2: $author$project$Pages$Ingredients$Recipe$Page$ParentMsg(
							$author$project$Pages$Util$Parent$Page$SaveEdit(main.g4.ln)),
						l8: $author$project$Pages$Recipes$RecipeUpdateClientInput$lenses.hF,
						mE: $elm$core$Maybe$Just(
							$author$project$Pages$Ingredients$Recipe$Page$ParentMsg($author$project$Pages$Util$Parent$Page$ToggleControls)),
						mK: A2($elm$core$Basics$composeL, $author$project$Pages$Ingredients$Recipe$Page$ParentMsg, $author$project$Pages$Util$Parent$Page$Edit)
					})),
			lk: F2(
				function (recipe, showControls) {
					return A2(
						$author$project$Pages$Recipes$View$recipeLineWith,
						{
							H: _List_fromArray(
								[
									A2(
									$elm$html$Html$td,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.H]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$author$project$Pages$Util$Style$classes.a0.eb,
													$elm$html$Html$Events$onClick(
													$author$project$Pages$Ingredients$Recipe$Page$ParentMsg($author$project$Pages$Util$Parent$Page$EnterEdit))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Edit')
												]))
										])),
									A2(
									$elm$html$Html$td,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.H]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$author$project$Pages$Util$Style$classes.a0.af,
													$elm$html$Html$Events$onClick(
													$author$project$Pages$Ingredients$Recipe$Page$ParentMsg($author$project$Pages$Util$Parent$Page$RequestDelete))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Delete')
												]))
										])),
									A2(
									$elm$html$Html$td,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.H]),
									_List_fromArray(
										[
											$author$project$Pages$Util$Links$linkButton(
											{
												S: _List_fromArray(
													[$author$project$Pages$Util$Style$classes.a0.k8]),
												T: _List_fromArray(
													[
														$elm$html$Html$text('Nutrients')
													]),
												id: $author$project$Pages$Util$Links$frontendPage(
													$author$project$Addresses$Frontend$statisticsRecipeSelect.iA(main.g4.ln.gn))
											})
										])),
									A2(
									$elm$html$Html$td,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.H]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$author$project$Pages$Util$Style$classes.a0.d4,
													$elm$html$Html$Events$onClick(
													$author$project$Pages$Ingredients$Recipe$Page$ParentMsg($author$project$Pages$Util$Parent$Page$Duplicate))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Duplicate')
												]))
										])),
									A2(
									$elm$html$Html$td,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.H]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_Utils_ap(
												_List_fromArray(
													[
														$author$project$Pages$Util$Style$classes.a0.lW,
														$elm$html$Html$Attributes$disabled(!rescalable)
													]),
												rescalableCmd),
											_List_fromArray(
												[
													$elm$html$Html$text('Rescale')
												]))
										]))
								]),
							hH: showControls,
							h4: $author$project$Pages$Ingredients$Recipe$Page$ParentMsg($author$project$Pages$Util$Parent$Page$ToggleControls)
						},
						recipe);
				}),
			mt: $author$project$Pages$Recipes$View$tableHeader
		},
		main);
};
var $author$project$Pages$Ingredients$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{jg: $elm$core$Maybe$Nothing, me: true},
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[$author$project$Pages$Util$Style$ids.kf]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Ingredients$Page$RecipeMsg,
							$author$project$Pages$Ingredients$Recipe$View$viewMain(main.lD))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.jD]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Ingredients')
								]))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Ingredients$Page$IngredientMsg,
					$author$project$Pages$Ingredients$Plain$View$viewIngredients(main.em)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.jD]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Complex ingredients')
								]))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Ingredients$Page$ComplexIngredientMsg,
					$author$project$Pages$Ingredients$Complex$View$viewComplexIngredients(main.fO)),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$disabled(!main.jT),
									$elm$html$Html$Events$onClick(
									$author$project$Pages$Ingredients$Page$ChangeFoodsMode(0)),
									$author$project$Pages$Util$Style$classes.a0.fo
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Ingredients')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$disabled(main.jT === 1),
									$elm$html$Html$Events$onClick(
									$author$project$Pages$Ingredients$Page$ChangeFoodsMode(1)),
									$author$project$Pages$Util$Style$classes.a0.fo
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Complex ingredients')
								]))
						])),
					function () {
					var _v0 = main.jT;
					if (!_v0) {
						return A2(
							$elm$html$Html$map,
							$author$project$Pages$Ingredients$Page$IngredientMsg,
							$author$project$Pages$Ingredients$Plain$View$viewFoods(main.em));
					} else {
						return A2(
							$elm$html$Html$map,
							$author$project$Pages$Ingredients$Page$ComplexIngredientMsg,
							$author$project$Pages$Ingredients$Complex$View$viewFoods(main.fO));
					}
				}()
				])));
};
var $author$project$Pages$Ingredients$View$view = $author$project$Pages$View$Tristate$view(
	{md: true, mT: $author$project$Pages$Ingredients$View$viewMain});
var $elm$html$Html$article = _VirtualDom_node('article');
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $elm$html$Html$p = _VirtualDom_node('p');
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$Pages$Landing$View$view = A2(
	$elm$html$Html$main_,
	_List_fromArray(
		[$author$project$Pages$Util$Style$classes.d4]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$article,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Foodie')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Track your meals, manage recipes, and monitor your nutrient intake.')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Create custom recipes, log daily meals, and view detailed nutritional statistics.')
								]))
						]))
				])),
			A2(
			$elm$html$Html$nav,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Pages$Util$Links$linkButton(
					{
						S: _List_fromArray(
							[$author$project$Pages$Util$Style$classes.a0.d4]),
						T: _List_fromArray(
							[
								$elm$html$Html$text('Log in')
							]),
						id: $author$project$Pages$Util$Links$frontendPage(
							$author$project$Addresses$Frontend$login.iA(0))
					}),
					$author$project$Pages$Util$Links$linkButton(
					{
						S: _List_fromArray(
							[$author$project$Pages$Util$Style$classes.a0.kY]),
						T: _List_fromArray(
							[
								$elm$html$Html$text('Create account')
							]),
						id: $author$project$Pages$Util$Links$frontendPage(
							$author$project$Addresses$Frontend$requestRegistration.iA(0))
					})
				]))
		]));
var $author$project$Pages$Login$Page$Login = {$: 2};
var $author$project$Pages$Util$ViewUtil$Login = 5;
var $author$project$Pages$Login$Page$SetNickname = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Login$Page$SetPassword = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$Pages$Login$View$viewMain = function (model) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{
			jg: $elm$core$Maybe$Just(5),
			me: false
		},
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.d4]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Nickname')
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$autocomplete(true),
									$elm$html$Html$Events$onInput($author$project$Pages$Login$Page$SetNickname),
									$elm_community$html_extra$Html$Events$Extra$onEnter($author$project$Pages$Login$Page$Login),
									$elm$html$Html$Attributes$value(model.ct.gU),
									$author$project$Pages$Util$Style$classes.ec
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Password')
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('password'),
									$elm$html$Html$Attributes$autocomplete(true),
									$elm$html$Html$Events$onInput($author$project$Pages$Login$Page$SetPassword),
									$elm_community$html_extra$Html$Events$Extra$onEnter($author$project$Pages$Login$Page$Login),
									$elm$html$Html$Attributes$value(model.ct.g5),
									$author$project$Pages$Util$Style$classes.ec
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Pages$Login$Page$Login),
									$author$project$Pages$Util$Style$classes.a0.d4
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Log In')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Util$Links$linkButton(
							{
								S: _List_fromArray(
									[$author$project$Pages$Util$Style$classes.a0.kY]),
								T: _List_fromArray(
									[
										$elm$html$Html$text('Create account')
									]),
								id: $author$project$Pages$Util$Links$frontendPage(
									$author$project$Addresses$Frontend$requestRegistration.iA(0))
							})
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Util$Links$linkButton(
							{
								S: _List_fromArray(
									[$author$project$Pages$Util$Style$classes.a0.kY]),
								T: _List_fromArray(
									[
										$elm$html$Html$text('Recover account')
									]),
								id: $author$project$Pages$Util$Links$frontendPage(
									$author$project$Addresses$Frontend$requestRecovery.iA(0))
							})
						]))
				])));
};
var $author$project$Pages$Login$View$view = $author$project$Pages$View$Tristate$view(
	{md: false, mT: $author$project$Pages$Login$View$viewMain});
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$ExpectingInt = {$: 1};
var $elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				fy: $elm$core$Result$Err(invalid),
				f8: expecting,
				gb: $elm$core$Result$Err(invalid),
				j$: $elm$core$Result$Err(invalid),
				gu: $elm$core$Result$Ok($elm$core$Basics$identity),
				kn: invalid,
				g_: $elm$core$Result$Err(invalid)
			});
	});
var $elm$parser$Parser$int = A2($elm$parser$Parser$Advanced$int, $elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $author$project$Pages$Util$DateUtil$intWithOptionalLeadingZero = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$andThen,
			$elm$core$Basics$always($elm$parser$Parser$int),
			$elm$parser$Parser$symbol('0')),
			$elm$parser$Parser$int
		]));
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $author$project$Pages$Util$DateUtil$dateParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($author$project$Api$Types$Date$Date),
			A2(
				$elm$parser$Parser$ignorer,
				$author$project$Pages$Util$DateUtil$intWithOptionalLeadingZero,
				$elm$parser$Parser$symbol('-'))),
		A2(
			$elm$parser$Parser$ignorer,
			$author$project$Pages$Util$DateUtil$intWithOptionalLeadingZero,
			$elm$parser$Parser$symbol('-'))),
	$author$project$Pages$Util$DateUtil$intWithOptionalLeadingZero);
var $author$project$Pages$Util$SimpleDateInput$lenses = {
	fR: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.fR;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{fR: b});
			})),
	h$: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.h$;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{h$: b});
			}))
};
var $author$project$Pages$Util$DateUtil$timeParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($author$project$Api$Types$Time$Time),
		A2(
			$elm$parser$Parser$ignorer,
			$author$project$Pages$Util$DateUtil$intWithOptionalLeadingZero,
			$elm$parser$Parser$symbol(':'))),
	$author$project$Pages$Util$DateUtil$intWithOptionalLeadingZero);
var $author$project$Pages$Util$DateUtil$timeToString = function (time) {
	return A2(
		$elm$core$String$join,
		':',
		A2(
			$elm$core$List$map,
			$author$project$Pages$Util$DateUtil$padToTwo,
			_List_fromArray(
				[time.gk, time.gJ])));
};
var $author$project$Pages$Meals$Editor$View$editMealLineWith = F3(
	function (handling, profileName, editedValue) {
		var name = A2(
			$elm$core$Maybe$withDefault,
			'',
			handling.kR.jZ(editedValue));
		var deepTimeLens = A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$SimpleDateInput$lenses.h$, handling.ji);
		var timeInteraction = A2(
			$elm$core$Basics$composeR,
			$elm$parser$Parser$run($author$project$Pages$Util$DateUtil$timeParser),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Result$toMaybe,
				A2(
					$elm$core$Basics$composeR,
					A2($elm_community$basics_extra$Basics$Extra$flip, deepTimeLens.eW, editedValue),
					handling.mK)));
		var deepDateLens = A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$SimpleDateInput$lenses.fR, handling.ji);
		var validatedSaveAction = A2(
			$author$project$Util$MaybeUtil$optional,
			$elm_community$maybe_extra$Maybe$Extra$isJust(
				deepDateLens.jY(editedValue)),
			$elm_community$html_extra$Html$Events$Extra$onEnter(handling.l2));
		var dateParsedInteraction = A2(
			$elm$core$Basics$composeR,
			$elm$parser$Parser$run($author$project$Pages$Util$DateUtil$dateParser),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Result$toMaybe,
				A2(
					$elm$core$Basics$composeR,
					A2($elm_community$basics_extra$Basics$Extra$flip, deepDateLens.eW, editedValue),
					handling.mK)));
		var date = handling.ji.jY(editedValue);
		var dateValue = $elm_community$maybe_extra$Maybe$Extra$toList(
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Pages$Util$DateUtil$dateToString, $elm$html$Html$Attributes$value),
				date.fR));
		var timeValue = $elm_community$maybe_extra$Maybe$Extra$toList(
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Pages$Util$DateUtil$timeToString, $elm$html$Html$Attributes$value),
				date.h$));
		var infoColumns = _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.fR]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_Utils_ap(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('date'),
									$author$project$Pages$Util$Style$classes.fR,
									$elm$html$Html$Events$onInput(dateParsedInteraction),
									$author$project$Pages$Util$HtmlUtil$onEscape(handling.iS)
								]),
							dateValue),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.h$]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_Utils_ap(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('time'),
									$author$project$Pages$Util$Style$classes.h$,
									$elm$html$Html$Events$onInput(timeInteraction),
									$author$project$Pages$Util$HtmlUtil$onEscape(handling.iS)
								]),
							timeValue),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.ec]),
				_List_fromArray(
					[
						$elm$html$Html$text(profileName)
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.ec]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						$elm_community$maybe_extra$Maybe$Extra$values(
							_List_fromArray(
								[
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Attributes$value(name)),
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Events$onInput(
										A2(
											$elm$core$Basics$composeR,
											A2($elm_community$basics_extra$Basics$Extra$flip, handling.kR.eW, editedValue),
											handling.mK))),
									$author$project$Util$MaybeUtil$defined(
									$author$project$Pages$Util$HtmlUtil$onEscape(handling.iS)),
									validatedSaveAction
								])),
						_List_Nil)
					]))
			]);
		var validInput = $elm_community$maybe_extra$Maybe$Extra$isJust(date.fR);
		var controlsRow = $author$project$Pages$Util$ParentEditor$View$controlsRowWith(
			{
				iR: {gM: handling.iS, gN: handling.iT},
				i1: $elm$core$List$length(infoColumns),
				d4: {gM: handling.l2, gN: handling.ja},
				mO: validInput
			});
		var commandToggle = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			A2($elm$core$Basics$composeR, $author$project$Pages$Util$HtmlUtil$toggleControlsCell, $elm$core$List$singleton),
			handling.mE);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				handling.l_,
				_Utils_ap(infoColumns, commandToggle)),
				controlsRow
			]);
	});
var $author$project$Pages$Meals$Editor$MealUpdateClientInput$lenses = {
	fR: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.fR;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{fR: b});
			})),
	gN: A2(
		$arturopala$elm_monocle$Monocle$Optional$Optional,
		function ($) {
			return $.gN;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{
						gN: A2(
							$elm_community$maybe_extra$Maybe$Extra$filter,
							A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not),
							$elm$core$Maybe$Just(b))
					});
			}))
};
var $author$project$Pages$Util$DateUtil$dateToPrettyString = function (date) {
	return A2(
		$elm$core$String$join,
		'.',
		A2(
			$elm$core$List$map,
			$author$project$Pages$Util$DateUtil$padToTwo,
			_List_fromArray(
				[date.iq, date.gL, date.fS])));
};
var $author$project$Pages$Meals$Editor$View$mealInfoColumns = F2(
	function (profileName, meal) {
		return _List_fromArray(
			[
				{
				S: _List_fromArray(
					[$author$project$Pages$Util$Style$classes.ec]),
				T: _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Pages$Util$DateUtil$dateToPrettyString(meal.fR.fR))
					])
			},
				{
				S: _List_fromArray(
					[$author$project$Pages$Util$Style$classes.ec]),
				T: _List_fromArray(
					[
						$elm$html$Html$text(
						A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $author$project$Pages$Util$DateUtil$timeToString, meal.fR.h$))
					])
			},
				{
				S: _List_fromArray(
					[$author$project$Pages$Util$Style$classes.ec]),
				T: _List_fromArray(
					[
						$elm$html$Html$text(profileName)
					])
			},
				{
				S: _List_fromArray(
					[$author$project$Pages$Util$Style$classes.ec]),
				T: _List_fromArray(
					[
						$elm$html$Html$text(
						A2($elm$core$Maybe$withDefault, '', meal.gN))
					])
			}
			]);
	});
var $author$project$Pages$Meals$Editor$View$mealLineWith = F2(
	function (ps, profileName) {
		return $author$project$Pages$Util$ParentEditor$View$lineWith(
			{
				l$: function (meal) {
					return {
						H: ps.H,
						d8: A2($author$project$Pages$Meals$Editor$View$mealInfoColumns, profileName, meal)
					};
				},
				hH: ps.hH,
				h4: ps.h4
			});
	});
var $author$project$Pages$Meals$Editor$View$tableHeader = $author$project$Pages$Util$ParentEditor$View$tableHeaderWith(
	{
		i2: _List_fromArray(
			[
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Date')
					])),
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Time')
					])),
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Profile')
					])),
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Name')
					]))
			]),
		mo: $author$project$Pages$Util$Style$classes.kE
	});
var $author$project$Pages$MealEntries$Meal$View$viewMain = F2(
	function (profile, main) {
		return A2(
			$author$project$Pages$Util$Parent$View$viewMain,
			{
				la: A2(
					$author$project$Pages$Meals$Editor$View$mealLineWith,
					{
						H: _List_fromArray(
							[
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.H]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$author$project$Pages$Util$Style$classes.a0.af,
												$elm$html$Html$Events$onClick($author$project$Pages$Util$Parent$Page$ConfirmDelete)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Delete?')
											]))
									])),
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.H]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$author$project$Pages$Util$Style$classes.a0.d4,
												$elm$html$Html$Events$onClick($author$project$Pages$Util$Parent$Page$CancelDelete)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									]))
							]),
						hH: true,
						h4: $author$project$Pages$Util$Parent$Page$ToggleControls
					},
					profile.gN),
				lh: $elm$core$Basics$always(
					A2(
						$author$project$Pages$Meals$Editor$View$editMealLineWith,
						{
							iS: $author$project$Pages$Util$Parent$Page$ExitEdit,
							iT: 'Cancel',
							ja: 'Save',
							ji: $author$project$Pages$Meals$Editor$MealUpdateClientInput$lenses.fR,
							kR: $author$project$Pages$Meals$Editor$MealUpdateClientInput$lenses.gN,
							l_: _List_Nil,
							l2: $author$project$Pages$Util$Parent$Page$SaveEdit(main.g4.ln),
							mE: $elm$core$Maybe$Just($author$project$Pages$Util$Parent$Page$ToggleControls),
							mK: $author$project$Pages$Util$Parent$Page$Edit
						},
						profile.gN)),
				lk: F2(
					function (meal, showControls) {
						return A3(
							$author$project$Pages$Meals$Editor$View$mealLineWith,
							{
								H: _List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_fromArray(
											[$author$project$Pages$Util$Style$classes.H]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$author$project$Pages$Util$Style$classes.a0.eb,
														$elm$html$Html$Events$onClick($author$project$Pages$Util$Parent$Page$EnterEdit)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Edit')
													]))
											])),
										A2(
										$elm$html$Html$td,
										_List_fromArray(
											[$author$project$Pages$Util$Style$classes.H]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$author$project$Pages$Util$Style$classes.a0.af,
														$elm$html$Html$Events$onClick($author$project$Pages$Util$Parent$Page$RequestDelete)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Delete')
													]))
											])),
										A2(
										$elm$html$Html$td,
										_List_fromArray(
											[$author$project$Pages$Util$Style$classes.H]),
										_List_fromArray(
											[
												$author$project$Pages$Util$Links$linkButton(
												{
													S: _List_fromArray(
														[$author$project$Pages$Util$Style$classes.a0.k8]),
													T: _List_fromArray(
														[
															$elm$html$Html$text('Nutrients')
														]),
													id: $author$project$Pages$Util$Links$frontendPage(
														$author$project$Addresses$Frontend$statisticsMealSelect.iA(
															_Utils_Tuple2(profile.gn, main.g4.ln.gn)))
												})
											])),
										A2(
										$elm$html$Html$td,
										_List_fromArray(
											[$author$project$Pages$Util$Style$classes.H]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$author$project$Pages$Util$Style$classes.a0.d4,
														$elm$html$Html$Events$onClick($author$project$Pages$Util$Parent$Page$Duplicate)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Duplicate')
													]))
											]))
									]),
								hH: showControls,
								h4: $author$project$Pages$Util$Parent$Page$ToggleControls
							},
							profile.gN,
							meal);
					}),
				mt: $author$project$Pages$Meals$Editor$View$tableHeader
			},
			main);
	});
var $author$project$Pages$MealEntries$MealEntryUpdateClientInput$lenses = {
	gY: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.gY;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{gY: b});
			}))
};
var $elm_community$list_extra$List$Extra$removeAt = F2(
	function (index, l) {
		if (index < 0) {
			return l;
		} else {
			var _v0 = A2($elm$core$List$drop, index, l);
			if (!_v0.b) {
				return l;
			} else {
				var rest = _v0.b;
				return _Utils_ap(
					A2($elm$core$List$take, index, l),
					rest);
			}
		}
	});
var $author$project$Pages$MealEntries$Entries$View$recipeInfo = A2(
	$elm$core$Basics$composeR,
	$author$project$Pages$Recipes$View$recipeInfoColumns,
	$elm_community$list_extra$List$Extra$removeAt(2));
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $author$project$Pages$MealEntries$Entries$View$recipeInfoFromMap = F2(
	function (recipes, recipeId) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			A2(
				$elm$core$List$repeat,
				4,
				{
					S: _List_fromArray(
						[$author$project$Pages$Util$Style$classes.ec]),
					T: _List_Nil
				}),
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ln;
				},
				$author$project$Pages$MealEntries$Entries$View$recipeInfo),
			A2($author$project$Util$DictList$get, recipeId, recipes));
	});
var $author$project$Pages$MealEntries$Entries$View$viewMealEntries = function (main) {
	return A2(
		$author$project$Pages$Util$Choice$View$viewElements,
		{
			iZ: function ($) {
				return $.hk;
			},
			eb: F2(
				function (mealEntry, mealEntryUpdateClientInput) {
					return _Utils_ap(
						A2($author$project$Pages$MealEntries$Entries$View$recipeInfoFromMap, main.i$, mealEntry.hk),
						_List_fromArray(
							[
								{
								S: _List_fromArray(
									[$author$project$Pages$Util$Style$classes.cW]),
								T: _List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$value(mealEntryUpdateClientInput.gY.mx),
												$elm$html$Html$Events$onInput(
												A2(
													$elm$core$Basics$composeR,
													A2(
														$elm_community$basics_extra$Basics$Extra$flip,
														$author$project$Pages$Util$ValidatedInput$lift($author$project$Pages$MealEntries$MealEntryUpdateClientInput$lenses.gY).eW,
														mealEntryUpdateClientInput),
													$author$project$Pages$Util$Choice$Page$Edit(mealEntry.gn))),
												$author$project$Pages$Util$Style$classes.M
											]),
										_List_Nil)
									])
							}
							]));
				}),
			jC: _List_fromArray(
				[
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Name')
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Description')
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.M]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Serving size')
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.M]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Servings')
								]))
						]))
				]),
			j7: function ($) {
				return $.gn;
			},
			kd: function (mealEntry) {
				return {
					H: _List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.a0.eb,
											$elm$html$Html$Events$onClick(
											$author$project$Pages$Util$Choice$Page$EnterEdit(mealEntry.gn))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.a0.af,
											$elm$html$Html$Events$onClick(
											$author$project$Pages$Util$Choice$Page$RequestDelete(mealEntry.gn))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									$author$project$Pages$Util$NavigationUtil$recipeEditorLinkButton(mealEntry.hk)
								]))
						]),
					d8: _Utils_ap(
						A2($author$project$Pages$MealEntries$Entries$View$recipeInfoFromMap, main.i$, mealEntry.hk),
						_List_fromArray(
							[
								{
								S: _List_fromArray(
									[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.M]),
								T: _List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$fromFloat(mealEntry.gY))
											]))
									])
							}
							]))
				};
			},
			ko: A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.gY;
				},
				$author$project$Pages$Util$ValidatedInput$isValid),
			kT: function ($) {
				return $.gN;
			}
		},
		main);
};
var $author$project$Pages$MealEntries$MealEntryCreationClientInput$lenses = {
	gY: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.gY;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{gY: b});
			}))
};
var $author$project$Pages$MealEntries$Entries$View$viewRecipes = function (main) {
	var numberOfServings = A2($author$project$Pages$Util$DictListUtil$existsValue, $author$project$Util$Editing$isUpdate, main.i$) ? 'Servings' : '';
	return A2(
		$author$project$Pages$Util$Choice$View$viewChoices,
		{
			iX: _List_fromArray(
				[
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Name')
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Description')
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.M]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Serving size')
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.M]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(numberOfServings)
								]))
						]))
				]),
			jA: F2(
				function (recipe, creation) {
					var validInput = $author$project$Pages$Util$ValidatedInput$isValid(creation.gY);
					var cancelMsg = $author$project$Pages$Util$Choice$Page$DeselectChoice(recipe.gn);
					var addMsg = $author$project$Pages$Util$Choice$Page$Create(recipe.gn);
					var _v0 = A2(
						$author$project$Pages$Util$DictListUtil$existsValue,
						function (mealEntry) {
							return _Utils_eq(mealEntry.ln.hk, creation.hk);
						},
						main.jD) ? _Utils_Tuple2('Add again', $author$project$Pages$Util$Style$classes.a0.eb) : _Utils_Tuple2('Add', $author$project$Pages$Util$Style$classes.a0.d4);
					var confirmName = _v0.a;
					var confirmStyle = _v0.b;
					return {
						H: _List_fromArray(
							[
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.H]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										$elm_community$maybe_extra$Maybe$Extra$values(
											_List_fromArray(
												[
													$author$project$Util$MaybeUtil$defined(confirmStyle),
													$author$project$Util$MaybeUtil$defined(
													$elm$html$Html$Attributes$disabled(!validInput)),
													A2(
													$author$project$Util$MaybeUtil$optional,
													validInput,
													$elm$html$Html$Events$onClick(addMsg))
												])),
										_List_fromArray(
											[
												$elm$html$Html$text(confirmName)
											]))
									])),
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.H]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$author$project$Pages$Util$Style$classes.a0.iR,
												$elm$html$Html$Events$onClick(cancelMsg)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									]))
							]),
						d8: _Utils_ap(
							$author$project$Pages$MealEntries$Entries$View$recipeInfo(recipe),
							_List_fromArray(
								[
									{
									S: _List_fromArray(
										[$author$project$Pages$Util$Style$classes.M]),
									T: _List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											$elm_community$maybe_extra$Maybe$Extra$values(
												_List_fromArray(
													[
														$author$project$Util$MaybeUtil$defined(
														$elm$html$Html$Attributes$value(creation.gY.mx)),
														$author$project$Util$MaybeUtil$defined(
														$elm$html$Html$Events$onInput(
															A2(
																$elm$core$Basics$composeR,
																A2(
																	$elm_community$basics_extra$Basics$Extra$flip,
																	$author$project$Pages$Util$ValidatedInput$lift($author$project$Pages$MealEntries$MealEntryCreationClientInput$lenses.gY).eW,
																	creation),
																$author$project$Pages$Util$Choice$Page$UpdateCreation))),
														$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.M),
														$author$project$Util$MaybeUtil$defined(
														$author$project$Pages$Util$HtmlUtil$onEscape(cancelMsg)),
														A2(
														$author$project$Util$MaybeUtil$optional,
														validInput,
														$elm_community$html_extra$Html$Events$Extra$onEnter(addMsg))
													])),
											_List_Nil)
										])
								}
								]))
					};
				}),
			j6: function ($) {
				return $.gn;
			},
			kC: F2(
				function (string, recipe) {
					return A2($author$project$Util$SearchUtil$search, string, recipe.gN) || A2(
						$author$project$Util$SearchUtil$search,
						string,
						A2($elm$core$Maybe$withDefault, '', recipe.fX));
				}),
			mg: function ($) {
				return $.gN;
			},
			mR: function (recipe) {
				var selectMsg = $author$project$Pages$Util$Choice$Page$SelectChoice(recipe);
				return {
					H: _List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.a0.l6,
											$elm$html$Html$Events$onClick(selectMsg)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Select')
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									$author$project$Pages$Util$NavigationUtil$recipeEditorLinkButton(recipe.gn)
								]))
						]),
					d8: _Utils_ap(
						$author$project$Pages$MealEntries$Entries$View$recipeInfo(recipe),
						_List_fromArray(
							[
								{
								S: _List_fromArray(
									[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.cW]),
								T: _List_Nil
							}
							]))
				};
			}
		},
		main);
};
var $author$project$Pages$MealEntries$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{jg: $elm$core$Maybe$Nothing, me: true},
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[$author$project$Pages$Util$Style$ids.kF]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$MealEntries$Page$MealMsg,
							A2($author$project$Pages$MealEntries$Meal$View$viewMain, main.ly, main.kD))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.jD]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Dishes')
								]))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Pages$MealEntries$Page$EntriesMsg,
					$author$project$Pages$MealEntries$Entries$View$viewMealEntries(main.f5)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.jD]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Recipes')
								]))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Pages$MealEntries$Page$EntriesMsg,
					$author$project$Pages$MealEntries$Entries$View$viewRecipes(main.f5))
				])));
};
var $author$project$Pages$MealEntries$View$view = $author$project$Pages$View$Tristate$view(
	{md: true, mT: $author$project$Pages$MealEntries$View$viewMain});
var $author$project$Pages$Util$ParentEditor$Page$SetPagination = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Util$ParentEditor$Page$SetSearchString = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Util$ParentEditor$Page$UpdateCreation = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Util$ParentEditor$Page$Create = {$: 2};
var $author$project$Pages$Meals$Editor$View$createMealLine = function (profileName) {
	return A2(
		$elm$core$Basics$composeR,
		A2(
			$author$project$Pages$Meals$Editor$View$editMealLineWith,
			{
				iS: $author$project$Pages$Util$ParentEditor$Page$UpdateCreation($elm$core$Maybe$Nothing),
				iT: 'Cancel',
				ja: 'Add',
				ji: $author$project$Pages$Meals$Editor$MealCreationClientInput$lenses.fR,
				kR: $author$project$Pages$Meals$Editor$MealCreationClientInput$lenses.gN,
				l_: _List_fromArray(
					[$author$project$Pages$Util$Style$classes.f0]),
				l2: $author$project$Pages$Util$ParentEditor$Page$Create,
				mE: $elm$core$Maybe$Nothing,
				mK: A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Pages$Util$ParentEditor$Page$UpdateCreation)
			},
			profileName),
		$elm$core$List$map(
			$elm$html$Html$map($author$project$Pages$Meals$Editor$Page$ParentEditorMsg)));
};
var $author$project$Pages$Util$SimpleDateInput$SimpleDateInput = F2(
	function (date, time) {
		return {fR: date, h$: time};
	});
var $author$project$Pages$Util$SimpleDateInput$default = A2($author$project$Pages$Util$SimpleDateInput$SimpleDateInput, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
var $author$project$Pages$Meals$Editor$MealCreationClientInput$default = {fR: $author$project$Pages$Util$SimpleDateInput$default, gN: $elm$core$Maybe$Nothing};
var $author$project$Pages$Util$ParentEditor$Page$CancelDelete = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Util$ParentEditor$Page$ConfirmDelete = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Util$ParentEditor$Page$ToggleControls = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Meals$Editor$View$deleteMealLine = F2(
	function (profileName, meal) {
		return A3(
			$author$project$Pages$Meals$Editor$View$mealLineWith,
			{
				H: A2(
					$elm$core$List$map,
					$elm$html$Html$map($author$project$Pages$Meals$Editor$Page$ParentEditorMsg),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.a0.af,
											$elm$html$Html$Events$onClick(
											$author$project$Pages$Util$ParentEditor$Page$ConfirmDelete(meal.gn))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete?')
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.a0.d4,
											$elm$html$Html$Events$onClick(
											$author$project$Pages$Util$ParentEditor$Page$CancelDelete(meal.gn))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Cancel')
										]))
								]))
						])),
				hH: true,
				h4: $author$project$Pages$Meals$Editor$Page$ParentEditorMsg(
					$author$project$Pages$Util$ParentEditor$Page$ToggleControls(meal.gn))
			},
			profileName,
			meal);
	});
var $elm$core$String$trim = _String_trim;
var $author$project$Pages$Util$DateUtil$toString = function (simpleDate) {
	return $elm$core$String$trim(
		A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					$author$project$Pages$Util$DateUtil$dateToString(simpleDate.fR),
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $author$project$Pages$Util$DateUtil$timeToString, simpleDate.h$)
				])));
};
var $author$project$Pages$Util$ParentEditor$Page$Edit = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Util$ParentEditor$Page$ExitEdit = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Util$ParentEditor$Page$SaveEdit = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Meals$Editor$View$updateMealLine = F2(
	function (profileName, mealId) {
		return A2(
			$elm$core$Basics$composeR,
			A2(
				$author$project$Pages$Meals$Editor$View$editMealLineWith,
				{
					iS: $author$project$Pages$Util$ParentEditor$Page$ExitEdit(mealId),
					iT: 'Cancel',
					ja: 'Save',
					ji: $author$project$Pages$Meals$Editor$MealUpdateClientInput$lenses.fR,
					kR: $author$project$Pages$Meals$Editor$MealUpdateClientInput$lenses.gN,
					l_: _List_fromArray(
						[$author$project$Pages$Util$Style$classes.f0]),
					l2: $author$project$Pages$Util$ParentEditor$Page$SaveEdit(mealId),
					mE: $elm$core$Maybe$Just(
						$author$project$Pages$Util$ParentEditor$Page$ToggleControls(mealId)),
					mK: $author$project$Pages$Util$ParentEditor$Page$Edit(mealId)
				},
				profileName),
			$elm$core$List$map(
				$elm$html$Html$map($author$project$Pages$Meals$Editor$Page$ParentEditorMsg)));
	});
var $author$project$Pages$Util$ParentEditor$Page$Duplicate = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Util$ParentEditor$Page$EnterEdit = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Util$ParentEditor$Page$RequestDelete = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Meals$Editor$View$viewMealLine = F3(
	function (profile, meal, showControls) {
		var mealKey = _Utils_Tuple2(profile.gn, meal.gn);
		return A3(
			$author$project$Pages$Meals$Editor$View$mealLineWith,
			{
				H: A2(
					$elm$core$List$map,
					$elm$html$Html$map($author$project$Pages$Meals$Editor$Page$ParentEditorMsg),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.a0.eb,
											$elm$html$Html$Events$onClick(
											$author$project$Pages$Util$ParentEditor$Page$EnterEdit(meal.gn))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									$author$project$Pages$Util$Links$linkButton(
									{
										S: _List_fromArray(
											[$author$project$Pages$Util$Style$classes.a0.jy]),
										T: _List_fromArray(
											[
												$elm$html$Html$text('Entries')
											]),
										id: $author$project$Pages$Util$Links$frontendPage(
											$author$project$Addresses$Frontend$mealEntryEditor.iA(mealKey))
									})
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.a0.af,
											$elm$html$Html$Events$onClick(
											$author$project$Pages$Util$ParentEditor$Page$RequestDelete(meal.gn))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									$author$project$Pages$Util$Links$linkButton(
									{
										S: _List_fromArray(
											[$author$project$Pages$Util$Style$classes.a0.k8]),
										T: _List_fromArray(
											[
												$elm$html$Html$text('Nutrients')
											]),
										id: $author$project$Pages$Util$Links$frontendPage(
											$author$project$Addresses$Frontend$statisticsMealSelect.iA(mealKey))
									})
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.a0.d4,
											$elm$html$Html$Events$onClick(
											$author$project$Pages$Util$ParentEditor$Page$Duplicate(meal.gn))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Duplicate')
										]))
								]))
						])),
				hH: showControls,
				h4: $author$project$Pages$Meals$Editor$Page$ParentEditorMsg(
					$author$project$Pages$Util$ParentEditor$Page$ToggleControls(meal.gn))
			},
			profile.gN,
			meal);
	});
var $elm$html$Html$caption = _VirtualDom_node('caption');
var $author$project$Pages$Util$ParentEditor$View$creationButton = function (ps) {
	return A2(
		$elm$html$Html$button,
		$elm_community$maybe_extra$Maybe$Extra$values(
			_List_fromArray(
				[
					$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.a0.fk),
					A2(
					$author$project$Util$MaybeUtil$optional,
					ps.jH,
					$elm$html$Html$Events$onClick(
						ps.ic(
							$elm$core$Maybe$Just(ps.fU)))),
					$author$project$Util$MaybeUtil$defined(
					$elm$html$Html$Attributes$disabled(!ps.jH))
				])),
		_List_fromArray(
			[
				$elm$html$Html$text(ps.kr)
			]));
};
var $author$project$Util$DictList$filter = function (p) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Util$DictList$toList,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$filter(
				$elm_community$basics_extra$Basics$Extra$uncurry(p)),
			$author$project$Util$DictList$fromList));
};
var $elm_community$maybe_extra$Maybe$Extra$isNothing = function (m) {
	if (m.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $jschomay$elm_paginate$Paginate$Custom$foldMap = F2(
	function (f, _v0) {
		var items = _v0.gy;
		return f(items);
	});
var $jschomay$elm_paginate$Paginate$length = $jschomay$elm_paginate$Paginate$Custom$foldMap($elm$core$List$length);
var $author$project$Pages$Util$ParentEditor$View$viewParentsWith = F2(
	function (ps, main) {
		return A2(
			$author$project$Pages$Util$ViewUtil$viewMainWith,
			{jg: ps.jg, me: true},
			function () {
				var viewParents = A3(
					$author$project$Pages$Util$ViewUtil$paginate,
					{
						lt: A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$ParentEditor$Pagination$lenses.lu, $author$project$Pages$Util$ParentEditor$Page$lenses.kz.lt)
					},
					main,
					ps.mf(
						$author$project$Util$DictList$values(
							A2(
								$author$project$Util$DictList$filter,
								F2(
									function (_v0, v) {
										return A2(ps.kC, main.hz, v.ln);
									}),
								main.lu))));
				var viewParent = $author$project$Util$Editing$unpack(
					{la: ps.jq, lh: ps.mJ, lk: ps.mS});
				var numberOfParents = $jschomay$elm_paginate$Paginate$length(viewParents);
				var creationLine = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, ps.ae.j9, main.dc);
				var button = _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[$author$project$Pages$Util$Style$ids.fk]),
						_List_fromArray(
							[
								$author$project$Pages$Util$ParentEditor$View$creationButton(
								{
									fU: ps.ae.jn,
									jH: $elm_community$maybe_extra$Maybe$Extra$isNothing(main.dc),
									kr: ps.ae.kr,
									ic: ps.ae.ac
								})
							]))
					]);
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[ps.mp]),
					_Utils_ap(
						button,
						_List_fromArray(
							[
								$author$project$Pages$Util$HtmlUtil$searchAreaWith(
								{gM: ps.ma, hz: main.hz}),
								A2(
								$elm$html$Html$table,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.jF]),
								A2(
									$elm$core$List$cons,
									ps.mt,
									A2(
										$elm$core$List$cons,
										A2(
											$elm$html$Html$caption,
											_List_fromArray(
												[$author$project$Pages$Util$Style$classes.hy.kd]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(numberOfParents) + ' matches')
												])),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tbody,
												_List_Nil,
												_Utils_ap(
													creationLine,
													A2(
														$elm$core$List$concatMap,
														viewParent,
														$jschomay$elm_paginate$Paginate$page(viewParents))))
											])))),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.lt]),
								_List_fromArray(
									[
										$author$project$Pages$Util$ViewUtil$pagerButtons(
										{
											jD: viewParents,
											gM: A2(
												$elm$core$Basics$composeR,
												A2(
													$author$project$Pages$Util$PaginationSettings$updateCurrentPage,
													{gy: $author$project$Pages$Util$ParentEditor$Pagination$lenses.lu, lt: $author$project$Pages$Util$ParentEditor$Page$lenses.kz.lt},
													main),
												ps.l9)
										})
									]))
							])));
			}());
	});
var $author$project$Pages$Meals$Editor$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ParentEditor$View$viewParentsWith,
		{
			ae: {
				jn: $author$project$Pages$Meals$Editor$MealCreationClientInput$default,
				j9: $author$project$Pages$Meals$Editor$View$createMealLine(main.ly.gN),
				kr: 'New meal for ' + main.ly.gN,
				ac: A2($elm$core$Basics$composeR, $author$project$Pages$Util$ParentEditor$Page$UpdateCreation, $author$project$Pages$Meals$Editor$Page$ParentEditorMsg)
			},
			jg: $elm$core$Maybe$Nothing,
			jq: $author$project$Pages$Meals$Editor$View$deleteMealLine(main.ly.gN),
			kC: F2(
				function (string, meal) {
					return A2(
						$author$project$Util$SearchUtil$search,
						string,
						A2($elm$core$Maybe$withDefault, '', meal.gN)) || A2(
						$author$project$Util$SearchUtil$search,
						string,
						$author$project$Pages$Util$DateUtil$toString(meal.fR));
				}),
			l9: A2($elm$core$Basics$composeR, $author$project$Pages$Util$ParentEditor$Page$SetPagination, $author$project$Pages$Meals$Editor$Page$ParentEditorMsg),
			ma: A2($elm$core$Basics$composeR, $author$project$Pages$Util$ParentEditor$Page$SetSearchString, $author$project$Pages$Meals$Editor$Page$ParentEditorMsg),
			mf: A2(
				$elm$core$Basics$composeR,
				$elm$core$List$sortBy(
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.ln;
						},
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.fR;
							},
							$author$project$Pages$Util$DateUtil$toString))),
				$elm$core$List$reverse),
			mp: $author$project$Pages$Util$Style$ids.iv,
			mt: $author$project$Pages$Meals$Editor$View$tableHeader,
			mJ: A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.gn;
				},
				$author$project$Pages$Meals$Editor$View$updateMealLine(main.ly.gN)),
			mS: $author$project$Pages$Meals$Editor$View$viewMealLine(main.ly)
		},
		main.eF);
};
var $author$project$Pages$Meals$Editor$View$view = function (model) {
	return A2(
		$author$project$Pages$View$Tristate$view,
		{md: true, mT: $author$project$Pages$Meals$Editor$View$viewMain},
		model);
};
var $elm$html$Html$menu = _VirtualDom_node('menu');
var $elm$html$Html$li = _VirtualDom_node('li');
var $author$project$Pages$Util$ProfileChoice$View$viewProfileButtonWith = F2(
	function (ps, profile) {
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Pages$Util$Links$linkButton(
					{
						S: _List_fromArray(
							[$author$project$Pages$Util$Style$classes.a0.eD]),
						T: _List_fromArray(
							[
								$elm$html$Html$text(profile.gN)
							]),
						id: $author$project$Pages$Util$Links$frontendPage(
							ps.iA(profile.gn))
					})
				]));
	});
var $author$project$Pages$Util$ProfileChoice$View$viewMainWith = F2(
	function (ps, main) {
		return A2(
			$author$project$Pages$Util$ViewUtil$viewMainWith,
			{
				jg: $elm$core$Maybe$Just(ps.jg),
				me: true
			},
			ps.kP(
				A2(
					$elm$html$Html$menu,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Pages$Util$ProfileChoice$View$viewProfileButtonWith(ps),
						main.eM))));
	});
var $author$project$Pages$Util$ProfileChoice$View$viewWith = function (ps) {
	return $author$project$Pages$View$Tristate$view(
		{
			md: true,
			mT: $author$project$Pages$Util$ProfileChoice$View$viewMainWith(ps)
		});
};
var $author$project$Pages$Meals$ProfileChoice$View$view = function (model) {
	return A2(
		$author$project$Pages$Util$ProfileChoice$View$viewWith,
		{iA: $author$project$Addresses$Frontend$meals.iA, jg: 1, kP: $elm$core$Basics$identity},
		model);
};
var $author$project$Pages$Util$ViewUtil$Overview = 6;
var $author$project$Pages$Overview$View$viewMain = A2(
	$author$project$Pages$Util$ViewUtil$viewMainWith,
	{
		jg: $elm$core$Maybe$Just(6),
		me: false
	},
	A2(
		$elm$html$Html$div,
		_List_fromArray(
			[$author$project$Pages$Util$Style$ids.lp]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Util$Links$linkButton(
						{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.a0.eD]),
							T: _List_fromArray(
								[
									$elm$html$Html$text('Recipes')
								]),
							id: $author$project$Pages$Util$Links$frontendPage(
								$author$project$Addresses$Frontend$recipes.iA(0))
						})
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Util$Links$linkButton(
						{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.a0.eD]),
							T: _List_fromArray(
								[
									$elm$html$Html$text('Meals')
								]),
							id: $author$project$Pages$Util$Links$frontendPage(
								$author$project$Addresses$Frontend$mealBranch.iA(0))
						})
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Util$Links$linkButton(
						{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.a0.eD]),
							T: _List_fromArray(
								[
									$elm$html$Html$text('Complex foods')
								]),
							id: $author$project$Pages$Util$Links$frontendPage(
								$author$project$Addresses$Frontend$complexFoods.iA(0))
						})
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Util$Links$linkButton(
						{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.a0.eD]),
							T: _List_fromArray(
								[
									$elm$html$Html$text('Statistics')
								]),
							id: $author$project$Pages$Util$Links$frontendPage(
								$author$project$Addresses$Frontend$statisticsTime.iA(0))
						})
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Util$Links$linkButton(
						{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.a0.eD]),
							T: _List_fromArray(
								[
									$elm$html$Html$text('Reference maps')
								]),
							id: $author$project$Pages$Util$Links$frontendPage(
								$author$project$Addresses$Frontend$referenceMaps.iA(0))
						})
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Util$Links$linkButton(
						{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.a0.eD]),
							T: _List_fromArray(
								[
									$elm$html$Html$text('Profiles')
								]),
							id: $author$project$Pages$Util$Links$frontendPage(
								$author$project$Addresses$Frontend$profiles.iA(0))
						})
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Util$Links$linkButton(
						{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.a0.eD]),
							T: _List_fromArray(
								[
									$elm$html$Html$text('User settings')
								]),
							id: $author$project$Pages$Util$Links$frontendPage(
								$author$project$Addresses$Frontend$userSettings.iA(0))
						})
					]))
			])));
var $author$project$Pages$Overview$View$view = $author$project$Pages$View$Tristate$view(
	{
		md: true,
		mT: $elm$core$Basics$always($author$project$Pages$Overview$View$viewMain)
	});
var $author$project$Pages$Profiles$View$editProfileLineWith = F2(
	function (handling, editedValue) {
		var validInput = $author$project$Pages$Util$ValidatedInput$isValid(
			handling.kR.jY(editedValue));
		var validatedSaveAction = A2(
			$author$project$Util$MaybeUtil$optional,
			validInput,
			$elm_community$html_extra$Html$Events$Extra$onEnter(handling.l2));
		var infoColumns = _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.ec]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						$elm_community$maybe_extra$Maybe$Extra$values(
							_List_fromArray(
								[
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Attributes$value(
										handling.kR.jY(editedValue).mx)),
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Events$onInput(
										A2(
											$elm$core$Basics$composeR,
											A2(
												$elm_community$basics_extra$Basics$Extra$flip,
												$author$project$Pages$Util$ValidatedInput$lift(handling.kR).eW,
												editedValue),
											handling.mK))),
									$author$project$Util$MaybeUtil$defined(
									$author$project$Pages$Util$HtmlUtil$onEscape(handling.iS)),
									validatedSaveAction
								])),
						_List_Nil)
					]))
			]);
		var controlsRow = $author$project$Pages$Util$ParentEditor$View$controlsRowWith(
			{
				iR: {gM: handling.iS, gN: handling.iT},
				i1: $elm$core$List$length(infoColumns),
				d4: {gM: handling.l2, gN: handling.ja},
				mO: validInput
			});
		var commandToggle = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			A2($elm$core$Basics$composeR, $author$project$Pages$Util$HtmlUtil$toggleControlsCell, $elm$core$List$singleton),
			handling.mE);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				handling.l_,
				_Utils_ap(infoColumns, commandToggle)),
				controlsRow
			]);
	});
var $author$project$Pages$Profiles$ProfileCreationClientInput$lenses = {
	gN: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.gN;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{gN: b});
			}))
};
var $author$project$Pages$Profiles$View$createProfileLine = function (profileCreationClientInput) {
	return A2(
		$author$project$Pages$Profiles$View$editProfileLineWith,
		{
			iS: $author$project$Pages$Util$ParentEditor$Page$UpdateCreation($elm$core$Maybe$Nothing),
			iT: 'Cancel',
			ja: 'Add',
			kR: $author$project$Pages$Profiles$ProfileCreationClientInput$lenses.gN,
			l_: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.f0]),
			l2: $author$project$Pages$Util$ParentEditor$Page$Create,
			mE: $elm$core$Maybe$Nothing,
			mK: A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Pages$Util$ParentEditor$Page$UpdateCreation)
		},
		profileCreationClientInput);
};
var $author$project$Pages$Profiles$ProfileCreationClientInput$default = {gN: $author$project$Pages$Util$ValidatedInput$nonEmptyString};
var $author$project$Pages$Profiles$View$profileInfoColumns = function (profile) {
	return _List_fromArray(
		[
			{
			S: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.ec]),
			T: _List_fromArray(
				[
					$elm$html$Html$text(profile.gN)
				])
		}
		]);
};
var $author$project$Pages$Profiles$View$profileLineWith = function (ps) {
	return $author$project$Pages$Util$ParentEditor$View$lineWith(
		{
			l$: function (profile) {
				return {
					H: ps.H,
					d8: $author$project$Pages$Profiles$View$profileInfoColumns(profile)
				};
			},
			hH: ps.hH,
			h4: ps.h4
		});
};
var $author$project$Pages$Profiles$View$deleteProfileLine = function (profile) {
	return A2(
		$author$project$Pages$Profiles$View$profileLineWith,
		{
			H: _List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.H]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$author$project$Pages$Util$Style$classes.a0.af,
									$elm$html$Html$Events$onClick(
									$author$project$Pages$Util$ParentEditor$Page$ConfirmDelete(profile.gn))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Delete?')
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.H]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$author$project$Pages$Util$Style$classes.a0.d4,
									$elm$html$Html$Events$onClick(
									$author$project$Pages$Util$ParentEditor$Page$CancelDelete(profile.gn))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								]))
						]))
				]),
			hH: true,
			h4: $author$project$Pages$Util$ParentEditor$Page$ToggleControls(profile.gn)
		},
		profile);
};
var $author$project$Pages$Profiles$View$tableHeader = $author$project$Pages$Util$ParentEditor$View$tableHeaderWith(
	{
		i2: _List_fromArray(
			[
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Name')
					]))
			]),
		mo: $author$project$Pages$Util$Style$classes.lz
	});
var $author$project$Pages$Profiles$ProfileUpdateClientInput$lenses = {
	gN: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.gN;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{gN: b});
			}))
};
var $author$project$Pages$Profiles$View$updateProfileLine = function (profileId) {
	return $author$project$Pages$Profiles$View$editProfileLineWith(
		{
			iS: $author$project$Pages$Util$ParentEditor$Page$ExitEdit(profileId),
			iT: 'Cancel',
			ja: 'Save',
			kR: $author$project$Pages$Profiles$ProfileUpdateClientInput$lenses.gN,
			l_: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.f0]),
			l2: $author$project$Pages$Util$ParentEditor$Page$SaveEdit(profileId),
			mE: $elm$core$Maybe$Just(
				$author$project$Pages$Util$ParentEditor$Page$ToggleControls(profileId)),
			mK: $author$project$Pages$Util$ParentEditor$Page$Edit(profileId)
		});
};
var $author$project$Pages$Profiles$View$viewProfileLine = F2(
	function (profile, showControls) {
		return A2(
			$author$project$Pages$Profiles$View$profileLineWith,
			{
				H: _List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.H]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$author$project$Pages$Util$Style$classes.a0.eb,
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Util$ParentEditor$Page$EnterEdit(profile.gn))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Edit')
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.H]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$author$project$Pages$Util$Style$classes.a0.af,
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Util$ParentEditor$Page$RequestDelete(profile.gn))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Delete')
									]))
							]))
					]),
				hH: showControls,
				h4: $author$project$Pages$Util$ParentEditor$Page$ToggleControls(profile.gn)
			},
			profile);
	});
var $author$project$Pages$Profiles$View$viewMain = $author$project$Pages$Util$ParentEditor$View$viewParentsWith(
	{
		ae: {jn: $author$project$Pages$Profiles$ProfileCreationClientInput$default, j9: $author$project$Pages$Profiles$View$createProfileLine, kr: 'New profile', ac: $author$project$Pages$Util$ParentEditor$Page$UpdateCreation},
		jg: $elm$core$Maybe$Just(8),
		jq: $author$project$Pages$Profiles$View$deleteProfileLine,
		kC: F2(
			function (string, profile) {
				return A2($author$project$Util$SearchUtil$search, string, profile.gN);
			}),
		l9: $author$project$Pages$Util$ParentEditor$Page$SetPagination,
		ma: $author$project$Pages$Util$ParentEditor$Page$SetSearchString,
		mf: $elm$core$List$sortBy(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ln;
				},
				function ($) {
					return $.gN;
				})),
		mp: $author$project$Pages$Util$Style$ids.iw,
		mt: $author$project$Pages$Profiles$View$tableHeader,
		mJ: A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.gn;
			},
			$author$project$Pages$Profiles$View$updateProfileLine),
		mS: $author$project$Pages$Profiles$View$viewProfileLine
	});
var $author$project$Pages$Profiles$View$view = $author$project$Pages$View$Tristate$view(
	{md: true, mT: $author$project$Pages$Profiles$View$viewMain});
var $author$project$Pages$Recipes$RecipeCreationClientInput$lenses = {
	fX: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.fX;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{fX: b});
			})),
	gN: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.gN;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{gN: b});
			})),
	gY: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.gY;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{gY: b});
			})),
	hF: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.hF;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{hF: b});
			}))
};
var $author$project$Pages$Recipes$View$createRecipeLine = $author$project$Pages$Recipes$View$editRecipeLineWith(
	{
		iS: $author$project$Pages$Recipes$Page$ParentMsg(
			$author$project$Pages$Util$ParentEditor$Page$UpdateCreation($elm$core$Maybe$Nothing)),
		iT: 'Cancel',
		ja: 'Add',
		jt: $author$project$Pages$Recipes$RecipeCreationClientInput$lenses.fX,
		kR: $author$project$Pages$Recipes$RecipeCreationClientInput$lenses.gN,
		k6: $author$project$Pages$Recipes$RecipeCreationClientInput$lenses.gY,
		l_: _List_fromArray(
			[$author$project$Pages$Util$Style$classes.f0]),
		l2: $author$project$Pages$Recipes$Page$ParentMsg($author$project$Pages$Util$ParentEditor$Page$Create),
		l8: $author$project$Pages$Recipes$RecipeCreationClientInput$lenses.hF,
		mE: $elm$core$Maybe$Nothing,
		mK: A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$Just,
			A2($elm$core$Basics$composeR, $author$project$Pages$Util$ParentEditor$Page$UpdateCreation, $author$project$Pages$Recipes$Page$ParentMsg))
	});
var $author$project$Pages$Recipes$RecipeCreationClientInput$default = {fX: $elm$core$Maybe$Nothing, gN: $author$project$Pages$Util$ValidatedInput$nonEmptyString, gY: $author$project$Pages$Util$ValidatedInput$positive, hF: $elm$core$Maybe$Nothing};
var $author$project$Pages$Recipes$View$deleteRecipeLine = function (recipe) {
	return A2(
		$author$project$Pages$Recipes$View$recipeLineWith,
		{
			H: A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Pages$Recipes$Page$ParentMsg),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.H]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$author$project$Pages$Util$Style$classes.a0.af,
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Util$ParentEditor$Page$ConfirmDelete(recipe.gn))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Delete?')
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.H]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$author$project$Pages$Util$Style$classes.a0.d4,
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Util$ParentEditor$Page$CancelDelete(recipe.gn))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									]))
							]))
					])),
			hH: true,
			h4: $author$project$Pages$Recipes$Page$ParentMsg(
				$author$project$Pages$Util$ParentEditor$Page$ToggleControls(recipe.gn))
		},
		recipe);
};
var $author$project$Pages$Recipes$View$updateRecipeLine = F2(
	function (recipeId, recipeUpdateClientInput) {
		return A2(
			$author$project$Pages$Recipes$View$editRecipeLineWith,
			{
				iS: $author$project$Pages$Recipes$Page$ParentMsg(
					$author$project$Pages$Util$ParentEditor$Page$ExitEdit(recipeId)),
				iT: 'Cancel',
				ja: 'Save',
				jt: $author$project$Pages$Recipes$RecipeUpdateClientInput$lenses.fX,
				kR: $author$project$Pages$Recipes$RecipeUpdateClientInput$lenses.gN,
				k6: $author$project$Pages$Recipes$RecipeUpdateClientInput$lenses.gY,
				l_: _List_fromArray(
					[$author$project$Pages$Util$Style$classes.f0]),
				l2: $author$project$Pages$Recipes$Page$ParentMsg(
					$author$project$Pages$Util$ParentEditor$Page$SaveEdit(recipeId)),
				l8: $author$project$Pages$Recipes$RecipeUpdateClientInput$lenses.hF,
				mE: $elm$core$Maybe$Just(
					$author$project$Pages$Recipes$Page$ParentMsg(
						$author$project$Pages$Util$ParentEditor$Page$ToggleControls(recipeId))),
				mK: A2(
					$elm$core$Basics$composeL,
					$author$project$Pages$Recipes$Page$ParentMsg,
					$author$project$Pages$Util$ParentEditor$Page$Edit(recipeId))
			},
			recipeUpdateClientInput);
	});
var $author$project$Pages$Recipes$Page$Rescale = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Recipes$View$viewRecipeLine = F2(
	function (recipe, showControls) {
		var rescalable = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, false, $author$project$Pages$Recipes$Util$isRescalableServingSize, recipe.hF);
		var rescalableCmd = rescalable ? _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$Pages$Recipes$Page$Rescale(recipe.gn))
			]) : _List_Nil;
		return A2(
			$author$project$Pages$Recipes$View$recipeLineWith,
			{
				H: _List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.H]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$author$project$Pages$Util$Style$classes.a0.eb,
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Recipes$Page$ParentMsg(
											$author$project$Pages$Util$ParentEditor$Page$EnterEdit(recipe.gn)))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Edit')
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.H]),
						_List_fromArray(
							[
								$author$project$Pages$Util$Links$linkButton(
								{
									S: _List_fromArray(
										[$author$project$Pages$Util$Style$classes.a0.jy]),
									T: _List_fromArray(
										[
											$elm$html$Html$text('Ingredients')
										]),
									id: $author$project$Pages$Util$Links$frontendPage(
										$author$project$Addresses$Frontend$ingredientEditor.iA(recipe.gn))
								})
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.H]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$author$project$Pages$Util$Style$classes.a0.af,
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Recipes$Page$ParentMsg(
											$author$project$Pages$Util$ParentEditor$Page$RequestDelete(recipe.gn)))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Delete')
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.H]),
						_List_fromArray(
							[
								$author$project$Pages$Util$Links$linkButton(
								{
									S: _List_fromArray(
										[$author$project$Pages$Util$Style$classes.a0.k8]),
									T: _List_fromArray(
										[
											$elm$html$Html$text('Nutrients')
										]),
									id: $author$project$Pages$Util$Links$frontendPage(
										$author$project$Addresses$Frontend$statisticsRecipeSelect.iA(recipe.gn))
								})
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.H]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$author$project$Pages$Util$Style$classes.a0.d4,
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Recipes$Page$ParentMsg(
											$author$project$Pages$Util$ParentEditor$Page$Duplicate(recipe.gn)))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Duplicate')
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.H]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_Utils_ap(
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.a0.lW,
											$elm$html$Html$Attributes$disabled(!rescalable)
										]),
									rescalableCmd),
								_List_fromArray(
									[
										$elm$html$Html$text('Rescale')
									]))
							]))
					]),
				hH: showControls,
				h4: $author$project$Pages$Recipes$Page$ParentMsg(
					$author$project$Pages$Util$ParentEditor$Page$ToggleControls(recipe.gn))
			},
			recipe);
	});
var $author$project$Pages$Recipes$View$viewMain = $author$project$Pages$Util$ParentEditor$View$viewParentsWith(
	{
		ae: {
			jn: $author$project$Pages$Recipes$RecipeCreationClientInput$default,
			j9: $author$project$Pages$Recipes$View$createRecipeLine,
			kr: 'New recipe',
			ac: A2($elm$core$Basics$composeL, $author$project$Pages$Recipes$Page$ParentMsg, $author$project$Pages$Util$ParentEditor$Page$UpdateCreation)
		},
		jg: $elm$core$Maybe$Just(0),
		jq: $author$project$Pages$Recipes$View$deleteRecipeLine,
		kC: F2(
			function (string, recipe) {
				return A2($author$project$Util$SearchUtil$search, string, recipe.gN) || A2(
					$author$project$Util$SearchUtil$search,
					string,
					A2($elm$core$Maybe$withDefault, '', recipe.fX));
			}),
		l9: A2($elm$core$Basics$composeL, $author$project$Pages$Recipes$Page$ParentMsg, $author$project$Pages$Util$ParentEditor$Page$SetPagination),
		ma: A2($elm$core$Basics$composeL, $author$project$Pages$Recipes$Page$ParentMsg, $author$project$Pages$Util$ParentEditor$Page$SetSearchString),
		mf: $elm$core$List$sortBy(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ln;
				},
				function ($) {
					return $.gN;
				})),
		mp: $author$project$Pages$Util$Style$ids.ix,
		mt: $author$project$Pages$Recipes$View$tableHeader,
		mJ: A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.gn;
			},
			$author$project$Pages$Recipes$View$updateRecipeLine),
		mS: $author$project$Pages$Recipes$View$viewRecipeLine
	});
var $author$project$Pages$Recipes$View$view = $author$project$Pages$View$Tristate$view(
	{md: true, mT: $author$project$Pages$Recipes$View$viewMain});
var $author$project$Pages$Recovery$Confirm$View$viewConfirmed = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[$author$project$Pages$Util$Style$classes.d4]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Successfully reset password.')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Pages$Util$Links$toLoginButton(
					{fC: 'Main page'})
				]))
		]));
var $author$project$Pages$Recovery$Confirm$Page$Confirm = {$: 1};
var $author$project$Pages$Recovery$Confirm$Page$SetPasswordInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Util$PasswordInput$isValidPassword = function (complementInput) {
	return _Utils_eq(complementInput.lw, complementInput.g6);
};
var $author$project$Pages$Util$PasswordInput$lenses = {
	lw: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.lw;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{lw: b});
			})),
	g6: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.g6;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{g6: b});
			}))
};
var $author$project$Pages$Recovery$Confirm$View$viewResetting = function (model) {
	var isValidPassword = $author$project$Pages$Util$PasswordInput$isValidPassword(model.eH);
	var enterAction = A2(
		$author$project$Util$MaybeUtil$optional,
		isValidPassword,
		$elm_community$html_extra$Html$Events$Extra$onEnter($author$project$Pages$Recovery$Confirm$Page$Confirm));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[$author$project$Pages$Util$Style$classes.d4]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.kd]),
						_List_fromArray(
							[
								$elm$html$Html$text('Account recovery')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$table,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tbody,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('New password')
															]))
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$input,
														$elm_community$maybe_extra$Maybe$Extra$values(
															_List_fromArray(
																[
																	$author$project$Util$MaybeUtil$defined(
																	$elm$html$Html$Events$onInput(
																		A2(
																			$elm$core$Basics$composeR,
																			A2($elm_community$basics_extra$Basics$Extra$flip, $author$project$Pages$Util$PasswordInput$lenses.lw.eW, model.eH),
																			$author$project$Pages$Recovery$Confirm$Page$SetPasswordInput))),
																	$author$project$Util$MaybeUtil$defined(
																	$elm$html$Html$Attributes$type_('password')),
																	$author$project$Util$MaybeUtil$defined(
																	$elm$html$Html$Attributes$value(
																		$author$project$Pages$Util$PasswordInput$lenses.lw.jY(model.eH))),
																	$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.ec),
																	enterAction
																])),
														_List_Nil)
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Password repetition')
															]))
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$input,
														$elm_community$maybe_extra$Maybe$Extra$values(
															_List_fromArray(
																[
																	$author$project$Util$MaybeUtil$defined(
																	$elm$html$Html$Events$onInput(
																		A2(
																			$elm$core$Basics$composeR,
																			A2($elm_community$basics_extra$Basics$Extra$flip, $author$project$Pages$Util$PasswordInput$lenses.g6.eW, model.eH),
																			$author$project$Pages$Recovery$Confirm$Page$SetPasswordInput))),
																	$author$project$Util$MaybeUtil$defined(
																	$elm$html$Html$Attributes$type_('password')),
																	$author$project$Util$MaybeUtil$defined(
																	$elm$html$Html$Attributes$value(
																		$author$project$Pages$Util$PasswordInput$lenses.g6.jY(model.eH))),
																	$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.ec),
																	enterAction
																])),
														_List_Nil)
													]))
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Pages$Recovery$Confirm$Page$Confirm),
										$author$project$Pages$Util$Style$classes.a0.d4,
										$elm$html$Html$Attributes$disabled(!isValidPassword)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Reset password')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Recovery$Confirm$View$viewMain = function (model) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{jg: $elm$core$Maybe$Nothing, me: false},
		function () {
			var _v0 = model.gK;
			if (!_v0) {
				return $author$project$Pages$Recovery$Confirm$View$viewResetting(model);
			} else {
				return $author$project$Pages$Recovery$Confirm$View$viewConfirmed;
			}
		}());
};
var $author$project$Pages$Recovery$Confirm$View$view = $author$project$Pages$View$Tristate$view(
	{md: true, mT: $author$project$Pages$Recovery$Confirm$View$viewMain});
var $author$project$Pages$Recovery$Request$Page$Find = {$: 0};
var $author$project$Pages$Recovery$Request$Page$SetSearchString = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Recovery$Request$View$searchComponents = function (main) {
	var isValid = !$elm$core$String$isEmpty(main.hz);
	var enterAction = A2(
		$author$project$Util$MaybeUtil$optional,
		isValid,
		$elm_community$html_extra$Html$Events$Extra$onEnter($author$project$Pages$Recovery$Request$Page$Find));
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.kd]),
					_List_fromArray(
						[
							$elm$html$Html$text('Recovery')
						]))
				])),
			A2(
			$elm$html$Html$table,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Nickname or email')
												]))
										])),
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											$elm_community$maybe_extra$Maybe$Extra$values(
												_List_fromArray(
													[
														$author$project$Util$MaybeUtil$defined(
														$elm$html$Html$Events$onInput($author$project$Pages$Recovery$Request$Page$SetSearchString)),
														$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.ec),
														$author$project$Util$MaybeUtil$defined(
														$elm$html$Html$Attributes$value(main.hz)),
														enterAction
													])),
											_List_Nil)
										]))
								]))
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Pages$Recovery$Request$Page$Find),
							$author$project$Pages$Util$Style$classes.a0.d4,
							$elm$html$Html$Attributes$disabled(!isValid)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Find')
						]))
				]))
		]);
};
var $author$project$Pages$Recovery$Request$View$viewInitial = A2(
	$elm$core$Basics$composeL,
	$elm$html$Html$div(
		_List_fromArray(
			[$author$project$Pages$Util$Style$classes.eS])),
	$author$project$Pages$Recovery$Request$View$searchComponents);
var $author$project$Pages$Recovery$Request$View$viewRequested = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[$author$project$Pages$Util$Style$classes.d4]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Requested user recovery. Please check your email')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Pages$Util$Links$toLoginButton(
					{fC: 'Main page'})
				]))
		]));
var $author$project$Pages$Recovery$Request$Page$RequestRecovery = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Recovery$Request$View$viewRequesting = function (main) {
	var chooseUser = function (user) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Pages$Recovery$Request$Page$RequestRecovery(user.gn)),
							$author$project$Pages$Util$Style$classes.a0.kY
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(user.gU)
						]))
				]));
	};
	var remainder = $elm$core$List$isEmpty(main.mN) ? _List_fromArray(
		[
			A2(
			$elm$html$Html$label,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('No matching user found')
				]))
		]) : _List_fromArray(
		[
			A2(
			$elm$html$Html$label,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Multiple users found. Please choose one.')
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			A2($elm$core$List$map, chooseUser, main.mN))
		]);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[$author$project$Pages$Util$Style$classes.eS]),
		_Utils_ap(
			$author$project$Pages$Recovery$Request$View$searchComponents(main),
			remainder));
};
var $author$project$Pages$Recovery$Request$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{jg: $elm$core$Maybe$Nothing, me: false},
		function () {
			var _v0 = main.gK;
			switch (_v0) {
				case 0:
					return $author$project$Pages$Recovery$Request$View$viewInitial(main);
				case 1:
					return $author$project$Pages$Recovery$Request$View$viewRequesting(main);
				default:
					return $author$project$Pages$Recovery$Request$View$viewRequested;
			}
		}());
};
var $author$project$Pages$Recovery$Request$View$view = $author$project$Pages$View$Tristate$view(
	{md: true, mT: $author$project$Pages$Recovery$Request$View$viewMain});
var $author$project$Pages$ReferenceMaps$View$editReferenceMapLineWith = F2(
	function (handling, editedValue) {
		var validInput = $author$project$Pages$Util$ValidatedInput$isValid(
			handling.kR.jY(editedValue));
		var validatedSaveAction = A2(
			$author$project$Util$MaybeUtil$optional,
			validInput,
			$elm_community$html_extra$Html$Events$Extra$onEnter(handling.l2));
		var infoColumns = _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.ec]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						$elm_community$maybe_extra$Maybe$Extra$values(
							_List_fromArray(
								[
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Attributes$value(
										handling.kR.jY(editedValue).mx)),
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Events$onInput(
										A2(
											$elm$core$Basics$composeR,
											A2(
												$elm_community$basics_extra$Basics$Extra$flip,
												$author$project$Pages$Util$ValidatedInput$lift(handling.kR).eW,
												editedValue),
											handling.mK))),
									$author$project$Util$MaybeUtil$defined(
									$author$project$Pages$Util$HtmlUtil$onEscape(handling.iS)),
									validatedSaveAction
								])),
						_List_Nil)
					]))
			]);
		var controlsRow = $author$project$Pages$Util$ParentEditor$View$controlsRowWith(
			{
				iR: {gM: handling.iS, gN: handling.iT},
				i1: $elm$core$List$length(infoColumns),
				d4: {gM: handling.l2, gN: handling.ja},
				mO: validInput
			});
		var commandToggle = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			A2($elm$core$Basics$composeR, $author$project$Pages$Util$HtmlUtil$toggleControlsCell, $elm$core$List$singleton),
			handling.mE);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				handling.l_,
				_Utils_ap(infoColumns, commandToggle)),
				controlsRow
			]);
	});
var $author$project$Pages$ReferenceMaps$ReferenceMapUpdateClientInput$lenses = {
	gN: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.gN;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{gN: b});
			}))
};
var $author$project$Pages$ReferenceMaps$View$referenceMapInfoColumns = function (referenceMap) {
	return _List_fromArray(
		[
			{
			S: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.ec]),
			T: _List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(referenceMap.gN)
						]))
				])
		}
		]);
};
var $author$project$Pages$ReferenceMaps$View$referenceMapLineWith = function (ps) {
	return $author$project$Pages$Util$ParentEditor$View$lineWith(
		{
			l$: function (referenceMap) {
				return {
					H: ps.H,
					d8: $author$project$Pages$ReferenceMaps$View$referenceMapInfoColumns(referenceMap)
				};
			},
			hH: ps.hH,
			h4: ps.h4
		});
};
var $author$project$Pages$ReferenceMaps$View$tableHeader = $author$project$Pages$Util$ParentEditor$View$tableHeaderWith(
	{
		i2: _List_fromArray(
			[
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Name')
							]))
					]))
			]),
		mo: $author$project$Pages$Util$Style$classes.lM
	});
var $author$project$Pages$ReferenceEntries$Map$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$Parent$View$viewMain,
		{
			la: $author$project$Pages$ReferenceMaps$View$referenceMapLineWith(
				{
					H: _List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.a0.af,
											$elm$html$Html$Events$onClick($author$project$Pages$Util$Parent$Page$ConfirmDelete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete?')
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.a0.d4,
											$elm$html$Html$Events$onClick($author$project$Pages$Util$Parent$Page$CancelDelete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Cancel')
										]))
								]))
						]),
					hH: true,
					h4: $author$project$Pages$Util$Parent$Page$ToggleControls
				}),
			lh: $elm$core$Basics$always(
				$author$project$Pages$ReferenceMaps$View$editReferenceMapLineWith(
					{
						iS: $author$project$Pages$Util$Parent$Page$ExitEdit,
						iT: 'Cancel',
						ja: 'Save',
						kR: $author$project$Pages$ReferenceMaps$ReferenceMapUpdateClientInput$lenses.gN,
						l_: _List_Nil,
						l2: $author$project$Pages$Util$Parent$Page$SaveEdit(main.g4.ln),
						mE: $elm$core$Maybe$Just($author$project$Pages$Util$Parent$Page$ToggleControls),
						mK: $author$project$Pages$Util$Parent$Page$Edit
					})),
			lk: F2(
				function (referenceMap, showControls) {
					return A2(
						$author$project$Pages$ReferenceMaps$View$referenceMapLineWith,
						{
							H: _List_fromArray(
								[
									A2(
									$elm$html$Html$td,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.H]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$author$project$Pages$Util$Style$classes.a0.eb,
													$elm$html$Html$Events$onClick($author$project$Pages$Util$Parent$Page$EnterEdit)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Edit')
												]))
										])),
									A2(
									$elm$html$Html$td,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.H]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$author$project$Pages$Util$Style$classes.a0.af,
													$elm$html$Html$Events$onClick($author$project$Pages$Util$Parent$Page$RequestDelete)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Delete')
												]))
										])),
									A2(
									$elm$html$Html$td,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.H]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$author$project$Pages$Util$Style$classes.a0.d4,
													$elm$html$Html$Events$onClick($author$project$Pages$Util$Parent$Page$Duplicate)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Duplicate')
												]))
										]))
								]),
							hH: showControls,
							h4: $author$project$Pages$Util$Parent$Page$ToggleControls
						},
						referenceMap);
				}),
			mt: $author$project$Pages$ReferenceMaps$View$tableHeader
		},
		main);
};
var $author$project$Pages$ReferenceEntries$ReferenceEntryCreationClientInput$lenses = {
	fp: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.fp;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{fp: b});
			}))
};
var $author$project$Pages$ReferenceEntries$Entries$View$viewNutrients = function (main) {
	var _v0 = A2($author$project$Pages$Util$DictListUtil$existsValue, $author$project$Util$Editing$isUpdate, main.i$) ? _Utils_Tuple2('Reference value', 'Unit') : _Utils_Tuple2('', '');
	var referenceValue = _v0.a;
	var unit = _v0.b;
	return A2(
		$author$project$Pages$Util$Choice$View$viewChoices,
		{
			iX: _List_fromArray(
				[
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Name')
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.M]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(referenceValue)
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.M]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(unit)
								]))
						]))
				]),
			jA: F2(
				function (nutrient, creation) {
					var validInput = $author$project$Pages$Util$ValidatedInput$isValid(creation.fp);
					var cancelMsg = $author$project$Pages$Util$Choice$Page$DeselectChoice(nutrient.fJ);
					var addMsg = $author$project$Pages$Util$Choice$Page$Create(nutrient.fJ);
					return {
						H: _List_fromArray(
							[
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.H]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										$elm_community$maybe_extra$Maybe$Extra$values(
											_List_fromArray(
												[
													$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.a0.d4),
													$author$project$Util$MaybeUtil$defined(
													$elm$html$Html$Attributes$disabled(!validInput)),
													A2(
													$author$project$Util$MaybeUtil$optional,
													validInput,
													$elm$html$Html$Events$onClick(addMsg))
												])),
										_List_fromArray(
											[
												$elm$html$Html$text('Add')
											]))
									])),
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.H]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$author$project$Pages$Util$Style$classes.a0.iR,
												$elm$html$Html$Events$onClick(cancelMsg)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									]))
							]),
						d8: _List_fromArray(
							[
								{
								S: _List_fromArray(
									[$author$project$Pages$Util$Style$classes.ec]),
								T: _List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(nutrient.gN)
											]))
									])
							},
								{
								S: _List_fromArray(
									[$author$project$Pages$Util$Style$classes.cW]),
								T: _List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										$elm_community$maybe_extra$Maybe$Extra$values(
											_List_fromArray(
												[
													$author$project$Util$MaybeUtil$defined(
													$elm$html$Html$Attributes$value(creation.fp.mx)),
													$author$project$Util$MaybeUtil$defined(
													$elm$html$Html$Events$onInput(
														A2(
															$elm$core$Basics$composeR,
															A2(
																$elm_community$basics_extra$Basics$Extra$flip,
																$author$project$Pages$Util$ValidatedInput$lift($author$project$Pages$ReferenceEntries$ReferenceEntryCreationClientInput$lenses.fp).eW,
																creation),
															$author$project$Pages$Util$Choice$Page$UpdateCreation))),
													$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.M),
													$author$project$Util$MaybeUtil$defined(
													$author$project$Pages$Util$HtmlUtil$onEscape(cancelMsg)),
													A2(
													$author$project$Util$MaybeUtil$optional,
													validInput,
													$elm_community$html_extra$Html$Events$Extra$onEnter(addMsg))
												])),
										_List_Nil)
									])
							},
								{
								S: _List_fromArray(
									[
										$author$project$Pages$Util$Style$classes.ec,
										$author$project$Pages$Util$Style$classes.M,
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Util$Choice$Page$SelectChoice(nutrient))
									]),
								T: _List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Api$Types$NutrientUnit$toString(nutrient.ib))
											]))
									])
							}
							])
					};
				}),
			j6: function ($) {
				return $.fJ;
			},
			kC: function (string) {
				return A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.gN;
					},
					$author$project$Util$SearchUtil$search(string));
			},
			mg: function ($) {
				return $.gN;
			},
			mR: function (nutrient) {
				var exists = A2(
					$author$project$Pages$Util$DictListUtil$existsValue,
					function (n) {
						return _Utils_eq(n.ln.gZ, nutrient.fJ);
					},
					main.jD);
				var _v1 = exists ? _Utils_Tuple2(
					'Added',
					_List_fromArray(
						[
							$author$project$Pages$Util$Style$classes.a0.eb,
							$elm$html$Html$Attributes$disabled(true)
						])) : _Utils_Tuple2(
					'Select',
					_List_fromArray(
						[
							$author$project$Pages$Util$Style$classes.a0.d4,
							$elm$html$Html$Events$onClick(
							$author$project$Pages$Util$Choice$Page$SelectChoice(nutrient))
						]));
				var selectName = _v1.a;
				var selectStyles = _v1.b;
				return {
					H: _List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									selectStyles,
									_List_fromArray(
										[
											$elm$html$Html$text(selectName)
										]))
								]))
						]),
					d8: _List_fromArray(
						[
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.ec]),
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(nutrient.gN)
										]))
								])
						},
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.cW]),
							T: _List_Nil
						},
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.cW]),
							T: _List_Nil
						}
						])
				};
			}
		},
		main);
};
var $author$project$Pages$ReferenceEntries$ReferenceEntryUpdateClientInput$lenses = {
	fp: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.fp;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{fp: b});
			}))
};
var $author$project$Pages$ReferenceEntries$Entries$View$viewReferenceEntries = function (main) {
	return A2(
		$author$project$Pages$Util$Choice$View$viewElements,
		{
			iZ: function ($) {
				return $.gZ;
			},
			eb: F2(
				function (referenceEntry, referenceEntryUpdateClientInput) {
					var nutrient = A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.ln;
						},
						A2($author$project$Util$DictList$get, referenceEntry.gZ, main.i$));
					return _List_fromArray(
						[
							{
							S: _List_Nil,
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3(
												$elm_community$maybe_extra$Maybe$Extra$unwrap,
												'',
												function ($) {
													return $.gN;
												},
												nutrient))
										]))
								])
						},
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.cW]),
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(referenceEntryUpdateClientInput.fp.mx),
											$elm$html$Html$Events$onInput(
											A2(
												$elm$core$Basics$composeR,
												A2(
													$elm_community$basics_extra$Basics$Extra$flip,
													$author$project$Pages$Util$ValidatedInput$lift($author$project$Pages$ReferenceEntries$ReferenceEntryUpdateClientInput$lenses.fp).eW,
													referenceEntryUpdateClientInput),
												$author$project$Pages$Util$Choice$Page$Edit(referenceEntry.gZ))),
											$author$project$Pages$Util$Style$classes.M
										]),
									_List_Nil)
								])
						},
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.cW]),
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.M]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3(
												$elm_community$maybe_extra$Maybe$Extra$unwrap,
												'',
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.ib;
													},
													$author$project$Api$Types$NutrientUnit$toString),
												nutrient))
										]))
								])
						}
						]);
				}),
			jC: _List_fromArray(
				[
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Name')
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.M]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Reference value')
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.M]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Unit')
								]))
						]))
				]),
			j7: function ($) {
				return $.gZ;
			},
			kd: function (referenceEntry) {
				var nutrient = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.ln;
					},
					A2($author$project$Util$DictList$get, referenceEntry.gZ, main.i$));
				return {
					H: _List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.a0.eb,
											$elm$html$Html$Events$onClick(
											$author$project$Pages$Util$Choice$Page$EnterEdit(referenceEntry.gZ))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.a0.af,
											$elm$html$Html$Events$onClick(
											$author$project$Pages$Util$Choice$Page$RequestDelete(referenceEntry.gZ))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										]))
								]))
						]),
					d8: _List_fromArray(
						[
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.ec]),
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3(
												$elm_community$maybe_extra$Maybe$Extra$unwrap,
												'',
												function ($) {
													return $.gN;
												},
												nutrient))
										]))
								])
						},
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.M]),
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromFloat(referenceEntry.fp))
										]))
								])
						},
							{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.M]),
							T: _List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.M]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3(
												$elm_community$maybe_extra$Maybe$Extra$unwrap,
												'',
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.ib;
													},
													$author$project$Api$Types$NutrientUnit$toString),
												nutrient))
										]))
								])
						}
						])
				};
			},
			ko: A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.fp;
				},
				$author$project$Pages$Util$ValidatedInput$isValid),
			kT: function ($) {
				return $.gN;
			}
		},
		main);
};
var $author$project$Pages$ReferenceEntries$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{jg: $elm$core$Maybe$Nothing, me: true},
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[$author$project$Pages$Util$Style$ids.lL]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$ReferenceEntries$Page$MapMsg,
							$author$project$Pages$ReferenceEntries$Map$View$viewMain(main.gE))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.jD]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Reference values')
								]))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Pages$ReferenceEntries$Page$EntriesMsg,
					$author$project$Pages$ReferenceEntries$Entries$View$viewReferenceEntries(main.f5)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.jD]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Nutrients')
								]))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Pages$ReferenceEntries$Page$EntriesMsg,
					$author$project$Pages$ReferenceEntries$Entries$View$viewNutrients(main.f5))
				])));
};
var $author$project$Pages$ReferenceEntries$View$view = $author$project$Pages$View$Tristate$view(
	{md: true, mT: $author$project$Pages$ReferenceEntries$View$viewMain});
var $author$project$Pages$ReferenceMaps$ReferenceMapCreationClientInput$lenses = {
	gN: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.gN;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{gN: b});
			}))
};
var $author$project$Pages$ReferenceMaps$View$createReferenceMapLine = function (referenceMapCreationClientInput) {
	return A2(
		$author$project$Pages$ReferenceMaps$View$editReferenceMapLineWith,
		{
			iS: $author$project$Pages$Util$ParentEditor$Page$UpdateCreation($elm$core$Maybe$Nothing),
			iT: 'Cancel',
			ja: 'Add',
			kR: $author$project$Pages$ReferenceMaps$ReferenceMapCreationClientInput$lenses.gN,
			l_: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.f0]),
			l2: $author$project$Pages$Util$ParentEditor$Page$Create,
			mE: $elm$core$Maybe$Nothing,
			mK: A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Pages$Util$ParentEditor$Page$UpdateCreation)
		},
		referenceMapCreationClientInput);
};
var $author$project$Pages$ReferenceMaps$ReferenceMapCreationClientInput$default = {gN: $author$project$Pages$Util$ValidatedInput$nonEmptyString};
var $author$project$Pages$ReferenceMaps$View$deleteReferenceMapLine = function (referenceMap) {
	return A2(
		$author$project$Pages$ReferenceMaps$View$referenceMapLineWith,
		{
			H: _List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.H]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$author$project$Pages$Util$Style$classes.a0.af,
									$elm$html$Html$Events$onClick(
									$author$project$Pages$Util$ParentEditor$Page$ConfirmDelete(referenceMap.gn))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Delete?')
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.H]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$author$project$Pages$Util$Style$classes.a0.d4,
									$elm$html$Html$Events$onClick(
									$author$project$Pages$Util$ParentEditor$Page$CancelDelete(referenceMap.gn))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								]))
						]))
				]),
			hH: true,
			h4: $author$project$Pages$Util$ParentEditor$Page$ToggleControls(referenceMap.gn)
		},
		referenceMap);
};
var $author$project$Pages$ReferenceMaps$View$updateReferenceMapLine = function (referenceMapId) {
	return $author$project$Pages$ReferenceMaps$View$editReferenceMapLineWith(
		{
			iS: $author$project$Pages$Util$ParentEditor$Page$ExitEdit(referenceMapId),
			iT: 'Cancel',
			ja: 'Save',
			kR: $author$project$Pages$ReferenceMaps$ReferenceMapUpdateClientInput$lenses.gN,
			l_: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.f0]),
			l2: $author$project$Pages$Util$ParentEditor$Page$SaveEdit(referenceMapId),
			mE: $elm$core$Maybe$Just(
				$author$project$Pages$Util$ParentEditor$Page$ToggleControls(referenceMapId)),
			mK: $author$project$Pages$Util$ParentEditor$Page$Edit(referenceMapId)
		});
};
var $author$project$Pages$ReferenceMaps$View$viewReferenceMapLine = F2(
	function (referenceMap, showControls) {
		return A2(
			$author$project$Pages$ReferenceMaps$View$referenceMapLineWith,
			{
				H: _List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.H]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$author$project$Pages$Util$Style$classes.a0.eb,
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Util$ParentEditor$Page$EnterEdit(referenceMap.gn))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Edit')
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.H]),
						_List_fromArray(
							[
								$author$project$Pages$Util$Links$linkButton(
								{
									S: _List_fromArray(
										[$author$project$Pages$Util$Style$classes.a0.jy]),
									T: _List_fromArray(
										[
											$elm$html$Html$text('Entries')
										]),
									id: $author$project$Pages$Util$Links$frontendPage(
										$author$project$Addresses$Frontend$referenceEntries.iA(referenceMap.gn))
								})
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.H]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$author$project$Pages$Util$Style$classes.a0.af,
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Util$ParentEditor$Page$RequestDelete(referenceMap.gn))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Delete')
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.H]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$author$project$Pages$Util$Style$classes.a0.d4,
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Util$ParentEditor$Page$Duplicate(referenceMap.gn))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Duplicate')
									]))
							]))
					]),
				hH: showControls,
				h4: $author$project$Pages$Util$ParentEditor$Page$ToggleControls(referenceMap.gn)
			},
			referenceMap);
	});
var $author$project$Pages$ReferenceMaps$View$viewMain = $author$project$Pages$Util$ParentEditor$View$viewParentsWith(
	{
		ae: {jn: $author$project$Pages$ReferenceMaps$ReferenceMapCreationClientInput$default, j9: $author$project$Pages$ReferenceMaps$View$createReferenceMapLine, kr: 'New reference map', ac: $author$project$Pages$Util$ParentEditor$Page$UpdateCreation},
		jg: $elm$core$Maybe$Just(3),
		jq: $author$project$Pages$ReferenceMaps$View$deleteReferenceMapLine,
		kC: F2(
			function (string, referenceMap) {
				return A2($author$project$Util$SearchUtil$search, string, referenceMap.gN);
			}),
		l9: $author$project$Pages$Util$ParentEditor$Page$SetPagination,
		ma: $author$project$Pages$Util$ParentEditor$Page$SetSearchString,
		mf: $elm$core$List$sortBy(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ln;
				},
				function ($) {
					return $.gN;
				})),
		mp: $author$project$Pages$Util$Style$ids.iy,
		mt: $author$project$Pages$ReferenceMaps$View$tableHeader,
		mJ: A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.gn;
			},
			$author$project$Pages$ReferenceMaps$View$updateReferenceMapLine),
		mS: $author$project$Pages$ReferenceMaps$View$viewReferenceMapLine
	});
var $author$project$Pages$ReferenceMaps$View$view = $author$project$Pages$View$Tristate$view(
	{md: true, mT: $author$project$Pages$ReferenceMaps$View$viewMain});
var $author$project$Pages$Registration$Confirm$View$viewConfirmed = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[$author$project$Pages$Util$Style$classes.d4]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('User creation successful.')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Pages$Util$Links$toLoginButton(
					{fC: 'Main page'})
				]))
		]));
var $author$project$Pages$Registration$Confirm$Page$Request = {$: 1};
var $author$project$Pages$Registration$Confirm$Page$SetComplementInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Registration$Confirm$View$viewEditing = function (main) {
	var password2Lens = A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$PasswordInput$lenses.g6, $author$project$Pages$Util$ComplementInput$lenses.eH);
	var password1Lens = A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$PasswordInput$lenses.lw, $author$project$Pages$Util$ComplementInput$lenses.eH);
	var isValid = $author$project$Pages$Util$PasswordInput$isValidPassword(main.d2.eH);
	var enterAction = A2(
		$author$project$Util$MaybeUtil$optional,
		isValid,
		$elm_community$html_extra$Html$Events$Extra$onEnter($author$project$Pages$Registration$Confirm$Page$Request));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[$author$project$Pages$Util$Style$classes.d4]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.kd]),
						_List_fromArray(
							[
								$elm$html$Html$text('Confirm registration')
							]))
					])),
				A2(
				$elm$html$Html$table,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Nickname')
													]))
											])),
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(main.fe.gU)
													]))
											]))
									])),
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Email')
													]))
											])),
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(main.fe.f2)
													]))
											]))
									])),
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Display name (optional)')
													]))
											])),
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												$elm_community$maybe_extra$Maybe$Extra$values(
													_List_fromArray(
														[
															$author$project$Util$MaybeUtil$defined(
															$elm$html$Html$Events$onInput(
																A2(
																	$elm$core$Basics$composeR,
																	$elm$core$Maybe$Just,
																	A2(
																		$elm$core$Basics$composeR,
																		$elm_community$maybe_extra$Maybe$Extra$filter(
																			A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)),
																		A2(
																			$elm$core$Basics$composeR,
																			A2($elm_community$basics_extra$Basics$Extra$flip, $author$project$Pages$Util$ComplementInput$lenses.fZ.eW, main.d2),
																			$author$project$Pages$Registration$Confirm$Page$SetComplementInput))))),
															$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.ec),
															enterAction
														])),
												_List_Nil)
											]))
									])),
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Password')
													]))
											])),
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												$elm_community$maybe_extra$Maybe$Extra$values(
													_List_fromArray(
														[
															$author$project$Util$MaybeUtil$defined(
															$elm$html$Html$Events$onInput(
																A2(
																	$elm$core$Basics$composeR,
																	A2($elm_community$basics_extra$Basics$Extra$flip, password1Lens.eW, main.d2),
																	$author$project$Pages$Registration$Confirm$Page$SetComplementInput))),
															$author$project$Util$MaybeUtil$defined(
															$elm$html$Html$Attributes$value(
																password1Lens.jY(main.d2))),
															$author$project$Util$MaybeUtil$defined(
															$elm$html$Html$Attributes$type_('password')),
															$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.ec),
															enterAction
														])),
												_List_Nil)
											]))
									])),
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Password repetition')
													]))
											])),
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												$elm_community$maybe_extra$Maybe$Extra$values(
													_List_fromArray(
														[
															$author$project$Util$MaybeUtil$defined(
															$elm$html$Html$Events$onInput(
																A2(
																	$elm$core$Basics$composeR,
																	A2($elm_community$basics_extra$Basics$Extra$flip, password2Lens.eW, main.d2),
																	$author$project$Pages$Registration$Confirm$Page$SetComplementInput))),
															$author$project$Util$MaybeUtil$defined(
															$elm$html$Html$Attributes$value(
																password2Lens.jY(main.d2))),
															$author$project$Util$MaybeUtil$defined(
															$elm$html$Html$Attributes$type_('password')),
															$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.ec),
															enterAction
														])),
												_List_Nil)
											]))
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$Pages$Registration$Confirm$Page$Request),
								$author$project$Pages$Util$Style$classes.a0.d4,
								$elm$html$Html$Attributes$disabled(!isValid)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Confirm')
							]))
					]))
			]));
};
var $author$project$Pages$Registration$Confirm$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{jg: $elm$core$Maybe$Nothing, me: false},
		function () {
			var _v0 = main.gK;
			if (!_v0) {
				return $author$project$Pages$Registration$Confirm$View$viewEditing(main);
			} else {
				return $author$project$Pages$Registration$Confirm$View$viewConfirmed;
			}
		}());
};
var $author$project$Pages$Registration$Confirm$View$view = $author$project$Pages$View$Tristate$view(
	{md: true, mT: $author$project$Pages$Registration$Confirm$View$viewMain});
var $author$project$Pages$Registration$Request$View$viewConfirmed = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[$author$project$Pages$Util$Style$classes.d4]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Registration requested. Please check your email to continue.')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Pages$Util$Links$toLoginButton(
					{fC: 'Main page'})
				]))
		]));
var $author$project$Pages$Registration$Request$Page$Request = {$: 2};
var $author$project$Pages$Registration$Request$Page$SetEmail = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Registration$Request$Page$SetNickname = function (a) {
	return {$: 0, a: a};
};
var $author$project$Util$LensUtil$identityLens = A2($arturopala$elm_monocle$Monocle$Lens$Lens, $elm$core$Basics$identity, $elm$core$Basics$always);
var $author$project$Pages$Registration$Request$View$viewEditing = function (main) {
	var isValid = $author$project$Pages$Util$ValidatedInput$isValid(main.gU) && $author$project$Pages$Util$ValidatedInput$isValid(main.f2);
	var enterAction = A2(
		$author$project$Util$MaybeUtil$optional,
		isValid,
		$elm_community$html_extra$Html$Events$Extra$onEnter($author$project$Pages$Registration$Request$Page$Request));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[$author$project$Pages$Util$Style$classes.eS]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.kd]),
						_List_fromArray(
							[
								$elm$html$Html$text('Registration')
							]))
					])),
				A2(
				$elm$html$Html$table,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Nickname')
													]))
											])),
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												$elm_community$maybe_extra$Maybe$Extra$values(
													_List_fromArray(
														[
															$author$project$Util$MaybeUtil$defined(
															$elm$html$Html$Events$onInput(
																A2(
																	$elm$core$Basics$composeR,
																	A2(
																		$elm_community$basics_extra$Basics$Extra$flip,
																		$author$project$Pages$Util$ValidatedInput$lift($author$project$Util$LensUtil$identityLens).eW,
																		main.gU),
																	$author$project$Pages$Registration$Request$Page$SetNickname))),
															$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.ec),
															enterAction
														])),
												_List_Nil)
											]))
									])),
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Email')
													]))
											])),
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												$elm_community$maybe_extra$Maybe$Extra$values(
													_List_fromArray(
														[
															$author$project$Util$MaybeUtil$defined(
															$elm$html$Html$Events$onInput(
																A2(
																	$elm$core$Basics$composeR,
																	A2(
																		$elm_community$basics_extra$Basics$Extra$flip,
																		$author$project$Pages$Util$ValidatedInput$lift($author$project$Util$LensUtil$identityLens).eW,
																		main.f2),
																	$author$project$Pages$Registration$Request$Page$SetEmail))),
															$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.ec),
															enterAction
														])),
												_List_Nil)
											]))
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$Pages$Registration$Request$Page$Request),
								$author$project$Pages$Util$Style$classes.a0.d4,
								$elm$html$Html$Attributes$disabled(!isValid)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Register')
							]))
					]))
			]));
};
var $author$project$Pages$Registration$Request$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{jg: $elm$core$Maybe$Nothing, me: false},
		function () {
			var _v0 = main.gK;
			if (!_v0) {
				return $author$project$Pages$Registration$Request$View$viewEditing(main);
			} else {
				return $author$project$Pages$Registration$Request$View$viewConfirmed;
			}
		}());
};
var $author$project$Pages$Registration$Request$View$view = $author$project$Pages$View$Tristate$view(
	{md: true, mT: $author$project$Pages$Registration$Request$View$viewMain});
var $author$project$Pages$Statistics$ComplexFood$Search$Page$SetComplexFoodsPagination = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Statistics$ComplexFood$Search$Page$SetSearchString = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Statistics$ComplexFood$Search$Pagination$lenses = {
	d3: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.d3;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{d3: b});
			}))
};
var $author$project$Pages$Statistics$ComplexFood$Search$View$viewComplexFoodLine = function (complexFood) {
	return A2(
		$elm$html$Html$tr,
		_List_fromArray(
			[$author$project$Pages$Util$Style$classes.jx]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.ec]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(complexFood.gN)
							]))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.H]),
				_List_fromArray(
					[
						$author$project$Pages$Util$NavigationUtil$complexFoodNutrientLinkButton(complexFood.hk)
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.H]),
				_List_fromArray(
					[
						$author$project$Pages$Util$NavigationUtil$recipeEditorLinkButton(complexFood.hk)
					]))
			]));
};
var $author$project$Addresses$StatisticsVariant$addressSuffix = function (page) {
	var suffix = function () {
		switch (page) {
			case 0:
				return $author$project$Addresses$StatisticsVariant$food;
			case 1:
				return $author$project$Addresses$StatisticsVariant$complexFood;
			case 2:
				return $author$project$Addresses$StatisticsVariant$recipe;
			case 3:
				return $author$project$Addresses$StatisticsVariant$meal;
			case 4:
				return '';
			default:
				return 'recipe-occurrences';
		}
	}();
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			['statistics', suffix]),
		_List_Nil);
};
var $author$project$Addresses$StatisticsVariant$nameOfPage = function (page) {
	switch (page) {
		case 0:
			return 'Food';
		case 1:
			return 'Complex food';
		case 2:
			return 'Recipe';
		case 3:
			return 'Meal';
		case 4:
			return 'Over time';
		default:
			return 'Recipe occurrences';
	}
};
var $author$project$Pages$Statistics$StatisticsView$navigationPages = _List_fromArray(
	[0, 1, 2, 3, 4, 5]);
var $author$project$Pages$Statistics$StatisticsView$navigationBar = function (ps) {
	return $author$project$Pages$Util$ViewUtil$navigationBarWith(
		{
			kZ: $author$project$Pages$Statistics$StatisticsView$navigationPages,
			lr: function (page) {
				return $author$project$Pages$Util$ViewUtil$navigationToPageButtonWith(
					{iB: $author$project$Addresses$StatisticsVariant$addressSuffix, jg: ps.jg, kS: $author$project$Addresses$StatisticsVariant$nameOfPage, N: page});
			}
		});
};
var $author$project$Pages$Statistics$StatisticsView$withNavigationBar = F2(
	function (ps, html) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Pages$Statistics$StatisticsView$navigationBar(ps),
					html
				]));
	});
var $author$project$Pages$Statistics$ComplexFood$Search$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{
			jg: $elm$core$Maybe$Just(2),
			me: true
		},
		A2(
			$author$project$Pages$Statistics$StatisticsView$withNavigationBar,
			{
				jg: $elm$core$Maybe$Just(1)
			},
			function () {
				var filterOn = $author$project$Util$SearchUtil$search(main.i7);
				var viewComplexFoods = A3(
					$author$project$Pages$Util$ViewUtil$paginate,
					{
						lt: A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Statistics$ComplexFood$Search$Pagination$lenses.d3, $author$project$Pages$Statistics$ComplexFood$Search$Page$lenses.kz.lt)
					},
					main,
					A2(
						$elm$core$List$sortBy,
						function ($) {
							return $.gN;
						},
						A2(
							$elm$core$List$filter,
							function (v) {
								return filterOn(v.gN) || filterOn(
									A2($elm$core$Maybe$withDefault, '', v.fX));
							},
							main.d3)));
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[$author$project$Pages$Util$Style$ids.mj.i4]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Pages$Util$HtmlUtil$searchAreaWith(
									{gM: $author$project$Pages$Statistics$ComplexFood$Search$Page$SetSearchString, hz: main.i7}),
									A2(
									$elm$html$Html$table,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.jF]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$thead,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$tr,
													_List_fromArray(
														[$author$project$Pages$Util$Style$classes.mt]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$th,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Name')
																		]))
																])),
															A2($elm$html$Html$th, _List_Nil, _List_Nil),
															A2($elm$html$Html$th, _List_Nil, _List_Nil)
														]))
												])),
											A2(
											$elm$html$Html$tbody,
											_List_Nil,
											A2(
												$elm$core$List$map,
												$author$project$Pages$Statistics$ComplexFood$Search$View$viewComplexFoodLine,
												$jschomay$elm_paginate$Paginate$page(viewComplexFoods)))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.lt]),
									_List_fromArray(
										[
											$author$project$Pages$Util$ViewUtil$pagerButtons(
											{
												jD: viewComplexFoods,
												gM: A2(
													$elm$core$Basics$composeR,
													A2(
														$author$project$Pages$Util$PaginationSettings$updateCurrentPage,
														{gy: $author$project$Pages$Statistics$ComplexFood$Search$Pagination$lenses.d3, lt: $author$project$Pages$Statistics$ComplexFood$Search$Page$lenses.kz.lt},
														main),
													$author$project$Pages$Statistics$ComplexFood$Search$Page$SetComplexFoodsPagination)
											})
										]))
								]))
						]));
			}()));
};
var $author$project$Pages$Statistics$ComplexFood$Search$View$view = $author$project$Pages$View$Tristate$view(
	{md: true, mT: $author$project$Pages$Statistics$ComplexFood$Search$View$viewMain});
var $author$project$Pages$Statistics$ComplexFood$Select$Page$SelectReferenceMap = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Statistics$ComplexFood$Select$Page$SetNutrientsSearchString = function (a) {
	return {$: 4, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber = F5(
	function (original, integers, decimals, prefix, suffix) {
		return {fT: decimals, gv: integers, ln: original, de: prefix, dJ: suffix};
	});
var $cuducos$elm_format_number$FormatNumber$Parser$Negative = 2;
var $cuducos$elm_format_number$FormatNumber$Parser$Positive = 0;
var $cuducos$elm_format_number$FormatNumber$Parser$Zero = 1;
var $cuducos$elm_format_number$FormatNumber$Parser$classify = function (formatted) {
	var onlyZeros = A2(
		$elm$core$String$all,
		function (_char) {
			return _char === '0';
		},
		$elm$core$String$concat(
			A2(
				$elm$core$List$append,
				formatted.gv,
				$elm$core$List$singleton(formatted.fT))));
	return onlyZeros ? 1 : ((formatted.ln < 0) ? 2 : 0);
};
var $elm$core$String$filter = _String_filter;
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit = F2(
	function (desiredLength, value) {
		var length = $elm$core$String$length(value);
		var missing = (_Utils_cmp(length, desiredLength) < 0) ? $elm$core$Basics$abs(desiredLength - length) : 0;
		return _Utils_ap(
			value,
			A2($elm$core$String$repeat, missing, '0'));
	});
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $cuducos$elm_format_number$FormatNumber$Parser$removeZeros = function (decimals) {
	return (A2($elm$core$String$right, 1, decimals) !== '0') ? decimals : $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(
		A2($elm$core$String$dropRight, 1, decimals));
};
var $cuducos$elm_format_number$FormatNumber$Parser$getDecimals = F2(
	function (locale, digits) {
		var _v0 = locale.fT;
		switch (_v0.$) {
			case 1:
				return $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(digits);
			case 2:
				return digits;
			default:
				var min = _v0.a;
				return A2($cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit, min, digits);
		}
	});
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (c !== '0') && (c !== '.');
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (head === '9') {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 1) {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				'0',
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$String$reverse = _String_reverse;
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					'0',
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3($elm$core$String$padRight, s, '0', after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('5' === _v0.a.a) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $cuducos$elm_format_number$FormatNumber$Parser$splitInParts = F2(
	function (locale, value) {
		var toString = function () {
			var _v1 = locale.fT;
			switch (_v1.$) {
				case 1:
					var max = _v1.a;
					return $myrho$elm_round$Round$round(max);
				case 0:
					return $elm$core$String$fromFloat;
				default:
					var exact = _v1.a;
					return $myrho$elm_round$Round$round(exact);
			}
		}();
		var asList = A2(
			$elm$core$String$split,
			'.',
			toString(value));
		var decimals = function () {
			var _v0 = $elm$core$List$tail(asList);
			if (!_v0.$) {
				var values = _v0.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(values));
			} else {
				return '';
			}
		}();
		var integers = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(asList));
		return _Utils_Tuple2(integers, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Parser$splitByIndian = function (integers) {
	var thousand = ($elm$core$String$length(integers) > 3) ? A2($elm$core$String$right, 3, integers) : integers;
	var reversedSplitHundreds = function (value) {
		return ($elm$core$String$length(value) > 2) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 2, value),
			reversedSplitHundreds(
				A2($elm$core$String$dropRight, 2, value))) : ((!$elm$core$String$length(value)) ? _List_Nil : _List_fromArray(
			[value]));
	};
	return $elm$core$List$reverse(
		A2(
			$elm$core$List$cons,
			thousand,
			reversedSplitHundreds(
				A2($elm$core$String$dropRight, 3, integers))));
};
var $cuducos$elm_format_number$FormatNumber$Parser$splitByWestern = function (integers) {
	var reversedSplitThousands = function (value) {
		return ($elm$core$String$length(value) > 3) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 3, value),
			reversedSplitThousands(
				A2($elm$core$String$dropRight, 3, value))) : _List_fromArray(
			[value]);
	};
	return $elm$core$List$reverse(
		reversedSplitThousands(integers));
};
var $cuducos$elm_format_number$FormatNumber$Parser$splitIntegers = F2(
	function (system, integers) {
		if (!system) {
			return $cuducos$elm_format_number$FormatNumber$Parser$splitByWestern(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, integers));
		} else {
			return $cuducos$elm_format_number$FormatNumber$Parser$splitByIndian(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, integers));
		}
	});
var $cuducos$elm_format_number$FormatNumber$Parser$parse = F2(
	function (locale, original) {
		var parts = A2($cuducos$elm_format_number$FormatNumber$Parser$splitInParts, locale, original);
		var integers = A2(
			$cuducos$elm_format_number$FormatNumber$Parser$splitIntegers,
			locale.dK,
			A2($elm$core$String$filter, $elm$core$Char$isDigit, parts.a));
		var decimals = A2($cuducos$elm_format_number$FormatNumber$Parser$getDecimals, locale, parts.b);
		var partial = A5($cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber, original, integers, decimals, '', '');
		var _v0 = $cuducos$elm_format_number$FormatNumber$Parser$classify(partial);
		switch (_v0) {
			case 2:
				return _Utils_update(
					partial,
					{de: locale.ew, dJ: locale.ex});
			case 0:
				return _Utils_update(
					partial,
					{de: locale.ha, dJ: locale.hb});
			default:
				return _Utils_update(
					partial,
					{de: locale.ir, dJ: locale.is});
		}
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals = F2(
	function (locale, decimals) {
		return (decimals === '') ? '' : _Utils_ap(locale.aF, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$stringfy = F2(
	function (locale, formatted) {
		var stringfyDecimals = $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals(locale);
		var integers = A2($elm$core$String$join, locale.aA, formatted.gv);
		var decimals = stringfyDecimals(formatted.fT);
		return $elm$core$String$concat(
			_List_fromArray(
				[formatted.de, integers, decimals, formatted.dJ]));
	});
var $cuducos$elm_format_number$FormatNumber$format = F2(
	function (locale, number_) {
		return A2(
			$cuducos$elm_format_number$FormatNumber$Stringfy$stringfy,
			locale,
			A2($cuducos$elm_format_number$FormatNumber$Parser$parse, locale, number_));
	});
var $cuducos$elm_format_number$FormatNumber$Locales$Exact = function (a) {
	return {$: 2, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Min = function (a) {
	return {$: 0, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Western = 0;
var $cuducos$elm_format_number$FormatNumber$Locales$base = {
	aF: '.',
	fT: $cuducos$elm_format_number$FormatNumber$Locales$Min(0),
	ew: '−',
	ex: '',
	ha: '',
	hb: '',
	dK: 0,
	aA: '',
	ir: '',
	is: ''
};
var $cuducos$elm_format_number$FormatNumber$Locales$frenchLocale = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$base,
	{
		aF: ',',
		fT: $cuducos$elm_format_number$FormatNumber$Locales$Exact(3),
		aA: '\u202F'
	});
var $author$project$Pages$Statistics$StatisticsView$displayFloat = A2(
	$elm$core$Basics$composeR,
	$cuducos$elm_format_number$FormatNumber$format($cuducos$elm_format_number$FormatNumber$Locales$frenchLocale),
	A2($elm$core$String$replace, ',', '.'));
var $author$project$Pages$Statistics$StatisticsView$referenceMapDropdownWith = F2(
	function (ps, model) {
		return A3(
			$abadi199$elm_input_extra$Dropdown$dropdown,
			{
				f3: $elm$core$Maybe$Just(
					{jH: true, mx: '', ig: ''}),
				gy: A2(
					$elm$core$List$map,
					function (referenceTree) {
						return {
							jH: true,
							mx: referenceTree.gE.gN,
							ig: $danyx23$elm_uuid$Uuid$toString(referenceTree.gE.gn)
						};
					},
					A2(
						$elm$core$List$sortBy,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.gE;
							},
							function ($) {
								return $.gN;
							}),
						$author$project$Util$DictList$values(
							ps.lO(model)))),
				g0: ps.g0
			},
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.gE;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.gn;
						},
						$danyx23$elm_uuid$Uuid$toString)),
				ps.ds(model)));
	});
var $author$project$Pages$Statistics$StatisticsView$referenceMapSelection = F2(
	function (ps, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.jD]),
				_List_fromArray(
					[
						$elm$html$Html$text('Reference map')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.kd]),
				_List_fromArray(
					[
						A2(
						$author$project$Pages$Statistics$StatisticsView$referenceMapDropdownWith,
						{g0: ps.lf, ds: ps.ds, lO: ps.lO},
						model)
					]))
			]);
	});
var $author$project$Pages$Statistics$StatisticsView$factorStyle = function (factor) {
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		_List_Nil,
		function (percent) {
			return _List_fromArray(
				[
					(percent > 100) ? $author$project$Pages$Util$Style$classes.eN.j1 : ((percent === 100) ? $author$project$Pages$Util$Style$classes.eN.jJ : $author$project$Pages$Util$Style$classes.eN.ky)
				]);
		},
		factor);
};
var $author$project$Pages$Statistics$StatisticsView$quotientInfo = function (ps) {
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		'',
		function (v) {
			return A2(
				$elm$core$String$join,
				'',
				_List_fromArray(
					[' ', '(', v, ')']));
		},
		A2(
			$elm_community$maybe_extra$Maybe$Extra$filter,
			function (_v0) {
				return $elm_community$maybe_extra$Maybe$Extra$isJust(ps.ig);
			},
			$elm$core$Maybe$Just(
				A2(
					$elm$core$String$join,
					'/',
					A2(
						$elm$core$List$map,
						$elm$core$String$fromInt,
						_List_fromArray(
							[ps.fW, ps.h6]))))));
};
var $author$project$Pages$Statistics$StatisticsView$referenceFactor = function (vs) {
	return A2(
		$elm$core$Maybe$andThen,
		function (r) {
			return A2(
				$elm$core$Maybe$map,
				function (a) {
					return 100 * (a / r);
				},
				vs.fj);
		},
		A2(
			$elm_community$maybe_extra$Maybe$Extra$filter,
			function (x) {
				return x > 0;
			},
			vs.hn));
};
var $author$project$Pages$Statistics$StatisticsView$nutrientInformationLineWith = F3(
	function (ps, referenceValues, information) {
		var referenceValue = A2(
			$elm$core$Dict$get,
			ps.k7(information).gZ,
			referenceValues);
		var dailyValue = ps.jh(information);
		var factor = $author$project$Pages$Statistics$StatisticsView$referenceFactor(
			{fj: dailyValue, hn: referenceValue});
		var amount = ps.iG(information);
		var _v0 = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_Utils_Tuple2('', _List_Nil),
			function (completenessFraction) {
				var total = completenessFraction.mF(information);
				var defined = completenessFraction.jo(information);
				return _Utils_eq(defined, total) ? _Utils_Tuple2('', _List_Nil) : _Utils_Tuple2(
					$author$project$Pages$Statistics$StatisticsView$quotientInfo(
						{fW: defined, h6: total, ig: amount}),
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.kb]));
			},
			ps.i3);
		var completenessInfo = _v0.a;
		var completenessStyles = _v0.b;
		var displayValue = A2(
			$elm$core$Basics$composeR,
			A2($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $author$project$Pages$Statistics$StatisticsView$displayFloat),
			A2($elm_community$basics_extra$Basics$Extra$flip, $elm$core$Basics$append, completenessInfo));
		var dailyAverage = ps.mc ? _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.cW]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						completenessStyles,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $author$project$Pages$Statistics$StatisticsView$displayFloat, dailyValue))
							]))
					]))
			]) : _List_Nil;
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.f0]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.ec]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										ps.k7(information).gN)
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.cW]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								completenessStyles,
								_List_fromArray(
									[
										$elm$html$Html$text(
										displayValue(
											ps.iG(information)))
									]))
							]))
					]),
				_Utils_ap(
					dailyAverage,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.cW]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $author$project$Pages$Statistics$StatisticsView$displayFloat, referenceValue))
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.cW]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Types$NutrientUnit$toString(
												ps.k7(information).ib))
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.cW]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_Utils_ap(
										$author$project$Pages$Statistics$StatisticsView$factorStyle(factor),
										completenessStyles),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3(
												$elm_community$maybe_extra$Maybe$Extra$unwrap,
												'',
												A2(
													$elm$core$Basics$composeR,
													$author$project$Pages$Statistics$StatisticsView$displayFloat,
													A2($elm_community$basics_extra$Basics$Extra$flip, $elm$core$Basics$append, '%')),
												factor))
										]))
								]))
						]))));
	});
var $author$project$Pages$Statistics$StatisticsView$nutrientTableHeader = function (ps) {
	var dailyAverageColumn = ps.$9 ? _List_fromArray(
		[
			A2(
			$elm$html$Html$th,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.M]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Daily (avg.)')
						]))
				]))
		]) : _List_Nil;
	return A2(
		$elm$html$Html$thead,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.mt]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$th,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Name')
										]))
								])),
							A2(
							$elm$html$Html$th,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.M]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Total')
										]))
								]))
						]),
					_Utils_ap(
						dailyAverageColumn,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$th,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.M]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Reference daily')
											]))
									])),
								A2(
								$elm$html$Html$th,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.M]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Unit')
											]))
									])),
								A2(
								$elm$html$Html$th,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.M]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('%')
											]))
									]))
							]))))
			]));
};
var $author$project$Pages$Statistics$StatisticsView$statisticsTable = F2(
	function (ps, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.jD]),
				_List_fromArray(
					[
						$elm$html$Html$text(ps.mu)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.kd, $author$project$Pages$Util$Style$classes.k8]),
				_List_fromArray(
					[
						$author$project$Pages$Util$HtmlUtil$searchAreaWith(
						{
							gM: ps.lg,
							hz: ps.l5(model)
						}),
						A2(
						$elm$html$Html$table,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.jF]),
						_List_fromArray(
							[
								$author$project$Pages$Statistics$StatisticsView$nutrientTableHeader(
								{$9: ps.mc}),
								A2(
								$elm$html$Html$tbody,
								_List_Nil,
								A2(
									$elm$core$List$map,
									A2(
										$author$project$Pages$Statistics$StatisticsView$nutrientInformationLineWith,
										{iG: ps.iG, i3: ps.i3, jh: ps.jh, k7: ps.k7, mc: ps.mc},
										A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											$elm$core$Dict$empty,
											function ($) {
												return $.ih;
											},
											ps.ds(model))),
									A2(
										$elm$core$List$filter,
										function (information) {
											return $elm_community$maybe_extra$Maybe$Extra$isJust(
												A2(
													$elm_community$list_extra$List$Extra$find,
													$author$project$Util$SearchUtil$search(
														ps.l5(model)),
													_List_fromArray(
														[
															ps.k7(information).gN,
															ps.k7(information).hV
														])));
										},
										ps.ke(model))))
							]))
					]))
			]);
	});
var $author$project$Pages$Statistics$ComplexFood$Select$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{jg: $elm$core$Maybe$Nothing, me: true},
		A2(
			$author$project$Pages$Statistics$StatisticsView$withNavigationBar,
			{jg: $elm$core$Maybe$Nothing},
			function () {
				var millilitresLine = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					function (amount) {
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_fromArray(
											[$author$project$Pages$Util$Style$classes.cw]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Volume (set)')
													]))
											])),
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A3(
															$elm_community$basics_extra$Basics$Extra$flip,
															$elm$core$Basics$append,
															'ml',
															$author$project$Pages$Statistics$StatisticsView$displayFloat(amount)))
													]))
											]))
									]))
							]);
					},
					main.i4.fr);
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.lv]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$table,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.kd]),
									_Utils_ap(
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$td,
														_List_fromArray(
															[$author$project$Pages$Util$Style$classes.cw]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$label,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Complex food')
																	]))
															])),
														A2(
														$elm$html$Html$td,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$label,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(main.i4.gN)
																	]))
															]))
													])),
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$td,
														_List_fromArray(
															[$author$project$Pages$Util$Style$classes.cw]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$label,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Description')
																	]))
															])),
														A2(
														$elm$html$Html$td,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$label,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2($elm$core$Maybe$withDefault, '', main.i4.fX))
																	]))
															]))
													])),
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$td,
														_List_fromArray(
															[$author$project$Pages$Util$Style$classes.cw]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$label,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Weight (set)')
																	]))
															])),
														A2(
														$elm$html$Html$td,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$label,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A3(
																			$elm_community$basics_extra$Basics$Extra$flip,
																			$elm$core$Basics$append,
																			'g',
																			$author$project$Pages$Statistics$StatisticsView$displayFloat(main.i4.fq)))
																	]))
															]))
													]))
											]),
										millilitresLine))
								])),
						_Utils_ap(
							A2(
								$author$project$Pages$Statistics$StatisticsView$referenceMapSelection,
								{
									lf: A2(
										$elm$core$Basics$composeR,
										$elm$core$Maybe$andThen($danyx23$elm_uuid$Uuid$fromString),
										$author$project$Pages$Statistics$ComplexFood$Select$Page$SelectReferenceMap),
									ds: A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.hO;
										},
										function ($) {
											return $.ds;
										}),
									lO: A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.hO;
										},
										function ($) {
											return $.lO;
										})
								},
								main),
							A2(
								$author$project$Pages$Statistics$StatisticsView$statisticsTable,
								{
									iG: A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.fp;
										},
										function ($) {
											return $.ig;
										}),
									i3: $elm$core$Maybe$Just(
										{
											jo: A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.fp;
												},
												function ($) {
													return $.gW;
												}),
											mF: A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.fp;
												},
												function ($) {
													return $.gX;
												})
										}),
									jh: A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.fp;
										},
										function ($) {
											return $.ig;
										}),
									ke: A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.bB;
										},
										function ($) {
											return $.k8;
										}),
									k7: function ($) {
										return $.fx;
									},
									lg: $author$project$Pages$Statistics$ComplexFood$Select$Page$SetNutrientsSearchString,
									ds: A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.hO;
										},
										function ($) {
											return $.ds;
										}),
									l5: A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.hO;
										},
										function ($) {
											return $.k9;
										}),
									mc: false,
									mu: 'Nutrients per 100g'
								},
								main))));
			}()));
};
var $author$project$Pages$Statistics$ComplexFood$Select$View$view = $author$project$Pages$View$Tristate$view(
	{md: true, mT: $author$project$Pages$Statistics$ComplexFood$Select$View$viewMain});
var $author$project$Pages$Statistics$Food$Search$Page$SetFoodsPagination = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Statistics$Food$Search$Page$SetSearchString = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$col = _VirtualDom_node('col');
var $elm$html$Html$colgroup = _VirtualDom_node('colgroup');
var $author$project$Pages$Statistics$Food$Search$Pagination$lenses = {
	jS: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.jS;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{jS: b});
			}))
};
var $author$project$Pages$Statistics$Food$Search$View$viewFoodLine = function (food) {
	return A2(
		$elm$html$Html$tr,
		_List_fromArray(
			[$author$project$Pages$Util$Style$classes.jx]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.ec]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(food.gN)
							]))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.H]),
				_List_fromArray(
					[
						$author$project$Pages$Util$Links$linkButton(
						{
							S: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.a0.k8]),
							T: _List_fromArray(
								[
									$elm$html$Html$text('Nutrients')
								]),
							id: $author$project$Pages$Util$Links$frontendPage(
								$author$project$Addresses$Frontend$statisticsFoodSelect.iA(food.gn))
						})
					]))
			]));
};
var $author$project$Pages$Statistics$Food$Search$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{
			jg: $elm$core$Maybe$Just(2),
			me: true
		},
		A2(
			$author$project$Pages$Statistics$StatisticsView$withNavigationBar,
			{
				jg: $elm$core$Maybe$Just(0)
			},
			function () {
				var viewFoods = A3(
					$author$project$Pages$Util$ViewUtil$paginate,
					{
						lt: A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Statistics$Food$Search$Pagination$lenses.jS, $author$project$Pages$Statistics$Food$Search$Page$lenses.kz.lt)
					},
					main,
					A2(
						$elm$core$List$sortBy,
						function ($) {
							return $.gN;
						},
						A2(
							$elm$core$List$filter,
							function (v) {
								return A2($author$project$Util$SearchUtil$search, main.jU, v.gN);
							},
							main.jS)));
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[$author$project$Pages$Util$Style$ids.mj.gc]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Pages$Util$HtmlUtil$searchAreaWith(
									{gM: $author$project$Pages$Statistics$Food$Search$Page$SetSearchString, hz: main.jU}),
									A2(
									$elm$html$Html$table,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.jF]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$colgroup,
											_List_Nil,
											_List_fromArray(
												[
													A2($elm$html$Html$col, _List_Nil, _List_Nil),
													A2($elm$html$Html$col, _List_Nil, _List_Nil)
												])),
											A2(
											$elm$html$Html$thead,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$tr,
													_List_fromArray(
														[$author$project$Pages$Util$Style$classes.mt]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$th,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Name')
																		]))
																])),
															A2(
															$elm$html$Html$th,
															_List_fromArray(
																[$author$project$Pages$Util$Style$classes.jd]),
															_List_Nil)
														]))
												])),
											A2(
											$elm$html$Html$tbody,
											_List_Nil,
											A2(
												$elm$core$List$map,
												$author$project$Pages$Statistics$Food$Search$View$viewFoodLine,
												$jschomay$elm_paginate$Paginate$page(viewFoods)))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.lt]),
									_List_fromArray(
										[
											$author$project$Pages$Util$ViewUtil$pagerButtons(
											{
												jD: viewFoods,
												gM: A2(
													$elm$core$Basics$composeR,
													A2(
														$author$project$Pages$Util$PaginationSettings$updateCurrentPage,
														{gy: $author$project$Pages$Statistics$Food$Search$Pagination$lenses.jS, lt: $author$project$Pages$Statistics$Food$Search$Page$lenses.kz.lt},
														main),
													$author$project$Pages$Statistics$Food$Search$Page$SetFoodsPagination)
											})
										]))
								]))
						]));
			}()));
};
var $author$project$Pages$Statistics$Food$Search$View$view = $author$project$Pages$View$Tristate$view(
	{md: true, mT: $author$project$Pages$Statistics$Food$Search$View$viewMain});
var $author$project$Pages$Statistics$Food$Select$Page$SelectReferenceMap = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Statistics$Food$Select$Page$SetNutrientsSearchString = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Statistics$Food$Select$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{jg: $elm$core$Maybe$Nothing, me: true},
		A2(
			$author$project$Pages$Statistics$StatisticsView$withNavigationBar,
			{jg: $elm$core$Maybe$Nothing},
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.lv]),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$table,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.kd]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[$author$project$Pages$Util$Style$classes.cw]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Food')
															]))
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(main.jR.gN)
															]))
													]))
											]))
									]))
							])),
					_Utils_ap(
						A2(
							$author$project$Pages$Statistics$StatisticsView$referenceMapSelection,
							{
								lf: A2(
									$elm$core$Basics$composeR,
									$elm$core$Maybe$andThen($danyx23$elm_uuid$Uuid$fromString),
									$author$project$Pages$Statistics$Food$Select$Page$SelectReferenceMap),
								ds: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.hO;
									},
									function ($) {
										return $.ds;
									}),
								lO: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.hO;
									},
									function ($) {
										return $.lO;
									})
							},
							main),
						A2(
							$author$project$Pages$Statistics$StatisticsView$statisticsTable,
							{
								iG: function ($) {
									return $.fp;
								},
								i3: $elm$core$Maybe$Nothing,
								jh: function ($) {
									return $.fp;
								},
								ke: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.bB;
									},
									function ($) {
										return $.k8;
									}),
								k7: function ($) {
									return $.fx;
								},
								lg: $author$project$Pages$Statistics$Food$Select$Page$SetNutrientsSearchString,
								ds: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.hO;
									},
									function ($) {
										return $.ds;
									}),
								l5: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.hO;
									},
									function ($) {
										return $.k9;
									}),
								mc: false,
								mu: 'Nutrients per 100g'
							},
							main))))));
};
var $author$project$Pages$Statistics$Food$Select$View$view = $author$project$Pages$View$Tristate$view(
	{md: true, mT: $author$project$Pages$Statistics$Food$Select$View$viewMain});
var $author$project$Pages$Statistics$Meal$ProfileChoice$View$view = function (model) {
	return A2(
		$author$project$Pages$Util$ProfileChoice$View$viewWith,
		{
			iA: $author$project$Addresses$Frontend$statisticsMealSearch.iA,
			jg: 2,
			kP: $author$project$Pages$Statistics$StatisticsView$withNavigationBar(
				{
					jg: $elm$core$Maybe$Just(3)
				})
		},
		model);
};
var $author$project$Pages$Statistics$Meal$Search$Page$SetMealsPagination = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Statistics$Meal$Search$Page$SetSearchString = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Statistics$Meal$Search$Pagination$lenses = {
	gG: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.gG;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{gG: b});
			}))
};
var $author$project$Pages$Util$DateUtil$toPrettyString = function (simpleDate) {
	return $elm$core$String$trim(
		A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					$author$project$Pages$Util$DateUtil$dateToPrettyString(simpleDate.fR),
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $author$project$Pages$Util$DateUtil$timeToString, simpleDate.h$)
				])));
};
var $author$project$Pages$Util$NavigationUtil$mealEditorLinkButton = F2(
	function (profileId, mealId) {
		return $author$project$Pages$Util$Links$linkButton(
			{
				S: _List_fromArray(
					[$author$project$Pages$Util$Style$classes.a0.jy]),
				T: _List_fromArray(
					[
						$elm$html$Html$text('Meal')
					]),
				id: $author$project$Pages$Util$Links$frontendPage(
					$author$project$Addresses$Frontend$mealEntryEditor.iA(
						_Utils_Tuple2(profileId, mealId)))
			});
	});
var $author$project$Pages$Util$NavigationUtil$mealNutrientsLinkButton = F2(
	function (profileId, mealId) {
		return $author$project$Pages$Util$NavigationUtil$nutrientButtonWith(
			{
				iA: $author$project$Pages$Util$Links$frontendPage(
					$author$project$Addresses$Frontend$statisticsMealSelect.iA(
						_Utils_Tuple2(profileId, mealId)))
			});
	});
var $author$project$Pages$Statistics$Meal$Search$View$viewMealLine = F2(
	function (profile, meal) {
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.f0]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.ec]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Pages$Util$DateUtil$dateToPrettyString(meal.fR.fR))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.ec]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $author$project$Pages$Util$DateUtil$timeToString, meal.fR.h$))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.ec]),
					_List_fromArray(
						[
							$elm$html$Html$text(profile.gN)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.ec]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($elm$core$Maybe$withDefault, '', meal.gN))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.H]),
					_List_fromArray(
						[
							A2($author$project$Pages$Util$NavigationUtil$mealNutrientsLinkButton, profile.gn, meal.gn)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.H]),
					_List_fromArray(
						[
							A2($author$project$Pages$Util$NavigationUtil$mealEditorLinkButton, profile.gn, meal.gn)
						]))
				]));
	});
var $author$project$Pages$Statistics$Meal$Search$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{
			jg: $elm$core$Maybe$Just(2),
			me: true
		},
		A2(
			$author$project$Pages$Statistics$StatisticsView$withNavigationBar,
			{
				jg: $elm$core$Maybe$Just(3)
			},
			function () {
				var filterOn = $author$project$Util$SearchUtil$search(main.kH);
				var viewMeals = A3(
					$author$project$Pages$Util$ViewUtil$paginate,
					{
						lt: A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Statistics$Meal$Search$Pagination$lenses.gG, $author$project$Pages$Statistics$Meal$Search$Page$lenses.kz.lt)
					},
					main,
					$elm$core$List$reverse(
						A2(
							$elm$core$List$sortBy,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.fR;
								},
								$author$project$Pages$Util$DateUtil$toPrettyString),
							A2(
								$elm$core$List$filter,
								function (v) {
									return filterOn(
										A2($elm$core$Maybe$withDefault, '', v.gN)) || filterOn(
										$author$project$Pages$Util$DateUtil$toPrettyString(v.fR));
								},
								main.gG))));
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[$author$project$Pages$Util$Style$ids.mj.kD]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Pages$Util$HtmlUtil$searchAreaWith(
									{gM: $author$project$Pages$Statistics$Meal$Search$Page$SetSearchString, hz: main.kH}),
									A2(
									$elm$html$Html$table,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.jF]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$thead,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$tr,
													_List_fromArray(
														[$author$project$Pages$Util$Style$classes.mt, $author$project$Pages$Util$Style$classes.kE]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$th,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Date')
																])),
															A2(
															$elm$html$Html$th,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Time')
																])),
															A2(
															$elm$html$Html$th,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Profile')
																])),
															A2(
															$elm$html$Html$th,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Name')
																])),
															A2($elm$html$Html$th, _List_Nil, _List_Nil),
															A2($elm$html$Html$th, _List_Nil, _List_Nil)
														]))
												])),
											A2(
											$elm$html$Html$tbody,
											_List_Nil,
											A2(
												$elm$core$List$map,
												$author$project$Pages$Statistics$Meal$Search$View$viewMealLine(main.ly),
												$jschomay$elm_paginate$Paginate$page(viewMeals)))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.lt]),
									_List_fromArray(
										[
											$author$project$Pages$Util$ViewUtil$pagerButtons(
											{
												jD: viewMeals,
												gM: A2(
													$elm$core$Basics$composeR,
													A2(
														$author$project$Pages$Util$PaginationSettings$updateCurrentPage,
														{gy: $author$project$Pages$Statistics$Meal$Search$Pagination$lenses.gG, lt: $author$project$Pages$Statistics$Meal$Search$Page$lenses.kz.lt},
														main),
													$author$project$Pages$Statistics$Meal$Search$Page$SetMealsPagination)
											})
										]))
								]))
						]));
			}()));
};
var $author$project$Pages$Statistics$Meal$Search$View$view = $author$project$Pages$View$Tristate$view(
	{md: true, mT: $author$project$Pages$Statistics$Meal$Search$View$viewMain});
var $author$project$Pages$Statistics$Meal$Select$Page$SelectReferenceMap = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Statistics$Meal$Select$Page$SetNutrientsSearchString = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Statistics$Meal$Select$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{jg: $elm$core$Maybe$Nothing, me: true},
		A2(
			$author$project$Pages$Statistics$StatisticsView$withNavigationBar,
			{jg: $elm$core$Maybe$Nothing},
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.lv]),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$table,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.kd]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[$author$project$Pages$Util$Style$classes.cw]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Date')
															]))
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																A3(
																	$elm$core$Basics$composeL,
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Pages$Util$DateUtil$dateToPrettyString,
																		function ($) {
																			return $.fR;
																		}),
																	function ($) {
																		return $.fR;
																	},
																	main.kD))
															]))
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[$author$project$Pages$Util$Style$classes.cw]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Time')
															]))
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																A3(
																	$elm$core$Basics$composeL,
																	A2(
																		$elm$core$Basics$composeL,
																		A2($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $author$project$Pages$Util$DateUtil$timeToString),
																		function ($) {
																			return $.h$;
																		}),
																	function ($) {
																		return $.fR;
																	},
																	main.kD))
															]))
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[$author$project$Pages$Util$Style$classes.cw]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Profile')
															]))
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(main.ly.gN)
															]))
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[$author$project$Pages$Util$Style$classes.cw]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Name')
															]))
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																A2($elm$core$Maybe$withDefault, '', main.kD.gN))
															]))
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[$author$project$Pages$Util$Style$classes.cw]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Weight of ingredients')
															]))
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																A3(
																	$elm_community$basics_extra$Basics$Extra$flip,
																	$elm$core$Basics$append,
																	'g',
																	$author$project$Pages$Statistics$StatisticsView$displayFloat(main.kG.ik)))
															]))
													]))
											]))
									]))
							])),
					_Utils_ap(
						A2(
							$author$project$Pages$Statistics$StatisticsView$referenceMapSelection,
							{
								lf: A2(
									$elm$core$Basics$composeR,
									$elm$core$Maybe$andThen($danyx23$elm_uuid$Uuid$fromString),
									$author$project$Pages$Statistics$Meal$Select$Page$SelectReferenceMap),
								ds: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.hO;
									},
									function ($) {
										return $.ds;
									}),
								lO: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.hO;
									},
									function ($) {
										return $.lO;
									})
							},
							main),
						A2(
							$author$project$Pages$Statistics$StatisticsView$statisticsTable,
							{
								iG: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.fp;
									},
									function ($) {
										return $.ig;
									}),
								i3: $elm$core$Maybe$Just(
									{
										jo: A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.fp;
											},
											function ($) {
												return $.gW;
											}),
										mF: A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.fp;
											},
											function ($) {
												return $.gX;
											})
									}),
								jh: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.fp;
									},
									function ($) {
										return $.ig;
									}),
								ke: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.kG;
									},
									function ($) {
										return $.k8;
									}),
								k7: function ($) {
									return $.fx;
								},
								lg: $author$project$Pages$Statistics$Meal$Select$Page$SetNutrientsSearchString,
								ds: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.hO;
									},
									function ($) {
										return $.ds;
									}),
								l5: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.hO;
									},
									function ($) {
										return $.k9;
									}),
								mc: false,
								mu: 'Nutrients in the meal'
							},
							main))))));
};
var $author$project$Pages$Statistics$Meal$Select$View$view = $author$project$Pages$View$Tristate$view(
	{md: true, mT: $author$project$Pages$Statistics$Meal$Select$View$viewMain});
var $author$project$Pages$Statistics$Recipe$Search$Page$SetRecipesPagination = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Statistics$Recipe$Search$Page$SetSearchString = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Statistics$Recipe$Search$Pagination$lenses = {
	eO: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.eO;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{eO: b});
			}))
};
var $author$project$Pages$Statistics$Recipe$Search$View$viewRecipeLine = function (recipe) {
	return A2(
		$elm$html$Html$tr,
		_List_fromArray(
			[$author$project$Pages$Util$Style$classes.jx]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.ec]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(recipe.gN)
							]))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.ec]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($elm$core$Maybe$withDefault, '', recipe.fX))
							]))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.H]),
				_List_fromArray(
					[
						$author$project$Pages$Util$NavigationUtil$recipeNutrientsLinkButton(recipe.gn)
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.H]),
				_List_fromArray(
					[
						$author$project$Pages$Util$NavigationUtil$recipeEditorLinkButton(recipe.gn)
					]))
			]));
};
var $author$project$Pages$Statistics$Recipe$Search$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{
			jg: $elm$core$Maybe$Just(2),
			me: true
		},
		A2(
			$author$project$Pages$Statistics$StatisticsView$withNavigationBar,
			{
				jg: $elm$core$Maybe$Just(2)
			},
			function () {
				var filterOn = $author$project$Util$SearchUtil$search(main.lI);
				var viewRecipes = A3(
					$author$project$Pages$Util$ViewUtil$paginate,
					{
						lt: A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Statistics$Recipe$Search$Pagination$lenses.eO, $author$project$Pages$Statistics$Recipe$Search$Page$lenses.kz.lt)
					},
					main,
					A2(
						$elm$core$List$sortBy,
						function ($) {
							return $.gN;
						},
						A2(
							$elm$core$List$filter,
							function (v) {
								return filterOn(v.gN) || filterOn(
									A2($elm$core$Maybe$withDefault, '', v.fX));
							},
							main.eO)));
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[$author$project$Pages$Util$Style$ids.mj.lD]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Pages$Util$HtmlUtil$searchAreaWith(
									{gM: $author$project$Pages$Statistics$Recipe$Search$Page$SetSearchString, hz: main.lI}),
									A2(
									$elm$html$Html$table,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.jF]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$thead,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$tr,
													_List_fromArray(
														[$author$project$Pages$Util$Style$classes.mt]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$th,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Name')
																		]))
																])),
															A2(
															$elm$html$Html$th,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Description')
																		]))
																])),
															A2($elm$html$Html$th, _List_Nil, _List_Nil),
															A2($elm$html$Html$th, _List_Nil, _List_Nil)
														]))
												])),
											A2(
											$elm$html$Html$tbody,
											_List_Nil,
											A2(
												$elm$core$List$map,
												$author$project$Pages$Statistics$Recipe$Search$View$viewRecipeLine,
												$jschomay$elm_paginate$Paginate$page(viewRecipes)))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.lt]),
									_List_fromArray(
										[
											$author$project$Pages$Util$ViewUtil$pagerButtons(
											{
												jD: viewRecipes,
												gM: A2(
													$elm$core$Basics$composeR,
													A2(
														$author$project$Pages$Util$PaginationSettings$updateCurrentPage,
														{gy: $author$project$Pages$Statistics$Recipe$Search$Pagination$lenses.eO, lt: $author$project$Pages$Statistics$Recipe$Search$Page$lenses.kz.lt},
														main),
													$author$project$Pages$Statistics$Recipe$Search$Page$SetRecipesPagination)
											})
										]))
								]))
						]));
			}()));
};
var $author$project$Pages$Statistics$Recipe$Search$View$view = $author$project$Pages$View$Tristate$view(
	{md: true, mT: $author$project$Pages$Statistics$Recipe$Search$View$viewMain});
var $author$project$Pages$Statistics$Recipe$Select$Page$SelectReferenceMap = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Statistics$Recipe$Select$Page$SetNutrientsSearchString = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Statistics$Recipe$Select$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{jg: $elm$core$Maybe$Nothing, me: true},
		A2(
			$author$project$Pages$Statistics$StatisticsView$withNavigationBar,
			{jg: $elm$core$Maybe$Nothing},
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.lv]),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$table,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.kd]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[$author$project$Pages$Util$Style$classes.cw]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Recipe')
															]))
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(main.lD.gN)
															]))
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[$author$project$Pages$Util$Style$classes.cw]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Description')
															]))
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																A2($elm$core$Maybe$withDefault, '', main.lD.fX))
															]))
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[$author$project$Pages$Util$Style$classes.cw]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Servings')
															]))
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Pages$Statistics$StatisticsView$displayFloat(main.lD.gY))
															]))
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[$author$project$Pages$Util$Style$classes.cw]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Serving size')
															]))
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																A2($elm$core$Maybe$withDefault, '', main.lD.hF))
															]))
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[$author$project$Pages$Util$Style$classes.cw]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Weight of ingredients')
															]))
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																A3(
																	$elm_community$basics_extra$Basics$Extra$flip,
																	$elm$core$Basics$append,
																	'g',
																	$author$project$Pages$Statistics$StatisticsView$displayFloat(main.lH.ik)))
															]))
													]))
											]))
									]))
							])),
					_Utils_ap(
						A2(
							$author$project$Pages$Statistics$StatisticsView$referenceMapSelection,
							{
								lf: A2(
									$elm$core$Basics$composeR,
									$elm$core$Maybe$andThen($danyx23$elm_uuid$Uuid$fromString),
									$author$project$Pages$Statistics$Recipe$Select$Page$SelectReferenceMap),
								ds: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.hO;
									},
									function ($) {
										return $.ds;
									}),
								lO: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.hO;
									},
									function ($) {
										return $.lO;
									})
							},
							main),
						A2(
							$author$project$Pages$Statistics$StatisticsView$statisticsTable,
							{
								iG: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.fp;
									},
									function ($) {
										return $.ig;
									}),
								i3: $elm$core$Maybe$Just(
									{
										jo: A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.fp;
											},
											function ($) {
												return $.gW;
											}),
										mF: A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.fp;
											},
											function ($) {
												return $.gX;
											})
									}),
								jh: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.fp;
									},
									function ($) {
										return $.ig;
									}),
								ke: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.lH;
									},
									function ($) {
										return $.k8;
									}),
								k7: function ($) {
									return $.fx;
								},
								lg: $author$project$Pages$Statistics$Recipe$Select$Page$SetNutrientsSearchString,
								ds: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.hO;
									},
									function ($) {
										return $.ds;
									}),
								l5: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.hO;
									},
									function ($) {
										return $.k9;
									}),
								mc: false,
								mu: 'Nutrients per serving' + A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									'',
									function (size) {
										return $elm$core$String$concat(
											_List_fromArray(
												[' ', '(', size, ')']));
									},
									main.lD.hF)
							},
							main))))));
};
var $author$project$Pages$Statistics$Recipe$Select$View$view = $author$project$Pages$View$Tristate$view(
	{md: true, mT: $author$project$Pages$Statistics$Recipe$Select$View$viewMain});
var $author$project$Pages$Statistics$RecipeOccurrences$ProfileChoice$View$view = function (model) {
	return A2(
		$author$project$Pages$Util$ProfileChoice$View$viewWith,
		{
			iA: $author$project$Addresses$Frontend$statisticsRecipeOccurrences.iA,
			jg: 2,
			kP: $author$project$Pages$Statistics$StatisticsView$withNavigationBar(
				{
					jg: $elm$core$Maybe$Just(5)
				})
		},
		model);
};
var $author$project$Pages$Statistics$RecipeOccurrences$Search$Page$MealDate = 1;
var $author$project$Pages$Statistics$RecipeOccurrences$Search$Page$SetRecipeOccurrencesPagination = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Statistics$RecipeOccurrences$Search$Page$SetSearchString = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Statistics$RecipeOccurrences$Search$Page$SortBy = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Statistics$RecipeOccurrences$Search$Pagination$lenses = {
	lG: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.lG;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{lG: b});
			}))
};
var $author$project$Pages$Statistics$RecipeOccurrences$Search$View$sortBy = F2(
	function (sortType, recipeOccurrences) {
		if (!sortType) {
			return A2(
				$elm$core$List$sortBy,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.lD;
					},
					function ($) {
						return $.gN;
					}),
				recipeOccurrences);
		} else {
			return $elm$core$List$reverse(
				A2(
					$elm$core$List$sortBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.gC;
						},
						A2(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							'',
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.fR;
								},
								$author$project$Pages$Util$DateUtil$toPrettyString))),
					recipeOccurrences));
		}
	});
var $author$project$Pages$Statistics$RecipeOccurrences$Search$View$viewRecipeOccurrenceLine = F2(
	function (profile, recipeOccurrence) {
		var _v0 = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_Utils_Tuple3('', '', _List_Nil),
			function (meal) {
				return _Utils_Tuple3(
					$author$project$Pages$Util$DateUtil$toPrettyString(meal.fR),
					A2($elm$core$Maybe$withDefault, '', meal.gN),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.H]),
							_List_fromArray(
								[
									A2($author$project$Pages$Util$NavigationUtil$mealEditorLinkButton, profile.gn, meal.gn)
								]))
						]));
			},
			recipeOccurrence.gC);
		var mealDate = _v0.a;
		var mealName = _v0.b;
		var mealButton = _v0.c;
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.f0]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.ec]),
						_List_fromArray(
							[
								$elm$html$Html$text(recipeOccurrence.lD.gN)
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.ec]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($elm$core$Maybe$withDefault, '', recipeOccurrence.lD.fX))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.ec]),
						_List_fromArray(
							[
								$elm$html$Html$text(profile.gN)
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.ec]),
						_List_fromArray(
							[
								$elm$html$Html$text(mealDate)
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.ec]),
						_List_fromArray(
							[
								$elm$html$Html$text(mealName)
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.ec]),
						_List_fromArray(
							[
								$author$project$Pages$Util$NavigationUtil$recipeEditorLinkButton(recipeOccurrence.lD.gn)
							]))
					]),
				mealButton));
	});
var $author$project$Pages$Statistics$RecipeOccurrences$Search$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{
			jg: $elm$core$Maybe$Just(2),
			me: true
		},
		A2(
			$author$project$Pages$Statistics$StatisticsView$withNavigationBar,
			{
				jg: $elm$core$Maybe$Just(5)
			},
			function () {
				var filterOn = $author$project$Util$SearchUtil$search(main.lI);
				var viewRecipes = A3(
					$author$project$Pages$Util$ViewUtil$paginate,
					{
						lt: A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Statistics$RecipeOccurrences$Search$Pagination$lenses.lG, $author$project$Pages$Statistics$RecipeOccurrences$Search$Page$lenses.kz.lt)
					},
					main,
					A2(
						$author$project$Pages$Statistics$RecipeOccurrences$Search$View$sortBy,
						main.mi,
						A2(
							$elm$core$List$filter,
							function (v) {
								return filterOn(v.lD.gN) || (filterOn(
									A2($elm$core$Maybe$withDefault, '', v.lD.fX)) || (filterOn(
									A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										'',
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.fR;
											},
											$author$project$Pages$Util$DateUtil$toPrettyString),
										v.gC)) || filterOn(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$andThen,
											function ($) {
												return $.gN;
											},
											v.gC)))));
							},
							main.lG)));
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[$author$project$Pages$Util$Style$ids.mj.lF]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Pages$Util$HtmlUtil$searchAreaWith(
									{gM: $author$project$Pages$Statistics$RecipeOccurrences$Search$Page$SetSearchString, hz: main.lI}),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.mh]),
									_List_fromArray(
										[
											$elm$html$Html$text('Sort by'),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$disabled(!main.mi),
													$elm$html$Html$Events$onClick(
													$author$project$Pages$Statistics$RecipeOccurrences$Search$Page$SortBy(0)),
													$author$project$Pages$Util$Style$classes.a0.fo
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Recipe name')
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$disabled(main.mi === 1),
													$elm$html$Html$Events$onClick(
													$author$project$Pages$Statistics$RecipeOccurrences$Search$Page$SortBy(1)),
													$author$project$Pages$Util$Style$classes.a0.fo
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Meal date')
												]))
										])),
									A2(
									$elm$html$Html$table,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.jF]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$thead,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$tr,
													_List_fromArray(
														[$author$project$Pages$Util$Style$classes.mt]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$th,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Recipe')
																])),
															A2(
															$elm$html$Html$th,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Description')
																])),
															A2(
															$elm$html$Html$th,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Profile')
																])),
															A2(
															$elm$html$Html$th,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Meal date')
																])),
															A2(
															$elm$html$Html$th,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Meal name')
																])),
															A2($elm$html$Html$th, _List_Nil, _List_Nil),
															A2($elm$html$Html$th, _List_Nil, _List_Nil)
														]))
												])),
											A2(
											$elm$html$Html$tbody,
											_List_Nil,
											A2(
												$elm$core$List$map,
												$author$project$Pages$Statistics$RecipeOccurrences$Search$View$viewRecipeOccurrenceLine(main.ly),
												$jschomay$elm_paginate$Paginate$page(viewRecipes)))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.lt]),
									_List_fromArray(
										[
											$author$project$Pages$Util$ViewUtil$pagerButtons(
											{
												jD: viewRecipes,
												gM: A2(
													$elm$core$Basics$composeR,
													A2(
														$author$project$Pages$Util$PaginationSettings$updateCurrentPage,
														{gy: $author$project$Pages$Statistics$RecipeOccurrences$Search$Pagination$lenses.lG, lt: $author$project$Pages$Statistics$RecipeOccurrences$Search$Page$lenses.kz.lt},
														main),
													$author$project$Pages$Statistics$RecipeOccurrences$Search$Page$SetRecipeOccurrencesPagination)
											})
										]))
								]))
						]));
			}()));
};
var $author$project$Pages$Statistics$RecipeOccurrences$Search$View$view = $author$project$Pages$View$Tristate$view(
	{md: true, mT: $author$project$Pages$Statistics$RecipeOccurrences$Search$View$viewMain});
var $author$project$Pages$Statistics$Time$Page$FetchStats = {$: 3};
var $author$project$Pages$Statistics$Time$Page$SelectProfile = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Statistics$Time$Page$SelectReferenceMap = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Statistics$Time$Page$SetFromDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Statistics$Time$Page$SetNutrientsSearchString = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Statistics$Time$Page$SetPagination = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Statistics$Time$Page$SetToDate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Statistics$Time$View$dateInput = F3(
	function (model, mkCmd, lens) {
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('date'),
					$elm$html$Html$Attributes$value(
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						$author$project$Pages$Util$DateUtil$dateToString,
						lens.jY(model))),
					$elm$html$Html$Events$onInput(
					A2(
						$elm$core$Basics$composeR,
						$elm$parser$Parser$run($author$project$Pages$Util$DateUtil$dateParser),
						A2($elm$core$Basics$composeR, $elm$core$Result$toMaybe, mkCmd))),
					$author$project$Pages$Util$Style$classes.fR
				]),
			_List_Nil);
	});
var $author$project$Pages$Statistics$Time$Pagination$lenses = {
	gG: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.gG;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{gG: b});
			}))
};
var $author$project$Pages$Statistics$Time$View$mealLine = F2(
	function (profile, meal) {
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.f0]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.fR]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Pages$Util$DateUtil$dateToPrettyString(meal.fR.fR))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.h$]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $author$project$Pages$Util$DateUtil$timeToString, meal.fR.h$))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.ec]),
					_List_fromArray(
						[
							$elm$html$Html$text(profile.gN)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.ec]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($elm$core$Maybe$withDefault, '', meal.gN))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.H]),
					_List_fromArray(
						[
							A2($author$project$Pages$Util$NavigationUtil$mealNutrientsLinkButton, profile.gn, meal.gn)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.H]),
					_List_fromArray(
						[
							A2($author$project$Pages$Util$NavigationUtil$mealEditorLinkButton, profile.gn, meal.gn)
						]))
				]));
	});
var $author$project$Pages$Statistics$StatisticsView$profileDropdownWith = F2(
	function (ps, model) {
		return A3(
			$abadi199$elm_input_extra$Dropdown$dropdown,
			{
				f3: $elm$core$Maybe$Just(
					{jH: true, mx: '', ig: ''}),
				gy: A2(
					$elm$core$List$map,
					function (profile) {
						return {
							jH: true,
							mx: profile.gN,
							ig: $danyx23$elm_uuid$Uuid$toString(profile.gn)
						};
					},
					A2(
						$elm$core$List$sortBy,
						function ($) {
							return $.gN;
						},
						$author$project$Util$DictList$values(
							ps.eM(model)))),
				g0: A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$andThen($danyx23$elm_uuid$Uuid$fromString),
					ps.g0)
			},
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.gn;
					},
					$danyx23$elm_uuid$Uuid$toString),
				ps.ly(model)));
	});
var $author$project$Pages$Statistics$StatisticsView$profileSelection = F2(
	function (ps, model) {
		return _List_fromArray(
			[
				A2(
				$author$project$Pages$Statistics$StatisticsView$profileDropdownWith,
				{g0: ps.le, ly: ps.ly, eM: ps.eM},
				model)
			]);
	});
var $author$project$Pages$Statistics$Time$View$viewMain = function (main) {
	var weightRow = function () {
		var _v2 = main.bU;
		if (_v2 === 2) {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.jD]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Weight of ingredients: ' + A3(
										$elm_community$basics_extra$Basics$Extra$flip,
										$elm$core$Basics$append,
										'g',
										$author$project$Pages$Statistics$StatisticsView$displayFloat(main.mk.ik)))
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	}();
	var viewMeals = A3(
		$author$project$Pages$Util$ViewUtil$paginate,
		{
			lt: A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Statistics$Time$Pagination$lenses.gG, $author$project$Pages$Statistics$Time$Page$lenses.kz.lt)
		},
		main,
		$elm$core$List$reverse(
			A2(
				$elm$core$List$sortBy,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.fR;
					},
					$author$project$Pages$Util$DateUtil$toString),
				main.mk.gG)));
	var stats = function () {
		var _v0 = _Utils_Tuple2(main.bU, main.hD);
		if ((_v0.a === 2) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			var profile = _v0.b.a;
			return _Utils_ap(
				A2(
					$author$project$Pages$Statistics$StatisticsView$statisticsTable,
					{
						iG: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.ft;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.ih;
								},
								$elm$core$Maybe$map(
									function ($) {
										return $.h6;
									}))),
						i3: $elm$core$Maybe$Just(
							{
								jo: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.ft;
									},
									function ($) {
										return $.gW;
									}),
								mF: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.ft;
									},
									function ($) {
										return $.gX;
									})
							}),
						jh: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.ft;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.ih;
								},
								$elm$core$Maybe$map(
									function ($) {
										return $.fQ;
									}))),
						ke: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.mk;
							},
							function ($) {
								return $.k8;
							}),
						k7: function ($) {
							return $.fx;
						},
						lg: $author$project$Pages$Statistics$Time$Page$SetNutrientsSearchString,
						ds: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.hO;
							},
							function ($) {
								return $.ds;
							}),
						l5: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.hO;
							},
							function ($) {
								return $.k9;
							}),
						mc: true,
						mu: 'Nutrients in all meals in the interval'
					},
					main),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.jD]),
						_List_fromArray(
							[
								$elm$html$Html$text('Meals')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.kd, $author$project$Pages$Util$Style$classes.gG]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$table,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.jF, $author$project$Pages$Util$Style$classes.kE]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$label,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Date')
																	]))
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$label,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Time')
																	]))
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$label,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Profile')
																	]))
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$label,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Name')
																	]))
															])),
														A2($elm$html$Html$th, _List_Nil, _List_Nil),
														A2($elm$html$Html$th, _List_Nil, _List_Nil)
													]))
											])),
										A2(
										$elm$html$Html$tbody,
										_List_Nil,
										A2(
											$elm$core$List$map,
											$author$project$Pages$Statistics$Time$View$mealLine(profile),
											$jschomay$elm_paginate$Paginate$page(viewMeals)))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.lt]),
								_List_fromArray(
									[
										$author$project$Pages$Util$ViewUtil$pagerButtons(
										{
											jD: viewMeals,
											gM: A2(
												$elm$core$Basics$composeR,
												A2(
													$author$project$Pages$Util$PaginationSettings$updateCurrentPage,
													{gy: $author$project$Pages$Statistics$Time$Pagination$lenses.gG, lt: $author$project$Pages$Statistics$Time$Page$lenses.kz.lt},
													main),
												$author$project$Pages$Statistics$Time$Page$SetPagination)
										})
									]))
							]))
					]));
		} else {
			return _List_Nil;
		}
	}();
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{
			jg: $elm$core$Maybe$Just(2),
			me: true
		},
		A2(
			$author$project$Pages$Statistics$StatisticsView$withNavigationBar,
			{
				jg: $elm$core$Maybe$Just(4)
			},
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[$author$project$Pages$Util$Style$ids.mj.h$]),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$table,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.km, $author$project$Pages$Util$Style$classes.jF]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tr,
												_List_fromArray(
													[$author$project$Pages$Util$Style$classes.mt]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('From')
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('To')
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Profile')
															])),
														A2($elm$html$Html$th, _List_Nil, _List_Nil),
														A2($elm$html$Html$th, _List_Nil, _List_Nil)
													]))
											])),
										A2(
										$elm$html$Html$tbody,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$td,
														_List_fromArray(
															[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.fR]),
														_List_fromArray(
															[
																A3($author$project$Pages$Statistics$Time$View$dateInput, main, $author$project$Pages$Statistics$Time$Page$SetFromDate, $author$project$Pages$Statistics$Time$Page$lenses.kz.jV)
															])),
														A2(
														$elm$html$Html$td,
														_List_fromArray(
															[$author$project$Pages$Util$Style$classes.ec, $author$project$Pages$Util$Style$classes.fR]),
														_List_fromArray(
															[
																A3($author$project$Pages$Statistics$Time$View$dateInput, main, $author$project$Pages$Statistics$Time$Page$SetToDate, $author$project$Pages$Statistics$Time$Page$lenses.kz.mA)
															])),
														A2(
														$elm$html$Html$td,
														_List_fromArray(
															[$author$project$Pages$Util$Style$classes.ec]),
														A2(
															$author$project$Pages$Statistics$StatisticsView$profileSelection,
															{
																le: $author$project$Pages$Statistics$Time$Page$SelectProfile,
																ly: function ($) {
																	return $.hD;
																},
																eM: function ($) {
																	return $.eM;
																}
															},
															main)),
														A2(
														$elm$html$Html$td,
														_List_fromArray(
															[$author$project$Pages$Util$Style$classes.H]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$button,
																$elm_community$maybe_extra$Maybe$Extra$values(
																	_List_fromArray(
																		[
																			$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.a0.l6),
																			A2(
																			$author$project$Util$MaybeUtil$optional,
																			$elm_community$maybe_extra$Maybe$Extra$isJust(main.hD),
																			$elm$html$Html$Events$onClick($author$project$Pages$Statistics$Time$Page$FetchStats)),
																			$author$project$Util$MaybeUtil$defined(
																			$elm$html$Html$Attributes$disabled(
																				$elm_community$maybe_extra$Maybe$Extra$isNothing(main.hD)))
																		])),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Compute')
																	]))
															])),
														A2(
														$elm$html$Html$td,
														_List_fromArray(
															[$author$project$Pages$Util$Style$classes.H]),
														A2(
															$elm$core$List$filter,
															$elm$core$Basics$always(main.bU === 1),
															_List_fromArray(
																[$author$project$Pages$Util$Links$loadingSymbol])))
													]))
											]))
									]))
							])),
					_Utils_ap(
						A2(
							$author$project$Pages$Statistics$StatisticsView$referenceMapSelection,
							{
								lf: A2(
									$elm$core$Basics$composeR,
									$elm$core$Maybe$andThen($danyx23$elm_uuid$Uuid$fromString),
									$author$project$Pages$Statistics$Time$Page$SelectReferenceMap),
								ds: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.hO;
									},
									function ($) {
										return $.ds;
									}),
								lO: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.hO;
									},
									function ($) {
										return $.lO;
									})
							},
							main),
						_Utils_ap(weightRow, stats))))));
};
var $author$project$Pages$Statistics$Time$View$view = $author$project$Pages$View$Tristate$view(
	{md: true, mT: $author$project$Pages$Statistics$Time$View$viewMain});
var $author$project$Api$Types$Mode$All = 0;
var $author$project$Pages$UserSettings$Page$Logout = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$UserSettings$Page$RequestDeletion = {$: 5};
var $author$project$Pages$UserSettings$Page$SetComplementInput = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Types$Mode$This = 1;
var $author$project$Pages$UserSettings$Page$UpdatePassword = {$: 1};
var $author$project$Pages$UserSettings$Page$UpdateSettings = {$: 3};
var $author$project$Pages$UserSettings$View$viewRegular = function (main) {
	var password2Lens = A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$PasswordInput$lenses.g6, $author$project$Pages$Util$ComplementInput$lenses.eH);
	var password1Lens = A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$PasswordInput$lenses.lw, $author$project$Pages$Util$ComplementInput$lenses.eH);
	var isValidPassword = $author$project$Pages$Util$PasswordInput$isValidPassword(main.d2.eH);
	var enterPasswordAction = A2(
		$author$project$Util$MaybeUtil$optional,
		isValidPassword,
		$elm_community$html_extra$Html$Events$Extra$onEnter($author$project$Pages$UserSettings$Page$UpdatePassword));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[$author$project$Pages$Util$Style$classes.d4]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.kd]),
						_List_fromArray(
							[
								$elm$html$Html$text('User settings')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$table,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tbody,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Nickname')
															]))
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(main.ie.gU)
															]))
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Email')
															]))
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(main.ie.f2)
															]))
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Display name')
															]))
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																A2($elm$core$Maybe$withDefault, '', main.ie.fZ))
															]))
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('New display name')
															]))
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Events$onInput(
																A2(
																	$elm$core$Basics$composeR,
																	$elm$core$Maybe$Just,
																	A2(
																		$elm$core$Basics$composeR,
																		$elm_community$maybe_extra$Maybe$Extra$filter(
																			A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)),
																		A2(
																			$elm$core$Basics$composeR,
																			A2($elm_community$basics_extra$Basics$Extra$flip, $author$project$Pages$Util$ComplementInput$lenses.fZ.eW, main.d2),
																			$author$project$Pages$UserSettings$Page$SetComplementInput)))),
																$elm$html$Html$Attributes$value(
																A2($elm$core$Maybe$withDefault, '', main.d2.fZ)),
																$author$project$Pages$Util$Style$classes.ec,
																$elm_community$html_extra$Html$Events$Extra$onEnter($author$project$Pages$UserSettings$Page$UpdateSettings)
															]),
														_List_Nil)
													]))
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Pages$UserSettings$Page$UpdateSettings),
										$author$project$Pages$Util$Style$classes.a0.d4
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Update settings')
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$table,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tbody,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('New password')
															]))
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$input,
														$elm_community$maybe_extra$Maybe$Extra$values(
															_List_fromArray(
																[
																	$author$project$Util$MaybeUtil$defined(
																	$elm$html$Html$Events$onInput(
																		A2(
																			$elm$core$Basics$composeR,
																			A2($elm_community$basics_extra$Basics$Extra$flip, password1Lens.eW, main.d2),
																			$author$project$Pages$UserSettings$Page$SetComplementInput))),
																	$author$project$Util$MaybeUtil$defined(
																	$elm$html$Html$Attributes$type_('password')),
																	$author$project$Util$MaybeUtil$defined(
																	$elm$html$Html$Attributes$value(
																		password1Lens.jY(main.d2))),
																	$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.ec),
																	enterPasswordAction
																])),
														_List_Nil)
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Password repetition')
															]))
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$input,
														$elm_community$maybe_extra$Maybe$Extra$values(
															_List_fromArray(
																[
																	$author$project$Util$MaybeUtil$defined(
																	$elm$html$Html$Events$onInput(
																		A2(
																			$elm$core$Basics$composeR,
																			A2($elm_community$basics_extra$Basics$Extra$flip, password2Lens.eW, main.d2),
																			$author$project$Pages$UserSettings$Page$SetComplementInput))),
																	$author$project$Util$MaybeUtil$defined(
																	$elm$html$Html$Attributes$type_('password')),
																	$author$project$Util$MaybeUtil$defined(
																	$elm$html$Html$Attributes$value(
																		password2Lens.jY(main.d2))),
																	$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.ec),
																	enterPasswordAction
																])),
														_List_Nil)
													]))
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Pages$UserSettings$Page$UpdatePassword),
										$author$project$Pages$Util$Style$classes.a0.d4,
										$elm$html$Html$Attributes$disabled(!isValidPassword)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Update password')
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$Pages$UserSettings$Page$RequestDeletion),
								$author$project$Pages$Util$Style$classes.a0.af
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Delete account')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Pages$UserSettings$Page$Logout(1)),
								$author$project$Pages$Util$Style$classes.a0.kx
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Logout this device')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Pages$UserSettings$Page$Logout(0)),
								$author$project$Pages$Util$Style$classes.a0.kx
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Logout all devices')
							]))
					]))
			]));
};
var $author$project$Pages$UserSettings$View$viewRequestedDeletion = function (_v0) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[$author$project$Pages$Util$Style$classes.d4]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Account deletion requested. Please check your email to continue.')
							]))
					]))
			]));
};
var $author$project$Pages$UserSettings$View$viewMain = function (model) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{
			jg: $elm$core$Maybe$Just(4),
			me: true
		},
		function () {
			var _v0 = model.gK;
			if (!_v0) {
				return $author$project$Pages$UserSettings$View$viewRegular(model);
			} else {
				return $author$project$Pages$UserSettings$View$viewRequestedDeletion(model);
			}
		}());
};
var $author$project$Pages$UserSettings$View$view = $author$project$Pages$View$Tristate$view(
	{md: true, mT: $author$project$Pages$UserSettings$View$viewMain});
var $author$project$Main$view = function (model) {
	var _v0 = model.N;
	switch (_v0.$) {
		case 0:
			return $author$project$Pages$Landing$View$view;
		case 1:
			var login = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$LoginMsg,
				$author$project$Pages$Login$View$view(login));
		case 2:
			var overview = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$OverviewMsg,
				$author$project$Pages$Overview$View$view(overview));
		case 3:
			var recipes = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$RecipesMsg,
				$author$project$Pages$Recipes$View$view(recipes));
		case 4:
			var ingredients = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$IngredientsMsg,
				$author$project$Pages$Ingredients$View$view(ingredients));
		case 5:
			var profileChoice = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$ProfileChoiceMsg,
				$author$project$Pages$Meals$ProfileChoice$View$view(profileChoice));
		case 6:
			var meals = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$MealsMsg,
				$author$project$Pages$Meals$Editor$View$view(meals));
		case 7:
			var mealEntries = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$MealEntriesMsg,
				$author$project$Pages$MealEntries$View$view(mealEntries));
		case 8:
			var statisticsTime = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$StatisticsTimeMsg,
				$author$project$Pages$Statistics$Time$View$view(statisticsTime));
		case 9:
			var statisticsFoodSearch = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$StatisticsFoodSearchMsg,
				$author$project$Pages$Statistics$Food$Search$View$view(statisticsFoodSearch));
		case 10:
			var statisticsFoodSelect = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$StatisticsFoodSelectMsg,
				$author$project$Pages$Statistics$Food$Select$View$view(statisticsFoodSelect));
		case 11:
			var statisticsComplexFoodSearch = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$StatisticsComplexFoodSearchMsg,
				$author$project$Pages$Statistics$ComplexFood$Search$View$view(statisticsComplexFoodSearch));
		case 12:
			var statisticsComplexFoodSelect = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$StatisticsComplexFoodSelectMsg,
				$author$project$Pages$Statistics$ComplexFood$Select$View$view(statisticsComplexFoodSelect));
		case 13:
			var statisticsRecipeSearch = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$StatisticsRecipeSearchMsg,
				$author$project$Pages$Statistics$Recipe$Search$View$view(statisticsRecipeSearch));
		case 14:
			var statisticsRecipeSelect = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$StatisticsRecipeSelectMsg,
				$author$project$Pages$Statistics$Recipe$Select$View$view(statisticsRecipeSelect));
		case 15:
			var statisticsMealProfileChoice = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$StatisticsMealProfileChoiceMsg,
				$author$project$Pages$Statistics$Meal$ProfileChoice$View$view(statisticsMealProfileChoice));
		case 16:
			var statisticsMealSearch = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$StatisticsMealSearchMsg,
				$author$project$Pages$Statistics$Meal$Search$View$view(statisticsMealSearch));
		case 17:
			var statisticsMealSelect = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$StatisticsMealSelectMsg,
				$author$project$Pages$Statistics$Meal$Select$View$view(statisticsMealSelect));
		case 18:
			var statisticsRecipeOccurrencesProfileChoice = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$StatisticsRecipeOccurrencesProfileChoiceMsg,
				$author$project$Pages$Statistics$RecipeOccurrences$ProfileChoice$View$view(statisticsRecipeOccurrencesProfileChoice));
		case 19:
			var statisticsRecipeOccurrences = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$StatisticsRecipeOccurrencesMsg,
				$author$project$Pages$Statistics$RecipeOccurrences$Search$View$view(statisticsRecipeOccurrences));
		case 20:
			var referenceMaps = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$ReferenceMapsMsg,
				$author$project$Pages$ReferenceMaps$View$view(referenceMaps));
		case 21:
			var referenceEntries = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$ReferenceEntriesMsg,
				$author$project$Pages$ReferenceEntries$View$view(referenceEntries));
		case 22:
			var requestRegistration = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$RequestRegistrationMsg,
				$author$project$Pages$Registration$Request$View$view(requestRegistration));
		case 23:
			var confirmRegistration = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$ConfirmRegistrationMsg,
				$author$project$Pages$Registration$Confirm$View$view(confirmRegistration));
		case 24:
			var userSettings = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$UserSettingsMsg,
				$author$project$Pages$UserSettings$View$view(userSettings));
		case 25:
			var deletion = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$DeletionMsg,
				$author$project$Pages$Deletion$View$view(deletion));
		case 26:
			var requestRecovery = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$RequestRecoveryMsg,
				$author$project$Pages$Recovery$Request$View$view(requestRecovery));
		case 27:
			var confirmRecovery = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$ConfirmRecoveryMsg,
				$author$project$Pages$Recovery$Confirm$View$view(confirmRecovery));
		case 28:
			var complexFoods = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$ComplexFoodsMsg,
				$author$project$Pages$ComplexFoods$View$view(complexFoods));
		case 29:
			var profiles = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Main$ProfilesMsg,
				$author$project$Pages$Profiles$View$view(profiles));
		default:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Page not found')
					]));
	}
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{
		kh: $author$project$Main$init,
		li: $author$project$Main$ChangedUrl,
		lj: $author$project$Main$ClickedLink,
		mr: $author$project$Main$subscriptions,
		ac: $author$project$Main$update,
		mQ: function (model) {
			return {
				iO: _List_fromArray(
					[
						$author$project$Main$view(model)
					]),
				mz: $author$project$Main$titleFor(model)
			};
		}
	});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (backendURL) {
			return $elm$json$Json$Decode$succeed(
				{iL: backendURL});
		},
		A2($elm$json$Json$Decode$field, 'backendURL', $elm$json$Json$Decode$string)))(0)}});}(this));